(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { isRunningLocalPartnerApi as MF, getPartnerDevApiHeaders as BF, WidgetContextProvider as qF, makeExecuteQuery as HF, makeUseLazyQuery as WF, makeUseQuery as KF, makeUseMutation as GF, useWidgetSettingsMutations as dr, useWidgetSettingsQuery as ur, useRenderConditions as mr, PartnerSettingsWrapper as pr, handleWidgetSubmit as fr, MisconfigurationBanner as hr, validateApiHostName as kl, PartnerHookFormSecretText as Ir, WidgetSettingsFormFooter as yr, useTracking as Cn, useWidgetContext as hn, hasDownstreamApiForbiddenError as bl, hasDownstreamApiAuthorizationError as _l, DisplayErrors as En, settingsToFormValues as xl, useCopyWithDelay as Jt, defaultDateFormat as jt, displayAttributeValue as Li, OAuthSettings as fi, useData as dy, isDownstreamApiNotFoundError as YF, isDownstreamApiAuthorizationError as rw, isDownstreamApiPermissionError as JF, capitalizeFirstCharacter as iw, humanizeKey as QF, hasDownstreamApiTooManyRequestsError as XF, hasDownstreamApiPermissionError as aw, PartnerHookFormBasicAuth as ZF, hasDownstreamApiNotFoundError as ba, getCountryNameFromCountryCode as eI, parseBoolean as nI, parseString as tI, IntegrationModal as rI } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import qe, { useMemo as Qn, useState as me, useEffect as Qe, useRef as Er, useCallback as _t, useReducer as iI, useLayoutEffect as aI, useContext as uy, isValidElement as ow, Fragment as oI, createContext as sw, createElement as sI } from "react";
import { FlexBox as b, Switch as Fo, FieldLabel as lw, FieldWrapper as We, InputText as cr, InputSelectionList as ci, FormGrid as nt, FormField as Z, Text as $, Spinner as fn, Icon as ve, Tooltip as Xe, List as Ye, Badge as Mn, Button as ct, IconButton as rr, Tag as Jn, NavigationButton as Lt, Select as $r, CollapseCard as br, Box as st, Modal as wt, ModalHead as Ct, ModalBody as Ft, ModalFoot as Et, Textarea as bh, TagsInput as Sl, Image as _a, Banner as my, FieldSwitch as cw, SelectionList as mt, Divider as Nl, FieldText as qr, FieldTextarea as lI, CopyToClipboardButton as cI, getSelectionListContext as dI, Avatar as py, Timestamp as uI, Attachment as mI, EmptyState as Io, Table as at, Checkbox as Kg, TextWithHighlight as dw, ErrorBoundaryContext as uw } from "@dixa/lib-shared-habla";
import dt from "classnames";
import { ApolloLink as fy, Observable as mw, ApolloClient as pI, InMemoryCache as fI, createHttpLink as hI, ApolloProvider as yI, useApolloClient as gI, ApolloConsumer as vI, NetworkStatus as tr, isApolloError as pw, gql as jl, ApolloError as fw } from "@apollo/client";
import kI from "cross-fetch";
import { config as Eo } from "lib-shared-backend-config";
import Gn from "moment";
import "moment-timezone";
import { __rest as bI, __assign as Ql } from "tslib";
function hy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qo = { exports: {} }, Ra = {};
var Gg;
function _I() {
  if (Gg) return Ra;
  Gg = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ra.Fragment = r, Ra.jsx = s, Ra.jsxs = s, Ra;
}
var Da = {};
var Yg;
function xI() {
  return Yg || (Yg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c, w));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    Da.Fragment = i, Da.jsx = zn, Da.jsxs = Wn;
  })()), Da;
}
var Jg;
function SI() {
  return Jg || (Jg = 1, process.env.NODE_ENV === "production" ? Qo.exports = _I() : Qo.exports = xI()), Qo.exports;
}
var Zn = SI();
function hw(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: NI } = Object.prototype, { getPrototypeOf: fa } = Object, { iterator: Do, toStringTag: yw } = Symbol, Ys = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), $o = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), Ys(r, n))
      return !0;
    r = fa(r);
  }
  return !1;
}, jI = (e, n) => e != null && $o(e, n) ? e[n] : void 0, yy = /* @__PURE__ */ ((e) => (n) => {
  const r = NI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Tr = (e) => (e = e.toLowerCase(), (n) => yy(n) === e), wl = (e) => (n) => typeof n === e, { isArray: Vi } = Array, ha = wl("undefined");
function xa(e) {
  return e !== null && !ha(e) && e.constructor !== null && !ha(e.constructor) && er(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const gw = Tr("ArrayBuffer");
function wI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && gw(e.buffer), n;
}
const CI = wl("string"), er = wl("function"), vw = wl("number"), Sa = (e) => e !== null && typeof e == "object", FI = (e) => e === !0 || e === !1, Os = (e) => {
  if (!Sa(e))
    return !1;
  const n = fa(e);
  return (n === null || n === Object.prototype || fa(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !$o(e, yw) && !$o(e, Do);
}, II = (e) => {
  if (!Sa(e) || xa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, EI = Tr("Date"), $I = Tr("File"), TI = (e) => !!(e && typeof e.uri < "u"), OI = (e) => e && typeof e.getParts < "u", RI = Tr("Blob"), DI = Tr("FileList"), PI = (e) => Sa(e) && er(e.pipe);
function AI() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Qg = AI(), Xg = typeof Qg.FormData < "u" ? Qg.FormData : void 0, LI = (e) => {
  if (!e) return !1;
  if (Xg && e instanceof Xg) return !0;
  const n = fa(e);
  if (!n || n === Object.prototype || !er(e.append)) return !1;
  const r = yy(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && er(e.toString) && e.toString() === "[object FormData]";
}, VI = Tr("URLSearchParams"), [zI, UI, MI, BI] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Tr), qI = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Po(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Vi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (xa(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function kw(e, n) {
  if (xa(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Ei = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, bw = (e) => !ha(e) && e !== Ei;
function _h(...e) {
  const { caseless: n, skipUndefined: r } = bw(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && kw(i, s) || s, d = Ys(i, l) ? i[l] : void 0;
    Os(d) && Os(o) ? i[l] = _h(d, o) : Os(o) ? i[l] = _h({}, o) : Vi(o) ? i[l] = o.slice() : (!r || !ha(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || xa(l) || (Po(l, a), typeof l != "object" || Vi(l)))
      continue;
    const d = Object.getOwnPropertySymbols(l);
    for (let p = 0; p < d.length; p++) {
      const u = d[p];
      tE.call(l, u) && a(l[u], u);
    }
  }
  return i;
}
const HI = (e, n, r, { allOwnKeys: i } = {}) => (Po(
  n,
  (a, o) => {
    r && er(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: hw(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), WI = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), KI = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, GI = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && fa(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, YI = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, JI = (e) => {
  if (!e) return null;
  if (Vi(e)) return e;
  let n = e.length;
  if (!vw(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, QI = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && fa(Uint8Array)), XI = (e, n) => {
  const i = (e && e[Do]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, ZI = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, eE = Tr("HTMLFormElement"), nE = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: tE } = Object.prototype, rE = Tr("RegExp"), _w = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Po(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, iE = (e) => {
  _w(e, (n, r) => {
    if (er(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (er(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, aE = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Vi(e) ? i(e) : i(String(e).split(n)), r;
}, oE = () => {
}, sE = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function lE(e) {
  return !!(e && er(e.append) && e[yw] === "FormData" && e[Do]);
}
const cE = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (Sa(i)) {
      if (n.has(i))
        return;
      if (xa(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Vi(i) ? [] : {};
        return Po(i, (o, s) => {
          const l = r(o);
          !ha(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, dE = Tr("AsyncFunction"), uE = (e) => e && (Sa(e) || er(e)) && er(e.then) && er(e.catch), xw = ((e, n) => e ? setImmediate : n ? ((r, i) => (Ei.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Ei && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Ei.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", er(Ei.postMessage)), mE = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ei) : typeof process < "u" && process.nextTick || xw, Sw = (e) => e != null && er(e[Do]), pE = (e) => e != null && $o(e, Do) && Sw(e), he = {
  isArray: Vi,
  isArrayBuffer: gw,
  isBuffer: xa,
  isFormData: LI,
  isArrayBufferView: wI,
  isString: CI,
  isNumber: vw,
  isBoolean: FI,
  isObject: Sa,
  isPlainObject: Os,
  isEmptyObject: II,
  isReadableStream: zI,
  isRequest: UI,
  isResponse: MI,
  isHeaders: BI,
  isUndefined: ha,
  isDate: EI,
  isFile: $I,
  isReactNativeBlob: TI,
  isReactNative: OI,
  isBlob: RI,
  isRegExp: rE,
  isFunction: er,
  isStream: PI,
  isURLSearchParams: VI,
  isTypedArray: QI,
  isFileList: DI,
  forEach: Po,
  merge: _h,
  extend: HI,
  trim: qI,
  stripBOM: WI,
  inherits: KI,
  toFlatObject: GI,
  kindOf: yy,
  kindOfTest: Tr,
  endsWith: YI,
  toArray: JI,
  forEachEntry: XI,
  matchAll: ZI,
  isHTMLForm: eE,
  hasOwnProperty: Ys,
  hasOwnProp: Ys,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: $o,
  getSafeProp: jI,
  reduceDescriptors: _w,
  freezeMethods: iE,
  toObjectSet: aE,
  toCamelCase: nE,
  noop: oE,
  toFiniteNumber: sE,
  findKey: kw,
  global: Ei,
  isContextDefined: bw,
  isSpecCompliantForm: lE,
  toJSONObject: cE,
  isAsyncFn: dE,
  isThenable: uE,
  setImmediate: xw,
  asap: mE,
  isIterable: Sw,
  isSafeIterable: pE
}, fE = he.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), hE = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && fE[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function yE(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const gE = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), vE = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function gy(e, n) {
  return he.isArray(e) ? e.map((r) => gy(r, n)) : yE(String(e).replace(n, ""));
}
const kE = (e) => gy(e, gE), bE = (e) => gy(e, vE);
function Nw(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return he.forEach(e.toJSON(), (r, i) => {
    n[i] = bE(r);
  }), n;
}
const Zg = /* @__PURE__ */ Symbol("internals");
function Pa(e) {
  return e && String(e).trim().toLowerCase();
}
function Rs(e) {
  return e === !1 || e == null ? e : he.isArray(e) ? e.map(Rs) : kE(String(e));
}
function _E(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const xE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Xl(e, n, r, i, a) {
  if (he.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!he.isString(n)) {
    if (he.isString(i))
      return n.indexOf(i) !== -1;
    if (he.isRegExp(i))
      return i.test(n);
  }
}
function SE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function NE(e, n) {
  const r = he.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ut = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, p) {
      const u = Pa(d);
      if (!u)
        return;
      const f = he.findKey(a, u);
      (!f || a[f] === void 0 || p === !0 || p === void 0 && a[f] !== !1) && (a[f || d] = Rs(l));
    }
    const s = (l, d) => he.forEach(l, (p, u) => o(p, u, d));
    if (he.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (he.isString(n) && (n = n.trim()) && !xE(n))
      s(hE(n), r);
    else if (he.isObject(n) && he.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), d, p;
      for (const u of n) {
        if (!he.isArray(u))
          throw new TypeError("Object iterator must return a key-value pair");
        p = u[0], he.hasOwnProp(l, p) ? (d = l[p], l[p] = he.isArray(d) ? [...d, u[1]] : [d, u[1]]) : l[p] = u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Pa(n), n) {
      const i = he.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return _E(a);
        if (he.isFunction(r))
          return r.call(this, a, i);
        if (he.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Pa(n), n) {
      const i = he.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Xl(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Pa(s), s) {
        const l = he.findKey(i, s);
        l && (!r || Xl(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return he.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || Xl(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return he.forEach(this, (a, o) => {
      const s = he.findKey(i, o);
      if (s) {
        r[s] = Rs(a), delete r[o];
        return;
      }
      const l = n ? SE(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Rs(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return he.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && he.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Zg] = this[Zg] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Pa(s);
      i[l] || (NE(a, s), i[l] = !0);
    }
    return he.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ut.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
he.reduceDescriptors(Ut.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
he.freezeMethods(Ut);
const jE = "[REDACTED ****]";
function wE(e) {
  if (he.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (he.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function CE(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || he.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Ut && (o = o.toJSON()), i.push(o);
    let s;
    if (he.isArray(o))
      s = [], o.forEach((l, d) => {
        const p = a(l);
        he.isUndefined(p) || (s[d] = p);
      });
    else {
      if (!he.isPlainObject(o) && wE(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, d] of Object.entries(o)) {
        const p = r.has(l.toLowerCase()) ? jE : a(d);
        he.isUndefined(p) || (s[l] = p);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let on = class jw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new jw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && he.hasOwnProp(n, "redact") ? n.redact : void 0, i = he.isArray(r) && r.length > 0 ? CE(n, r) : he.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
on.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
on.ERR_BAD_OPTION = "ERR_BAD_OPTION";
on.ECONNABORTED = "ECONNABORTED";
on.ETIMEDOUT = "ETIMEDOUT";
on.ECONNREFUSED = "ECONNREFUSED";
on.ERR_NETWORK = "ERR_NETWORK";
on.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
on.ERR_DEPRECATED = "ERR_DEPRECATED";
on.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
on.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
on.ERR_CANCELED = "ERR_CANCELED";
on.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
on.ERR_INVALID_URL = "ERR_INVALID_URL";
on.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const FE = null, ww = 100;
function xh(e) {
  return he.isPlainObject(e) || he.isArray(e);
}
function Cw(e) {
  return he.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Zl(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Cw(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function IE(e) {
  return he.isArray(e) && !e.some(xh);
}
const EE = he.toFlatObject(he, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Cl(e, n, r) {
  if (!he.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = he.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(g, D) {
      return !he.isUndefined(D[g]);
    }
  );
  const i = r.metaTokens, a = r.visitor || C, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? ww : r.maxDepth, p = l && he.isSpecCompliantForm(n), u = [];
  if (!he.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(_) {
    if (_ === null) return "";
    if (he.isDate(_))
      return _.toISOString();
    if (he.isBoolean(_))
      return _.toString();
    if (!p && he.isBlob(_))
      throw new on("Blob is not supported. Use a Buffer instead.");
    return he.isArrayBuffer(_) || he.isTypedArray(_) ? p && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function h(_) {
    if (_ > d)
      throw new on(
        "Object is too deeply nested (" + _ + " levels). Max depth: " + d,
        on.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function k(_, g) {
    if (d === 1 / 0)
      return JSON.stringify(_);
    const D = [];
    return JSON.stringify(_, function(I, F) {
      if (!he.isObject(F))
        return F;
      for (; D.length && D[D.length - 1] !== this; )
        D.pop();
      return D.push(F), h(g + D.length - 1), F;
    });
  }
  function C(_, g, D) {
    let O = _;
    if (he.isReactNative(n) && he.isReactNativeBlob(_))
      return n.append(Zl(D, g, o), f(_)), !1;
    if (_ && !D && typeof _ == "object") {
      if (he.endsWith(g, "{}"))
        g = i ? g : g.slice(0, -2), _ = k(_, 1);
      else if (he.isArray(_) && IE(_) || (he.isFileList(_) || he.endsWith(g, "[]")) && (O = he.toArray(_)))
        return g = Cw(g), O.forEach(function(F, L) {
          !(he.isUndefined(F) || F === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Zl([g], L, o) : s === null ? g : g + "[]",
            f(F)
          );
        }), !1;
    }
    return xh(_) ? !0 : (n.append(Zl(D, g, o), f(_)), !1);
  }
  const N = Object.assign(EE, {
    defaultVisitor: C,
    convertValue: f,
    isVisitable: xh
  });
  function j(_, g, D = 0) {
    if (!he.isUndefined(_)) {
      if (h(D), u.indexOf(_) !== -1)
        throw new Error("Circular reference detected in " + g.join("."));
      u.push(_), he.forEach(_, function(I, F) {
        (!(he.isUndefined(I) || I === null) && a.call(n, I, he.isString(F) ? F.trim() : F, g, N)) === !0 && j(I, g ? g.concat(F) : [F], D + 1);
      }), u.pop();
    }
  }
  if (!he.isObject(e))
    throw new TypeError("data must be an object");
  return j(e), n;
}
function ev(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function vy(e, n) {
  this._pairs = [], e && Cl(e, this, n);
}
const Fw = vy.prototype;
Fw.append = function(n, r) {
  this._pairs.push([n, r]);
};
Fw.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, ev);
  } : ev;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function $E(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Iw(e, n, r) {
  if (!n)
    return e;
  const i = he.isFunction(r) ? {
    serialize: r
  } : r, a = he.getSafeProp(i, "encode") || $E, o = he.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = he.isURLSearchParams(n) ? n.toString() : new vy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class nv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    he.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const ky = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, TE = typeof URLSearchParams < "u" ? URLSearchParams : vy, OE = typeof FormData < "u" ? FormData : null, RE = typeof Blob < "u" ? Blob : null, DE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: TE,
    FormData: OE,
    Blob: RE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, by = typeof window < "u" && typeof document < "u", Sh = typeof navigator == "object" && navigator || void 0, PE = by && (!Sh || ["ReactNative", "NativeScript", "NS"].indexOf(Sh.product) < 0), AE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", LE = by && window.location.href || "http://localhost", VE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: by,
  hasStandardBrowserEnv: PE,
  hasStandardBrowserWebWorkerEnv: AE,
  navigator: Sh,
  origin: LE
}, Symbol.toStringTag, { value: "Module" })), Pt = {
  ...VE,
  ...DE
};
function zE(e, n) {
  return Cl(e, new Pt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Pt.isNode && he.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const tv = ww;
function Ew(e) {
  if (e > tv)
    throw new on(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + tv,
      on.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function UE(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    Ew(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function ME(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function $w(e) {
  function n(r, i, a, o) {
    Ew(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && he.isArray(a) ? a.length : s, d ? (he.hasOwnProp(a, s) ? a[s] = he.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!he.hasOwnProp(a, s) || !he.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && he.isArray(a[s]) && (a[s] = ME(a[s])), !l);
  }
  if (he.isFormData(e) && he.isFunction(e.entries)) {
    const r = {};
    return he.forEachEntry(e, (i, a) => {
      n(UE(i), a, r, 0);
    }), r;
  }
  return null;
}
const Gi = (e, n) => e != null && he.hasOwnProp(e, n) ? e[n] : void 0;
function BE(e, n, r) {
  if (he.isString(e))
    try {
      return (n || JSON.parse)(e), he.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Ao = {
  transitional: ky,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = he.isObject(n);
      if (o && he.isHTMLForm(n) && (n = new FormData(n)), he.isFormData(n))
        return a ? JSON.stringify($w(n)) : n;
      if (he.isArrayBuffer(n) || he.isBuffer(n) || he.isStream(n) || he.isFile(n) || he.isBlob(n) || he.isReadableStream(n))
        return n;
      if (he.isArrayBufferView(n))
        return n.buffer;
      if (he.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Gi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return zE(n, d).toString();
        if ((l = he.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const p = Gi(this, "env"), u = p && p.FormData;
          return Cl(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), BE(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Gi(this, "transitional") || Ao.transitional, i = r && r.forcedJSONParsing, a = Gi(this, "responseType"), o = a === "json";
      if (he.isResponse(n) || he.isReadableStream(n))
        return n;
      if (n && he.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Gi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? on.from(d, on.ERR_BAD_RESPONSE, this, null, Gi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Pt.classes.FormData,
    Blob: Pt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
he.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Ao.headers[e] = {};
});
function ec(e, n) {
  const r = this || Ao, i = n || r, a = Ut.from(i.headers);
  let o = i.data;
  return he.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Tw(e) {
  return !!(e && e.__CANCEL__);
}
let Lo = class extends on {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", on.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Ow(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new on(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? on.ERR_BAD_REQUEST : on.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function qE(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function HE(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const p = Date.now(), u = i[o];
    s || (s = p), r[a] = d, i[a] = p;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), p - s < n)
      return;
    const k = u && p - u;
    return k ? Math.round(h * 1e3 / k) : void 0;
  };
}
function WE(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (p, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...p);
  };
  return [(...p) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(p, u) : (a = p, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Js = (e, n, r = 3) => {
  let i = 0;
  const a = HE(50, 250);
  return WE((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, p = Math.max(0, d - i), u = a(p);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: p,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, rv = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, iv = (e) => (...n) => he.asap(() => e(...n)), KE = Pt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Pt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Pt.origin),
  Pt.navigator && /(msie|trident)/i.test(Pt.navigator.userAgent)
) : () => !0, GE = Pt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      he.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), he.isString(i) && l.push(`path=${i}`), he.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), he.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function YE(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function JE(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const QE = /^https?:(?!\/\/)/i, XE = /[\t\n\r]/g;
function ZE(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function e$(e) {
  return ZE(e).replace(XE, "");
}
function av(e, n) {
  if (typeof e == "string" && QE.test(e$(e)))
    throw new on(
      'Invalid URL: missing "//" after protocol',
      on.ERR_INVALID_URL,
      n
    );
}
function Rw(e, n, r, i) {
  av(n, i);
  let a = !YE(n);
  return e && (a || r === !1) ? (av(e, i), JE(e, n)) : n;
}
const ov = (e) => e instanceof Ut ? { ...e } : e;
function zi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(u, f, h, k) {
    return he.isPlainObject(u) && he.isPlainObject(f) ? he.merge.call({ caseless: k }, u, f) : he.isPlainObject(f) ? he.merge({}, f) : he.isArray(f) ? f.slice() : f;
  }
  function a(u, f, h, k) {
    if (he.isUndefined(f)) {
      if (!he.isUndefined(u))
        return i(void 0, u, h, k);
    } else return i(u, f, h, k);
  }
  function o(u, f) {
    if (!he.isUndefined(f))
      return i(void 0, f);
  }
  function s(u, f) {
    if (he.isUndefined(f)) {
      if (!he.isUndefined(u))
        return i(void 0, u);
    } else return i(void 0, f);
  }
  function l(u) {
    const f = he.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!he.isUndefined(f))
      if (he.isPlainObject(f)) {
        if (he.hasOwnProp(f, u))
          return f[u];
      } else
        return;
    const h = he.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (he.isPlainObject(h) && he.hasOwnProp(h, u))
      return h[u];
  }
  function d(u, f, h) {
    if (he.hasOwnProp(n, h))
      return i(u, f);
    if (he.hasOwnProp(e, h))
      return i(void 0, u);
  }
  const p = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: d,
    headers: (u, f, h) => a(ov(u), ov(f), h, !0)
  };
  return he.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = he.hasOwnProp(p, f) ? p[f] : a, k = he.hasOwnProp(e, f) ? e[f] : void 0, C = he.hasOwnProp(n, f) ? n[f] : void 0, N = h(k, C, f);
    he.isUndefined(N) && h !== d || (r[f] = N);
  }), he.hasOwnProp(n, "validateStatus") && he.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (he.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const n$ = ["content-type", "content-length"];
function t$(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    n$.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const r$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function Dw(e) {
  const n = zi({}, e), r = (h) => he.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), p = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Ut.from(l), n.url = Iw(
    Rw(p, f, u, n),
    r("params"),
    r("paramsSerializer")
  ), d) {
    const h = he.getSafeProp(d, "username") || "", k = he.getSafeProp(d, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (k ? r$(k) : ""))
    );
  }
  if (he.isFormData(i) && (Pt.hasStandardBrowserEnv || Pt.hasStandardBrowserWebWorkerEnv || he.isReactNative(i) ? l.setContentType(void 0) : he.isFunction(i.getHeaders) && t$(l, i.getHeaders(), r("formDataHeaderPolicy"))), Pt.hasStandardBrowserEnv && (he.isFunction(a) && (a = a(n)), a === !0 || a == null && KE(n.url))) {
    const k = o && s && GE.read(s);
    k && l.set(o, k);
  }
  return n;
}
const i$ = typeof XMLHttpRequest < "u", a$ = i$ && function(e) {
  return new Promise(function(r, i) {
    const a = Dw(e);
    let o = a.data;
    const s = Ut.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: p } = a, u, f, h, k, C;
    function N() {
      k && k(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function _() {
      if (!j)
        return;
      const D = Ut.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: D,
        config: e,
        request: j
      };
      Ow(
        function(L) {
          r(L), N();
        },
        function(L) {
          i(L), N();
        },
        I
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = _ : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.startsWith("file:")) || setTimeout(_);
    }, j.onabort = function() {
      j && (i(new on("Request aborted", on.ECONNABORTED, e, j)), N(), j = null);
    }, j.onerror = function(O) {
      const I = O && O.message ? O.message : "Network Error", F = new on(I, on.ERR_NETWORK, e, j);
      F.event = O || null, i(F), N(), j = null;
    }, j.ontimeout = function() {
      let O = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || ky;
      a.timeoutErrorMessage && (O = a.timeoutErrorMessage), i(
        new on(
          O,
          I.clarifyTimeoutError ? on.ETIMEDOUT : on.ECONNABORTED,
          e,
          j
        )
      ), N(), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && he.forEach(Nw(s), function(O, I) {
      j.setRequestHeader(I, O);
    }), he.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), p && ([h, C] = Js(p, !0), j.addEventListener("progress", h)), d && j.upload && ([f, k] = Js(d), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", k)), (a.cancelToken || a.signal) && (u = (D) => {
      j && (i(!D || D.type ? new Lo(null, e, j) : D), j.abort(), N(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = qE(a.url);
    if (g && !Pt.protocols.includes(g)) {
      i(
        new on(
          "Unsupported protocol " + g + ":",
          on.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, o$ = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(d) {
    if (!i) {
      i = !0, s();
      const p = d instanceof Error ? d : this.reason;
      r.abort(
        p instanceof on ? p : new Lo(p instanceof Error ? p.message : p)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new on(`timeout of ${n}ms exceeded`, on.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((d) => {
      d.unsubscribe ? d.unsubscribe(a) : d.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((d) => d.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => he.asap(s), l;
}, s$ = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, l$ = async function* (e, n) {
  for await (const r of c$(e))
    yield* s$(r, n);
}, c$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, sv = (e, n, r, i) => {
  const a = l$(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: p, value: u } = await a.next();
          if (p) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (p) {
          throw l(p), p;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Qs = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, d$ = (e, n, r) => n + 2 < r && Qs(e.charCodeAt(n + 1)) && Qs(e.charCodeAt(n + 2));
function u$(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let k = 0; k < l; k++)
      if (i.charCodeAt(k) === 37 && k + 2 < l) {
        const C = i.charCodeAt(k + 1), N = i.charCodeAt(k + 2);
        Qs(C) && Qs(N) && (s -= 2, k += 2);
      }
    let d = 0, p = l - 1;
    const u = (k) => k >= 2 && i.charCodeAt(k - 2) === 37 && // '%'
    i.charCodeAt(k - 1) === 51 && // '3'
    (i.charCodeAt(k) === 68 || i.charCodeAt(k) === 100);
    p >= 0 && (i.charCodeAt(p) === 61 ? (d++, p--) : u(p) && (d++, p -= 3)), d === 1 && p >= 0 && (i.charCodeAt(p) === 61 || u(p)) && d++;
    const h = Math.floor(s / 4) * 3 - (d || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const d = i.charCodeAt(s);
    if (d === 37 && d$(i, s, l))
      o += 1, s += 2;
    else if (d < 128)
      o += 1;
    else if (d < 2048)
      o += 2;
    else if (d >= 55296 && d <= 56319 && s + 1 < l) {
      const p = i.charCodeAt(s + 1);
      p >= 56320 && p <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const _y = "1.18.0", lv = 64 * 1024, { isFunction: Xo } = he, m$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), cv = (e) => {
  if (!he.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, dv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, p$ = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, f$ = (e) => {
  const n = he.global !== void 0 && he.global !== null ? he.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = he.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? Xo(a) : typeof fetch == "function", d = Xo(o), p = Xo(s);
  if (!l)
    return !1;
  const u = l && Xo(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((_) => (g) => _.encode(g))(new i()) : async (_) => new Uint8Array(await new o(_).arrayBuffer())), h = d && u && dv(() => {
    let _ = !1;
    const g = new o(Pt.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return _ = !0, "half";
      }
    }), D = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), _ && !D;
  }), k = p && u && dv(() => he.isReadableStream(new s("").body)), C = {
    stream: k && ((_) => _.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((_) => {
    !C[_] && (C[_] = (g, D) => {
      let O = g && g[_];
      if (O)
        return O.call(g);
      throw new on(
        `Response type '${_}' is not supported`,
        on.ERR_NOT_SUPPORT,
        D
      );
    });
  });
  const N = async (_) => {
    if (_ == null)
      return 0;
    if (he.isBlob(_))
      return _.size;
    if (he.isSpecCompliantForm(_))
      return (await new o(Pt.origin, {
        method: "POST",
        body: _
      }).arrayBuffer()).byteLength;
    if (he.isArrayBufferView(_) || he.isArrayBuffer(_))
      return _.byteLength;
    if (he.isURLSearchParams(_) && (_ = _ + ""), he.isString(_))
      return (await f(_)).byteLength;
  }, j = async (_, g) => {
    const D = he.toFiniteNumber(_.getContentLength());
    return D ?? N(g);
  };
  return async (_) => {
    let {
      url: g,
      method: D,
      data: O,
      signal: I,
      cancelToken: F,
      timeout: L,
      onDownloadProgress: K,
      onUploadProgress: J,
      responseType: re,
      headers: W,
      withCredentials: Y = "same-origin",
      fetchOptions: P,
      maxContentLength: B,
      maxBodyLength: ee
    } = Dw(_);
    const Ne = he.isNumber(B) && B > -1, ue = he.isNumber(ee) && ee > -1, oe = (Ie) => he.hasOwnProp(_, Ie) ? _[Ie] : void 0;
    let fe = a || fetch;
    re = re ? (re + "").toLowerCase() : "text";
    let V = o$(
      [I, F && F.toAbortSignal()],
      L
    ), ke = null;
    const Oe = V && V.unsubscribe && (() => {
      V.unsubscribe();
    });
    let q, Ge = null;
    const sn = () => new on(
      "Request body larger than maxBodyLength limit",
      on.ERR_BAD_REQUEST,
      _,
      ke
    );
    try {
      let Ie;
      const Ue = oe("auth");
      if (Ue) {
        const le = he.getSafeProp(Ue, "username") || "", xe = he.getSafeProp(Ue, "password") || "";
        Ie = {
          username: le,
          password: xe
        };
      }
      if (p$(g)) {
        const le = new URL(g, Pt.origin);
        if (!Ie && (le.username || le.password)) {
          const xe = cv(le.username), Ve = cv(le.password);
          Ie = {
            username: xe,
            password: Ve
          };
        }
        (le.username || le.password) && (le.username = "", le.password = "", g = le.href);
      }
      if (Ie && (W.delete("authorization"), W.set(
        "Authorization",
        "Basic " + btoa(m$((Ie.username || "") + ":" + (Ie.password || "")))
      )), Ne && typeof g == "string" && g.startsWith("data:") && u$(g) > B)
        throw new on(
          "maxContentLength size of " + B + " exceeded",
          on.ERR_BAD_RESPONSE,
          _,
          ke
        );
      if (ue && D !== "get" && D !== "head") {
        const le = await N(O);
        if (typeof le == "number" && isFinite(le) && (q = le, le > ee))
          throw sn();
      }
      const De = ue && (he.isReadableStream(O) || he.isStream(O)), Be = (le, xe, Ve) => sv(
        le,
        lv,
        (Pe) => {
          if (ue && Pe > ee)
            throw Ge = sn();
          xe && xe(Pe);
        },
        Ve
      );
      if (h && D !== "get" && D !== "head" && (J || De)) {
        if (q = q ?? await j(W, O), q !== 0 || De) {
          let le = new o(g, {
            method: "POST",
            body: O,
            duplex: "half"
          }), xe;
          if (he.isFormData(O) && (xe = le.headers.get("content-type")) && W.setContentType(xe), le.body) {
            const [Ve, Pe] = J && rv(
              q,
              Js(iv(J))
            ) || [];
            O = Be(le.body, Ve, Pe);
          }
        }
      } else if (De && !d && u && D !== "get" && D !== "head")
        O = Be(O);
      else if (De && d && !h && D !== "get" && D !== "head")
        throw new on(
          "Stream request bodies are not supported by the current fetch implementation",
          on.ERR_NOT_SUPPORT,
          _,
          ke
        );
      he.isString(Y) || (Y = Y ? "include" : "omit");
      const Ae = d && "credentials" in o.prototype;
      if (he.isFormData(O)) {
        const le = W.getContentType();
        le && /^multipart\/form-data/i.test(le) && !/boundary=/i.test(le) && W.delete("content-type");
      }
      W.set("User-Agent", "axios/" + _y, !1);
      const Je = {
        ...P,
        signal: V,
        method: D.toUpperCase(),
        headers: Nw(W.normalize()),
        body: O,
        duplex: "half",
        credentials: Ae ? Y : void 0
      };
      ke = d && new o(g, Je);
      let $e = await (d ? fe(ke, P) : fe(g, Je));
      const Me = Ut.from($e.headers);
      if (Ne) {
        const le = he.toFiniteNumber(Me.getContentLength());
        if (le != null && le > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            ke
          );
      }
      const en = k && (re === "stream" || re === "response");
      if (k && $e.body && (K || Ne || en && Oe)) {
        const le = {};
        ["status", "statusText", "headers"].forEach((E) => {
          le[E] = $e[E];
        });
        const xe = he.toFiniteNumber(Me.getContentLength()), [Ve, Pe] = K && rv(
          xe,
          Js(iv(K), !0)
        ) || [];
        let vn = 0;
        const Q = (E) => {
          if (Ne && (vn = E, vn > B))
            throw new on(
              "maxContentLength size of " + B + " exceeded",
              on.ERR_BAD_RESPONSE,
              _,
              ke
            );
          Ve && Ve(E);
        };
        $e = new s(
          sv($e.body, lv, Q, () => {
            Pe && Pe(), Oe && Oe();
          }),
          le
        );
      }
      re = re || "text";
      let se = await C[he.findKey(C, re) || "text"](
        $e,
        _
      );
      if (Ne && !k && !en) {
        let le;
        if (se != null && (typeof se.byteLength == "number" ? le = se.byteLength : typeof se.size == "number" ? le = se.size : typeof se == "string" && (le = typeof i == "function" ? new i().encode(se).byteLength : se.length)), typeof le == "number" && le > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            ke
          );
      }
      return !en && Oe && Oe(), await new Promise((le, xe) => {
        Ow(le, xe, {
          data: se,
          headers: Ut.from($e.headers),
          status: $e.status,
          statusText: $e.statusText,
          config: _,
          request: ke
        });
      });
    } catch (Ie) {
      if (Oe && Oe(), V && V.aborted && V.reason instanceof on) {
        const Ue = V.reason;
        throw Ue.config = _, ke && (Ue.request = ke), Ie !== Ue && (Ue.cause = Ie), Ue;
      }
      throw Ge ? (ke && !Ge.request && (Ge.request = ke), Ge) : Ie instanceof on ? (ke && !Ie.request && (Ie.request = ke), Ie) : Ie && Ie.name === "TypeError" && /Load failed|fetch/i.test(Ie.message) ? Object.assign(
        new on(
          "Network Error",
          on.ERR_NETWORK,
          _,
          ke,
          Ie && Ie.response
        ),
        {
          cause: Ie.cause || Ie
        }
      ) : on.from(Ie, Ie && Ie.code, _, ke, Ie && Ie.response);
    }
  };
}, h$ = /* @__PURE__ */ new Map(), Pw = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, p, u = h$;
  for (; l--; )
    d = o[l], p = u.get(d), p === void 0 && u.set(d, p = l ? /* @__PURE__ */ new Map() : f$(n)), u = p;
  return p;
};
Pw();
const xy = {
  http: FE,
  xhr: a$,
  fetch: {
    get: Pw
  }
};
he.forEach(xy, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const uv = (e) => `- ${e}`, y$ = (e) => he.isFunction(e) || e === null || e === !1;
function g$(e, n) {
  e = he.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !y$(i) && (a = xy[(l = String(i)).toLowerCase()], a === void 0))
      throw new on(`Unknown adapter '${l}'`);
    if (a && (he.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, p]) => `adapter ${d} ` + (p === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(uv).join(`
`) : " " + uv(s[0]) : "as no adapter specified";
    throw new on(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Aw = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: g$,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: xy
};
function nc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Lo(null, e);
}
function mv(e) {
  return nc(e), e.headers = Ut.from(e.headers), e.data = ec.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Aw.getAdapter(e.adapter || Ao.adapter, e)(e).then(
    function(i) {
      nc(e), e.response = i;
      try {
        i.data = ec.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Ut.from(i.headers), i;
    },
    function(i) {
      if (!Tw(i) && (nc(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = ec.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Ut.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const Fl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Fl[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const pv = {};
Fl.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + _y + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new on(
        a(s, " has been removed" + (r ? " in " + r : "")),
        on.ERR_DEPRECATED
      );
    return r && !pv[s] && (pv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Fl.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function v$(e, n, r) {
  if (typeof e != "object")
    throw new on("options must be an object", on.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new on(
          "option " + o + " must be " + d,
          on.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new on("Unknown option " + o, on.ERR_BAD_OPTION);
  }
}
const Ds = {
  assertOptions: v$,
  validators: Fl
}, zt = Ds.validators;
let Oi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new nv(),
      response: new nv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = zi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Ds.assertOptions(
      i,
      {
        silentJSONParsing: zt.transitional(zt.boolean),
        forcedJSONParsing: zt.transitional(zt.boolean),
        clarifyTimeoutError: zt.transitional(zt.boolean),
        legacyInterceptorReqResOrdering: zt.transitional(zt.boolean),
        advertiseZstdAcceptEncoding: zt.transitional(zt.boolean),
        validateStatusUndefinedResolves: zt.transitional(zt.boolean)
      },
      !1
    ), a != null && (he.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Ds.assertOptions(
      a,
      {
        encode: zt.function,
        serialize: zt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ds.assertOptions(
      r,
      {
        baseUrl: zt.spelling("baseURL"),
        withXsrfToken: zt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && he.merge(o.common, o[r.method]);
    o && he.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (C) => {
      delete o[C];
    }), r.headers = Ut.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(N) {
      if (typeof N.runWhen == "function" && N.runWhen(r) === !1)
        return;
      d = d && N.synchronous;
      const j = r.transitional || ky;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(N.fulfilled, N.rejected) : l.push(N.fulfilled, N.rejected);
    });
    const p = [];
    this.interceptors.response.forEach(function(N) {
      p.push(N.fulfilled, N.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [mv.bind(this), void 0];
      for (C.unshift(...l), C.push(...p), h = C.length, u = Promise.resolve(r); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let k = r;
    for (; f < h; ) {
      const C = l[f++], N = l[f++];
      try {
        k = C(k);
      } catch (j) {
        N.call(this, j);
        break;
      }
    }
    try {
      u = mv.call(this, k);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = p.length; f < h; )
      u = u.then(p[f++], p[f++]);
    return u;
  }
  getUri(n) {
    n = zi(this.defaults, n);
    const r = Rw(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return Iw(r, n.params, n.paramsSerializer);
  }
};
he.forEach(["delete", "get", "head", "options"], function(n) {
  Oi.prototype[n] = function(r, i) {
    return this.request(
      zi(i || {}, {
        method: n,
        url: r,
        data: i && he.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
he.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        zi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  Oi.prototype[n] = r(), n !== "query" && (Oi.prototype[n + "Form"] = r(!0));
});
let k$ = class Lw {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Lo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Lw(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function b$(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function _$(e) {
  return he.isObject(e) && e.isAxiosError === !0;
}
const Nh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Nh).forEach(([e, n]) => {
  Nh[n] = e;
});
function Vw(e) {
  const n = new Oi(e), r = hw(Oi.prototype.request, n);
  return he.extend(r, Oi.prototype, n, { allOwnKeys: !0 }), he.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Vw(zi(e, a));
  }, r;
}
const vt = Vw(Ao);
vt.Axios = Oi;
vt.CanceledError = Lo;
vt.CancelToken = k$;
vt.isCancel = Tw;
vt.VERSION = _y;
vt.toFormData = Cl;
vt.AxiosError = on;
vt.Cancel = vt.CanceledError;
vt.all = function(n) {
  return Promise.all(n);
};
vt.spread = b$;
vt.isAxiosError = _$;
vt.mergeConfig = zi;
vt.AxiosHeaders = Ut;
vt.formToJSON = (e) => $w(he.isHTMLForm(e) ? new FormData(e) : e);
vt.getAdapter = Aw.getAdapter;
vt.HttpStatusCode = Nh;
vt.default = vt;
const {
  Axios: i8,
  AxiosError: a8,
  CanceledError: o8,
  isCancel: s8,
  CancelToken: l8,
  VERSION: c8,
  all: d8,
  Cancel: u8,
  isAxiosError: x$,
  spread: m8,
  toFormData: p8,
  AxiosHeaders: f8,
  HttpStatusCode: h8,
  formToJSON: y8,
  getAdapter: g8,
  mergeConfig: v8,
  create: k8
} = vt;
class S$ {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const fv = new S$();
function N$(e, n) {
  return hv(e), hv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function hv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const j$ = Object.prototype.toString;
function w$(e, n) {
  return j$.call(e) === `[object ${n}]`;
}
function C$(e) {
  return w$(e, "Object");
}
function F$(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const ko = "8.36.0", ti = globalThis;
function Sy(e, n, r) {
  const i = r || ti, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[ko] = a[ko] || {};
  return o[e] || (o[e] = n());
}
const zw = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, I$ = "Sentry Logger ", yv = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], gv = {};
function Uw(e) {
  if (!("console" in ti))
    return e();
  const n = ti.console, r = {}, i = Object.keys(gv);
  i.forEach((a) => {
    const o = gv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function E$() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return zw ? yv.forEach((r) => {
    n[r] = (...i) => {
      e && Uw(() => {
        ti.console[r](`${I$}[${r}]:`, ...i);
      });
    };
  }) : yv.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Ps = Sy("logger", E$);
function $$(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    zw && Ps.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Mw = 1e3;
function Ny() {
  return Date.now() / Mw;
}
function T$() {
  const { performance: e } = ti;
  if (!e || !e.now)
    return Ny;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Mw;
}
const O$ = T$();
(() => {
  const { performance: e } = ti;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, p = d < n;
  return o || p ? a <= d ? e.timeOrigin : s : i;
})();
function la() {
  const e = ti, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function vv() {
  return {
    traceId: la(),
    spanId: la().substring(16)
  };
}
function jy() {
  return wy(ti), ti;
}
function wy(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || ko, n[ko] = n[ko] || {};
}
function R$(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || O$(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : la()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const jh = "_sentrySpan";
function kv(e, n) {
  n ? $$(e, jh, n) : delete e[jh];
}
function bv(e) {
  return e[jh];
}
const D$ = 100;
class Cy {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = vv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Cy();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, kv(n, bv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && R$(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof ya ? [r.getScopeData(), r.getRequestSession()] : C$(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: p, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), p && (this._level = p), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, kv(this, void 0), this._attachments = [], this._propagationContext = vv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : D$;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Ny(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: bv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : la();
    if (!this._client)
      return Ps.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : la();
    if (!this._client)
      return Ps.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : la();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Ps.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const ya = Cy;
function P$() {
  return Sy("defaultCurrentScope", () => new ya());
}
function A$() {
  return Sy("defaultIsolationScope", () => new ya());
}
class L$ {
  constructor(n, r) {
    let i;
    n ? i = n : i = new ya();
    let a;
    r ? a = r : a = new ya(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return F$(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ga() {
  const e = jy(), n = wy(e);
  return n.stack = n.stack || new L$(P$(), A$());
}
function V$(e) {
  return ga().withScope(e);
}
function z$(e, n) {
  const r = ga();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function _v(e) {
  return ga().withScope(() => e(ga().getIsolationScope()));
}
function U$() {
  return {
    withIsolationScope: _v,
    withScope: V$,
    withSetScope: z$,
    withSetIsolationScope: (e, n) => _v(n),
    getCurrentScope: () => ga().getScope(),
    getIsolationScope: () => ga().getIsolationScope()
  };
}
function Bw(e) {
  const n = wy(e);
  return n.acs ? n.acs : U$();
}
function Fy() {
  const e = jy();
  return Bw(e).getCurrentScope();
}
function qw() {
  const e = jy();
  return Bw(e).getIsolationScope();
}
function M$() {
  return Fy().getClient();
}
function B$(e) {
  if (e)
    return q$(e) ? { captureContext: e } : W$(e) ? {
      captureContext: e
    } : e;
}
function q$(e) {
  return e instanceof ya || typeof e == "function";
}
const H$ = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function W$(e) {
  return Object.keys(e).some((n) => H$.includes(n));
}
function xv(e, n) {
  return Fy().captureException(e, B$(n));
}
function K$(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Fy().captureMessage(e, r, i);
}
function G$(e, n) {
  qw().setContext(e, n);
}
const Y$ = 100;
function Ci(e, n) {
  const r = M$(), i = qw();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = Y$ } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Ny(), ...e }, d = a ? Uw(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var To;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(To || (To = {}));
function ca(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const J$ = Eo.backendDomain ? {
  "backend-domain": Eo.backendDomain
} : void 0;
function As() {
  const e = new URLSearchParams({
    noToken: "true",
    ...J$
  }).toString();
  document.location.href = `${Eo.url.logIn}?${e}`;
}
const tc = "authData", rc = 30, Q$ = 600, ic = 5;
class X$ {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= ic || this.clientServerTimeDiff <= -ic ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + Q$, a = ca(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > ic) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(tc, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(tc), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(tc);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - rc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = ca(n), i = r.exp - rc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - rc - this.estimatedServerTime()) * 1e3;
  }
}
const $t = new X$();
async function Z$(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? ca(o).exp : "None", l = await Il.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), p = l?.access_token, u = l?.refresh_token, f = p ? ca(p).exp : "None", h = u ? ca(u).exp : "None", k = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", N = typeof h == "number" ? d - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      G$("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: k,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: N,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    K$("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: To.Platform,
        domain: n
      }
    });
  }
}
const ac = /* @__PURE__ */ new Map(), eT = 3;
function nT(e) {
  e.interceptors.response.use((n) => (ac.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case wh.Unauthorized:
          if (!Il.isRefreshTokenExpired() && n.config) {
            Ci({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = ac.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= eT)
              return ac.set(n.config.url, i + 1), e(n.config);
          }
          Z$(n), console.error("401 unauthorized interceptor"), As();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Hw = vt.create();
nT(Hw);
const Jr = console.log;
async function Sv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class tT extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function rT(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const iT = 5;
class aT {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      $t.setAuthData(r);
    else {
      const i = $t.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new tT("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = $t.getAccessToken();
    if (!n)
      return {};
    const r = ca(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return $t.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = $t.getAuthData();
    return r ? $t.isAccessTokenExpired() ? (Ci({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && $t.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return $t.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return $t.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return $t.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = $t.getAuthData();
    return n ? $t.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!fv.isElectron())
      return !0;
    const n = await fv.getVersion();
    return N$(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = iT) {
    try {
      return await Hw.post(`${Eo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Jr("AUTH", "Network connection offline - waiting..."), Ci({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Sv(5);
    n && (Jr("AUTH", "Network connection restored"), Ci({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = rT(this.retryCount);
    return Jr("AUTH", `Retrying in ${i} seconds`), await Sv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if ($t.isRefreshTokenExpired(r))
      return Jr("AUTH", "Refresh token expired"), Ci({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), $t.removeAuthData(), As(), null;
    if (x$(n)) {
      if (n.message === "timeout exceeded")
        return Jr("AUTH", "Timeout exceeded"), Ci({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Jr("AUTH", "Network error"), Ci({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Jr("AUTH", "Refresh token invalid (401)"), $t.removeAuthData(), As(), null;
      xv(n, {
        level: "error",
        tags: {
          team: To.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Jr("AUTH", "Retries exhausted, logging out"), xv(n, {
      level: "error",
      tags: {
        team: To.Platform,
        errorSource: "authManager.refresh"
      }
    }), $t.removeAuthData(), As(), null) : (Jr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return $t.accessTokenExpiresInMs();
  }
}
const Il = new aT();
var wh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(wh || (wh = {}));
const oT = new fy((e, n) => new mw((r) => {
  Il.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), sT = new fy(
  (e, n) => new mw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Il.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...MF(Eo.url.partnerIntegrations) && d?.access_token && BF(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), lT = new AbortController(), Ww = (e) => new pI({
  queryDeduplication: !1,
  cache: new fI(),
  link: fy.from([
    oT,
    sT,
    hI({
      uri: `${e}/graphql`,
      fetch: kI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: lT.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), cT = ({
  configuration: e,
  children: n
}) => {
  const r = Qn(
    () => Ww(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Zn.jsx(yI, { client: r, children: n });
};
function dT() {
  try {
    return gI(), !0;
  } catch {
    return !1;
  }
}
const uT = ({
  configuration: e,
  children: n
}) => dT() ? n : /* @__PURE__ */ Zn.jsx(cT, { configuration: e, children: n }), mT = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Zn.jsx(vI, { children: (o) => /* @__PURE__ */ Zn.jsx(
  qF,
  {
    value: {
      useMutation: GF(e, n),
      useQuery: KF(e, n),
      useLazyQuery: WF(e, n),
      executeQuery: HF(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Kw = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Zn.jsx(uT, { configuration: r, children: s ? /* @__PURE__ */ Zn.jsx(
    mT,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, pT = "_unmatchedHeader_qcj19_1", fT = {
  unmatchedHeader: pT
};
var Vo = (e) => e.type === "checkbox", $i = (e) => e instanceof Date, Gt = (e) => e == null;
const Gw = (e) => typeof e == "object";
var yt = (e) => !Gt(e) && !Array.isArray(e) && Gw(e) && !$i(e), Yw = (e) => yt(e) && e.target ? Vo(e.target) ? e.target.checked : e.target.value : e, hT = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Jw = (e, n) => e.has(hT(n)), yT = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return yt(n) && n.hasOwnProperty("isPrototypeOf");
}, Iy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Rt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Iy && (e instanceof Blob || i)) && (r || yt(e)))
    if (n = r ? [] : {}, !r && !yT(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Rt(e[a]));
  else
    return e;
  return n;
}
var El = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ft = (e) => e === void 0, nn = (e, n, r) => {
  if (!n || !yt(e))
    return r;
  const i = El(n.split(/[,[\].]+?/)).reduce((a, o) => Gt(a) ? a : a[o], e);
  return ft(i) || i === e ? ft(e[n]) ? r : e[n] : i;
}, or = (e) => typeof e == "boolean", Ey = (e) => /^\w*$/.test(e), Qw = (e) => El(e.replace(/["|']|\]/g, "").split(/\.|\[/)), rt = (e, n, r) => {
  let i = -1;
  const a = Ey(n) ? [n] : Qw(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const p = e[l];
      d = yt(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Xs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Nr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Xw = qe.createContext(null), Or = () => qe.useContext(Xw), $y = (e) => {
  const { children: n, ...r } = e;
  return qe.createElement(Xw.Provider, { value: r }, n);
};
var Zw = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Nr.all && (n._proxyFormState[s] = !i || Nr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function gT(e) {
  const n = Or(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = qe.useRef(a);
  return p.current = a, qe.useEffect(() => r._subscribe({
    name: p.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => Zw(s, r, d.current, !1), [s, r]);
}
var Ur = (e) => typeof e == "string", eC = (e, n, r, i, a) => Ur(e) ? (i && n.watch.add(e), nn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), nn(r, o))) : (i && (n.watchAll = !0), r);
function pi(e) {
  const n = Or(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(eC(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [p, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), p;
}
function Ty(e) {
  const n = Or(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Jw(a._names.array, r), l = pi({
    control: a,
    name: r,
    defaultValue: nn(a._formValues, r, nn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = gT({
    control: a,
    name: r,
    exact: !0
  }), p = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...or(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!nn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!nn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!nn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!nn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => nn(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((j) => u.current.onChange({
    target: {
      value: Yw(j),
      name: r
    },
    type: Xs.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: nn(a._formValues, r),
      name: r
    },
    type: Xs.BLUR
  }), [r, a._formValues]), C = qe.useCallback((j) => {
    const _ = nn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = qe.useMemo(() => ({
    name: r,
    value: l,
    ...or(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: C
  }), [r, i, d.disabled, h, k, C, l]);
  return qe.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...or(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const _ = (g, D) => {
      const O = nn(a._fields, g);
      O && O._f && (O._f.mount = D);
    };
    if (_(r, !0), j) {
      const g = Rt(nn(a._options.defaultValues, r));
      rt(a._defaultValues, r, g), ft(nn(a._formValues, r)) && rt(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const bt = (e) => e.render(Ty(e));
var vT = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, bo = (e) => Array.isArray(e) ? e : [e], Nv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Ch = (e) => Gt(e) || !Gw(e);
function di(e, n) {
  if (Ch(e) || Ch(n))
    return e === n;
  if ($i(e) && $i(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if ($i(o) && $i(s) || yt(o) && yt(s) || Array.isArray(o) && Array.isArray(s) ? !di(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Wt = (e) => yt(e) && !Object.keys(e).length, Oy = (e) => e.type === "file", jr = (e) => typeof e == "function", Zs = (e) => {
  if (!Iy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, nC = (e) => e.type === "select-multiple", Ry = (e) => e.type === "radio", kT = (e) => Ry(e) || Vo(e), oc = (e) => Zs(e) && e.isConnected;
function bT(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ft(e) ? i++ : e[n[i++]];
  return e;
}
function _T(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ft(e[n]))
      return !1;
  return !0;
}
function St(e, n) {
  const r = Array.isArray(n) ? n : Ey(n) ? [n] : Qw(n), i = r.length === 1 ? e : bT(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (yt(i) && Wt(i) || Array.isArray(i) && _T(i)) && St(e, r.slice(0, -1)), e;
}
var tC = (e) => {
  for (const n in e)
    if (jr(e[n]))
      return !0;
  return !1;
};
function el(e, n = {}) {
  const r = Array.isArray(e);
  if (yt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || yt(e[i]) && !tC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, el(e[i], n[i])) : Gt(e[i]) || (n[i] = !0);
  return n;
}
function rC(e, n, r) {
  const i = Array.isArray(e);
  if (yt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || yt(e[a]) && !tC(e[a]) ? ft(n) || Ch(r[a]) ? r[a] = Array.isArray(e[a]) ? el(e[a], []) : { ...el(e[a]) } : rC(e[a], Gt(n) ? {} : n[a], r[a]) : r[a] = !di(e[a], n[a]);
  return r;
}
var Aa = (e, n) => rC(e, n, el(n));
const jv = {
  value: !1,
  isValid: !1
}, wv = { value: !0, isValid: !0 };
var iC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ft(e[0].attributes.value) ? ft(e[0].value) || e[0].value === "" ? wv : { value: e[0].value, isValid: !0 } : wv
    ) : jv;
  }
  return jv;
}, aC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ft(e) ? e : n ? e === "" ? NaN : e && +e : r && Ur(e) ? new Date(e) : i ? i(e) : e;
const Cv = {
  isValid: !1,
  value: null
};
var oC = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Cv) : Cv;
function Fv(e) {
  const n = e.ref;
  return Oy(n) ? n.files : Ry(n) ? oC(e.refs).value : nC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Vo(n) ? iC(e.refs).value : aC(ft(n.value) ? e.ref.value : n.value, e);
}
var xT = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = nn(n, o);
    s && rt(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, nl = (e) => e instanceof RegExp, La = (e) => ft(e) ? e : nl(e) ? e.source : yt(e) ? nl(e.value) ? e.value.source : e.value : e, Iv = (e) => ({
  isOnSubmit: !e || e === Nr.onSubmit,
  isOnBlur: e === Nr.onBlur,
  isOnChange: e === Nr.onChange,
  isOnAll: e === Nr.all,
  isOnTouch: e === Nr.onTouched
});
const Ev = "AsyncFunction";
var ST = (e) => !!e && !!e.validate && !!(jr(e.validate) && e.validate.constructor.name === Ev || yt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Ev)), NT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), $v = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const _o = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = nn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (_o(l, n))
          break;
      } else if (yt(l) && _o(l, n))
        break;
    }
  }
};
function Tv(e, n, r) {
  const i = nn(e, r);
  if (i || Ey(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = nn(n, o), l = nn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var jT = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Wt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Nr.all));
}, wT = (e, n, r) => !e || !n || e === n || bo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), CT = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, FT = (e, n) => !El(nn(e, n)).length && St(e, n), IT = (e, n, r) => {
  const i = bo(nn(e, r));
  return rt(i, "root", n[r]), rt(e, r, i), e;
}, Ls = (e) => Ur(e);
function Ov(e, n, r = "validate") {
  if (Ls(e) || Array.isArray(e) && e.every(Ls) || or(e) && !e)
    return {
      type: r,
      message: Ls(e) ? e : "",
      ref: n
    };
}
var Yi = (e) => yt(e) && !nl(e) ? e : {
  value: e,
  message: ""
}, Rv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: p, minLength: u, min: f, max: h, pattern: k, validate: C, name: N, valueAsNumber: j, mount: _ } = e._f, g = nn(r, N);
  if (!_ || n.has(N))
    return {};
  const D = l ? l[0] : s, O = (Y) => {
    a && D.reportValidity && (D.setCustomValidity(or(Y) ? "" : Y || ""), D.reportValidity());
  }, I = {}, F = Ry(s), L = Vo(s), K = F || L, J = (j || Oy(s)) && ft(s.value) && ft(g) || Zs(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, re = vT.bind(null, N, i, I), W = (Y, P, B, ee = Qr.maxLength, Ne = Qr.minLength) => {
    const ue = Y ? P : B;
    I[N] = {
      type: Y ? ee : Ne,
      message: ue,
      ref: s,
      ...re(Y ? ee : Ne, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!K && (J || Gt(g)) || or(g) && !g || L && !iC(l).isValid || F && !oC(l).isValid)) {
    const { value: Y, message: P } = Ls(d) ? { value: !!d, message: d } : Yi(d);
    if (Y && (I[N] = {
      type: Qr.required,
      message: P,
      ref: D,
      ...re(Qr.required, P)
    }, !i))
      return O(P), I;
  }
  if (!J && (!Gt(f) || !Gt(h))) {
    let Y, P;
    const B = Yi(h), ee = Yi(f);
    if (!Gt(g) && !isNaN(g)) {
      const Ne = s.valueAsNumber || g && +g;
      Gt(B.value) || (Y = Ne > B.value), Gt(ee.value) || (P = Ne < ee.value);
    } else {
      const Ne = s.valueAsDate || new Date(g), ue = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), oe = s.type == "time", fe = s.type == "week";
      Ur(B.value) && g && (Y = oe ? ue(g) > ue(B.value) : fe ? g > B.value : Ne > new Date(B.value)), Ur(ee.value) && g && (P = oe ? ue(g) < ue(ee.value) : fe ? g < ee.value : Ne < new Date(ee.value));
    }
    if ((Y || P) && (W(!!Y, B.message, ee.message, Qr.max, Qr.min), !i))
      return O(I[N].message), I;
  }
  if ((p || u) && !J && (Ur(g) || o && Array.isArray(g))) {
    const Y = Yi(p), P = Yi(u), B = !Gt(Y.value) && g.length > +Y.value, ee = !Gt(P.value) && g.length < +P.value;
    if ((B || ee) && (W(B, Y.message, P.message), !i))
      return O(I[N].message), I;
  }
  if (k && !J && Ur(g)) {
    const { value: Y, message: P } = Yi(k);
    if (nl(Y) && !g.match(Y) && (I[N] = {
      type: Qr.pattern,
      message: P,
      ref: s,
      ...re(Qr.pattern, P)
    }, !i))
      return O(P), I;
  }
  if (C) {
    if (jr(C)) {
      const Y = await C(g, r), P = Ov(Y, D);
      if (P && (I[N] = {
        ...P,
        ...re(Qr.validate, P.message)
      }, !i))
        return O(P.message), I;
    } else if (yt(C)) {
      let Y = {};
      for (const P in C) {
        if (!Wt(Y) && !i)
          break;
        const B = Ov(await C[P](g, r), D, P);
        B && (Y = {
          ...B,
          ...re(P, B.message)
        }, O(B.message), i && (I[N] = Y));
      }
      if (!Wt(Y) && (I[N] = {
        ref: D,
        ...Y
      }, !i))
        return I;
    }
  }
  return O(!0), I;
};
const ET = {
  mode: Nr.onSubmit,
  reValidateMode: Nr.onChange,
  shouldFocusError: !0
};
function $T(e = {}) {
  let n = {
    ...ET,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: jr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = yt(n.defaultValues) || yt(n.values) ? Rt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Rt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, p = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Nv(),
    state: Nv()
  }, k = Iv(n.mode), C = Iv(n.reValidateMode), N = n.criteriaMode === Nr.all, j = (E) => (z) => {
    clearTimeout(p), p = setTimeout(E, z);
  }, _ = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const z = n.resolver ? Wt((await J()).errors) : await W(i, !0);
      z !== r.isValid && h.state.next({
        isValid: z
      });
    }
  }, g = (E, z) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((ie) => {
      ie && (z ? rt(r.validatingFields, ie, z) : St(r.validatingFields, ie));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Wt(r.validatingFields)
    }));
  }, D = (E, z = [], ie, ce, U = !0, G = !0) => {
    if (ce && ie && !n.disabled) {
      if (s.action = !0, G && Array.isArray(nn(i, E))) {
        const ye = ie(nn(i, E), ce.argA, ce.argB);
        U && rt(i, E, ye);
      }
      if (G && Array.isArray(nn(r.errors, E))) {
        const ye = ie(nn(r.errors, E), ce.argA, ce.argB);
        U && rt(r.errors, E, ye), FT(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && G && Array.isArray(nn(r.touchedFields, E))) {
        const ye = ie(nn(r.touchedFields, E), ce.argA, ce.argB);
        U && rt(r.touchedFields, E, ye);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Aa(a, o)), h.state.next({
        name: E,
        isDirty: P(E, z),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      rt(o, E, z);
  }, O = (E, z) => {
    rt(r.errors, E, z), h.state.next({
      errors: r.errors
    });
  }, I = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (E, z, ie, ce) => {
    const U = nn(i, E);
    if (U) {
      const G = nn(o, E, ft(ie) ? nn(a, E) : ie);
      ft(G) || ce && ce.defaultChecked || z ? rt(o, E, z ? G : Fv(U._f)) : Ne(E, G), s.mount && _();
    }
  }, L = (E, z, ie, ce, U) => {
    let G = !1, ye = !1;
    const je = {
      name: E
    };
    if (!n.disabled) {
      if (!ie || ce) {
        (u.isDirty || f.isDirty) && (ye = r.isDirty, r.isDirty = je.isDirty = P(), G = ye !== je.isDirty);
        const Re = di(nn(a, E), z);
        ye = !!nn(r.dirtyFields, E), Re ? St(r.dirtyFields, E) : rt(r.dirtyFields, E, !0), je.dirtyFields = r.dirtyFields, G = G || (u.dirtyFields || f.dirtyFields) && ye !== !Re;
      }
      if (ie) {
        const Re = nn(r.touchedFields, E);
        Re || (rt(r.touchedFields, E, ie), je.touchedFields = r.touchedFields, G = G || (u.touchedFields || f.touchedFields) && Re !== ie);
      }
      G && U && h.state.next(je);
    }
    return G ? je : {};
  }, K = (E, z, ie, ce) => {
    const U = nn(r.errors, E), G = (u.isValid || f.isValid) && or(z) && r.isValid !== z;
    if (n.delayError && ie ? (d = j(() => O(E, ie)), d(n.delayError)) : (clearTimeout(p), d = null, ie ? rt(r.errors, E, ie) : St(r.errors, E)), (ie ? !di(U, ie) : U) || !Wt(ce) || G) {
      const ye = {
        ...ce,
        ...G && or(z) ? { isValid: z } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...ye
      }, h.state.next(ye);
    }
  }, J = async (E) => {
    g(E, !0);
    const z = await n.resolver(o, n.context, xT(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(E), z;
  }, re = async (E) => {
    const { errors: z } = await J(E);
    if (E)
      for (const ie of E) {
        const ce = nn(z, ie);
        ce ? rt(r.errors, ie, ce) : St(r.errors, ie);
      }
    else
      r.errors = z;
    return z;
  }, W = async (E, z, ie = {
    valid: !0
  }) => {
    for (const ce in E) {
      const U = E[ce];
      if (U) {
        const { _f: G, ...ye } = U;
        if (G) {
          const je = l.array.has(G.name), Re = U._f && ST(U._f);
          Re && u.validatingFields && g([ce], !0);
          const rn = await Rv(U, l.disabled, o, N, n.shouldUseNativeValidation && !z, je);
          if (Re && u.validatingFields && g([ce]), rn[G.name] && (ie.valid = !1, z))
            break;
          !z && (nn(rn, G.name) ? je ? IT(r.errors, rn, G.name) : rt(r.errors, G.name, rn[G.name]) : St(r.errors, G.name));
        }
        !Wt(ye) && await W(ye, z, ie);
      }
    }
    return ie.valid;
  }, Y = () => {
    for (const E of l.unMount) {
      const z = nn(i, E);
      z && (z._f.refs ? z._f.refs.every((ie) => !oc(ie)) : !oc(z._f.ref)) && Be(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (E, z) => !n.disabled && (E && z && rt(o, E, z), !di(Oe(), a)), B = (E, z, ie) => eC(E, l, {
    ...s.mount ? o : ft(z) ? a : Ur(E) ? { [E]: z } : z
  }, ie, z), ee = (E) => El(nn(s.mount ? o : a, E, n.shouldUnregister ? nn(a, E, []) : [])), Ne = (E, z, ie = {}) => {
    const ce = nn(i, E);
    let U = z;
    if (ce) {
      const G = ce._f;
      G && (!G.disabled && rt(o, E, aC(z, G)), U = Zs(G.ref) && Gt(z) ? "" : z, nC(G.ref) ? [...G.ref.options].forEach((ye) => ye.selected = U.includes(ye.value)) : G.refs ? Vo(G.ref) ? G.refs.length > 1 ? G.refs.forEach((ye) => (!ye.defaultChecked || !ye.disabled) && (ye.checked = Array.isArray(U) ? !!U.find((je) => je === ye.value) : U === ye.value)) : G.refs[0] && (G.refs[0].checked = !!U) : G.refs.forEach((ye) => ye.checked = ye.value === U) : Oy(G.ref) ? G.ref.value = "" : (G.ref.value = U, G.ref.type || h.state.next({
        name: E,
        values: Rt(o)
      })));
    }
    (ie.shouldDirty || ie.shouldTouch) && L(E, U, ie.shouldTouch, ie.shouldDirty, !0), ie.shouldValidate && ke(E);
  }, ue = (E, z, ie) => {
    for (const ce in z) {
      const U = z[ce], G = `${E}.${ce}`, ye = nn(i, G);
      (l.array.has(E) || yt(U) || ye && !ye._f) && !$i(U) ? ue(G, U, ie) : Ne(G, U, ie);
    }
  }, oe = (E, z, ie = {}) => {
    const ce = nn(i, E), U = l.array.has(E), G = Rt(z);
    rt(o, E, G), U ? (h.array.next({
      name: E,
      values: Rt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && ie.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Aa(a, o),
      isDirty: P(E, G)
    })) : ce && !ce._f && !Gt(G) ? ue(E, G, ie) : Ne(E, G, ie), $v(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Rt(o)
    });
  }, fe = async (E) => {
    s.mount = !0;
    const z = E.target;
    let ie = z.name, ce = !0;
    const U = nn(i, ie), G = (ye) => {
      ce = Number.isNaN(ye) || $i(ye) && isNaN(ye.getTime()) || di(ye, nn(o, ie, ye));
    };
    if (U) {
      let ye, je;
      const Re = z.type ? Fv(U._f) : Yw(E), rn = E.type === Xs.BLUR || E.type === Xs.FOCUS_OUT, kn = !NT(U._f) && !n.resolver && !nn(r.errors, ie) && !U._f.deps || CT(rn, nn(r.touchedFields, ie), r.isSubmitted, C, k), an = $v(ie, l, rn);
      rt(o, ie, Re), rn ? (U._f.onBlur && U._f.onBlur(E), d && d(0)) : U._f.onChange && U._f.onChange(E);
      const pn = L(ie, Re, rn), $n = !Wt(pn) || an;
      if (!rn && h.state.next({
        name: ie,
        type: E.type,
        values: Rt(o)
      }), kn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? rn && _() : rn || _()), $n && h.state.next({ name: ie, ...an ? {} : pn });
      if (!rn && an && h.state.next({ ...r }), n.resolver) {
        const { errors: _n } = await J([ie]);
        if (G(Re), ce) {
          const Fn = Tv(r.errors, i, ie), Ze = Tv(_n, i, Fn.name || ie);
          ye = Ze.error, ie = Ze.name, je = Wt(_n);
        }
      } else
        g([ie], !0), ye = (await Rv(U, l.disabled, o, N, n.shouldUseNativeValidation))[ie], g([ie]), G(Re), ce && (ye ? je = !1 : (u.isValid || f.isValid) && (je = await W(i, !0)));
      ce && (U._f.deps && ke(U._f.deps), K(ie, je, ye, pn));
    }
  }, V = (E, z) => {
    if (nn(r.errors, z) && E.focus)
      return E.focus(), 1;
  }, ke = async (E, z = {}) => {
    let ie, ce;
    const U = bo(E);
    if (n.resolver) {
      const G = await re(ft(E) ? E : U);
      ie = Wt(G), ce = E ? !U.some((ye) => nn(G, ye)) : ie;
    } else E ? (ce = (await Promise.all(U.map(async (G) => {
      const ye = nn(i, G);
      return await W(ye && ye._f ? { [G]: ye } : ye);
    }))).every(Boolean), !(!ce && !r.isValid) && _()) : ce = ie = await W(i);
    return h.state.next({
      ...!Ur(E) || (u.isValid || f.isValid) && ie !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: ie } : {},
      errors: r.errors
    }), z.shouldFocus && !ce && _o(i, V, E ? U : l.mount), ce;
  }, Oe = (E) => {
    const z = {
      ...s.mount ? o : a
    };
    return ft(E) ? z : Ur(E) ? nn(z, E) : E.map((ie) => nn(z, ie));
  }, q = (E, z) => ({
    invalid: !!nn((z || r).errors, E),
    isDirty: !!nn((z || r).dirtyFields, E),
    error: nn((z || r).errors, E),
    isValidating: !!nn(r.validatingFields, E),
    isTouched: !!nn((z || r).touchedFields, E)
  }), Ge = (E) => {
    E && bo(E).forEach((z) => St(r.errors, z)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, sn = (E, z, ie) => {
    const ce = (nn(i, E, { _f: {} })._f || {}).ref, U = nn(r.errors, E) || {}, { ref: G, message: ye, type: je, ...Re } = U;
    rt(r.errors, E, {
      ...Re,
      ...z,
      ref: ce
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), ie && ie.shouldFocus && ce && ce.focus && ce.focus();
  }, Ie = (E, z) => jr(E) ? h.state.subscribe({
    next: (ie) => E(B(void 0, z), ie)
  }) : B(E, z, !0), Ue = (E) => h.state.subscribe({
    next: (z) => {
      wT(E.name, z.name, E.exact) && jT(z, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...z
      });
    }
  }).unsubscribe, De = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Ue({
    ...E,
    formState: f
  })), Be = (E, z = {}) => {
    for (const ie of E ? bo(E) : l.mount)
      l.mount.delete(ie), l.array.delete(ie), z.keepValue || (St(i, ie), St(o, ie)), !z.keepError && St(r.errors, ie), !z.keepDirty && St(r.dirtyFields, ie), !z.keepTouched && St(r.touchedFields, ie), !z.keepIsValidating && St(r.validatingFields, ie), !n.shouldUnregister && !z.keepDefaultValue && St(a, ie);
    h.state.next({
      values: Rt(o)
    }), h.state.next({
      ...r,
      ...z.keepDirty ? { isDirty: P() } : {}
    }), !z.keepIsValid && _();
  }, Ae = ({ disabled: E, name: z }) => {
    (or(E) && s.mount || E || l.disabled.has(z)) && (E ? l.disabled.add(z) : l.disabled.delete(z));
  }, Je = (E, z = {}) => {
    let ie = nn(i, E);
    const ce = or(z.disabled) || or(n.disabled);
    return rt(i, E, {
      ...ie || {},
      _f: {
        ...ie && ie._f ? ie._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...z
      }
    }), l.mount.add(E), ie ? Ae({
      disabled: or(z.disabled) ? z.disabled : n.disabled,
      name: E
    }) : F(E, !0, z.value), {
      ...ce ? { disabled: z.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!z.required,
        min: La(z.min),
        max: La(z.max),
        minLength: La(z.minLength),
        maxLength: La(z.maxLength),
        pattern: La(z.pattern)
      } : {},
      name: E,
      onChange: fe,
      onBlur: fe,
      ref: (U) => {
        if (U) {
          Je(E, z), ie = nn(i, E);
          const G = ft(U.value) && U.querySelectorAll && U.querySelectorAll("input,select,textarea")[0] || U, ye = kT(G), je = ie._f.refs || [];
          if (ye ? je.find((Re) => Re === G) : G === ie._f.ref)
            return;
          rt(i, E, {
            _f: {
              ...ie._f,
              ...ye ? {
                refs: [
                  ...je.filter(oc),
                  G,
                  ...Array.isArray(nn(a, E)) ? [{}] : []
                ],
                ref: { type: G.type, name: E }
              } : { ref: G }
            }
          }), F(E, !1, void 0, G);
        } else
          ie = nn(i, E, {}), ie._f && (ie._f.mount = !1), (n.shouldUnregister || z.shouldUnregister) && !(Jw(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, $e = () => n.shouldFocusError && _o(i, V, l.mount), Me = (E) => {
    or(E) && (h.state.next({ disabled: E }), _o(i, (z, ie) => {
      const ce = nn(i, ie);
      ce && (z.disabled = ce._f.disabled || E, Array.isArray(ce._f.refs) && ce._f.refs.forEach((U) => {
        U.disabled = ce._f.disabled || E;
      }));
    }, 0, !1));
  }, en = (E, z) => async (ie) => {
    let ce;
    ie && (ie.preventDefault && ie.preventDefault(), ie.persist && ie.persist());
    let U = Rt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: G, values: ye } = await J();
      r.errors = G, U = ye;
    } else
      await W(i);
    if (l.disabled.size)
      for (const G of l.disabled)
        rt(U, G, void 0);
    if (St(r.errors, "root"), Wt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(U, ie);
      } catch (G) {
        ce = G;
      }
    } else
      z && await z({ ...r.errors }, ie), $e(), setTimeout($e);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Wt(r.errors) && !ce,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ce)
      throw ce;
  }, se = (E, z = {}) => {
    nn(i, E) && (ft(z.defaultValue) ? oe(E, Rt(nn(a, E))) : (oe(E, z.defaultValue), rt(a, E, Rt(z.defaultValue))), z.keepTouched || St(r.touchedFields, E), z.keepDirty || (St(r.dirtyFields, E), r.isDirty = z.defaultValue ? P(E, Rt(nn(a, E))) : P()), z.keepError || (St(r.errors, E), u.isValid && _()), h.state.next({ ...r }));
  }, le = (E, z = {}) => {
    const ie = E ? Rt(E) : a, ce = Rt(ie), U = Wt(E), G = U ? a : ce;
    if (z.keepDefaultValues || (a = ie), !z.keepValues) {
      if (z.keepDirtyValues) {
        const ye = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Aa(a, o))
        ]);
        for (const je of Array.from(ye))
          nn(r.dirtyFields, je) ? rt(G, je, nn(o, je)) : oe(je, nn(G, je));
      } else {
        if (Iy && ft(E))
          for (const ye of l.mount) {
            const je = nn(i, ye);
            if (je && je._f) {
              const Re = Array.isArray(je._f.refs) ? je._f.refs[0] : je._f.ref;
              if (Zs(Re)) {
                const rn = Re.closest("form");
                if (rn) {
                  rn.reset();
                  break;
                }
              }
            }
          }
        for (const ye of l.mount)
          oe(ye, nn(G, ye));
      }
      o = Rt(G), h.array.next({
        values: { ...G }
      }), h.state.next({
        values: { ...G }
      });
    }
    l = {
      mount: z.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!z.keepIsValid || !!z.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: z.keepSubmitCount ? r.submitCount : 0,
      isDirty: U ? !1 : z.keepDirty ? r.isDirty : !!(z.keepDefaultValues && !di(E, a)),
      isSubmitted: z.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: U ? {} : z.keepDirtyValues ? z.keepDefaultValues && o ? Aa(a, o) : r.dirtyFields : z.keepDefaultValues && E ? Aa(a, E) : z.keepDirty ? r.dirtyFields : {},
      touchedFields: z.keepTouched ? r.touchedFields : {},
      errors: z.keepErrors ? r.errors : {},
      isSubmitSuccessful: z.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (E, z) => le(jr(E) ? E(o) : E, z), Ve = (E, z = {}) => {
    const ie = nn(i, E), ce = ie && ie._f;
    if (ce) {
      const U = ce.refs ? ce.refs[0] : ce.ref;
      U.focus && (U.focus(), z.shouldSelect && jr(U.select) && U.select());
    }
  }, Pe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, Q = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: q,
      handleSubmit: en,
      setError: sn,
      _subscribe: Ue,
      _runSchema: J,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: D,
      _setDisabledField: Ae,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: le,
      _resetDefaultValues: () => jr(n.defaultValues) && n.defaultValues().then((E) => {
        xe(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: De,
    trigger: ke,
    register: Je,
    handleSubmit: en,
    watch: Ie,
    setValue: oe,
    getValues: Oe,
    reset: xe,
    resetField: se,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Ve,
    getFieldState: q
  };
  return {
    ...Q,
    formControl: Q
  };
}
function ut(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: jr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: jr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : $T(e),
    formState: i
  }, e.formControl && e.defaultValues && !jr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !di(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Wt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Zw(i, o), n.current;
}
var Zo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var sc = { exports: {} }, Va = {}, Dv;
function TT() {
  if (Dv) return Va;
  Dv = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Va.Fragment = r, Va.jsx = s, Va.jsxs = s, Va;
}
var es = {}, Pv;
function OT() {
  return Pv || (Pv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    es.Fragment = i, es.jsx = zn, es.jsxs = Wn;
  })()), es;
}
var Av;
function RT() {
  return Av || (Av = 1, process.env.NODE_ENV === "production" ? sc.exports = TT() : sc.exports = OT()), sc.exports;
}
var Ri = RT();
function DT(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var lc, Lv;
function hi() {
  if (Lv) return lc;
  Lv = 1;
  var e = Array.isArray;
  return lc = e, lc;
}
var cc, Vv;
function lC() {
  if (Vv) return cc;
  Vv = 1;
  var e = typeof Zo == "object" && Zo && Zo.Object === Object && Zo;
  return cc = e, cc;
}
var dc, zv;
function Wr() {
  if (zv) return dc;
  zv = 1;
  var e = lC(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return dc = r, dc;
}
var uc, Uv;
function zo() {
  if (Uv) return uc;
  Uv = 1;
  var e = Wr(), n = e.Symbol;
  return uc = n, uc;
}
var mc, Mv;
function PT() {
  if (Mv) return mc;
  Mv = 1;
  var e = zo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var u = i.call(s);
    return p && (l ? s[a] = d : delete s[a]), u;
  }
  return mc = o, mc;
}
var pc, Bv;
function AT() {
  if (Bv) return pc;
  Bv = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return pc = r, pc;
}
var fc, qv;
function Na() {
  if (qv) return fc;
  qv = 1;
  var e = zo(), n = PT(), r = AT(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return fc = s, fc;
}
var hc, Hv;
function Ui() {
  if (Hv) return hc;
  Hv = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return hc = e, hc;
}
var yc, Wv;
function Dy() {
  if (Wv) return yc;
  Wv = 1;
  var e = Na(), n = Ui(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return yc = i, yc;
}
var gc, Kv;
function LT() {
  if (Kv) return gc;
  Kv = 1;
  var e = hi(), n = Dy(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return gc = a, gc;
}
var vc, Gv;
function ja() {
  if (Gv) return vc;
  Gv = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return vc = e, vc;
}
var kc, Yv;
function cC() {
  if (Yv) return kc;
  Yv = 1;
  var e = Na(), n = ja(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return kc = s, kc;
}
var bc, Jv;
function VT() {
  if (Jv) return bc;
  Jv = 1;
  var e = Wr(), n = e["__core-js_shared__"];
  return bc = n, bc;
}
var _c, Qv;
function zT() {
  if (Qv) return _c;
  Qv = 1;
  var e = VT(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return _c = r, _c;
}
var xc, Xv;
function dC() {
  if (Xv) return xc;
  Xv = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return xc = r, xc;
}
var Sc, Zv;
function UT() {
  if (Zv) return Sc;
  Zv = 1;
  var e = cC(), n = zT(), r = ja(), i = dC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, p = l.hasOwnProperty, u = RegExp(
    "^" + d.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return Sc = f, Sc;
}
var Nc, ek;
function MT() {
  if (ek) return Nc;
  ek = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Nc = e, Nc;
}
var jc, nk;
function Mi() {
  if (nk) return jc;
  nk = 1;
  var e = UT(), n = MT();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return jc = r, jc;
}
var wc, tk;
function $l() {
  if (tk) return wc;
  tk = 1;
  var e = Mi(), n = e(Object, "create");
  return wc = n, wc;
}
var Cc, rk;
function BT() {
  if (rk) return Cc;
  rk = 1;
  var e = $l();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Cc = n, Cc;
}
var Fc, ik;
function qT() {
  if (ik) return Fc;
  ik = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Fc = e, Fc;
}
var Ic, ak;
function HT() {
  if (ak) return Ic;
  ak = 1;
  var e = $l(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Ic = a, Ic;
}
var Ec, ok;
function WT() {
  if (ok) return Ec;
  ok = 1;
  var e = $l(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Ec = i, Ec;
}
var $c, sk;
function KT() {
  if (sk) return $c;
  sk = 1;
  var e = $l(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return $c = r, $c;
}
var Tc, lk;
function GT() {
  if (lk) return Tc;
  lk = 1;
  var e = BT(), n = qT(), r = HT(), i = WT(), a = KT();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Tc = o, Tc;
}
var Oc, ck;
function YT() {
  if (ck) return Oc;
  ck = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Oc = e, Oc;
}
var Rc, dk;
function uC() {
  if (dk) return Rc;
  dk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Rc = e, Rc;
}
var Dc, uk;
function Tl() {
  if (uk) return Dc;
  uk = 1;
  var e = uC();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Dc = n, Dc;
}
var Pc, mk;
function JT() {
  if (mk) return Pc;
  mk = 1;
  var e = Tl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Pc = i, Pc;
}
var Ac, pk;
function QT() {
  if (pk) return Ac;
  pk = 1;
  var e = Tl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Ac = n, Ac;
}
var Lc, fk;
function XT() {
  if (fk) return Lc;
  fk = 1;
  var e = Tl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Lc = n, Lc;
}
var Vc, hk;
function ZT() {
  if (hk) return Vc;
  hk = 1;
  var e = Tl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Vc = n, Vc;
}
var zc, yk;
function Ol() {
  if (yk) return zc;
  yk = 1;
  var e = YT(), n = JT(), r = QT(), i = XT(), a = ZT();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, zc = o, zc;
}
var Uc, gk;
function Py() {
  if (gk) return Uc;
  gk = 1;
  var e = Mi(), n = Wr(), r = e(n, "Map");
  return Uc = r, Uc;
}
var Mc, vk;
function eO() {
  if (vk) return Mc;
  vk = 1;
  var e = GT(), n = Ol(), r = Py();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Mc = i, Mc;
}
var Bc, kk;
function nO() {
  if (kk) return Bc;
  kk = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Bc = e, Bc;
}
var qc, bk;
function Rl() {
  if (bk) return qc;
  bk = 1;
  var e = nO();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return qc = n, qc;
}
var Hc, _k;
function tO() {
  if (_k) return Hc;
  _k = 1;
  var e = Rl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Hc = n, Hc;
}
var Wc, xk;
function rO() {
  if (xk) return Wc;
  xk = 1;
  var e = Rl();
  function n(r) {
    return e(this, r).get(r);
  }
  return Wc = n, Wc;
}
var Kc, Sk;
function iO() {
  if (Sk) return Kc;
  Sk = 1;
  var e = Rl();
  function n(r) {
    return e(this, r).has(r);
  }
  return Kc = n, Kc;
}
var Gc, Nk;
function aO() {
  if (Nk) return Gc;
  Nk = 1;
  var e = Rl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Gc = n, Gc;
}
var Yc, jk;
function mC() {
  if (jk) return Yc;
  jk = 1;
  var e = eO(), n = tO(), r = rO(), i = iO(), a = aO();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Yc = o, Yc;
}
var Jc, wk;
function oO() {
  if (wk) return Jc;
  wk = 1;
  var e = mC(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var p = i.apply(this, s);
      return o.cache = d.set(l, p) || d, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Jc = r, Jc;
}
var Qc, Ck;
function sO() {
  if (Ck) return Qc;
  Ck = 1;
  var e = oO(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Qc = r, Qc;
}
var Xc, Fk;
function lO() {
  if (Fk) return Xc;
  Fk = 1;
  var e = sO(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, p) {
      o.push(d ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return Xc = i, Xc;
}
var Zc, Ik;
function pC() {
  if (Ik) return Zc;
  Ik = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Zc = e, Zc;
}
var ed, Ek;
function cO() {
  if (Ek) return ed;
  Ek = 1;
  var e = zo(), n = pC(), r = hi(), i = Dy(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return ed = s, ed;
}
var nd, $k;
function dO() {
  if ($k) return nd;
  $k = 1;
  var e = cO();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return nd = n, nd;
}
var td, Tk;
function wa() {
  if (Tk) return td;
  Tk = 1;
  var e = hi(), n = LT(), r = lO(), i = dO();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return td = a, td;
}
var rd, Ok;
function Dl() {
  if (Ok) return rd;
  Ok = 1;
  var e = Dy();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return rd = n, rd;
}
var id, Rk;
function fC() {
  if (Rk) return id;
  Rk = 1;
  var e = wa(), n = Dl();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return id = r, id;
}
var ad, Dk;
function hC() {
  if (Dk) return ad;
  Dk = 1;
  var e = Mi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return ad = n, ad;
}
var od, Pk;
function yC() {
  if (Pk) return od;
  Pk = 1;
  var e = hC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return od = n, od;
}
var sd, Ak;
function Ay() {
  if (Ak) return sd;
  Ak = 1;
  var e = yC(), n = uC(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return sd = a, sd;
}
var ld, Lk;
function Ly() {
  if (Lk) return ld;
  Lk = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return ld = r, ld;
}
var cd, Vk;
function uO() {
  if (Vk) return cd;
  Vk = 1;
  var e = Ay(), n = wa(), r = Ly(), i = ja(), a = Dl();
  function o(s, l, d, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var C = a(l[u]), N = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var j = k[C];
        N = p ? p(j, C, k) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(k, C, N), k = k[C];
    }
    return s;
  }
  return cd = o, cd;
}
var dd, zk;
function mO() {
  if (zk) return dd;
  zk = 1;
  var e = fC(), n = uO(), r = wa();
  function i(a, o, s) {
    for (var l = -1, d = o.length, p = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(p, r(u, a), f);
    }
    return p;
  }
  return dd = i, dd;
}
var ud, Uk;
function pO() {
  if (Uk) return ud;
  Uk = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return ud = e, ud;
}
var md, Mk;
function fO() {
  if (Mk) return md;
  Mk = 1;
  var e = Na(), n = Ui(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return md = i, md;
}
var pd, Bk;
function Vy() {
  if (Bk) return pd;
  Bk = 1;
  var e = fO(), n = Ui(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return pd = o, pd;
}
var fd, qk;
function zy() {
  if (qk) return fd;
  qk = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return fd = n, fd;
}
var hd, Hk;
function hO() {
  if (Hk) return hd;
  Hk = 1;
  var e = wa(), n = Vy(), r = hi(), i = Ly(), a = zy(), o = Dl();
  function s(l, d, p) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && p(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return hd = s, hd;
}
var yd, Wk;
function yO() {
  if (Wk) return yd;
  Wk = 1;
  var e = pO(), n = hO();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return yd = r, yd;
}
var gd, Kk;
function gO() {
  if (Kk) return gd;
  Kk = 1;
  var e = mO(), n = yO();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return gd = r, gd;
}
var vd, Gk;
function Uy() {
  if (Gk) return vd;
  Gk = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return vd = e, vd;
}
var kd, Yk;
function vO() {
  if (Yk) return kd;
  Yk = 1;
  var e = zo(), n = Vy(), r = hi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return kd = a, kd;
}
var bd, Jk;
function kO() {
  if (Jk) return bd;
  Jk = 1;
  var e = Uy(), n = vO();
  function r(i, a, o, s, l) {
    var d = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++d < p; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return bd = r, bd;
}
var _d, Qk;
function bO() {
  if (Qk) return _d;
  Qk = 1;
  var e = kO();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return _d = n, _d;
}
var xd, Xk;
function _O() {
  if (Xk) return xd;
  Xk = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return xd = e, xd;
}
var Sd, Zk;
function xO() {
  if (Zk) return Sd;
  Zk = 1;
  var e = _O(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), p = Array(d); ++l < d; )
        p[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(p), e(i, this, u);
    };
  }
  return Sd = r, Sd;
}
var Nd, eb;
function SO() {
  if (eb) return Nd;
  eb = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Nd = e, Nd;
}
var jd, nb;
function gC() {
  if (nb) return jd;
  nb = 1;
  function e(n) {
    return n;
  }
  return jd = e, jd;
}
var wd, tb;
function NO() {
  if (tb) return wd;
  tb = 1;
  var e = SO(), n = hC(), r = gC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return wd = i, wd;
}
var Cd, rb;
function jO() {
  if (rb) return Cd;
  rb = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Cd = i, Cd;
}
var Fd, ib;
function wO() {
  if (ib) return Fd;
  ib = 1;
  var e = NO(), n = jO(), r = n(e);
  return Fd = r, Fd;
}
var Id, ab;
function vC() {
  if (ab) return Id;
  ab = 1;
  var e = bO(), n = xO(), r = wO();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Id = i, Id;
}
var Ed, ob;
function CO() {
  if (ob) return Ed;
  ob = 1;
  var e = gO(), n = vC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Ed = r, Ed;
}
var FO = CO();
const kC = /* @__PURE__ */ sC(FO), IO = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function bC(e) {
  const n = kC(e, IO);
  return {
    controller: Ty(n),
    controllerProps: n
  };
}
const EO = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function _C(e) {
  const { controller: n, controllerProps: r } = bC(e), i = {
    ...kC(e, EO),
    required: DT(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var $d, sb;
function $O() {
  if (sb) return $d;
  sb = 1;
  var e = Ol();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return $d = n, $d;
}
var Td, lb;
function TO() {
  if (lb) return Td;
  lb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Td = e, Td;
}
var Od, cb;
function OO() {
  if (cb) return Od;
  cb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Od = e, Od;
}
var Rd, db;
function RO() {
  if (db) return Rd;
  db = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Rd = e, Rd;
}
var Dd, ub;
function DO() {
  if (ub) return Dd;
  ub = 1;
  var e = Ol(), n = Py(), r = mC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Dd = a, Dd;
}
var Pd, mb;
function PO() {
  if (mb) return Pd;
  mb = 1;
  var e = Ol(), n = $O(), r = TO(), i = OO(), a = RO(), o = DO();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Pd = s, Pd;
}
var Ad, pb;
function AO() {
  if (pb) return Ad;
  pb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Ad = e, Ad;
}
var Ld, fb;
function Uo() {
  if (fb) return Ld;
  fb = 1;
  var e = Ay(), n = yC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, p = a.length; ++d < p; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Ld = r, Ld;
}
var Vd, hb;
function LO() {
  if (hb) return Vd;
  hb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Vd = e, Vd;
}
var Vs = { exports: {} }, zd, yb;
function VO() {
  if (yb) return zd;
  yb = 1;
  function e() {
    return !1;
  }
  return zd = e, zd;
}
Vs.exports;
var gb;
function xC() {
  return gb || (gb = 1, (function(e, n) {
    var r = Wr(), i = VO(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, p = d || i;
    e.exports = p;
  })(Vs, Vs.exports)), Vs.exports;
}
var Ud, vb;
function zO() {
  if (vb) return Ud;
  vb = 1;
  var e = Na(), n = zy(), r = Ui(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", p = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", C = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", D = "[object Float64Array]", O = "[object Int8Array]", I = "[object Int16Array]", F = "[object Int32Array]", L = "[object Uint8Array]", K = "[object Uint8ClampedArray]", J = "[object Uint16Array]", re = "[object Uint32Array]", W = {};
  W[g] = W[D] = W[O] = W[I] = W[F] = W[L] = W[K] = W[J] = W[re] = !0, W[i] = W[a] = W[j] = W[o] = W[_] = W[s] = W[l] = W[d] = W[p] = W[u] = W[f] = W[h] = W[k] = W[C] = W[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!W[e(P)];
  }
  return Ud = Y, Ud;
}
var Md, kb;
function My() {
  if (kb) return Md;
  kb = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Md = e, Md;
}
var zs = { exports: {} };
zs.exports;
var bb;
function By() {
  return bb || (bb = 1, (function(e, n) {
    var r = lC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(zs, zs.exports)), zs.exports;
}
var Bd, _b;
function UO() {
  if (_b) return Bd;
  _b = 1;
  var e = zO(), n = My(), r = By(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Bd = a, Bd;
}
var qd, xb;
function SC() {
  if (xb) return qd;
  xb = 1;
  var e = LO(), n = Vy(), r = hi(), i = xC(), a = Ly(), o = UO(), s = Object.prototype, l = s.hasOwnProperty;
  function d(p, u) {
    var f = r(p), h = !f && n(p), k = !f && !h && i(p), C = !f && !h && !k && o(p), N = f || h || k || C, j = N ? e(p.length, String) : [], _ = j.length;
    for (var g in p)
      (u || l.call(p, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return qd = d, qd;
}
var Hd, Sb;
function qy() {
  if (Sb) return Hd;
  Sb = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Hd = n, Hd;
}
var Wd, Nb;
function NC() {
  if (Nb) return Wd;
  Nb = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Wd = e, Wd;
}
var Kd, jb;
function MO() {
  if (jb) return Kd;
  jb = 1;
  var e = NC(), n = e(Object.keys, Object);
  return Kd = n, Kd;
}
var Gd, wb;
function BO() {
  if (wb) return Gd;
  wb = 1;
  var e = qy(), n = MO(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Gd = a, Gd;
}
var Yd, Cb;
function jC() {
  if (Cb) return Yd;
  Cb = 1;
  var e = cC(), n = zy();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Yd = r, Yd;
}
var Jd, Fb;
function Hy() {
  if (Fb) return Jd;
  Fb = 1;
  var e = SC(), n = BO(), r = jC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Jd = i, Jd;
}
var Qd, Ib;
function qO() {
  if (Ib) return Qd;
  Ib = 1;
  var e = Uo(), n = Hy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Qd = r, Qd;
}
var Xd, Eb;
function HO() {
  if (Eb) return Xd;
  Eb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Xd = e, Xd;
}
var Zd, $b;
function WO() {
  if ($b) return Zd;
  $b = 1;
  var e = ja(), n = qy(), r = HO(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || d.push(p);
    return d;
  }
  return Zd = o, Zd;
}
var eu, Tb;
function Wy() {
  if (Tb) return eu;
  Tb = 1;
  var e = SC(), n = WO(), r = jC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return eu = i, eu;
}
var nu, Ob;
function KO() {
  if (Ob) return nu;
  Ob = 1;
  var e = Uo(), n = Wy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return nu = r, nu;
}
var Us = { exports: {} };
Us.exports;
var Rb;
function GO() {
  return Rb || (Rb = 1, (function(e, n) {
    var r = Wr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(p, u) {
      if (u)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = d;
  })(Us, Us.exports)), Us.exports;
}
var tu, Db;
function YO() {
  if (Db) return tu;
  Db = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return tu = e, tu;
}
var ru, Pb;
function JO() {
  if (Pb) return ru;
  Pb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return ru = e, ru;
}
var iu, Ab;
function wC() {
  if (Ab) return iu;
  Ab = 1;
  function e() {
    return [];
  }
  return iu = e, iu;
}
var au, Lb;
function Ky() {
  if (Lb) return au;
  Lb = 1;
  var e = JO(), n = wC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return au = o, au;
}
var ou, Vb;
function QO() {
  if (Vb) return ou;
  Vb = 1;
  var e = Uo(), n = Ky();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return ou = r, ou;
}
var su, zb;
function Gy() {
  if (zb) return su;
  zb = 1;
  var e = NC(), n = e(Object.getPrototypeOf, Object);
  return su = n, su;
}
var lu, Ub;
function CC() {
  if (Ub) return lu;
  Ub = 1;
  var e = Uy(), n = Gy(), r = Ky(), i = wC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return lu = o, lu;
}
var cu, Mb;
function XO() {
  if (Mb) return cu;
  Mb = 1;
  var e = Uo(), n = CC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return cu = r, cu;
}
var du, Bb;
function FC() {
  if (Bb) return du;
  Bb = 1;
  var e = Uy(), n = hi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return du = r, du;
}
var uu, qb;
function ZO() {
  if (qb) return uu;
  qb = 1;
  var e = FC(), n = Ky(), r = Hy();
  function i(a) {
    return e(a, r, n);
  }
  return uu = i, uu;
}
var mu, Hb;
function IC() {
  if (Hb) return mu;
  Hb = 1;
  var e = FC(), n = CC(), r = Wy();
  function i(a) {
    return e(a, r, n);
  }
  return mu = i, mu;
}
var pu, Wb;
function eR() {
  if (Wb) return pu;
  Wb = 1;
  var e = Mi(), n = Wr(), r = e(n, "DataView");
  return pu = r, pu;
}
var fu, Kb;
function nR() {
  if (Kb) return fu;
  Kb = 1;
  var e = Mi(), n = Wr(), r = e(n, "Promise");
  return fu = r, fu;
}
var hu, Gb;
function tR() {
  if (Gb) return hu;
  Gb = 1;
  var e = Mi(), n = Wr(), r = e(n, "Set");
  return hu = r, hu;
}
var yu, Yb;
function rR() {
  if (Yb) return yu;
  Yb = 1;
  var e = Mi(), n = Wr(), r = e(n, "WeakMap");
  return yu = r, yu;
}
var gu, Jb;
function Yy() {
  if (Jb) return gu;
  Jb = 1;
  var e = eR(), n = Py(), r = nR(), i = tR(), a = rR(), o = Na(), s = dC(), l = "[object Map]", d = "[object Object]", p = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), C = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != p || i && g(new i()) != u || a && g(new a()) != f) && (g = function(D) {
    var O = o(D), I = O == d ? D.constructor : void 0, F = I ? s(I) : "";
    if (F)
      switch (F) {
        case k:
          return h;
        case C:
          return l;
        case N:
          return p;
        case j:
          return u;
        case _:
          return f;
      }
    return O;
  }), gu = g, gu;
}
var vu, Qb;
function iR() {
  if (Qb) return vu;
  Qb = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return vu = r, vu;
}
var ku, Xb;
function aR() {
  if (Xb) return ku;
  Xb = 1;
  var e = Wr(), n = e.Uint8Array;
  return ku = n, ku;
}
var bu, Zb;
function Jy() {
  if (Zb) return bu;
  Zb = 1;
  var e = aR();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return bu = n, bu;
}
var _u, e_;
function oR() {
  if (e_) return _u;
  e_ = 1;
  var e = Jy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return _u = n, _u;
}
var xu, n_;
function sR() {
  if (n_) return xu;
  n_ = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return xu = n, xu;
}
var Su, t_;
function lR() {
  if (t_) return Su;
  t_ = 1;
  var e = zo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Su = i, Su;
}
var Nu, r_;
function cR() {
  if (r_) return Nu;
  r_ = 1;
  var e = Jy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Nu = n, Nu;
}
var ju, i_;
function dR() {
  if (i_) return ju;
  i_ = 1;
  var e = Jy(), n = oR(), r = sR(), i = lR(), a = cR(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", p = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", C = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", D = "[object Int32Array]", O = "[object Uint8Array]", I = "[object Uint8ClampedArray]", F = "[object Uint16Array]", L = "[object Uint32Array]";
  function K(J, re, W) {
    var Y = J.constructor;
    switch (re) {
      case k:
        return e(J);
      case o:
      case s:
        return new Y(+J);
      case C:
        return n(J, W);
      case N:
      case j:
      case _:
      case g:
      case D:
      case O:
      case I:
      case F:
      case L:
        return a(J, W);
      case l:
        return new Y();
      case d:
      case f:
        return new Y(J);
      case p:
        return r(J);
      case u:
        return new Y();
      case h:
        return i(J);
    }
  }
  return ju = K, ju;
}
var wu, a_;
function uR() {
  if (a_) return wu;
  a_ = 1;
  var e = ja(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return wu = r, wu;
}
var Cu, o_;
function mR() {
  if (o_) return Cu;
  o_ = 1;
  var e = uR(), n = Gy(), r = qy();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Cu = i, Cu;
}
var Fu, s_;
function pR() {
  if (s_) return Fu;
  s_ = 1;
  var e = Yy(), n = Ui(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Fu = i, Fu;
}
var Iu, l_;
function fR() {
  if (l_) return Iu;
  l_ = 1;
  var e = pR(), n = My(), r = By(), i = r && r.isMap, a = i ? n(i) : e;
  return Iu = a, Iu;
}
var Eu, c_;
function hR() {
  if (c_) return Eu;
  c_ = 1;
  var e = Yy(), n = Ui(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Eu = i, Eu;
}
var $u, d_;
function yR() {
  if (d_) return $u;
  d_ = 1;
  var e = hR(), n = My(), r = By(), i = r && r.isSet, a = i ? n(i) : e;
  return $u = a, $u;
}
var Tu, u_;
function gR() {
  if (u_) return Tu;
  u_ = 1;
  var e = PO(), n = AO(), r = Ay(), i = qO(), a = KO(), o = GO(), s = YO(), l = QO(), d = XO(), p = ZO(), u = IC(), f = Yy(), h = iR(), k = dR(), C = mR(), N = hi(), j = xC(), _ = fR(), g = ja(), D = yR(), O = Hy(), I = Wy(), F = 1, L = 2, K = 4, J = "[object Arguments]", re = "[object Array]", W = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", ee = "[object GeneratorFunction]", Ne = "[object Map]", ue = "[object Number]", oe = "[object Object]", fe = "[object RegExp]", V = "[object Set]", ke = "[object String]", Oe = "[object Symbol]", q = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", $e = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", se = {};
  se[J] = se[re] = se[Ge] = se[sn] = se[W] = se[Y] = se[Ie] = se[Ue] = se[De] = se[Be] = se[Ae] = se[Ne] = se[ue] = se[oe] = se[fe] = se[V] = se[ke] = se[Oe] = se[Je] = se[$e] = se[Me] = se[en] = !0, se[P] = se[B] = se[q] = !1;
  function le(xe, Ve, Pe, vn, Q, E) {
    var z, ie = Ve & F, ce = Ve & L, U = Ve & K;
    if (Pe && (z = Q ? Pe(xe, vn, Q, E) : Pe(xe)), z !== void 0)
      return z;
    if (!g(xe))
      return xe;
    var G = N(xe);
    if (G) {
      if (z = h(xe), !ie)
        return s(xe, z);
    } else {
      var ye = f(xe), je = ye == B || ye == ee;
      if (j(xe))
        return o(xe, ie);
      if (ye == oe || ye == J || je && !Q) {
        if (z = ce || je ? {} : C(xe), !ie)
          return ce ? d(xe, a(z, xe)) : l(xe, i(z, xe));
      } else {
        if (!se[ye])
          return Q ? xe : {};
        z = k(xe, ye, ie);
      }
    }
    E || (E = new e());
    var Re = E.get(xe);
    if (Re)
      return Re;
    E.set(xe, z), D(xe) ? xe.forEach(function(an) {
      z.add(le(an, Ve, Pe, an, xe, E));
    }) : _(xe) && xe.forEach(function(an, pn) {
      z.set(pn, le(an, Ve, Pe, pn, xe, E));
    });
    var rn = U ? ce ? u : p : ce ? I : O, kn = G ? void 0 : rn(xe);
    return n(kn || xe, function(an, pn) {
      kn && (pn = an, an = xe[pn]), r(z, pn, le(an, Ve, Pe, pn, xe, E));
    }), z;
  }
  return Tu = le, Tu;
}
var Ou, m_;
function vR() {
  if (m_) return Ou;
  m_ = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Ou = e, Ou;
}
var Ru, p_;
function kR() {
  if (p_) return Ru;
  p_ = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Ru = e, Ru;
}
var Du, f_;
function bR() {
  if (f_) return Du;
  f_ = 1;
  var e = fC(), n = kR();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Du = r, Du;
}
var Pu, h_;
function _R() {
  if (h_) return Pu;
  h_ = 1;
  var e = wa(), n = vR(), r = bR(), i = Dl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var p = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++p < u; ) {
      var f = i(d[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return Pu = s, Pu;
}
var Au, y_;
function xR() {
  if (y_) return Au;
  y_ = 1;
  var e = Na(), n = Gy(), r = Ui(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function p(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return Au = p, Au;
}
var Lu, g_;
function SR() {
  if (g_) return Lu;
  g_ = 1;
  var e = xR();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Lu = n, Lu;
}
var Vu, v_;
function NR() {
  if (v_) return Vu;
  v_ = 1;
  var e = pC(), n = gR(), r = _R(), i = wa(), a = Uo(), o = SR(), s = vC(), l = IC(), d = 1, p = 2, u = 4, f = s(function(h, k) {
    var C = {};
    if (h == null)
      return C;
    var N = !1;
    k = e(k, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), C), N && (C = n(C, d | p | u, o));
    for (var j = k.length; j--; )
      r(C, k[j]);
    return C;
  });
  return Vu = f, Vu;
}
NR();
const _r = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = _C(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ Ri.jsx(We, { ...a, children: /* @__PURE__ */ Ri.jsx(
    ci,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (p) => {
        n.componentProps?.onBlur?.(p), s();
      },
      onChange: (p) => {
        n.componentProps?.onChange?.(p), l(p.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: We.getStatus(a.meta),
      children: e
    }
  ) });
};
var jR = gC();
const wR = /* @__PURE__ */ sC(jR), bn = ({
  transformValue: e = wR,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = bC(a);
  return /* @__PURE__ */ Ri.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ri.jsx(
      Fo,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ri.jsx(lw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Pn = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = _C(e);
  return /* @__PURE__ */ Ri.jsx(We, { ...i, children: /* @__PURE__ */ Ri.jsx(
    cr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: We.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var zu = { exports: {} }, za = {}, k_;
function CR() {
  if (k_) return za;
  k_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return za.Fragment = r, za.jsx = s, za.jsxs = s, za;
}
var ns = {}, b_;
function FR() {
  return b_ || (b_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ns.Fragment = i, ns.jsx = zn, ns.jsxs = Wn;
  })()), ns;
}
var __;
function IR() {
  return __ || (__ = 1, process.env.NODE_ENV === "production" ? zu.exports = CR() : zu.exports = FR()), zu.exports;
}
var ne = IR();
const ER = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, $R = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, TR = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": ER,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": $R
};
function EC(e) {
  return TR[e] ?? {};
}
const OR = EC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), RR = EC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), DR = "_copyIcon_10dvk_54", PR = "_list_10dvk_59", AR = "_listItem_10dvk_69", LR = "_collapsible_10dvk_78", VR = "_collapsibleIsOpen_10dvk_86", zR = "_collapsibleHeader_10dvk_89", UR = "_collapsibleIconTrue_10dvk_92", MR = "_collapsibleIconFalse_10dvk_95", Un = {
  copyIcon: DR,
  list: PR,
  listItem: AR,
  collapsible: LR,
  collapsibleIsOpen: VR,
  collapsibleHeader: zR,
  collapsibleIconTrue: UR,
  collapsibleIconFalse: MR
}, BR = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: p
  } = e;
  return /* @__PURE__ */ ne.jsxs(
    b,
    {
      className: dt(Un.collapsible, {
        [Un.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ne.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Un.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ne.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ne.jsxs(Ye, { className: Un.list, children: [
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: Gn(d).format(jt) })
          ] }) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: Gn(p).format(jt) })
          ] }) })
        ] })
      ]
    }
  );
}, qR = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ne.jsx($.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ne.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ne.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ne.jsx(BR, { app: r, openByDefault: i === 0 }, i))
  ] });
}, HR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ne.jsx(ne.Fragment, { children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsx($.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ne.jsx(Ye, { className: Un.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ne.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ ne.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: i }),
          Li(a)
        ] })
      },
      o
    )) })
  ] }) });
}, WR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ne.jsx(ne.Fragment, { children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsx($.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ne.jsx(Ye, { className: Un.list, children: r.map((a, o) => /* @__PURE__ */ ne.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ ne.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ne.jsx(
            Xe,
            {
              content: /* @__PURE__ */ ne.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ne.jsx(b, { children: `First ${Gn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ ne.jsx(b, { children: `Last ${Gn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, tl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ne.jsx(Xe, { content: n ? null : l(), children: /* @__PURE__ */ ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ne.jsx(ve, { size: 14, name: o(), color: s() }) }) });
}, KR = "_wrapper_1xucg_1", GR = "_externalLink_1xucg_7", Uu = {
  wrapper: KR,
  externalLink: GR
}, YR = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt(), { isCopied: o, copy: s } = Jt(), { isCopied: l, copy: d } = Jt(), { isCopied: p, copy: u } = Jt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: k,
    last_name: C,
    home_city: N,
    country: j,
    email: _,
    phone: g,
    dob: D,
    created_at: O,
    email_subscribe: I,
    push_subscribe: F
  } = e, L = 14, K = `${k || ""} ${C || ""}`.trim() || "A customer has no name", J = `${N ? `${N} /` : ""} ${j || ""}`.trim(), re = D ? Gn(D).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ne.jsxs(b, { className: Uu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Uu.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ne.jsx($.Heading, { variant: "heading-2", children: K }),
          re && /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    O && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: Gn(O).format(jt) })
    ] }),
    J && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: L, name: "map-pin" }),
        /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: J })
      ] }),
      /* @__PURE__ */ ne.jsx(Xe, { content: "Copy location", children: /* @__PURE__ */ ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ne.jsx(
        ve,
        {
          size: L,
          name: o ? "done" : "copy",
          onClick: () => s(J),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    _ && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: L, name: "mail" }),
        /* @__PURE__ */ ne.jsx("span", { className: Uu.externalLink, children: _ })
      ] }),
      /* @__PURE__ */ ne.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ne.jsx(
        ve,
        {
          size: L,
          name: n ? "done" : "copy",
          onClick: () => r(_),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: L, name: "phone" }),
        /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ ne.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ne.jsx(
        ve,
        {
          size: L,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: L, name: "user" }),
        /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ne.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ne.jsx(Xe, { content: "Copy Braze ID", children: /* @__PURE__ */ ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ne.jsx(
        ve,
        {
          size: L,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: L, name: "tag" }),
        /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ne.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ne.jsx(Xe, { content: "Copy External ID", children: /* @__PURE__ */ ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ne.jsx(
        ve,
        {
          size: L,
          name: p ? "done" : "copy",
          onClick: () => u(f),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: L, name: "sync" }),
        /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ne.jsx(tl, { state: I })
    ] }),
    F && /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: L, name: "bell" }),
        /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ne.jsx(tl, { isPush: !0, state: F })
    ] })
  ] }) });
}, JR = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: p,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ne.jsxs(
    b,
    {
      className: dt(Un.collapsible, {
        [Un.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ne.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Un.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ne.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ne.jsxs(Ye, { className: Un.list, children: [
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ne.jsx(
              ve,
              {
                size: a,
                className: dt({
                  [Un.collapsibleIconTrue]: d,
                  [Un.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ne.jsx(Xe, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Xe, { content: "For iOS", children: /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: p })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, QR = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ne.jsx($.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ne.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ne.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ne.jsx(JR, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Ua = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, ts = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = Cn(), { useMutation: a } = hn(), [o, s] = me(!1), [l] = a(
    RR,
    {
      onCompleted: (p) => {
        p?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Ua[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ne.jsx(Xe, { content: Ua[n].tooltipContent, children: /* @__PURE__ */ ne.jsx(
    ct,
    {
      variant: "secondary",
      color: Ua[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ne.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(
          tl,
          {
            noTooltip: !0,
            state: Ua[n].parameter
          }
        ),
        Ua[n].label
      ] })
    }
  ) });
}, XR = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsx($.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ne.jsx(Ye, { className: Un.list, children: /* @__PURE__ */ ne.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ne.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ne.jsx(ve, { size: 14, name: "sync" }),
        /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ne.jsx(tl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ne.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ne.jsxs(ne.Fragment, { children: [
        /* @__PURE__ */ ne.jsx(
          ts,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ne.jsx(
          ts,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ne.jsx(
        ts,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ne.jsx(
        ts,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, ZR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ne.jsx(ne.Fragment, { children: /* @__PURE__ */ ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ne.jsx($.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ne.jsx(Ye, { className: Un.list, children: r.map((a, o) => /* @__PURE__ */ ne.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ ne.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ne.jsx(
            Xe,
            {
              content: /* @__PURE__ */ ne.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ne.jsx(b, { children: `First ${Gn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ ne.jsx(b, { children: `Last ${Gn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ne.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, eD = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Cn(), { useMutation: i } = hn(), [a, o] = me(), [s, l] = me(!1), [d, p] = me(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, k = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, N = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, _ = n.displayDevices ?? !1, g = n.displayApps ?? !1, D = !h && !k && !C && !N && !j, [O, { error: I }] = i(
    OR,
    {
      onError: () => {
      },
      onCompleted: (L) => {
        const K = L?.Braze?.exportUserDetails?.users?.[0];
        K ? (o(K), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), F = async () => {
    u || f ? await O({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Qe(() => {
    async function L() {
      p(!0), await F();
    }
    L().finally(() => p(!1));
  }, [u, f]), I) {
    const L = I.graphQLErrors;
    return bl({ errors: L }) ? /* @__PURE__ */ ne.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: L }) ? /* @__PURE__ */ ne.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ne.jsx(En, { error: I });
  }
  return d ? /* @__PURE__ */ ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ne.jsx(fn, {}) }) : D ? /* @__PURE__ */ ne.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ne.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ne.jsx(YR, { customerDetails: a }),
        k && !!a && /* @__PURE__ */ ne.jsx(
          XR,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await F()
          }
        ),
        C && !!a && /* @__PURE__ */ ne.jsx(HR, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ ne.jsx(WR, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ ne.jsx(ZR, { customerDetails: a }),
        _ && !!a && /* @__PURE__ */ ne.jsx(QR, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ ne.jsx(qR, { apps: a?.apps })
      ]
    }
  );
}, rl = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], nD = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...xl([], rl)
}, tD = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: nD
  }), {
    create: l,
    update: d,
    remove: p,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: rl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => fr(K, {
    fieldDefinitions: rl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ ne.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ ne.jsx(hr, { cause: h }),
        /* @__PURE__ */ ne.jsxs(nt, { children: [
          /* @__PURE__ */ ne.jsx(Z, { children: /* @__PURE__ */ ne.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(
            Pn,
            {
              name: "apiHostName",
              label: "API endpoint",
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (K) => kl(K) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(
            Ir,
            {
              name: "brazeApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(We, { label: "Display customer details", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(We, { label: "Display the button to change the email subscription state", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(We, { label: "Display a list of custom attributes", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(We, { label: "Display a list of custom events", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(We, { label: "Display a list of purchases", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(We, { label: "Display customer devices", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3, children: /* @__PURE__ */ ne.jsx(We, { label: "Display customer apps", children: /* @__PURE__ */ ne.jsx(
            bn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ne.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ ne.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ ne.jsx(
          yr,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
function rD() {
  var e = Er(!1), n = _t(function() {
    return e.current;
  }, []);
  return Qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var iD = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = _t(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, aD = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, x_ = function(e) {
  return iI(aD, e);
}, Mu, S_;
function oD() {
  return S_ || (S_ = 1, Mu = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Mu;
}
var Bu, N_;
function sD() {
  if (N_) return Bu;
  N_ = 1;
  var e = oD(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, p, u, f, h, k = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      p = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(N) {
        if (N.stopPropagation(), s.format)
          if (N.preventDefault(), typeof N.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            N.clipboardData.clearData(), N.clipboardData.setData(s.format, o);
        s.onCopy && (N.preventDefault(), s.onCopy(N.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      k = !0;
    } catch (N) {
      l && console.error("unable to copy using execCommand: ", N), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), k = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), p();
    }
    return k;
  }
  return Bu = a, Bu;
}
var lD = sD();
const cD = /* @__PURE__ */ hy(lD);
var $C = function() {
  var e = rD(), n = iD({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = _t(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = cD(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (p) {
        i({
          value: l,
          error: p,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function dD(e, n) {
  n === void 0 && (n = 0);
  var r = Er(!1), i = Er(), a = Er(e), o = _t(function() {
    return r.current;
  }, []), s = _t(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = _t(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Qe(function() {
    a.current = e;
  }, [e]), Qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function yi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = dD(e, n), a = i[0], o = i[1], s = i[2];
  return Qe(s, r), [a, o];
}
var uD = function(e) {
  Qe(e, []);
}, mD = function(e, n) {
  var r = Er(function() {
  });
  Qe(function() {
    r.current = e;
  }), Qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, pD = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = Qn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var p;
          return Ql(Ql({}, d), (p = {}, p[s] = l, p));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, p = s;
          d[p];
          var u = bI(d, [typeof p == "symbol" ? p : p + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Ql({ get: _t(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, fD = function(e) {
  var n = Er(e);
  n.current = e, uD(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var qu = { exports: {} }, Ma = {}, j_;
function hD() {
  if (j_) return Ma;
  j_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ma.Fragment = r, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var rs = {}, w_;
function yD() {
  return w_ || (w_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    rs.Fragment = i, rs.jsx = zn, rs.jsxs = Wn;
  })()), rs;
}
var C_;
function gD() {
  return C_ || (C_ = 1, process.env.NODE_ENV === "production" ? qu.exports = hD() : qu.exports = yD()), qu.exports;
}
var _e = gD();
const vD = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, kD = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, bD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, _D = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, xD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, SD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, ND = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, jD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, wD = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": bD,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": _D,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": xD,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": vD,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": kD,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SD,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": ND,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": jD
};
function Ca(e) {
  return wD[e] ?? {};
}
const CD = Ca(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), FD = Ca(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), ID = Ca(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), F_ = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, vr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, ED = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), I_ = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Fh = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ _e.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ _e.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function $D({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = me(
    []
  ), [o, s] = me([]), [l, d] = me([]), [p, u] = me([]), [f, h] = me(), { showNotification: k, showModal: C, executeQuery: N } = hn(), { track: j } = Cn(), {
    loading: _,
    data: g,
    error: D,
    store: O
  } = dy(e ?? null), I = g?.github?.issues || [], F = g?.github?.pullRequests || [], [L, K] = me(!1), [J, re] = me();
  Qe(
    () => h(D || J || void 0),
    [D, J]
  ), Qe(
    () => {
      !_ && (I?.length || F?.length) ? (a(I), s(F), Y(I, F)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const W = async (fe, V) => {
    await O(fe).then(() => {
      k({
        icon: "check-circle-filled",
        severity: "success",
        title: V.success.title,
        text: V.success.text
      });
    }).catch((ke) => {
      k({
        title: V.error.title,
        text: `${V.error.text} ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Y = (fe, V) => {
    if (!fe?.length && !V?.length) {
      d([]), u([]);
      return;
    }
    const ke = (fe || []).map(
      (Ge) => N(FD, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        issueNumber: Ge.number
      })
    ), Oe = (V || []).map(
      (Ge) => N(ID, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        prNumber: Ge.number
      })
    ), q = [...ke, ...Oe];
    K(!0), Promise.all(q).then((Ge) => {
      const sn = [], Ie = [];
      Ge.forEach((Ue) => {
        const De = Ue?.data?.GitHub;
        if (!De) {
          d([]), u([]);
          return;
        }
        Object.keys(De).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = De[Be];
            Object.keys(Ae).forEach((Je) => {
              const $e = Ae[Je], Me = {
                number: $e?.number,
                owner: $e?.repository?.owner?.login,
                repository: $e?.repository?.name
              };
              Je.startsWith("issue") && sn.push({
                ...$e,
                type: "ISSUE",
                key: Me
              }), Je.startsWith("pullRequest") && Ie.push({
                ...$e,
                type: "PR",
                key: Me
              });
            });
          }
        });
      }), d(sn), u(Ie);
    }).catch(re).finally(() => {
      K(!1);
    });
  }, P = ({ key: fe, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = g && (I.length || F.length) ? g : r, Oe = V === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Oe] = Array.from(
      new Set(ke.github[Oe]).add(fe)
    ), W(ke, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${vr(
          fe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${vr(fe)} failed. Please try again.`
      }
    });
  }, B = async ({ key: fe, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = g && (I.length || F.length) ? g : r, Oe = V === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Oe] = Array.from(
      new Set(ke.github[Oe]).add(fe)
    ), await O(ke).catch((q) => {
      k({
        title: "Linking failed",
        text: `Linking ${fe} failed. Please try again. ${q.message && " (" + q.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: fe, type: V }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const ke = V === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${ke} ${vr(fe)}?`,
      text: `You are about to unlink the ${ke} ${vr(
        fe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${ke}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Oe = V === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const q = {
          ...g,
          github: {
            ...g?.github,
            [Oe]: g?.github?.[Oe].filter(
              (Ge) => Ge.number !== fe.number || Ge.owner !== fe.owner || Ge.repository !== fe.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), W(q, {
          success: {
            title: `GitHub ${ke} unlinked`,
            text: `You unlinked the GitHub ${ke} ${vr(
              fe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${vr(fe)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, Ne = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), W(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ue = I.filter(
    (fe) => !i?.includes(fe)
  ) || [], oe = F.filter(
    (fe) => !o?.includes(fe)
  ) || [];
  return {
    linkGithubItem: P,
    linkGithubItemQuietly: B,
    unlinkGithubItem: ee,
    loadGithubItems: Y,
    removeDanglingGithubItemLinks: () => {
      const fe = {
        ...g,
        github: {
          ...g?.github,
          issues: I.filter(
            (V) => !ue.includes(V)
          ) || [],
          pullRequests: F.filter(
            (V) => !oe.includes(V)
          ) || []
        }
      };
      O(fe);
    },
    unlinkAllGithubItems: Ne,
    isLoadingGithubItemLinks: _,
    danglingIssueLinks: ue,
    danglingPullRequestLinks: oe,
    isLoadingGithubItems: L,
    issues: l,
    pullRequests: p,
    error: f
  };
}
const TD = "_contentWrapper_1vx3c_1", OD = "_contentWrapperHeadline_1vx3c_4", RD = "_contentWrapperBody_1vx3c_11", DD = "_contentWrapperAssigneeIcon_1vx3c_15", PD = "_contentWrapperStatusTag_1vx3c_20", Xr = {
  contentWrapper: TD,
  contentWrapperHeadline: OD,
  contentWrapperBody: RD,
  contentWrapperAssigneeIcon: DD,
  contentWrapperStatusTag: PD
}, TC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
  e && /* @__PURE__ */ _e.jsxs(st, { className: Xr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(st, { className: Xr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ _e.jsx(st, { className: Xr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ _e.jsxs(st, { className: Xr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(st, { className: Xr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ _e.jsx(st, { className: Xr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ _e.jsxs(st, { margin: "100 0", children: [
        /* @__PURE__ */ _e.jsx(
          "img",
          {
            className: Xr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ _e.jsx(st, { className: Xr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ _e.jsx(
      Jn,
      {
        className: Xr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), AD = "_collapse_1bdjy_1", LD = "_collapseHeader_1bdjy_10", VD = "_collapseHeaderKey_1bdjy_31", zD = "_collapseHeaderKeyIcon_1bdjy_36", UD = "_collapseHeaderKeyLink_1bdjy_41", MD = "_collapseHeaderIcon_1bdjy_44", BD = "_collapseHeaderTitle_1bdjy_49", qD = "_collapseContent_1bdjy_57", HD = "_collapseContentButtonSpacer_1bdjy_60", WD = "_collapseContentButtonLink_1bdjy_63", Rr = {
  collapse: AD,
  collapseHeader: LD,
  collapseHeaderKey: VD,
  collapseHeaderKeyIcon: zD,
  collapseHeaderKeyLink: UD,
  collapseHeaderIcon: MD,
  collapseHeaderTitle: BD,
  collapseContent: qD,
  collapseContentButtonSpacer: HD,
  collapseContentButtonLink: WD
}, KD = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, p) => ({ ...d, [p.id]: !1 }),
    {}
  ), [a, o] = me(i), { track: s } = Cn(), l = (d, p) => {
    o({ ...a, [d]: p });
  };
  return /* @__PURE__ */ _e.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: p,
      number: u,
      key: f,
      title: h,
      bodyText: k,
      repository: C,
      type: N,
      state: j,
      assignees: _,
      labels: g
    } = d, D = a[p];
    return /* @__PURE__ */ _e.jsxs(
      br,
      {
        onToggle: () => l(p, !a[p]),
        isOpen: D,
        className: Rr.collapse,
        children: [
          /* @__PURE__ */ _e.jsx(br.Header, { className: Rr.collapseHeader, children: /* @__PURE__ */ _e.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ _e.jsx(st, { children: /* @__PURE__ */ _e.jsxs(st, { as: "span", className: Rr.collapseHeaderKey, children: [
                  Fh(
                    N,
                    j,
                    Rr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ _e.jsxs(
                    "a",
                    {
                      href: F_(f),
                      className: Rr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (O) => {
                        O.stopPropagation();
                      },
                      children: [
                        vr(f),
                        /* @__PURE__ */ _e.jsx(
                          ve,
                          {
                            className: Rr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ _e.jsx(st, { className: Rr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ _e.jsx(br.Content, { className: Rr.collapseContent, children: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ _e.jsx(
              TC,
              {
                description: k,
                assignees: _,
                labels: g
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              ct,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Rr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: N
                }),
                children: [
                  "Unlink ",
                  I_(N)
                ]
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              Lt,
              {
                slotEnd: /* @__PURE__ */ _e.jsx(ve, { name: "external-link" }),
                variant: "tertiary",
                className: Rr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(F_(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  I_(N),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      p
    );
  }) : /* @__PURE__ */ _e.jsx(_e.Fragment, {}) });
}, GD = "_result_1uaom_1", YD = "_resultName_1uaom_21", JD = "_resultItemIcon_1uaom_29", QD = "_resultDescription_1uaom_34", XD = "_resultLinkIcon_1uaom_46", ZD = "_tooltip_1uaom_55", eP = "_tooltipName_1uaom_61", nP = "_tooltipTag_1uaom_71", Zr = {
  result: GD,
  resultName: YD,
  resultItemIcon: JD,
  resultDescription: QD,
  resultLinkIcon: XD,
  tooltip: ZD,
  tooltipName: eP,
  tooltipTag: nP
}, tP = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [p, u] = me(!1);
  return /* @__PURE__ */ _e.jsx(
    Xe,
    {
      className: Zr.tooltip,
      content: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ _e.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ _e.jsxs(st, { as: "span", className: Zr.tooltipName, children: [
                Fh(a, o, Zr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ _e.jsx(Jn, { className: Zr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ _e.jsx(
          TC,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ _e.jsxs(
        "button",
        {
          className: Zr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ _e.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: p ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsxs(st, { as: "span", className: Zr.resultName, children: [
                    Fh(a, o, Zr.resultItemIcon),
                    vr(r)
                  ] }) }),
                  /* @__PURE__ */ _e.jsx(st, { className: Zr.resultDescription, children: i })
                ]
              }
            ),
            p && /* @__PURE__ */ _e.jsx(
              ve,
              {
                className: Zr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, rP = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ _e.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ _e.jsx(ve, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), il = "[a-zA-z0-9_.-]+", OC = "[0-9]+", iP = new RegExp(
  `(${il})/(${il})/(?:issues|pull)/(${OC})`,
  "i"
), E_ = new RegExp(`^${iP.source}$`), $_ = new RegExp(
  `https://github.com/(${il})/(${il})/(?:issues|pull)/(${OC})`,
  "i"
), aP = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Qn(() => r?.map((F) => F.id) || [], [r]), o = Qn(() => i?.map((F) => F.id) || [], [i]), [s, l] = me([]), { useLazyQuery: d } = hn(), [p, u] = me(), [f, { loading: h, error: k, data: C, networkStatus: N }] = d(CD, {
    notifyOnNetworkStatusChange: !0
  });
  yi(
    () => {
      !h && p && N === tr.ready ? f({
        variables: {
          issueQuery: `${p} type:issue`,
          prQuery: `${p} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [p]
  ), Qe(() => {
    let F = C?.GitHub?.issues?.nodes || [], L = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (F = F.filter((K) => !a.includes(K.id))), o.length > 0 && (L = L.filter(
      (K) => !o.includes(K.id)
    )), l([
      ...F.map((K) => ({
        ...K,
        type: "ISSUE",
        key: {
          number: K.number,
          owner: K.repository.owner.login,
          repository: K.repository.name
        }
      })),
      ...L.map((K) => ({
        ...K,
        type: "PR",
        key: {
          number: K.number,
          owner: K.repository.owner.login,
          repository: K.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function j(F) {
    const L = F?.trim();
    if (E_.test(L)) {
      const [K, J, re, W] = L.match(E_) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: re,
        number: parseInt(W)
      };
    }
    if ($_.test(L)) {
      const [K, J, re, W] = L.match($_) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: re,
        number: parseInt(W)
      };
    }
  }
  const _ = (F) => {
    e({
      key: ED(F),
      type: F.type
    }), u(void 0);
  }, g = (F) => {
    const L = j(F);
    u(
      L ? `org:${L.owner} repo:${L.repository} ${L.number}` : `org:${n} ${F}`
    );
  }, D = () => {
    u(void 0);
  }, O = ({ className: F, searched: L }) => /* @__PURE__ */ _e.jsx(
    rP,
    {
      className: F,
      searched: L,
      githubOrganization: n
    }
  ), I = ({ item: F, onSelect: L }) => /* @__PURE__ */ _e.jsx(tP, { item: F, onSelect: L });
  return !h && k ? /* @__PURE__ */ _e.jsx(En, { error: k }) : /* @__PURE__ */ _e.jsx(
    $r,
    {
      items: s?.map((F) => ({ name: F.title, ...F })),
      loading: h,
      onSearch: g,
      onSelect: _,
      onClear: D,
      emptyMessage: p ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: O,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, oP = "_itemButton_3sxfy_1", sP = "_result_3sxfy_6", lP = "_resultName_3sxfy_30", cP = "_resultCheckIcon_3sxfy_38", dP = "_resultAssigneeIcon_3sxfy_41", Ba = {
  itemButton: oP,
  result: sP,
  resultName: lP,
  resultCheckIcon: cP,
  resultAssigneeIcon: dP
}, RC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ _e.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ _e.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Ba.itemButton,
        children: /* @__PURE__ */ _e.jsxs(b, { className: Ba.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ _e.jsx(st, { margin: "100 0", children: /* @__PURE__ */ _e.jsx(
            "img",
            {
              className: Ba.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ _e.jsx(st, { className: Ba.resultName, children: e.name }),
          n && /* @__PURE__ */ _e.jsx(st, { className: Ba.resultCheckIcon, children: /* @__PURE__ */ _e.jsx(ve, { name: "done" }) })
        ] })
      }
    )
  }
), uP = Ca(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), mP = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = me([]), [l, d] = me(""), p = 2, [u, { loading: f, error: h, data: k, networkStatus: C }] = a(
    uP,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return yi(
    () => {
      !f && l && l.length >= p && C === tr.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const N = k?.GitHub?.organization?.teams || { edges: [] }, j = [];
    N?.edges?.forEach((_) => {
      const g = _?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((D) => {
        const O = D?.node;
        O && (O?.id && j.find((I) => I.id === O.id) || j.push(O));
      });
    }), s(
      j.sort((_, g) => {
        const D = _.name?.toLowerCase() || _.login?.toLowerCase(), O = g.name?.toLowerCase() || g.login?.toLowerCase();
        return D.localeCompare(O, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [k]), !f && h ? /* @__PURE__ */ _e.jsx(En, { error: h }) : /* @__PURE__ */ _e.jsx(
    $r,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: N, name: j, login: _, avatarUrl: g }) => ({
        id: N,
        name: j || _,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (N) => d(N),
      onChange: (N, j) => {
        const _ = N.id;
        i ? (j && !n.find(
          (g) => g.id === _
        ) && n.push(N), j || (n = n.filter(
          (g) => g.id !== _
        ))) : n = j ? [N] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ _e.jsx(
        RC,
        {
          item: N,
          checked: _,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, pP = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ _e.jsx(cr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ _e.jsx(
        $r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ _e.jsx(
        Sl,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ _e.jsx(cr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ _e.jsx(
        $r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ _e.jsx(cr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ _e.jsx(bh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ _e.jsx(
        mP,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, fP = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ _e.jsx(
  bt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ _e.jsx(
      We,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: pP({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), hP = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ _e.jsxs($.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ _e.jsx(ve, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ _e.jsx(We, { label: "GitHub issue link", children: /* @__PURE__ */ _e.jsx(
          cr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, yP = "_modalBody_1hk1o_1", gP = "_modalBodyFormFields_1hk1o_4", Hu = {
  modalBody: yP,
  modalBodyFormFields: gP
}, vP = Ca(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), kP = Ca(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), bP = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], _P = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = hn(), { track: d } = Cn(), {
    control: p,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: k
  } = ut(), [C, N] = me(""), [j, _] = me([]), [g, D] = me(), [O, I] = me(!1), [F, L] = me(!1), [K, J] = $C(), [
    re,
    {
      loading: W,
      error: Y,
      networkStatus: P
    }
  ] = s(vP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Oe) => {
      _(
        Oe.GitHub.search?.edges?.map((q) => q?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), _([]);
    }
  });
  yi(
    () => {
      !W && C && P === tr.ready ? re({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : _([]);
    },
    500,
    [C]
  );
  const [B, { error: ee }] = l(
    kP,
    {
      onError: (Oe) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Oe);
      },
      onCompleted: (Oe) => {
        I(!1);
        const q = Oe.GitHub.createIssue?.issue;
        D(q), o({
          title: "Success",
          text: `GitHub issue '${q.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: q.repository.name,
          number: q.number
        });
      }
    }
  ), Ne = (Oe) => {
    N(`org:${a} ${Oe}`);
  }, ue = (Oe, q) => {
    q(Oe), N("");
  }, oe = () => {
    N("");
  }, fe = (Oe) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), B({
      variables: {
        input: {
          repositoryId: Oe.repository.id,
          title: Oe.title,
          body: Oe.body,
          assigneeIds: Oe.assignees?.length > 0 ? Oe.assignees.map((q) => q.id) : void 0
        }
      }
    });
  };
  Qe(() => {
    const Oe = F ? window.setTimeout(() => L(!1), 2e3) : void 0;
    return () => window.clearTimeout(Oe);
  }, [F]);
  const V = () => {
    N(""), _([]), D(void 0), I(!1), L(!1);
  }, ke = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), V(), h(), n();
  };
  return /* @__PURE__ */ _e.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: ke,
      children: [
        /* @__PURE__ */ _e.jsx(
          Ct,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: ke
          }
        ),
        /* @__PURE__ */ _e.jsxs(Ft, { className: Hu.modalBody, children: [
          !W && Y && /* @__PURE__ */ _e.jsx(En, { error: Y }),
          !O && ee && /* @__PURE__ */ _e.jsx(En, { error: ee }),
          g ? /* @__PURE__ */ _e.jsx(
            hP,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: F,
              setIssueLinkCopied: L,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ _e.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(fe),
              children: /* @__PURE__ */ _e.jsxs(nt, { children: [
                /* @__PURE__ */ _e.jsx(Z, { children: /* @__PURE__ */ _e.jsx(We, { label: "Repository", required: !0, children: /* @__PURE__ */ _e.jsx(
                  bt,
                  {
                    control: p,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Oe, value: q } }) => /* @__PURE__ */ _e.jsx(
                      $r,
                      {
                        className: Hu.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: W,
                        onSearch: Ne,
                        onSelect: (Ge) => ue(Ge, Oe),
                        onClear: oe,
                        selectedItems: [q],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: Y ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Ge, onSelect: sn, checked: Ie }) => /* @__PURE__ */ _e.jsx(
                          RC,
                          {
                            item: Ge,
                            checked: Ie,
                            onSelectItem: sn
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ _e.jsx(Z, { className: Hu.modalBodyFormFields, children: /* @__PURE__ */ _e.jsx(
                  fP,
                  {
                    control: p,
                    errors: f,
                    getValues: k,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: bP
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ _e.jsx(
          Et,
          {
            confirmOnClick: g ? ke : u(fe),
            confirmProps: {
              isLoading: O,
              loadingIndicator: /* @__PURE__ */ _e.jsx(fn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : ke
          }
        )
      ]
    }
  );
}, xP = "_wrapper_19v8w_1", SP = "_inputWrapper_19v8w_6", NP = "_buttonLink_19v8w_19", jP = "_noItemsFound_19v8w_23", wP = "_createIssueButton_19v8w_28", Ji = {
  wrapper: xP,
  inputWrapper: SP,
  buttonLink: NP,
  noItemsFound: jP,
  createIssueButton: wP
}, CP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1), { track: a } = Cn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: p,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: k,
    danglingIssueLinks: C,
    danglingPullRequestLinks: N,
    isLoadingGithubItems: j,
    issues: _,
    pullRequests: g,
    error: D
  } = $D({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), O = (J) => d({ key: J, type: "ISSUE" }), I = !(!!_?.length).valueOf() && !(!!g?.length).valueOf() && !(!!C?.length).valueOf() && !(!!N?.length).valueOf(), F = !k && !j && !!C?.length && !!N?.length && !!n?.showDanglingLinks, L = n?.enableCreateIssue, K = !!_?.length || !!g?.length;
  return !j && D ? /* @__PURE__ */ _e.jsx(En, { error: D, retry: () => u() }) : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(b, { className: Ji.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsxs(b, { className: Ji.inputWrapper, flexDirection: "column", children: [
        L && /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
          /* @__PURE__ */ _e.jsx(
            ct,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Ji.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ _e.jsx("div", { className: Ji.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ _e.jsx(
          aP,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: _,
            linkedPullRequests: g
          }
        )
      ] }),
      j ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(fn, { "data-testid": "github-widget-item-spinner" }) }) : K ? /* @__PURE__ */ _e.jsx(
        KD,
        {
          items: [..._, ...g],
          unlinkGithubItem: p,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ _e.jsx($.Paragraph, { align: "center", className: Ji.noItemsFound, children: "No linked items found." }),
      F && /* @__PURE__ */ _e.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ _e.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ _e.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((J) => /* @__PURE__ */ _e.jsx(
                Jn,
                {
                  onDelete: () => p({
                    key: J,
                    type: "ISSUE"
                  }),
                  children: vr(J)
                },
                vr(J)
              )),
              N.map((J) => /* @__PURE__ */ _e.jsx(
                Jn,
                {
                  onDelete: () => p({ key: J, type: "PR" }),
                  children: vr(J)
                },
                vr(J)
              ))
            ] }),
            /* @__PURE__ */ _e.jsx(
              ct,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && K && /* @__PURE__ */ _e.jsx(
        ct,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ _e.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ _e.jsx(ve, { name: "external-link" }),
          variant: "tertiary",
          className: Ji.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsx(
      _P,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: O,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Ih = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], bi = "GITHUB", FP = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, IP = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: FP
  }), {
    create: d,
    update: p,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = dr({
    integrationId: e,
    integrationType: bi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = ur({
    integrationId: e,
    fieldDefinitions: Ih,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = mr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => fr(J, {
    fieldDefinitions: Ih,
    isCreationMode: s,
    create: d,
    update: p,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ _e.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ _e.jsx(hr, { cause: k }),
        /* @__PURE__ */ _e.jsxs(nt, { children: [
          /* @__PURE__ */ _e.jsx(Z, { children: /* @__PURE__ */ _e.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Pn,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(We, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(We, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(We, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ _e.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: bi,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ _e.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          yr,
          {
            integrationType: bi,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ _e.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ _e.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  bi,
                  " integration, all links between Dixa and ",
                  bi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
                  "All data in ",
                  bi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  bi,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Wu = { exports: {} }, qa = {}, T_;
function EP() {
  if (T_) return qa;
  T_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return qa.Fragment = r, qa.jsx = s, qa.jsxs = s, qa;
}
var is = {}, O_;
function $P() {
  return O_ || (O_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    is.Fragment = i, is.jsx = zn, is.jsxs = Wn;
  })()), is;
}
var R_;
function TP() {
  return R_ || (R_ = 1, process.env.NODE_ENV === "production" ? Wu.exports = EP() : Wu.exports = $P()), Wu.exports;
}
var we = TP(), go = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(go || {}), Fi = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Fi || {}), Xt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Xt || {});
const OP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, RP = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": OP
};
function DP(e) {
  return RP[e] ?? {};
}
const PP = DP(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), D_ = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, DC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, AP = "_listItem_16pij_4", LP = "_clickableIcon_16pij_15", Oo = {
  listItem: AP,
  clickableIcon: LP
}, PC = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = me(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ we.jsx(ve, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Oo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ we.jsx(
              ve,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ we.jsx(Ye, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: p, quantity: u, price: f, image: h, sku: k } = l, C = l.currency ?? r;
      return /* @__PURE__ */ we.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ we.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ we.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: p }),
            f != null && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: DC(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ we.jsx(_a, { src: h, alt: p ?? "Product image" }),
          className: Oo.listItem
        },
        `item-${d}-${k}`
      );
    }) })
  ] }) });
}, VP = "_boxWrapper_89s7l_1", zP = "_trackButton_89s7l_10", P_ = {
  boxWrapper: VP,
  trackButton: zP
}, UP = {
  [Xt.StepUnknown]: "Unknown",
  [Xt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Xt.StepPreparedByMerchant]: "Prepared by merchant",
  [Xt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Xt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Xt.StepOnRoute]: "On route",
  [Xt.StepDeliveredToPickupPoint]: "At pickup point",
  [Xt.StepDeliveredToConsumer]: "Delivered to customer",
  [Xt.StepDeliveredToMerchant]: "Returned to merchant",
  [Xt.StepReturnRequested]: "Return requested",
  [Xt.StepSentBack]: "Sent back",
  [Xt.StepTerminated]: "Terminated",
  [Xt.StepAwaitingSupplier]: "Awaiting supplier"
}, MP = {
  [Fi.Delivery]: "Home delivery",
  [Fi.Pickup]: "Pickup point",
  [Fi.Instore]: "In-store pickup",
  [Fi.Mailbox]: "Mailbox",
  [Fi.Inwarehouse]: "Warehouse",
  [Fi.Unknown]: "Unknown"
}, BP = {
  [go.Outbound]: "From merchant to customer",
  [go.Return]: "Return from customer to merchant",
  [go.Unspecified]: "Unspecified",
  [go.UnknownDirectionType]: "Unknown"
}, qP = (e) => e ? UP[e] ?? e : "", HP = (e) => e ? MP[e] ?? e : "", WP = (e) => e ? BP[e] ?? e : "", KP = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, GP = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: p,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, k = p || l || i, C = a?.filter((O) => O?.time !== ""), N = qP(C?.[0]?.step), j = HP(u), _ = WP(f), g = KP(e.location?.address), D = 14;
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: P_.boxWrapper,
      children: [
        /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-4", children: k }),
        /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(
              ve,
              {
                size: D,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
            ve,
            {
              size: D,
              name: n ? "done" : "copy",
              className: Oo.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        N && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        _ && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: _ })
          ] })
        ] }),
        h && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ we.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
              D_(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: D_(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "info", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        g && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ we.jsx(PC, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ we.jsxs(
          Lt,
          {
            variant: "secondary",
            className: P_.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ we.jsx(ve, { name: "external-link" }),
            children: [
              "Track on ",
              k ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, YP = "_order_135ze_1", JP = "_orderIsOpen_135ze_9", QP = "_orderHeader_135ze_12", Ku = {
  order: YP,
  orderIsOpen: JP,
  orderHeader: QP
}, A_ = "No order number found", XP = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { isCopied: a, copy: o } = Jt(), { isCopied: s, copy: l } = Jt();
  if (!e)
    return null;
  const { cart: d, parcels: p, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), k = d?.currency || "", C = d?.prices?.total?.price ?? 0, N = DC(C / 100, k), j = 14, _ = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      className: dt(Ku.order, {
        [Ku.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ we.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ku.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsxs($.Paragraph, { variant: "4", children: [
                  "From ",
                  _
                ] }),
                h ? /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: /* @__PURE__ */ we.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: A_ })
              ] }),
              /* @__PURE__ */ we.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(ve, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: A_ }) })
              ] })
            ] }),
            h && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ we.jsx(
              ve,
              {
                size: j,
                name: s ? "done" : "copy",
                className: Oo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(
                ve,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
              ve,
              {
                size: j,
                name: a ? "done" : "copy",
                className: Oo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(ve, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(ve, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: N })
            ] })
          ] }),
          /* @__PURE__ */ we.jsx(
            PC,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((g) => g),
              currency: d?.currency
            }
          ),
          p && /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-4", children: "Parcels" }),
              p.length > 0 && /* @__PURE__ */ we.jsx(Mn, { variant: "success", size: "small", children: p.length })
            ] }),
            p.length === 0 && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            p.map((g, D) => /* @__PURE__ */ we.jsx(
              GP,
              {
                parcel: g
              },
              `parcel-${D}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, ZP = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, L_ = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, eA = (e) => [...e].sort(
  (n, r) => L_(r) - L_(n)
), nA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = hn(), [r, i] = me([]), a = !e, { data: o, loading: s, error: l } = n(PP, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, p = l ? YF({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? rw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      eA(
        ZP(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ we.jsx(fn, {}) }) : p || !d && !l ? /* @__PURE__ */ we.jsx($.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ we.jsx($.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ we.jsx(En, { error: l }) : /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ we.jsx(Mn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ we.jsx(
      XP,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, tA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ we.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ we.jsx(nA, { customerEmail: n })
    }
  );
}, Eh = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], rA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, iA = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: rA
  }), {
    create: l,
    update: d,
    remove: p,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: Eh,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => fr(K, {
    fieldDefinitions: Eh,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ we.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ we.jsx(hr, { cause: h }),
        /* @__PURE__ */ we.jsxs(nt, { children: [
          /* @__PURE__ */ we.jsx(Z, { children: /* @__PURE__ */ we.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ we.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(We, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ we.jsx(
            bn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            Pn,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            Ir,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ we.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          yr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Gu = { exports: {} }, Ha = {}, V_;
function aA() {
  if (V_) return Ha;
  V_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ha.Fragment = r, Ha.jsx = s, Ha.jsxs = s, Ha;
}
var as = {}, z_;
function oA() {
  return z_ || (z_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    as.Fragment = i, as.jsx = zn, as.jsxs = Wn;
  })()), as;
}
var U_;
function sA() {
  return U_ || (U_ = 1, process.env.NODE_ENV === "production" ? Gu.exports = aA() : Gu.exports = oA()), Gu.exports;
}
var pe = sA();
const Qy = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Qy(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, lA = "_jiraCode_h30p6_1", cA = "_jiraCodeInline_h30p6_8", Yu = {
  jiraCode: lA,
  jiraCodeInline: cA
}, AC = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ pe.jsx(pe.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ pe.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ pe.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ pe.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ pe.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ pe.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ pe.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ pe.jsx("pre", { children: /* @__PURE__ */ pe.jsx("code", { className: Yu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ pe.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ pe.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ pe.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ pe.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ pe.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ pe.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ pe.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ pe.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ pe.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ pe.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ pe.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ pe.jsx("code", { className: dt(Yu.jiraCode, Yu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, al = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = me(!1);
  return !e || i ? /* @__PURE__ */ pe.jsx(ve, { size: r, name: "question", className: n }) : /* @__PURE__ */ pe.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, dA = "_collapse_m2gjh_1", uA = "_collapseHeader_m2gjh_10", mA = "_collapseHeaderLink_m2gjh_31", pA = "_collapseHeaderStatus_m2gjh_40", fA = "_collapseHeaderTitle_m2gjh_51", hA = "_collapseContent_m2gjh_59", yA = "_collapseContentHeadline_m2gjh_62", gA = "_collapseContentButtonSpacer_m2gjh_68", vA = "_collapseContentButtonLink_m2gjh_71", kA = "_collapseContentStatusTag_m2gjh_74", bA = "_collapseContentDescription_m2gjh_77", Sr = {
  collapse: dA,
  collapseHeader: uA,
  collapseHeaderLink: mA,
  collapseHeaderStatus: pA,
  collapseHeaderTitle: fA,
  collapseContent: hA,
  collapseContentHeadline: yA,
  collapseContentButtonSpacer: gA,
  collapseContentButtonLink: vA,
  collapseContentStatusTag: kA,
  collapseContentDescription: bA
}, LC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, _A = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, p) => p?.id ? { ...d, [p.id]: !1 } : d,
    {}
  ), [a, o] = me(i), { track: s } = Cn(), l = (d, p) => {
    o({ ...a, [d]: p });
  };
  return /* @__PURE__ */ pe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: p, description: u, status: f, issuetype: h } = d?.fields || {}, k = LC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ pe.jsxs(
      br,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: Sr.collapse,
        children: [
          /* @__PURE__ */ pe.jsx(br.Header, { className: Sr.collapseHeader, children: /* @__PURE__ */ pe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ pe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ pe.jsx(al, { width: 16, iconUrl: k }),
                    /* @__PURE__ */ pe.jsx(
                      "a",
                      {
                        className: Sr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (N) => {
                          N.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ pe.jsx(ve, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ pe.jsx("span", { className: Sr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ pe.jsx(Jn, { className: Sr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ pe.jsx("div", { className: Sr.collapseHeaderTitle, children: p })
              ]
            }
          ) }),
          /* @__PURE__ */ pe.jsx(br.Content, { className: Sr.collapseContent, children: /* @__PURE__ */ pe.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ pe.jsx("div", { className: Sr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ pe.jsx(st, { className: Sr.collapseContentDescription, children: u ? Qy(u, AC) : "" }),
            /* @__PURE__ */ pe.jsx(
              ct,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Sr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ pe.jsx(
              Lt,
              {
                slotEnd: /* @__PURE__ */ pe.jsx(ve, { name: "external-link" }),
                variant: "tertiary",
                className: Sr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ pe.jsx(pe.Fragment, {}) });
}, xA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, SA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, NA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, jA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, wA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, CA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, FA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, IA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': xA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": SA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": NA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": jA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': wA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': CA,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": FA
};
function Bi(e) {
  return IA[e] ?? {};
}
const VC = Bi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), EA = Bi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), $A = Bi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), TA = Bi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), OA = Bi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), RA = Bi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), DA = Bi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Xy = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), PA = new RegExp(`^${Xy.source}$`), AA = new RegExp(`/${Xy.source}$`), M_ = new RegExp(
  `.+?[&?]selectedIssue=(${Xy.source})[&?]?.*`
);
function zC(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = me([]), [o, s] = me([]), [l, d] = me(), { track: p } = Cn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: k } = hn(), {
    loading: C,
    data: N,
    error: j,
    store: _
  } = dy(e ?? null), [
    g,
    { loading: D, error: O, data: I }
  ] = h(VC, {
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    const oe = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    oe?.length && (s(oe), a(oe.map((fe) => fe?.key).filter(Boolean)));
  }, [I]), Qe(
    () => d(j || O || void 0),
    [j, O]
  ), Qe(
    () => {
      C || Y();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N?.jira?.issues, C]
  );
  const F = async (oe, fe) => {
    await _(oe).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: fe.success.title,
        text: fe.success.text
      });
    }).catch((V) => {
      u({
        title: fe.error.title,
        text: `${fe.error.text} ${V.message && " (" + V.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [L] = k(EA, {
    onError: (oe) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${oe.message && " (" + oe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), K = (oe, fe) => {
    const V = window.location.href, ke = fe ? V.replace(
      e?.toString() ?? "",
      fe?.toString()
    ) : V, Oe = fe ? `# ${fe}` : `# ${e}`;
    L({
      variables: {
        issueKey: oe,
        title: Oe,
        url: ke,
        globalId: `system=${ke}`
      }
    });
  }, [J] = k($A, {
    onError: (oe) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${oe.message && " (" + oe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), re = (oe) => {
    const fe = window.location.href;
    J({
      variables: {
        issueKey: oe,
        globalId: `system=${fe}`
      }
    });
  }, W = (oe) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: oe
  }), Y = () => {
    N && N.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${N?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, P = async (oe, fe) => {
    p("jira:issue:link:clicked", W(oe));
    const V = N?.jira?.issues ? N : r;
    V.jira.issues = Array.from(
      new Set(V.jira.issues).add(oe)
    ), await _(V, fe?.toString()).then(() => K(oe, fe)).catch((ke) => {
      u({
        title: "Linking failed",
        text: `Linking ${oe} failed. Please try again. ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (oe) => {
    p("jira:issue:link:clicked", W(oe));
    const fe = N?.jira?.issues ? N : r;
    fe.jira.issues = Array.from(
      new Set(fe.jira.issues).add(oe)
    ), F(fe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${oe} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${oe} failed. Please try again.`
      }
    }).then(() => K(oe));
  }, ee = (oe) => {
    p("jira:issue:unlink:clicked", W(oe)), f({
      headline: `Unlink issue ${oe}?`,
      text: `You are about to unlink the issue ${oe}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink:confirmed", W(oe));
        const fe = {
          ...N,
          jira: {
            ...N?.jira,
            issues: N?.jira?.issues.filter((V) => V !== oe) || []
          }
        };
        F(fe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${oe}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${oe} failed.`
          }
        }).then(() => re(oe));
      },
      onCancel: () => p("jira:issue:unlink:cancelled", W(oe))
    });
  }, Ne = () => {
    p("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((oe) => oe?.key && re(oe.key)), F(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => p("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ue = N?.jira?.issues?.filter(
    (oe) => !i?.includes(oe)
  ) || [];
  return {
    linkIssue: B,
    linkIssueQuietly: P,
    unlinkIssue: ee,
    loadIssues: Y,
    removeDanglingIssueLinks: () => {
      p("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const oe = {
        ...N,
        jira: {
          ...N?.jira,
          issues: N?.jira?.issues.filter(
            (fe) => !ue.includes(fe)
          ) || []
        }
      };
      _(oe);
    },
    unlinkAllIssues: Ne,
    maybeExtractIssueKey: (oe) => {
      const fe = oe.replace(/\s/g, "");
      if (PA.test(fe))
        return fe;
      if (M_.test(oe))
        return oe.match(M_)?.[1];
      if (oe.startsWith(n) && AA.test(oe))
        return oe.substring(oe.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: ue,
    isLoadingIssues: D,
    issues: o,
    error: l
  };
}
function LA(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const VA = "_result_1wiub_54", zA = "_resultName_1wiub_74", UA = "_resultNameIcon_1wiub_82", MA = "_resultDescription_1wiub_87", BA = "_resultLinkIcon_1wiub_99", qA = "_tooltip_1wiub_108", HA = "_tooltipContent_1wiub_114", WA = "_tooltipName_1wiub_121", KA = "_tooltipNameIcon_1wiub_126", GA = "_tooltipDescription_1wiub_131", YA = "_tooltipSummary_1wiub_139", JA = "_tooltipTag_1wiub_143", gr = {
  result: VA,
  resultName: zA,
  resultNameIcon: UA,
  resultDescription: MA,
  resultLinkIcon: BA,
  tooltip: qA,
  tooltipContent: HA,
  tooltipName: WA,
  tooltipNameIcon: KA,
  tooltipDescription: GA,
  tooltipSummary: YA,
  tooltipTag: JA
}, QA = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: p } = e, [u, f] = me(!1), h = LC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ pe.jsx(
    Xe,
    {
      disabled: i,
      className: gr.tooltip,
      content: /* @__PURE__ */ pe.jsxs("div", { className: gr.tooltipContent, children: [
        /* @__PURE__ */ pe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ pe.jsxs("span", { className: gr.tooltipName, children: [
                /* @__PURE__ */ pe.jsx(
                  al,
                  {
                    width: 16,
                    iconUrl: h,
                    className: gr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ pe.jsx(Jn, { className: gr.tooltipTag, children: l.name })
            ]
          }
        ),
        p && /* @__PURE__ */ pe.jsx("div", { className: gr.tooltipSummary, children: p }),
        d && /* @__PURE__ */ pe.jsx("div", { className: gr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ pe.jsxs(
        "button",
        {
          ...a,
          className: gr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ pe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ pe.jsxs("span", { className: gr.resultName, children: [
                    /* @__PURE__ */ pe.jsx(
                      al,
                      {
                        width: 16,
                        iconUrl: h,
                        className: gr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  p && /* @__PURE__ */ pe.jsx("div", { className: gr.resultDescription, children: p })
                ]
              }
            ),
            u && /* @__PURE__ */ pe.jsx(
              ve,
              {
                className: gr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, XA = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ pe.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ pe.jsx(ve, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), ZA = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = me([]), [l, d] = me(""), [p, { loading: u, error: f, data: h, networkStatus: k }] = a(VC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = zC(null, n);
  yi(
    () => {
      !u && l && k === tr.ready ? p({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const O = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      O.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? Qy(I?.fields.description, AC) : /* @__PURE__ */ pe.jsx(pe.Fragment, {})
      }))
    );
  }, [h]);
  const N = (O) => {
    e(O.id), d("");
  }, j = (O) => {
    const I = O.trim(), F = C(I);
    if (F) {
      const L = F.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${L}'`);
    } else I !== "" && d(
      `text ~ '${I}'${r ? " and project = " + r : ""}`
    );
  }, _ = () => {
    d("");
  }, g = (O) => /* @__PURE__ */ pe.jsx(XA, { ...O, jiraInstanceUrl: n }), D = (O) => /* @__PURE__ */ pe.jsx(
    QA,
    {
      ...O,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ pe.jsx(En, { error: f }) : /* @__PURE__ */ pe.jsx(
    $r,
    {
      items: o,
      loading: u,
      onSearch: j,
      onSelect: N,
      onClear: _,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: D,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, e2 = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = me(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return Qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ pe.jsx(
    $r,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, n2 = "_itemButton_1hl53_1", t2 = "_result_1hl53_6", r2 = "_resultIcon_1hl53_26", i2 = "_resultName_1hl53_30", a2 = "_resultCheckIcon_1hl53_38", Wa = {
  itemButton: n2,
  result: t2,
  resultIcon: r2,
  resultName: i2,
  resultCheckIcon: a2
}, $h = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ pe.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ pe.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Wa.itemButton,
          children: /* @__PURE__ */ pe.jsxs(b, { className: Wa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ pe.jsx(
              al,
              {
                width: 36,
                iconUrl: o || "",
                className: Wa.resultIcon
              }
            ),
            /* @__PURE__ */ pe.jsx(st, { className: Wa.resultName, children: e.name }),
            n && /* @__PURE__ */ pe.jsx(st, { className: Wa.resultCheckIcon, children: /* @__PURE__ */ pe.jsx(ve, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, o2 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = me([]), [l, d] = me(), p = 2, [u, { loading: f, error: h, data: k, networkStatus: C }] = a(DA, {
    notifyOnNetworkStatusChange: !0
  });
  return yi(
    () => {
      !f && l && l.length >= p && C === tr.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((N) => {
      if (N?.data?.Jira.findUsers?.length === 1) {
        const j = N?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), Qe(() => {
    const N = k?.Jira?.findUsers || [];
    s(
      N.filter(({ active: j }) => j).map(({ accountId: j, displayName: _, avatarUrls: g, active: D }) => ({
        id: j,
        name: _,
        avatarUrls: g,
        active: D
      }))
    );
  }, [k]), !f && h ? /* @__PURE__ */ pe.jsx(En, { error: h }) : /* @__PURE__ */ pe.jsx(
    $r,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (N) => d(N),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ pe.jsx(
        $h,
        {
          item: N,
          checked: _,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, B_ = ({
  field: e
}) => {
  const [n, r] = me(!1), [i, a] = $C();
  return Qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ pe.jsx(b, { children: /* @__PURE__ */ pe.jsx(ve, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ pe.jsx($.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ pe.jsx(Xe, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ pe.jsx(
      rr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, s2 = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ pe.jsx(B_, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ pe.jsx(cr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ pe.jsx(bh, { onChange: n, value: r }) : /* @__PURE__ */ pe.jsx(cr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ pe.jsx(bh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ pe.jsx(cr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ pe.jsx(
        o2,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ pe.jsx(
        $r,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: p }) => ({
              id: l,
              name: d || p
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ pe.jsx(e2, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ pe.jsx(B_, { field: e });
  }
}, l2 = ["description", "reporter", "summary"], c2 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ pe.jsx(pe.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || l2.includes(o)
).map((o) => /* @__PURE__ */ pe.jsx(
  bt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ pe.jsx(
      We,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: s2({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), d2 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ pe.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ pe.jsxs(
          $.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ pe.jsx(ve, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ pe.jsx(We, { label: "Jira issue link", children: /* @__PURE__ */ pe.jsx(
        cr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), u2 = "_modalBody_1hk1o_1", m2 = "_modalBodyFormFields_1hk1o_4", q_ = {
  modalBody: u2,
  modalBodyFormFields: m2
}, p2 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), f2 = (e) => e?.custom?.split(":")?.[1] || null, h2 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, y2 = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = h2(a, n), l = f2(s) ?? a;
        return r.includes(l) ? i[a] = p2(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, g2 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = me([]), [p, u] = me(), [f, h] = me(0), [k, C] = me([]), [N, j] = me([]), [_, g] = me(!1), [D, O] = me(!1), [I, F] = me({}), { track: L } = Cn(), { isCopied: K, copyToClipboard: J } = LA(), re = Qn(() => i?.conversationId, [e]), { useMutation: W, useLazyQuery: Y, showNotification: P } = hn(), {
    control: B,
    handleSubmit: ee,
    formState: { errors: Ne },
    reset: ue,
    setValue: oe,
    getValues: fe
  } = ut({
    defaultValues: s
  }), V = N.length > 0, ke = `${a}/browse`, Oe = Object.keys(I).length > 0, [q, { loading: Ge, error: sn }] = Y(TA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      d(le.Jira.getAllProjects);
    },
    onError: (le) => {
      P({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", le), d([]);
    }
  }), [
    Ie,
    { loading: Ue, error: De }
  ] = Y(OA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      h(0);
      const xe = le?.Jira?.getCreateIssueMeta?.projects[0];
      if (xe) {
        const Ve = xe?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        C(Ve || []), oe(
          "issuetype",
          Ve.length > 0 ? Ve[0] : void 0
        );
      } else
        P({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), j([]);
    },
    onError: (le) => {
      P({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", le), C([]), j([]), h(0);
    }
  }), [Be, { error: Ae }] = W(
    RA,
    {
      onError: () => {
        g(!1), P({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), L("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (le) => {
        if (g(!1), le?.Jira && "key" in le.Jira.createIssue)
          u(le?.Jira?.createIssue), P({
            title: "Success",
            text: `Jira issue '${le.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), L("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: le.Jira.createIssue.key
          }), re && r(
            le.Jira.createIssue.key,
            re
          );
        else if ("errorMessages" in le.Jira.createIssue || "errors" in le.Jira.createIssue) {
          const xe = le?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", xe), P({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Je = (le) => {
    g(!0), F({}), Be({
      variables: {
        input: y2(le, N)
      }
    });
  };
  Qe(() => {
    if (e)
      try {
        q();
      } catch (le) {
        console.warn("Error when fetching initial projects", le);
      }
  }, [e]), Qe(() => {
    const le = D ? window.setTimeout(() => O(!1), 2e3) : void 0;
    return () => window.clearTimeout(le);
  }, [D]), Qe(() => {
    if (k?.length > 0) {
      oe("issuetype", k[f]);
      const le = k[f]?.fields?.additionalProperties;
      if (le?.length > 0) {
        const xe = le.map(
          ({ value: Q }) => Q
        ), Ve = (o ? xe.sort(({ name: Q }, { name: E }) => Q.localeCompare(E)) : xe).sort(
          ({ required: Q }, { required: E }) => Number(E) - Number(Q)
        ), { project: Pe, issuetype: vn } = fe();
        ue({ project: Pe, issuetype: vn }), j(Ve);
      }
    } else
      j([]), oe("issuetype", void 0);
  }, [k, oe, f]), Qe(() => {
    if (Ae && pw(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: le } = Ae, xe = le[0].extensions?.integration?.responseBody;
        try {
          const Ve = JSON.parse(xe);
          if (Ve?.errors) {
            const Pe = Object.keys(Ve.errors).reduce(
              (vn, Q) => ({
                ...vn,
                [Q]: {
                  type: "required",
                  message: Ve.errors[Q],
                  ref: {
                    name: Q
                  }
                }
              }),
              {}
            );
            F(Pe);
          }
        } catch {
        }
      }
    } else
      F({});
  }, [Ae]);
  const $e = () => {
    d([]), j([]), C([]), u(void 0), h(0), g(!1), F({});
  }, Me = () => {
    $e(), ue(s), n();
  }, en = (le) => {
    le && Ie({
      variables: {
        projectKey: le
      }
    });
  }, se = (le) => {
    const xe = k.map((Ve) => Ve.id).indexOf(le);
    h(xe ?? 0);
  };
  return /* @__PURE__ */ pe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Me,
      children: [
        /* @__PURE__ */ pe.jsx(
          Ct,
          {
            title: p ? "Issue creation successful" : "Create new Jira issue",
            onClose: Me
          }
        ),
        /* @__PURE__ */ pe.jsxs(Ft, { className: q_.modalBody, children: [
          !Ge && sn && /* @__PURE__ */ pe.jsx(En, { error: sn, retry: q }),
          !Ue && De && /* @__PURE__ */ pe.jsx(
            En,
            {
              error: De,
              retry: Ie
            }
          ),
          !_ && Oe && /* @__PURE__ */ pe.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ pe.jsx(
            my,
            {
              variant: "warning",
              description: /* @__PURE__ */ pe.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ pe.jsx($.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ pe.jsx(
                      ct,
                      {
                        icon: K ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => J(JSON.stringify(N, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          p ? /* @__PURE__ */ pe.jsx(
            d2,
            {
              createdIssue: p,
              issueBaseLink: ke,
              issueLinkCopied: D,
              setIssueLinkCopied: O,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ pe.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(Je),
              children: /* @__PURE__ */ pe.jsxs(nt, { children: [
                /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: "Project", required: !0, children: /* @__PURE__ */ pe.jsx(
                  bt,
                  {
                    control: B,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: le, value: xe } }) => /* @__PURE__ */ pe.jsx(
                      $r,
                      {
                        searchable: !0,
                        loading: Ge,
                        onSelect: (Ve) => {
                          en(Ve.key), le(Ve);
                        },
                        selectedItems: [xe],
                        placeholder: "Select Jira project",
                        emptyMessage: sn ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: vn }) => /* @__PURE__ */ pe.jsx(
                          $h,
                          {
                            item: Ve,
                            checked: vn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: "Issue type", required: !0, children: /* @__PURE__ */ pe.jsx(
                  bt,
                  {
                    control: B,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: le, value: xe } }) => /* @__PURE__ */ pe.jsx(
                      $r,
                      {
                        disabled: k.length === 0,
                        loading: Ue,
                        onSelect: (Ve) => {
                          se(Ve.id), le(Ve);
                        },
                        selectedItems: [xe],
                        placeholder: k.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: De ? "No issues found" : "No issues available",
                        items: k,
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: vn }) => /* @__PURE__ */ pe.jsx(
                          $h,
                          {
                            item: Ve,
                            checked: vn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                V && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ pe.jsx(Z, { className: q_.modalBodyFormFields, children: /* @__PURE__ */ pe.jsx(
                  c2,
                  {
                    control: B,
                    errors: { ...Ne, ...I },
                    getValues: fe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: N
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ pe.jsx(
          Et,
          {
            confirmOnClick: p ? Me : ee(Je),
            confirmProps: {
              disabled: !V,
              isLoading: _,
              loadingIndicator: /* @__PURE__ */ pe.jsx(fn, { size: 16 })
            },
            confirmName: p ? "Close" : "Save",
            cancelOnClick: p ? void 0 : Me
          }
        )
      ]
    }
  );
}, v2 = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, k2 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, b2 = "_wrapper_1bylq_1", _2 = "_inputWrapper_1bylq_6", x2 = "_inputSeparator_1bylq_18", S2 = "_buttonLink_1bylq_23", N2 = "_noIssuesFound_1bylq_27", Ka = {
  wrapper: b2,
  inputWrapper: _2,
  inputSeparator: x2,
  buttonLink: S2,
  noIssuesFound: N2
}, j2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Cn(), i = v2(n?.jiraSiteUrl), [a, o] = me(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: p,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: k,
    isLoadingIssueLinks: C,
    isLoadingIssues: N,
    issues: j,
    error: _
  } = zC(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, D = !!n?.enableSortIssueTypeByLabel, O = !!(j?.length || k?.length), I = !!n?.enableRemoveAllLinks && O, F = !C && !N && k?.length > 0 && !!n?.showDanglingLinks;
  return !N && _ ? /* @__PURE__ */ pe.jsx(En, { error: _, retry: () => f() }) : /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
    /* @__PURE__ */ pe.jsxs(b, { className: Ka.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ pe.jsxs(b, { className: Ka.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
          /* @__PURE__ */ pe.jsx(
            ct,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ pe.jsx("div", { className: Ka.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ pe.jsx(
          ZA,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      N ? /* @__PURE__ */ pe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ pe.jsx(fn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ pe.jsx(
        _A,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: p
        }
      ) : /* @__PURE__ */ pe.jsx($.Paragraph, { align: "center", className: Ka.noIssuesFound, children: "No linked issues found" }),
      I && j?.length > 0 && /* @__PURE__ */ pe.jsx(
        ct,
        {
          variant: "secondary",
          disabled: !j?.length && !k?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      F && /* @__PURE__ */ pe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ pe.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: k.map((L) => /* @__PURE__ */ pe.jsx(Jn, { onDelete: () => p(L), children: L }, L)) }),
            /* @__PURE__ */ pe.jsx(
              ct,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ pe.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ pe.jsx(ve, { name: "external-link" }),
          variant: "tertiary",
          className: Ka.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ pe.jsx(
      g2,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: D
      }
    )
  ] });
}, Th = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], w2 = (e) => {
  const n = k2(e);
  return typeof n == "string" ? n : !0;
}, _i = "JIRA", C2 = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, F2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: C2
  }), {
    create: d,
    update: p,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = dr({
    integrationId: e,
    integrationType: _i,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = ur({
    integrationId: e,
    fieldDefinitions: Th,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = mr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => fr(J, {
    fieldDefinitions: Th,
    isCreationMode: s,
    create: d,
    update: p,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ pe.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ pe.jsx(hr, { cause: k }),
        /* @__PURE__ */ pe.jsxs(nt, { children: [
          /* @__PURE__ */ pe.jsx(Z, { children: /* @__PURE__ */ pe.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(
            Pn,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (J) => w2(J)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ pe.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: _i,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ pe.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ pe.jsx(
          yr,
          {
            integrationType: _i,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ pe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ pe.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ pe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ pe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  _i,
                  " integration, all links between Dixa and ",
                  _i,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  _i,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  _i,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ju = { exports: {} }, Ga = {}, H_;
function I2() {
  if (H_) return Ga;
  H_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var os = {}, W_;
function E2() {
  return W_ || (W_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    os.Fragment = i, os.jsx = zn, os.jsxs = Wn;
  })()), os;
}
var K_;
function $2() {
  return K_ || (K_ = 1, process.env.NODE_ENV === "production" ? Ju.exports = I2() : Ju.exports = E2()), Ju.exports;
}
var ge = $2();
function T2({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = hn(), [a, o] = me([]), [s] = i(e, n), [l, d] = me(
    []
  );
  return Qe(() => () => {
    l.forEach((p) => window.clearTimeout(p));
  }, []), [async (p) => {
    const u = [];
    for (const [f, h] of p.entries()) {
      f !== 0 && await new Promise((C) => {
        const N = setTimeout(C, r);
        d([...l, N]);
      });
      const k = await s({
        variables: h
      });
      u.push(k);
    }
    o(u);
  }, a];
}
var UC = /* @__PURE__ */ ((e) => (e.List = "list", e))(UC || {}), Oh = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(Oh || {}), Rh = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(Rh || {}), Dh = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(Dh || {});
const O2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, R2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, D2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, P2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListListResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "created" } }, { kind: "Field", name: { kind: "Name", value: "updated" } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, A2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, L2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, V2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, z2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, U2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, M2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, B2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, q2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, H2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, W2 = {
  "\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": P2,
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": O2,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": R2,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": A2,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": L2,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": D2,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": V2,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": z2,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": U2,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": M2,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": B2,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": q2,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": H2
};
function Kr(e) {
  return W2[e] ?? {};
}
const K2 = Kr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), G2 = Kr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Y2 = Kr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), J2 = Kr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Q2 = Kr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), X2 = Kr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Z2 = Kr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), eL = Kr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), nL = Kr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function Ph(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function G_(e) {
  return Ph(e) && e?.attributes?.event_properties?.$message;
}
function tL(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function Y_(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function rL(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function iL(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function aL(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function oL(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function sL(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function lL(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function J_(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function cL(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function dL(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const uL = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function mL(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function pL(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function fL({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = hn(), { track: a } = Cn(), [o, s] = me(null), [l, d] = me(
    null
  ), [p, u] = me(null), [f, h] = me(null), [k, C] = me(
    null
  ), [N, j] = me([]), {
    data: _,
    error: g,
    loading: D,
    networkStatus: O
  } = i(Y2, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: F,
      error: L,
      loading: K,
      networkStatus: J
    }
  ] = r(K2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    if (_ && !D && O === tr.ready) {
      const re = rL(_);
      s(
        re.find((W) => W?.attributes?.name === "Received Email")?.id || null
      ), d(
        re.find((W) => W?.attributes?.name === "Opened Email")?.id || null
      ), u(
        re.find((W) => W?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        re.find((W) => W?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        re.find((W) => W?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [_]), Qe(() => {
    o && l && p && f && k && !K && J === tr.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${k}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    p,
    f,
    k
  ]), Qe(() => {
    if (!K && F) {
      const re = iL(F), W = oL(
        F
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      ), Y = sL(
        F
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      );
      re.forEach((ue) => {
        const oe = ue.attributes?.event_properties.$message;
        ue.opened = W.includes(oe), ue.clicked = Y.includes(oe);
      });
      const P = aL(F), B = lL(F), ee = [
        ...re,
        ...B,
        ...P
      ].sort((ue, oe) => {
        const fe = Y_(ue), V = Y_(oe);
        return fe == null && V == null ? 0 : fe == null ? 1 : V == null ? -1 : V - fe;
      }).slice(0, n);
      j(ee);
      const Ne = ee.map((ue) => ue.id);
      a("klaviyo:messages:received", {
        emailsReceived: re.filter(
          (ue) => Ne.includes(ue.id)
        ).length,
        emailsBounced: B.filter(
          (ue) => Ne.includes(ue.id)
        ).length,
        smsReceived: P.filter(
          (ue) => Ne.includes(ue.id)
        ).length,
        total: Ne.length
      });
    } else
      j([]);
  }, [K, F]), Qn(
    () => ({
      receivedMessages: N,
      isLoading: D || K,
      error: g || L
    }),
    [
      N,
      D,
      K,
      g,
      L
    ]
  );
}
function hL({ profileId: e }) {
  const { useQuery: n } = hn(), [r, i] = me(), [a, o] = me(), {
    data: s,
    error: l,
    loading: d,
    refetch: p
  } = n(Q2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Qe(() => {
    l && o(l);
  }, [l]), Qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await p();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Qn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function yL({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = Cn(), { useLazyQuery: i } = hn(), [a, o] = me(), [s, l] = me(), [
    d,
    { data: p, error: u, loading: f }
  ] = i(J2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    if (!f && p) {
      const k = p.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByEmail || void 0, C = p.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByPhoneNumber || void 0;
      h(k, C);
    }
  }, [f, p]);
  const h = (k, C) => {
    const N = k?.data?.length === 1 && k.data[0]?.id || void 0, j = C?.data?.length === 1 && C.data[0]?.id || void 0, _ = N || j, g = !N || !j || N === j;
    if (_ && g) {
      o(N || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${N}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Qn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const Q_ = 800, gL = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, vL = 3, kL = 1.5, bL = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = vL,
  useDelayRange: a = !1
}) => {
  const o = (L) => Math.floor(Math.random() * (L.max - L.min) + L.min), [s, l] = me(0), [d, p] = me(n || Q_), [u, f] = me(r || gL), [h, k] = me(!1), [C, N] = me(!1), j = a || !!r, _ = j ? o(u) : n || Q_, [g, D] = me(_);
  mD(
    async () => {
      const L = s + 1, K = kL ** L;
      l(L), D(
        (j ? o(u) : d) * K
      ), await e().then(() => {
        N(!0), F();
      });
    },
    h ? g : null
  ), fD(() => F());
  const O = _t(() => {
    l(0), D(_);
  }, [_]), I = _t(
    (L = {}) => {
      const { delay: K, delayRange: J } = L;
      N(!1), O(), J && (f(J), D(o(J))), K && (p(K), D(K)), k(!0);
    },
    [O]
  ), F = _t(() => {
    k(!1), O();
  }, [O]);
  return Qe(() => {
    s >= i && F();
  }, [s, i, F]), Qn(
    () => ({ isRunning: h, isSuccessful: C, start: I, stop: F }),
    [h, C, I, F]
  );
}, _L = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, xL = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function SL({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = hn(), [i, a] = me(), [o, s] = me(), {
    data: l,
    error: d,
    loading: p,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? X2 : Z2,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: k,
    stop: C
  } = bL({
    query: u,
    useDelayRange: !0
  }), N = p || h;
  return Qe(() => {
    if (d)
      if (XF({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const j = _L(d);
          k({
            ...j && {
              delayRange: xL(j)
            }
          });
        }
      } else
        s(d);
  }, [d]), Qe(() => {
    if (!p && l?.Klaviyo) {
      let j = {}, _ = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (_ = l?.Klaviyo?.get_segments_for_profile), (j?.data || _?.data) && (C(), a(
        (n === "lists" ? j?.data : _?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [p, l]), Qn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: k,
      isLoading: N,
      error: o,
      networkStatus: f
    }),
    [i, N, o, f, k]
  );
}
const NL = "_notificationText_1polx_1", Zy = {
  notificationText: NL
}, Pl = ({ error: e }) => {
  const { track: n } = Cn();
  let r = e;
  if (pw(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && rw({ error: i[0] }), o = i.length === 1 && JF({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ ge.jsx(En, { error: e });
  }
  return /* @__PURE__ */ ge.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ ge.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ ge.jsx(ve, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, jL = "_message_zrl8q_54", wL = "_messageIsOpen_zrl8q_62", CL = "_messageHeader_zrl8q_65", FL = "_messageLabel_zrl8q_71", IL = "_messageText_zrl8q_74", da = {
  message: jL,
  messageIsOpen: wL,
  messageHeader: CL,
  messageLabel: FL,
  messageText: IL
}, EL = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && cL(e.flowMessage);
  return /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", className: da.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ ge.jsx($.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ ge.jsx(fn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ ge.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(
            $.Paragraph,
            {
              variant: "4",
              className: da.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", className: da.messageText, children: i })
        ]
      }
    )
  ] });
}, $L = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ ge.jsx(ge.Fragment, { children: /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ ge.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, TL = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = me(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, p = "DD MMM YYYY @ HH:mm", u = Qn(
    () => () => l ? Gn(l).format(p) : d ? Gn.unix(d).format(p) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", k = f && e.opened, C = f && e.clicked, N = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], _ = f ? "mail" : "sms";
  return /* @__PURE__ */ ge.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: dt(da.message, {
        [da.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ ge.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: da.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ ge.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ge.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ge.jsx(ve, { size: 16, name: _ }),
                  " ",
                  uL(s),
                  u && /* @__PURE__ */ ge.jsx(Mn, { size: "small", variant: "info", children: u })
                ] }),
                N && N,
                j && j
              ] }),
              /* @__PURE__ */ ge.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ ge.jsx(Nl, {}),
          tL(e) && /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(Mn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
            /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ ge.jsx(Jn, { children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ge.jsx(
                  ve,
                  {
                    size: 16,
                    color: k ? "green.400" : "red.400",
                    name: k ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ ge.jsx(Jn, { children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ge.jsx(
                  ve,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ ge.jsx(EL, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ ge.jsx($L, { event: e })
        ] })
      ]
    }
  );
}, OL = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, RL = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = me(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = fL({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = T2({
    query: G2,
    options: OL,
    delayMs: 1e3
  }), [p, u] = me([]);
  Qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((k) => Ph(k)).map((k) => G_(k));
      h.length > 0 && (i(!0), l(
        h.map((k) => ({
          messageId: k
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && Ph(h) && !h.flowMessage) {
          const k = G_(h), C = d.find((j) => (j.data && J_(j.data))?.id === k), N = C?.data && J_(C.data);
          if (N)
            return {
              ...dL(h),
              flowMessage: N
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ ge.jsx(ge.Fragment, { children: f.map((h, k) => h.graphQLErrors ? /* @__PURE__ */ ge.jsx(
    En,
    {
      error: h
    },
    `lastMessagesError${k}`
  ) : /* @__PURE__ */ ge.jsx(
    Pl,
    {
      error: h
    },
    `lastMessagesError${k}`
  )) }) : /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) : /* @__PURE__ */ ge.jsx(ge.Fragment, { children: p?.length > 0 ? /* @__PURE__ */ ge.jsx(b, { gap: "200", flexDirection: "column", children: p.map((h, k) => /* @__PURE__ */ ge.jsx(
      TL,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: k === 0
      },
      h.id
    )) }) : /* @__PURE__ */ ge.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Zy.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, DL = "_list_ld0hf_1", PL = "_listItem_ld0hf_4", ni = {
  list: DL,
  listItem: PL
}, AL = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ ge.jsx(Ye, { className: ni.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", children: QF(a) }),
          /* @__PURE__ */ ge.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Li(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, X_ = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = me(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = SL({ profileId: e, query: n });
  Qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const p = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ ge.jsx(Pl, { error: o }) : s ? /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ ge.jsx(fn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ ge.jsx(ge.Fragment, { children: u.map(
    ({ attributes: f, type: h }, k) => /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ ge.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ ge.jsx(Jn, { children: iw(h) })
    ] }) }, k)
  ) }) : r && !a ? /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ ge.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ge.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ ge.jsx(ve, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ ge.jsxs($.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ ge.jsx(Xe, { content: "Refresh lists and segments", children: /* @__PURE__ */ ge.jsx(ct, { icon: "sync", variant: "secondary", onClick: () => p(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ ge.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ ge.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, LL = 0.7, VL = 0.3, zL = (e) => e >= LL ? { variant: "error", label: "High risk" } : e >= VL ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, UL = (e) => /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), ML = (e) => {
  const n = zL(e);
  return /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ ge.jsx(Mn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, BL = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: UL(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Li(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: ML(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Li(o)
      }
    ] : []
  ];
}, qL = ({
  profile: e
}) => {
  const n = BL(e);
  return /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ ge.jsx(Ye, { className: ni.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ni.listItem, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, HL = "_tagHover_kzbzk_1", WL = "_channelUnsubscribed_kzbzk_6", Z_ = {
  tagHover: HL,
  channelUnsubscribed: WL
}, ex = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ ge.jsx(
    Xe,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ ge.jsx(
        Jn,
        {
          className: Z_.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ ge.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: dt({
                [Z_.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ ge.jsx(fn, { size: 16 }) : /* @__PURE__ */ ge.jsx(ve, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, KL = "_subscriptionError_1qhhx_1", GL = {
  subscriptionError: KL
}, YL = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = me(!1), [d, p] = me(!1), [u, f] = me(), { track: h } = Cn(), [k, C] = pD({
    channel: null,
    request: null
  }), N = mL(n), j = pL(n), _ = !!e, { useMutation: g } = hn(), [D] = g(
    eL
  ), [O] = g(
    nL
  ), I = (K) => {
    h("klaviyo:profile:subscribe:clicked", { channel: K }), C.setAll({
      channel: K,
      request: "subscribed"
    }), ((J) => D({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: Oh.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...J === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Rh.Subscribed
                        }
                      }
                    },
                    ...J === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Rh.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: UC.List,
              id: e
            }
          }
        }
      }
    }))(K).then(
      (J) => L({
        channel: K,
        mutationResponse: J,
        isSubscriptionRequest: !0
      })
    ).catch(
      (J) => L({
        channel: K,
        mutationErrorResponse: J,
        isSubscriptionRequest: !0
      })
    );
  }, F = (K) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: K }), C.setAll({
      channel: K,
      request: "unsubscribed"
    }), O({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: Oh.Profile,
                attributes: {
                  ...K === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...K === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...K === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Dh.Unsubscribed
                        }
                      }
                    },
                    ...K === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Dh.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (J) => L({
        channel: K,
        mutationResponse: J,
        isSubscriptionRequest: !1
      })
    ).catch(
      (J) => L({
        channel: K,
        mutationErrorResponse: J,
        isSubscriptionRequest: !1
      })
    );
  }, L = async ({
    channel: K,
    mutationResponse: J,
    mutationErrorResponse: re,
    isSubscriptionRequest: W
  }) => {
    const Y = re?.networkError, P = Y ? Y?.statusCode : NaN, B = J?.errors, ee = !!B && aw({
      errors: B
    });
    P === 202 ? (h(
      W ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: K }
    ), await o()) : ee ? (h(
      W ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: K,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${W ? "opt-in" : "opt-out"}.`
    )) : (h(
      W ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: K,
        reason: Y?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${W ? "opt-in" : "opt-out"}.`
    )), p(!1), l(!1);
  };
  return Qe(() => {
    if (k.request === "subscribed") {
      const K = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${k.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      k.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(K), C.reset()), k.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(K), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ ge.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ ge.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ ge.jsx(
            ex,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: N,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                l(!0), f(void 0), N ? F("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ ge.jsx(
            ex,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                p(!0), f(void 0), j ? F("SMS") : I("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ ge.jsx(b, { className: GL.subscriptionError, children: u })
      ] })
    }
  );
}, JL = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: p
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: k
  } = hL({ profileId: e });
  return f ? /* @__PURE__ */ ge.jsx(Pl, { error: f }) : h ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) : !u && !h ? /* @__PURE__ */ ge.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Zy.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ ge.jsxs(Ye, { className: ni.list, children: [
        i && /* @__PURE__ */ ge.jsx(X_, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ ge.jsx(
          X_,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ ge.jsx(
      YL,
      {
        profile: u,
        profileId: e,
        subscriptionListId: p,
        refetchProfile: k,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ ge.jsx(qL, { profile: u }),
    u && s && /* @__PURE__ */ ge.jsx(AL, { profile: u }),
    /* @__PURE__ */ ge.jsx(
      RL,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, QL = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, p = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: k,
    error: C
  } = yL({ email: r, phoneNumber: i });
  return aI(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : k ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) : C ? /* @__PURE__ */ ge.jsx(Pl, { error: C }) : f ? /* @__PURE__ */ ge.jsx(
    JL,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: p,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ ge.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Zy.notificationText,
      children: "No profile ID found"
    }
  );
}, nx = [
  { value: "3", label: "The three latest messages" },
  { value: "4", label: "The four latest messages" },
  { value: "5", label: "The five latest messages" }
], XL = ({
  control: e,
  name: n
}) => /* @__PURE__ */ ge.jsx(
  _r,
  {
    name: n,
    control: e,
    label: "Choose how many messages to show",
    rules: { required: "Please choose how many messages to show" },
    componentProps: {
      placeholder: "Select an option",
      equalityFn: (r, i) => r === i,
      getItemTitleByValue: (r) => {
        const i = nx.find(
          (a) => a.value === r
        )?.label;
        return i ? /* @__PURE__ */ ge.jsx($.Paragraph, { children: i }) : null;
      }
    },
    children: nx.map((r) => /* @__PURE__ */ ge.jsx(mt.Item, { value: r.value, children: r.label }, r.value))
  }
), ZL = "_settingsWrapper_eleyu_1", eV = {
  settingsWrapper: ZL
}, nV = Kr(
  /* GraphQL */
  `
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
          data {
            type
            id
            attributes {
              name
              created
              updated
            }
            links {
              self
            }
          }
          links {
            self
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), tx = [], tV = ({
  value: e,
  onChange: n
}) => {
  const { useQuery: r } = hn(), [i, a] = me(tx), [o, s] = me(!!e), {
    data: l,
    error: d,
    loading: p
  } = r(nV, {
    skip: !o,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    e && s(!0);
  }, [e]), Qe(() => {
    const u = l?.Klaviyo?.get_lists;
    if (o && u && !p && !d) {
      const f = u?.data?.map(
        (h) => ({
          value: h?.id,
          label: h?.attributes?.name
        })
      ) || tx;
      a(f);
    }
  }, [o, l, p, d]), /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: eV.settingsWrapper,
        children: [
          /* @__PURE__ */ ge.jsx(We, { label: "Activate re-/subscription list selection", children: /* @__PURE__ */ ge.jsx(
            cw,
            {
              input: {
                name: "subscriptionListId-switch",
                value: "switchValueFromComponent",
                checked: o,
                onChange: () => {
                  const u = !o;
                  u || n(""), s(u);
                }
              }
            }
          ) }),
          o && d && !p && /* @__PURE__ */ ge.jsx(We, { children: /* @__PURE__ */ ge.jsx(En, { error: d }) }),
          o && !d && p && /* @__PURE__ */ ge.jsx(We, { children: /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) }),
          o && !d && !p && i && /* @__PURE__ */ ge.jsx(We, { label: "Available lists to subscribe to", children: /* @__PURE__ */ ge.jsx(
            ci,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (u) => n(u?.selectedValues?.[0]?.value ?? ""),
              getItemTitleByValue: (u) => u ? /* @__PURE__ */ ge.jsx($.Paragraph, { children: u.label }) : null,
              value: e ? [
                {
                  label: (i || []).find(
                    (u) => u.value === e
                  )?.label,
                  value: e
                }
              ] : [],
              equalityFn: (u, f) => u.value === f.value,
              children: i.map((u) => /* @__PURE__ */ ge.jsx(mt.Item, { value: u, children: u.label }, u.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ ge.jsx(Z, { span: 3 })
  ] });
}, ol = [
  {
    key: "klaviyoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showProfileLists",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  // Populated by the subscribe-list selector; empty means the feature is off.
  {
    key: "subscriptionListId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "noOfMessagesToShow",
    type: "string",
    secret: !1,
    defaultValue: "5"
  }
], rV = [
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: fi
  }
], iV = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
], Qu = "KLAVIYO", aV = {
  enabled: !1,
  name: "",
  ...xl(
    [],
    ol
  )
}, oV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: aV
  }), {
    create: d,
    update: p,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = dr({
    integrationId: e,
    integrationType: Qu,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = ur({
    integrationId: e,
    fieldDefinitions: ol,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = mr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = s || !!D?.additionalProperties?.isUsingOAuth, K = (re) => fr(re, {
    fieldDefinitions: ol,
    isCreationMode: s,
    create: d,
    update: p,
    renderConditions: F
  }), J = l.watch("name");
  return /* @__PURE__ */ ge.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: K,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ ge.jsx(hr, { cause: k }),
        /* @__PURE__ */ ge.jsxs(nt, { children: [
          /* @__PURE__ */ ge.jsx(Z, { children: /* @__PURE__ */ ge.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          !L && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
            /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
              Ir,
              {
                name: "klaviyoApiKey",
                label: "API key",
                control: l.control,
                isCreationMode: s,
                rules: { required: "API key is required" },
                componentProps: {
                  placeholder: "API key from Klaviyo",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ ge.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: "Show Klaviyo lists for a profile", children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showProfileLists",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: "Show Klaviyo segments for a profile", children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showProfileSegments",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: "Show subscription channels for Klaviyo messages", children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showSubscriptions",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: "Show custom properties for a profile", children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showCustomProperties",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: "Show predictive analytics for a profile", children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showPredictiveAnalytics",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          !s && /* @__PURE__ */ ge.jsx(
            bt,
            {
              name: "subscriptionListId",
              control: l.control,
              render: ({ field: re }) => /* @__PURE__ */ ge.jsx(
                tV,
                {
                  value: re.value,
                  onChange: re.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
            XL,
            {
              name: "noOfMessagesToShow",
              control: l.control
            }
          ) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          L && !s && e && /* @__PURE__ */ ge.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Qu,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ ge.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ ge.jsx(
          yr,
          {
            integrationType: Qu,
            integrationId: e,
            widgetName: J,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
function sV(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const lV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, cV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, dV = {};
function rx(e, n) {
  return (dV.jsx ? cV : lV).test(e);
}
const uV = /[ \t\n\f\r]/g;
function mV(e) {
  return typeof e == "object" ? e.type === "text" ? ix(e.value) : !1 : ix(e);
}
function ix(e) {
  return e.replace(uV, "") === "";
}
class Mo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
Mo.prototype.property = {};
Mo.prototype.normal = {};
Mo.prototype.space = null;
function MC(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new Mo(r, i, n);
}
function Ah(e) {
  return e.toLowerCase();
}
class xr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
xr.prototype.space = null;
xr.prototype.boolean = !1;
xr.prototype.booleanish = !1;
xr.prototype.overloadedBoolean = !1;
xr.prototype.number = !1;
xr.prototype.commaSeparated = !1;
xr.prototype.spaceSeparated = !1;
xr.prototype.commaOrSpaceSeparated = !1;
xr.prototype.mustUseProperty = !1;
xr.prototype.defined = !1;
let pV = 0;
const Tn = qi(), kt = qi(), BC = qi(), Ke = qi(), ot = qi(), ua = qi(), ar = qi();
function qi() {
  return 2 ** ++pV;
}
const Lh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Tn,
  booleanish: kt,
  commaOrSpaceSeparated: ar,
  commaSeparated: ua,
  number: Ke,
  overloadedBoolean: BC,
  spaceSeparated: ot
}, Symbol.toStringTag, { value: "Module" })), Xu = Object.keys(Lh);
class eg extends xr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), ax(this, "space", a), typeof i == "number")
      for (; ++o < Xu.length; ) {
        const s = Xu[o];
        ax(this, Xu[o], (i & Lh[s]) === Lh[s]);
      }
  }
}
eg.prototype.defined = !0;
function ax(e, n, r) {
  r && (e[n] = r);
}
const fV = {}.hasOwnProperty;
function Fa(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (fV.call(e.properties, i)) {
      const a = e.properties[i], o = new eg(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Ah(i)] = i, r[Ah(o.attribute)] = i;
    }
  return new Mo(n, r, e.space);
}
const qC = Fa({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), HC = Fa({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function WC(e, n) {
  return n in e ? e[n] : n;
}
function KC(e, n) {
  return WC(e, n.toLowerCase());
}
const GC = Fa({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: KC,
  properties: { xmlns: null, xmlnsXLink: null }
}), YC = Fa({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: kt,
    ariaAutoComplete: null,
    ariaBusy: kt,
    ariaChecked: kt,
    ariaColCount: Ke,
    ariaColIndex: Ke,
    ariaColSpan: Ke,
    ariaControls: ot,
    ariaCurrent: null,
    ariaDescribedBy: ot,
    ariaDetails: null,
    ariaDisabled: kt,
    ariaDropEffect: ot,
    ariaErrorMessage: null,
    ariaExpanded: kt,
    ariaFlowTo: ot,
    ariaGrabbed: kt,
    ariaHasPopup: null,
    ariaHidden: kt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ot,
    ariaLevel: Ke,
    ariaLive: null,
    ariaModal: kt,
    ariaMultiLine: kt,
    ariaMultiSelectable: kt,
    ariaOrientation: null,
    ariaOwns: ot,
    ariaPlaceholder: null,
    ariaPosInSet: Ke,
    ariaPressed: kt,
    ariaReadOnly: kt,
    ariaRelevant: null,
    ariaRequired: kt,
    ariaRoleDescription: ot,
    ariaRowCount: Ke,
    ariaRowIndex: Ke,
    ariaRowSpan: Ke,
    ariaSelected: kt,
    ariaSetSize: Ke,
    ariaSort: null,
    ariaValueMax: Ke,
    ariaValueMin: Ke,
    ariaValueNow: Ke,
    ariaValueText: null,
    role: null
  }
}), hV = Fa({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: KC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ua,
    acceptCharset: ot,
    accessKey: ot,
    action: null,
    allow: null,
    allowFullScreen: Tn,
    allowPaymentRequest: Tn,
    allowUserMedia: Tn,
    alt: null,
    as: null,
    async: Tn,
    autoCapitalize: null,
    autoComplete: ot,
    autoFocus: Tn,
    autoPlay: Tn,
    blocking: ot,
    capture: null,
    charSet: null,
    checked: Tn,
    cite: null,
    className: ot,
    cols: Ke,
    colSpan: null,
    content: null,
    contentEditable: kt,
    controls: Tn,
    controlsList: ot,
    coords: Ke | ua,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Tn,
    defer: Tn,
    dir: null,
    dirName: null,
    disabled: Tn,
    download: BC,
    draggable: kt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Tn,
    formTarget: null,
    headers: ot,
    height: Ke,
    hidden: Tn,
    high: Ke,
    href: null,
    hrefLang: null,
    htmlFor: ot,
    httpEquiv: ot,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Tn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Tn,
    itemId: null,
    itemProp: ot,
    itemRef: ot,
    itemScope: Tn,
    itemType: ot,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Tn,
    low: Ke,
    manifest: null,
    max: null,
    maxLength: Ke,
    media: null,
    method: null,
    min: null,
    minLength: Ke,
    multiple: Tn,
    muted: Tn,
    name: null,
    nonce: null,
    noModule: Tn,
    noValidate: Tn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Tn,
    optimum: Ke,
    pattern: null,
    ping: ot,
    placeholder: null,
    playsInline: Tn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Tn,
    referrerPolicy: null,
    rel: ot,
    required: Tn,
    reversed: Tn,
    rows: Ke,
    rowSpan: Ke,
    sandbox: ot,
    scope: null,
    scoped: Tn,
    seamless: Tn,
    selected: Tn,
    shadowRootClonable: Tn,
    shadowRootDelegatesFocus: Tn,
    shadowRootMode: null,
    shape: null,
    size: Ke,
    sizes: null,
    slot: null,
    span: Ke,
    spellCheck: kt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ke,
    step: null,
    style: null,
    tabIndex: Ke,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Tn,
    useMap: null,
    value: kt,
    width: Ke,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ot,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ke,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ke,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Tn,
    // Lists. Use CSS to reduce space between items instead
    declare: Tn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ke,
    // `<img>` and `<object>`
    leftMargin: Ke,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ke,
    // `<body>`
    marginWidth: Ke,
    // `<body>`
    noResize: Tn,
    // `<frame>`
    noHref: Tn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Tn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Tn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ke,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: kt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ke,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ke,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Tn,
    disableRemotePlayback: Tn,
    prefix: null,
    property: null,
    results: Ke,
    security: null,
    unselectable: null
  }
}), yV = Fa({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: WC,
  properties: {
    about: ar,
    accentHeight: Ke,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ke,
    amplitude: Ke,
    arabicForm: null,
    ascent: Ke,
    attributeName: null,
    attributeType: null,
    azimuth: Ke,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ke,
    by: null,
    calcMode: null,
    capHeight: Ke,
    className: ot,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ke,
    diffuseConstant: Ke,
    direction: null,
    display: null,
    dur: null,
    divisor: Ke,
    dominantBaseline: null,
    download: Tn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ke,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ke,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ke,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ua,
    g2: ua,
    glyphName: ua,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ke,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ke,
    horizOriginX: Ke,
    horizOriginY: Ke,
    id: null,
    ideographic: Ke,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ke,
    k: Ke,
    k1: Ke,
    k2: Ke,
    k3: Ke,
    k4: Ke,
    kernelMatrix: ar,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ke,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ke,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ke,
    overlineThickness: Ke,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ke,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ot,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ke,
    pointsAtY: Ke,
    pointsAtZ: Ke,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ar,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ar,
    rev: ar,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ar,
    requiredFeatures: ar,
    requiredFonts: ar,
    requiredFormats: ar,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ke,
    specularExponent: Ke,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ke,
    strikethroughThickness: Ke,
    string: null,
    stroke: null,
    strokeDashArray: ar,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ke,
    strokeOpacity: Ke,
    strokeWidth: null,
    style: null,
    surfaceScale: Ke,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ar,
    tabIndex: Ke,
    tableValues: null,
    target: null,
    targetX: Ke,
    targetY: Ke,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ar,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ke,
    underlineThickness: Ke,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ke,
    values: null,
    vAlphabetic: Ke,
    vMathematical: Ke,
    vectorEffect: null,
    vHanging: Ke,
    vIdeographic: Ke,
    version: null,
    vertAdvY: Ke,
    vertOriginX: Ke,
    vertOriginY: Ke,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ke,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), gV = /^data[-\w.:]+$/i, ox = /-[a-z]/g, vV = /[A-Z]/g;
function kV(e, n) {
  const r = Ah(n);
  let i = n, a = xr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && gV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(ox, _V);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!ox.test(o)) {
        let s = o.replace(vV, bV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = eg;
  }
  return new a(i, n);
}
function bV(e) {
  return "-" + e.toLowerCase();
}
function _V(e) {
  return e.charAt(1).toUpperCase();
}
const xV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, SV = MC([HC, qC, GC, YC, hV], "html"), ng = MC([HC, qC, GC, YC, yV], "svg");
function NV(e) {
  return e.join(" ").trim();
}
var Qi = {}, Zu, sx;
function jV() {
  if (sx) return Zu;
  sx = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, p = "/", u = "*", f = "", h = "comment", k = "declaration";
  Zu = function(N, j) {
    if (typeof N != "string")
      throw new TypeError("First argument must be a string");
    if (!N) return [];
    j = j || {};
    var _ = 1, g = 1;
    function D(P) {
      var B = P.match(n);
      B && (_ += B.length);
      var ee = P.lastIndexOf(d);
      g = ~ee ? P.length - ee : g + P.length;
    }
    function O() {
      var P = { line: _, column: g };
      return function(B) {
        return B.position = new I(P), K(), B;
      };
    }
    function I(P) {
      this.start = P, this.end = { line: _, column: g }, this.source = j.source;
    }
    I.prototype.content = N;
    function F(P) {
      var B = new Error(
        j.source + ":" + _ + ":" + g + ": " + P
      );
      if (B.reason = P, B.filename = j.source, B.line = _, B.column = g, B.source = N, !j.silent) throw B;
    }
    function L(P) {
      var B = P.exec(N);
      if (B) {
        var ee = B[0];
        return D(ee), N = N.slice(ee.length), B;
      }
    }
    function K() {
      L(r);
    }
    function J(P) {
      var B;
      for (P = P || []; B = re(); )
        B !== !1 && P.push(B);
      return P;
    }
    function re() {
      var P = O();
      if (!(p != N.charAt(0) || u != N.charAt(1))) {
        for (var B = 2; f != N.charAt(B) && (u != N.charAt(B) || p != N.charAt(B + 1)); )
          ++B;
        if (B += 2, f === N.charAt(B - 1))
          return F("End of comment missing");
        var ee = N.slice(2, B - 2);
        return g += 2, D(ee), N = N.slice(B), g += 2, P({
          type: h,
          comment: ee
        });
      }
    }
    function W() {
      var P = O(), B = L(i);
      if (B) {
        if (re(), !L(a)) return F("property missing ':'");
        var ee = L(o), Ne = P({
          type: k,
          property: C(B[0].replace(e, f)),
          value: ee ? C(ee[0].replace(e, f)) : f
        });
        return L(s), Ne;
      }
    }
    function Y() {
      var P = [];
      J(P);
      for (var B; B = W(); )
        B !== !1 && (P.push(B), J(P));
      return P;
    }
    return K(), Y();
  };
  function C(N) {
    return N ? N.replace(l, f) : f;
  }
  return Zu;
}
var lx;
function wV() {
  if (lx) return Qi;
  lx = 1;
  var e = Qi && Qi.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.default = r;
  var n = e(jV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var p = d.property, u = d.value;
        l ? a(p, u, d) : u && (o = o || {}, o[p] = u);
      }
    }), o;
  }
  return Qi;
}
var CV = wV();
const cx = /* @__PURE__ */ hy(CV), FV = cx.default || cx, JC = QC("end"), tg = QC("start");
function QC(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function IV(e) {
  const n = tg(e), r = JC(e);
  if (n && r)
    return { start: n, end: r };
}
function xo(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? dx(e.position) : "start" in e || "end" in e ? dx(e) : "line" in e || "column" in e ? Vh(e) : "";
}
function Vh(e) {
  return ux(e && e.line) + ":" + ux(e && e.column);
}
function dx(e) {
  return Vh(e && e.start) + "-" + Vh(e && e.end);
}
function ux(e) {
  return e && typeof e == "number" ? e : 1;
}
class Bt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = xo(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Bt.prototype.file = "";
Bt.prototype.name = "";
Bt.prototype.reason = "";
Bt.prototype.message = "";
Bt.prototype.stack = "";
Bt.prototype.column = void 0;
Bt.prototype.line = void 0;
Bt.prototype.ancestors = void 0;
Bt.prototype.cause = void 0;
Bt.prototype.fatal = void 0;
Bt.prototype.place = void 0;
Bt.prototype.ruleId = void 0;
Bt.prototype.source = void 0;
const rg = {}.hasOwnProperty, EV = /* @__PURE__ */ new Map(), $V = /[A-Z]/g, TV = /-([a-z])/g, OV = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), RV = /* @__PURE__ */ new Set(["td", "th"]), XC = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function DV(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = BV(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = MV(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? ng : SV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = ZC(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function ZC(e, n, r) {
  if (n.type === "element")
    return PV(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return AV(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return VV(e, n, r);
  if (n.type === "mdxjsEsm")
    return LV(e, n);
  if (n.type === "root")
    return zV(e, n, r);
  if (n.type === "text")
    return UV(e, n);
}
function PV(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = ng, e.schema = a), e.ancestors.push(n);
  const o = n1(e, n.tagName, !1), s = qV(e, n);
  let l = ag(e, n);
  return OV.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !mV(d) : !0;
  })), e1(e, s, o, n), ig(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function AV(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Ro(e, n.position);
}
function LV(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Ro(e, n.position);
}
function VV(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = ng, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : n1(e, n.name, !0), s = HV(e, n), l = ag(e, n);
  return e1(e, s, o, n), ig(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function zV(e, n, r) {
  const i = {};
  return ig(i, ag(e, n)), e.create(n, e.Fragment, i, r);
}
function UV(e, n) {
  return n.value;
}
function e1(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function ig(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function MV(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const p = Array.isArray(s.children) ? r : n;
    return l ? p(o, s, l) : p(o, s);
  }
}
function BV(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = tg(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function qV(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && rg.call(n.properties, a)) {
      const o = WV(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && RV.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function HV(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Ro(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Ro(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function ag(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : EV;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const p = a.get(d) || 0;
        s = d + "-" + p, a.set(d, p + 1);
      }
    }
    const l = ZC(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function WV(e, n, r) {
  const i = kV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? sV(r) : NV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : KV(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = GV(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? xV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function KV(e, n) {
  const r = {};
  try {
    FV(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Bt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = XC + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(TV, JV)), r[s] = o;
  }
}
function n1(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = rx(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = rx(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return rg.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Ro(e);
}
function Ro(e, n) {
  const r = new Bt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = XC + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function GV(e) {
  const n = {};
  let r;
  for (r in e)
    rg.call(e, r) && (n[YV(r)] = e[r]);
  return n;
}
function YV(e) {
  let n = e.replace($V, QV);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function JV(e, n) {
  return n.toUpperCase();
}
function QV(e) {
  return "-" + e.toLowerCase();
}
const em = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, XV = {};
function ZV(e, n) {
  const r = XV, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return t1(e, i, a);
}
function t1(e, n, r) {
  if (e3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return mx(e.children, n, r);
  }
  return Array.isArray(e) ? mx(e, n, r) : "";
}
function mx(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = t1(e[a], n, r);
  return i.join("");
}
function e3(e) {
  return !!(e && typeof e == "object");
}
const px = document.createElement("i");
function og(e) {
  const n = "&" + e + ";";
  px.innerHTML = n;
  const r = px.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Hr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function kr(e, n) {
  return e.length > 0 ? (Hr(e, e.length, 0, n), e) : n;
}
const fx = {}.hasOwnProperty;
function n3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    t3(n, e[r]);
  return n;
}
function t3(e, n) {
  let r;
  for (r in n) {
    const a = (fx.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        fx.call(a, s) || (a[s] = []);
        const l = o[s];
        r3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function r3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Hr(e, 0, 0, i);
}
function r1(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ma(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Vr = gi(/[A-Za-z]/), lr = gi(/[\dA-Za-z]/), i3 = gi(/[#-'*+\--9=?A-Z^-~]/);
function zh(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Uh = gi(/\d/), a3 = gi(/[\dA-Fa-f]/), o3 = gi(/[!-/:-@[-`{-~]/);
function In(e) {
  return e !== null && e < -2;
}
function nr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Yn(e) {
  return e === -2 || e === -1 || e === 32;
}
const s3 = gi(new RegExp("\\p{P}|\\p{S}", "u")), l3 = gi(/\s/);
function gi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Ia(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && lr(e.charCodeAt(r + 1)) && lr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function lt(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return Yn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return Yn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const c3 = {
  tokenize: d3
};
function d3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), lt(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return In(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const u3 = {
  tokenize: m3
}, hx = {
  tokenize: p3
};
function m3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(D) {
    if (i < r.length) {
      const O = r[i];
      return n.containerState = O[1], e.attempt(O[0].continuation, d, p)(D);
    }
    return p(D);
  }
  function d(D) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const O = n.events.length;
      let I = O, F;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          F = n.events[I][1].end;
          break;
        }
      _(i);
      let L = O;
      for (; L < n.events.length; )
        n.events[L][1].end = {
          ...F
        }, L++;
      return Hr(n.events, I + 1, 0, n.events.slice(O)), n.events.length = L, p(D);
    }
    return l(D);
  }
  function p(D) {
    if (i === r.length) {
      if (!a)
        return h(D);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(D);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(hx, u, f)(D);
  }
  function u(D) {
    return a && g(), _(i), h(D);
  }
  function f(D) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(D);
  }
  function h(D) {
    return n.containerState = {}, e.attempt(hx, k, C)(D);
  }
  function k(D) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(D);
  }
  function C(D) {
    if (D === null) {
      a && g(), _(0), e.consume(D);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), N(D);
  }
  function N(D) {
    if (D === null) {
      j(e.exit("chunkFlow"), !0), _(0), e.consume(D);
      return;
    }
    return In(D) ? (e.consume(D), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(D), N);
  }
  function j(D, O) {
    const I = n.sliceStream(D);
    if (O && I.push(null), D.previous = o, o && (o.next = D), o = D, a.defineSkip(D.start), a.write(I), n.parser.lazy[D.start.line]) {
      let F = a.events.length;
      for (; F--; )
        if (
          // The token starts before the line ending…
          a.events[F][1].start.offset < s && // …and either is not ended yet…
          (!a.events[F][1].end || // …or ends after it.
          a.events[F][1].end.offset > s)
        )
          return;
      const L = n.events.length;
      let K = L, J, re;
      for (; K--; )
        if (n.events[K][0] === "exit" && n.events[K][1].type === "chunkFlow") {
          if (J) {
            re = n.events[K][1].end;
            break;
          }
          J = !0;
        }
      for (_(i), F = L; F < n.events.length; )
        n.events[F][1].end = {
          ...re
        }, F++;
      Hr(n.events, K + 1, 0, n.events.slice(L)), n.events.length = F;
    }
  }
  function _(D) {
    let O = r.length;
    for (; O-- > D; ) {
      const I = r[O];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    r.length = D;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function p3(e, n, r) {
  return lt(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function yx(e) {
  if (e === null || nr(e) || l3(e))
    return 1;
  if (s3(e))
    return 2;
}
function sg(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const Mh = {
  name: "attention",
  resolveAll: f3,
  tokenize: h3
};
function f3(e, n) {
  let r = -1, i, a, o, s, l, d, p, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          gx(f, -d), gx(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, p = [], e[i][1].end.offset - e[i][1].start.offset && (p = kr(p, [["enter", e[i][1], n], ["exit", e[i][1], n]])), p = kr(p, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), p = kr(p, sg(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), p = kr(p, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, p = kr(p, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Hr(e, i - 1, r - i + 3, p), r = i + p.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function h3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = yx(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const p = e.exit("attentionSequence"), u = yx(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return p._open = !!(o === 42 ? f : f && (a || !h)), p._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function gx(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const y3 = {
  name: "autolink",
  tokenize: g3
};
function g3(e, n, r) {
  let i = 0;
  return a;
  function a(k) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(k) {
    return Vr(k) ? (e.consume(k), s) : k === 64 ? r(k) : p(k);
  }
  function s(k) {
    return k === 43 || k === 45 || k === 46 || lr(k) ? (i = 1, l(k)) : p(k);
  }
  function l(k) {
    return k === 58 ? (e.consume(k), i = 0, d) : (k === 43 || k === 45 || k === 46 || lr(k)) && i++ < 32 ? (e.consume(k), l) : (i = 0, p(k));
  }
  function d(k) {
    return k === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : k === null || k === 32 || k === 60 || zh(k) ? r(k) : (e.consume(k), d);
  }
  function p(k) {
    return k === 64 ? (e.consume(k), u) : i3(k) ? (e.consume(k), p) : r(k);
  }
  function u(k) {
    return lr(k) ? f(k) : r(k);
  }
  function f(k) {
    return k === 46 ? (e.consume(k), i = 0, u) : k === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(k);
  }
  function h(k) {
    if ((k === 45 || lr(k)) && i++ < 63) {
      const C = k === 45 ? h : f;
      return e.consume(k), C;
    }
    return r(k);
  }
}
const Al = {
  partial: !0,
  tokenize: v3
};
function v3(e, n, r) {
  return i;
  function i(o) {
    return Yn(o) ? lt(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || In(o) ? n(o) : r(o);
  }
}
const i1 = {
  continuation: {
    tokenize: b3
  },
  exit: _3,
  name: "blockQuote",
  tokenize: k3
};
function k3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Yn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function b3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Yn(s) ? lt(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(i1, n, r)(s);
  }
}
function _3(e) {
  e.exit("blockQuote");
}
const a1 = {
  name: "characterEscape",
  tokenize: x3
};
function x3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return o3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const o1 = {
  name: "characterReference",
  tokenize: S3
};
function S3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), p) : (e.enter("characterReferenceValue"), o = 31, s = lr, u(f));
  }
  function p(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = a3, u) : (e.enter("characterReferenceValue"), o = 7, s = Uh, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === lr && !og(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const vx = {
  partial: !0,
  tokenize: j3
}, kx = {
  concrete: !0,
  name: "codeFenced",
  tokenize: N3
};
function N3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return d;
  function d(F) {
    return p(F);
  }
  function p(F) {
    const L = i.events[i.events.length - 1];
    return o = L && L[1].type === "linePrefix" ? L[2].sliceSerialize(L[1], !0).length : 0, l = F, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(F);
  }
  function u(F) {
    return F === l ? (s++, e.consume(F), u) : s < 3 ? r(F) : (e.exit("codeFencedFenceSequence"), Yn(F) ? lt(e, f, "whitespace")(F) : f(F));
  }
  function f(F) {
    return F === null || In(F) ? (e.exit("codeFencedFence"), i.interrupt ? n(F) : e.check(vx, N, O)(F)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(F));
  }
  function h(F) {
    return F === null || In(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(F)) : Yn(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), lt(e, k, "whitespace")(F)) : F === 96 && F === l ? r(F) : (e.consume(F), h);
  }
  function k(F) {
    return F === null || In(F) ? f(F) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(F));
  }
  function C(F) {
    return F === null || In(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(F)) : F === 96 && F === l ? r(F) : (e.consume(F), C);
  }
  function N(F) {
    return e.attempt(a, O, j)(F);
  }
  function j(F) {
    return e.enter("lineEnding"), e.consume(F), e.exit("lineEnding"), _;
  }
  function _(F) {
    return o > 0 && Yn(F) ? lt(e, g, "linePrefix", o + 1)(F) : g(F);
  }
  function g(F) {
    return F === null || In(F) ? e.check(vx, N, O)(F) : (e.enter("codeFlowValue"), D(F));
  }
  function D(F) {
    return F === null || In(F) ? (e.exit("codeFlowValue"), g(F)) : (e.consume(F), D);
  }
  function O(F) {
    return e.exit("codeFenced"), n(F);
  }
  function I(F, L, K) {
    let J = 0;
    return re;
    function re(ee) {
      return F.enter("lineEnding"), F.consume(ee), F.exit("lineEnding"), W;
    }
    function W(ee) {
      return F.enter("codeFencedFence"), Yn(ee) ? lt(F, Y, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : Y(ee);
    }
    function Y(ee) {
      return ee === l ? (F.enter("codeFencedFenceSequence"), P(ee)) : K(ee);
    }
    function P(ee) {
      return ee === l ? (J++, F.consume(ee), P) : J >= s ? (F.exit("codeFencedFenceSequence"), Yn(ee) ? lt(F, B, "whitespace")(ee) : B(ee)) : K(ee);
    }
    function B(ee) {
      return ee === null || In(ee) ? (F.exit("codeFencedFence"), L(ee)) : K(ee);
    }
  }
}
function j3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const nm = {
  name: "codeIndented",
  tokenize: C3
}, w3 = {
  partial: !0,
  tokenize: F3
};
function C3(e, n, r) {
  const i = this;
  return a;
  function a(p) {
    return e.enter("codeIndented"), lt(e, o, "linePrefix", 5)(p);
  }
  function o(p) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(p) : r(p);
  }
  function s(p) {
    return p === null ? d(p) : In(p) ? e.attempt(w3, s, d)(p) : (e.enter("codeFlowValue"), l(p));
  }
  function l(p) {
    return p === null || In(p) ? (e.exit("codeFlowValue"), s(p)) : (e.consume(p), l);
  }
  function d(p) {
    return e.exit("codeIndented"), n(p);
  }
}
function F3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : lt(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : In(s) ? a(s) : r(s);
  }
}
const I3 = {
  name: "codeText",
  previous: $3,
  resolve: E3,
  tokenize: T3
};
function E3(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function $3(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function T3(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : In(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), p(f));
  }
  function p(f) {
    return f === null || f === 32 || f === 96 || In(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), p);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", p(f));
  }
}
class O3 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ya(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ya(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ya(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ya(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ya(this.left, r.reverse());
      }
  }
}
function Ya(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function s1(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, p;
  const u = new O3(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, R3(u, r)), r = n[r], p = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Hr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !p;
}
function R3(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], p = {};
  let u, f, h = -1, k = r, C = 0, N = 0;
  const j = [N];
  for (; k; ) {
    for (; e.get(++a)[1] !== k; )
      ;
    o.push(a), k._tokenizer || (u = i.sliceStream(k), k.next || u.push(null), f && s.defineSkip(k.start), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = k, k = k.next;
  }
  for (k = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (N = h + 1, j.push(N), k._tokenizer = void 0, k.previous = void 0, k = k.next);
  for (s.events = [], k ? (k._tokenizer = void 0, k.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const _ = l.slice(j[h], j[h + 1]), g = o.pop();
    d.push([g, g + _.length - 1]), e.splice(g, 2, _);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    p[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return p;
}
const D3 = {
  resolve: A3,
  tokenize: L3
}, P3 = {
  partial: !0,
  tokenize: V3
};
function A3(e) {
  return s1(e), e;
}
function L3(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : In(l) ? e.check(P3, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function V3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), lt(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || In(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function l1(e, n, r, i, a, o, s, l, d) {
  const p = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(_) {
    return _ === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(_), e.exit(o), h) : _ === null || _ === 32 || _ === 41 || zh(_) ? r(_) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), N(_));
  }
  function h(_) {
    return _ === 62 ? (e.enter(o), e.consume(_), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), k(_));
  }
  function k(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(l), h(_)) : _ === null || _ === 60 || In(_) ? r(_) : (e.consume(_), _ === 92 ? C : k);
  }
  function C(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), k) : k(_);
  }
  function N(_) {
    return !u && (_ === null || _ === 41 || nr(_)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(_)) : u < p && _ === 40 ? (e.consume(_), u++, N) : _ === 41 ? (e.consume(_), u--, N) : _ === null || _ === 32 || _ === 40 || zh(_) ? r(_) : (e.consume(_), _ === 92 ? j : N);
  }
  function j(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), N) : N(_);
  }
}
function c1(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return p;
  function p(k) {
    return e.enter(i), e.enter(a), e.consume(k), e.exit(a), e.enter(o), u;
  }
  function u(k) {
    return l > 999 || k === null || k === 91 || k === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    k === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(k) : k === 93 ? (e.exit(o), e.enter(a), e.consume(k), e.exit(a), e.exit(i), n) : In(k) ? (e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || k === 91 || k === 93 || In(k) || l++ > 999 ? (e.exit("chunkString"), u(k)) : (e.consume(k), d || (d = !Yn(k)), k === 92 ? h : f);
  }
  function h(k) {
    return k === 91 || k === 92 || k === 93 ? (e.consume(k), l++, f) : f(k);
  }
}
function d1(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), p(h));
  }
  function p(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : In(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), lt(e, p, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || In(h) ? (e.exit("chunkString"), p(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function So(e, n) {
  let r;
  return i;
  function i(a) {
    return In(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Yn(a) ? lt(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const z3 = {
  name: "definition",
  tokenize: M3
}, U3 = {
  partial: !0,
  tokenize: B3
};
function M3(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(k) {
    return e.enter("definition"), s(k);
  }
  function s(k) {
    return c1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(k);
  }
  function l(k) {
    return a = ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), k === 58 ? (e.enter("definitionMarker"), e.consume(k), e.exit("definitionMarker"), d) : r(k);
  }
  function d(k) {
    return nr(k) ? So(e, p)(k) : p(k);
  }
  function p(k) {
    return l1(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(k);
  }
  function u(k) {
    return e.attempt(U3, f, f)(k);
  }
  function f(k) {
    return Yn(k) ? lt(e, h, "whitespace")(k) : h(k);
  }
  function h(k) {
    return k === null || In(k) ? (e.exit("definition"), i.parser.defined.push(a), n(k)) : r(k);
  }
}
function B3(e, n, r) {
  return i;
  function i(l) {
    return nr(l) ? So(e, a)(l) : r(l);
  }
  function a(l) {
    return d1(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Yn(l) ? lt(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || In(l) ? n(l) : r(l);
  }
}
const q3 = {
  name: "hardBreakEscape",
  tokenize: H3
};
function H3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return In(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const W3 = {
  name: "headingAtx",
  resolve: K3,
  tokenize: G3
};
function K3(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Hr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function G3(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || nr(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || In(u) ? (e.exit("atxHeading"), n(u)) : Yn(u) ? lt(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), p(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function p(u) {
    return u === null || u === 35 || nr(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), p);
  }
}
const Y3 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], bx = ["pre", "script", "style", "textarea"], J3 = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Z3,
  tokenize: ez
}, Q3 = {
  partial: !0,
  tokenize: tz
}, X3 = {
  partial: !0,
  tokenize: nz
};
function Z3(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function ez(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return p;
  function p(q) {
    return u(q);
  }
  function u(q) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(q), f;
  }
  function f(q) {
    return q === 33 ? (e.consume(q), h) : q === 47 ? (e.consume(q), o = !0, N) : q === 63 ? (e.consume(q), a = 3, i.interrupt ? n : V) : Vr(q) ? (e.consume(q), s = String.fromCharCode(q), j) : r(q);
  }
  function h(q) {
    return q === 45 ? (e.consume(q), a = 2, k) : q === 91 ? (e.consume(q), a = 5, l = 0, C) : Vr(q) ? (e.consume(q), a = 4, i.interrupt ? n : V) : r(q);
  }
  function k(q) {
    return q === 45 ? (e.consume(q), i.interrupt ? n : V) : r(q);
  }
  function C(q) {
    const Ge = "CDATA[";
    return q === Ge.charCodeAt(l++) ? (e.consume(q), l === Ge.length ? i.interrupt ? n : Y : C) : r(q);
  }
  function N(q) {
    return Vr(q) ? (e.consume(q), s = String.fromCharCode(q), j) : r(q);
  }
  function j(q) {
    if (q === null || q === 47 || q === 62 || nr(q)) {
      const Ge = q === 47, sn = s.toLowerCase();
      return !Ge && !o && bx.includes(sn) ? (a = 1, i.interrupt ? n(q) : Y(q)) : Y3.includes(s.toLowerCase()) ? (a = 6, Ge ? (e.consume(q), _) : i.interrupt ? n(q) : Y(q)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(q) : o ? g(q) : D(q));
    }
    return q === 45 || lr(q) ? (e.consume(q), s += String.fromCharCode(q), j) : r(q);
  }
  function _(q) {
    return q === 62 ? (e.consume(q), i.interrupt ? n : Y) : r(q);
  }
  function g(q) {
    return Yn(q) ? (e.consume(q), g) : re(q);
  }
  function D(q) {
    return q === 47 ? (e.consume(q), re) : q === 58 || q === 95 || Vr(q) ? (e.consume(q), O) : Yn(q) ? (e.consume(q), D) : re(q);
  }
  function O(q) {
    return q === 45 || q === 46 || q === 58 || q === 95 || lr(q) ? (e.consume(q), O) : I(q);
  }
  function I(q) {
    return q === 61 ? (e.consume(q), F) : Yn(q) ? (e.consume(q), I) : D(q);
  }
  function F(q) {
    return q === null || q === 60 || q === 61 || q === 62 || q === 96 ? r(q) : q === 34 || q === 39 ? (e.consume(q), d = q, L) : Yn(q) ? (e.consume(q), F) : K(q);
  }
  function L(q) {
    return q === d ? (e.consume(q), d = null, J) : q === null || In(q) ? r(q) : (e.consume(q), L);
  }
  function K(q) {
    return q === null || q === 34 || q === 39 || q === 47 || q === 60 || q === 61 || q === 62 || q === 96 || nr(q) ? I(q) : (e.consume(q), K);
  }
  function J(q) {
    return q === 47 || q === 62 || Yn(q) ? D(q) : r(q);
  }
  function re(q) {
    return q === 62 ? (e.consume(q), W) : r(q);
  }
  function W(q) {
    return q === null || In(q) ? Y(q) : Yn(q) ? (e.consume(q), W) : r(q);
  }
  function Y(q) {
    return q === 45 && a === 2 ? (e.consume(q), Ne) : q === 60 && a === 1 ? (e.consume(q), ue) : q === 62 && a === 4 ? (e.consume(q), ke) : q === 63 && a === 3 ? (e.consume(q), V) : q === 93 && a === 5 ? (e.consume(q), fe) : In(q) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(Q3, Oe, P)(q)) : q === null || In(q) ? (e.exit("htmlFlowData"), P(q)) : (e.consume(q), Y);
  }
  function P(q) {
    return e.check(X3, B, Oe)(q);
  }
  function B(q) {
    return e.enter("lineEnding"), e.consume(q), e.exit("lineEnding"), ee;
  }
  function ee(q) {
    return q === null || In(q) ? P(q) : (e.enter("htmlFlowData"), Y(q));
  }
  function Ne(q) {
    return q === 45 ? (e.consume(q), V) : Y(q);
  }
  function ue(q) {
    return q === 47 ? (e.consume(q), s = "", oe) : Y(q);
  }
  function oe(q) {
    if (q === 62) {
      const Ge = s.toLowerCase();
      return bx.includes(Ge) ? (e.consume(q), ke) : Y(q);
    }
    return Vr(q) && s.length < 8 ? (e.consume(q), s += String.fromCharCode(q), oe) : Y(q);
  }
  function fe(q) {
    return q === 93 ? (e.consume(q), V) : Y(q);
  }
  function V(q) {
    return q === 62 ? (e.consume(q), ke) : q === 45 && a === 2 ? (e.consume(q), V) : Y(q);
  }
  function ke(q) {
    return q === null || In(q) ? (e.exit("htmlFlowData"), Oe(q)) : (e.consume(q), ke);
  }
  function Oe(q) {
    return e.exit("htmlFlow"), n(q);
  }
}
function nz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function tz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Al, n, r);
  }
}
const rz = {
  name: "htmlText",
  tokenize: iz
};
function iz(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(V) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(V), d;
  }
  function d(V) {
    return V === 33 ? (e.consume(V), p) : V === 47 ? (e.consume(V), I) : V === 63 ? (e.consume(V), D) : Vr(V) ? (e.consume(V), K) : r(V);
  }
  function p(V) {
    return V === 45 ? (e.consume(V), u) : V === 91 ? (e.consume(V), o = 0, C) : Vr(V) ? (e.consume(V), g) : r(V);
  }
  function u(V) {
    return V === 45 ? (e.consume(V), k) : r(V);
  }
  function f(V) {
    return V === null ? r(V) : V === 45 ? (e.consume(V), h) : In(V) ? (s = f, ue(V)) : (e.consume(V), f);
  }
  function h(V) {
    return V === 45 ? (e.consume(V), k) : f(V);
  }
  function k(V) {
    return V === 62 ? Ne(V) : V === 45 ? h(V) : f(V);
  }
  function C(V) {
    const ke = "CDATA[";
    return V === ke.charCodeAt(o++) ? (e.consume(V), o === ke.length ? N : C) : r(V);
  }
  function N(V) {
    return V === null ? r(V) : V === 93 ? (e.consume(V), j) : In(V) ? (s = N, ue(V)) : (e.consume(V), N);
  }
  function j(V) {
    return V === 93 ? (e.consume(V), _) : N(V);
  }
  function _(V) {
    return V === 62 ? Ne(V) : V === 93 ? (e.consume(V), _) : N(V);
  }
  function g(V) {
    return V === null || V === 62 ? Ne(V) : In(V) ? (s = g, ue(V)) : (e.consume(V), g);
  }
  function D(V) {
    return V === null ? r(V) : V === 63 ? (e.consume(V), O) : In(V) ? (s = D, ue(V)) : (e.consume(V), D);
  }
  function O(V) {
    return V === 62 ? Ne(V) : D(V);
  }
  function I(V) {
    return Vr(V) ? (e.consume(V), F) : r(V);
  }
  function F(V) {
    return V === 45 || lr(V) ? (e.consume(V), F) : L(V);
  }
  function L(V) {
    return In(V) ? (s = L, ue(V)) : Yn(V) ? (e.consume(V), L) : Ne(V);
  }
  function K(V) {
    return V === 45 || lr(V) ? (e.consume(V), K) : V === 47 || V === 62 || nr(V) ? J(V) : r(V);
  }
  function J(V) {
    return V === 47 ? (e.consume(V), Ne) : V === 58 || V === 95 || Vr(V) ? (e.consume(V), re) : In(V) ? (s = J, ue(V)) : Yn(V) ? (e.consume(V), J) : Ne(V);
  }
  function re(V) {
    return V === 45 || V === 46 || V === 58 || V === 95 || lr(V) ? (e.consume(V), re) : W(V);
  }
  function W(V) {
    return V === 61 ? (e.consume(V), Y) : In(V) ? (s = W, ue(V)) : Yn(V) ? (e.consume(V), W) : J(V);
  }
  function Y(V) {
    return V === null || V === 60 || V === 61 || V === 62 || V === 96 ? r(V) : V === 34 || V === 39 ? (e.consume(V), a = V, P) : In(V) ? (s = Y, ue(V)) : Yn(V) ? (e.consume(V), Y) : (e.consume(V), B);
  }
  function P(V) {
    return V === a ? (e.consume(V), a = void 0, ee) : V === null ? r(V) : In(V) ? (s = P, ue(V)) : (e.consume(V), P);
  }
  function B(V) {
    return V === null || V === 34 || V === 39 || V === 60 || V === 61 || V === 96 ? r(V) : V === 47 || V === 62 || nr(V) ? J(V) : (e.consume(V), B);
  }
  function ee(V) {
    return V === 47 || V === 62 || nr(V) ? J(V) : r(V);
  }
  function Ne(V) {
    return V === 62 ? (e.consume(V), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(V);
  }
  function ue(V) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(V), e.exit("lineEnding"), oe;
  }
  function oe(V) {
    return Yn(V) ? lt(e, fe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(V) : fe(V);
  }
  function fe(V) {
    return e.enter("htmlTextData"), s(V);
  }
}
const lg = {
  name: "labelEnd",
  resolveAll: lz,
  resolveTo: cz,
  tokenize: dz
}, az = {
  tokenize: uz
}, oz = {
  tokenize: mz
}, sz = {
  tokenize: pz
};
function lz(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Hr(e, 0, e.length, r), e;
}
function cz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, p = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", p, n]], l = kr(l, e.slice(o + 1, o + i + 3)), l = kr(l, [["enter", u, n]]), l = kr(l, sg(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = kr(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", p, n]]), l = kr(l, e.slice(s + 1)), l = kr(l, [["exit", d, n]]), Hr(e, o, e.length, l), e;
}
function dz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ma(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(az, u, s ? u : f)(h) : h === 91 ? e.attempt(oz, u, s ? p : f)(h) : s ? u(h) : f(h);
  }
  function p(h) {
    return e.attempt(sz, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function uz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return nr(f) ? So(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : l1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return nr(f) ? So(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? d1(e, p, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function p(f) {
    return nr(f) ? So(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function mz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return c1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function pz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const fz = {
  name: "labelStartImage",
  resolveAll: lg.resolveAll,
  tokenize: hz
};
function hz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const yz = {
  name: "labelStartLink",
  resolveAll: lg.resolveAll,
  tokenize: gz
};
function gz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const tm = {
  name: "lineEnding",
  tokenize: vz
};
function vz(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), lt(e, n, "linePrefix");
  }
}
const Ms = {
  name: "thematicBreak",
  tokenize: kz
};
function kz(e, n, r) {
  let i = 0, a;
  return o;
  function o(p) {
    return e.enter("thematicBreak"), s(p);
  }
  function s(p) {
    return a = p, l(p);
  }
  function l(p) {
    return p === a ? (e.enter("thematicBreakSequence"), d(p)) : i >= 3 && (p === null || In(p)) ? (e.exit("thematicBreak"), n(p)) : r(p);
  }
  function d(p) {
    return p === a ? (e.consume(p), i++, d) : (e.exit("thematicBreakSequence"), Yn(p) ? lt(e, l, "whitespace")(p) : l(p));
  }
}
const Zt = {
  continuation: {
    tokenize: Sz
  },
  exit: jz,
  name: "list",
  tokenize: xz
}, bz = {
  partial: !0,
  tokenize: wz
}, _z = {
  partial: !0,
  tokenize: Nz
};
function xz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(k) {
    const C = i.containerState.type || (k === 42 || k === 43 || k === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || k === i.containerState.marker : Uh(k)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), k === 42 || k === 45 ? e.check(Ms, r, p)(k) : p(k);
      if (!i.interrupt || k === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(k);
    }
    return r(k);
  }
  function d(k) {
    return Uh(k) && ++s < 10 ? (e.consume(k), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? k === i.containerState.marker : k === 41 || k === 46) ? (e.exit("listItemValue"), p(k)) : r(k);
  }
  function p(k) {
    return e.enter("listItemMarker"), e.consume(k), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || k, e.check(
      Al,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(bz, h, f)
    );
  }
  function u(k) {
    return i.containerState.initialBlankLine = !0, o++, h(k);
  }
  function f(k) {
    return Yn(k) ? (e.enter("listItemPrefixWhitespace"), e.consume(k), e.exit("listItemPrefixWhitespace"), h) : r(k);
  }
  function h(k) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(k);
  }
}
function Sz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Al, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, lt(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Yn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(_z, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, lt(e, e.attempt(Zt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Nz(e, n, r) {
  const i = this;
  return lt(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function jz(e) {
  e.exit(this.containerState.type);
}
function wz(e, n, r) {
  const i = this;
  return lt(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Yn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const _x = {
  name: "setextUnderline",
  resolveTo: Cz,
  tokenize: Fz
};
function Cz(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function Fz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(p) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = p, s(p)) : r(p);
  }
  function s(p) {
    return e.enter("setextHeadingLineSequence"), l(p);
  }
  function l(p) {
    return p === a ? (e.consume(p), l) : (e.exit("setextHeadingLineSequence"), Yn(p) ? lt(e, d, "lineSuffix")(p) : d(p));
  }
  function d(p) {
    return p === null || In(p) ? (e.exit("setextHeadingLine"), n(p)) : r(p);
  }
}
const Iz = {
  tokenize: Ez
};
function Ez(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Al,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, lt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(D3, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const $z = {
  resolveAll: m1()
}, Tz = u1("string"), Oz = u1("text");
function u1(e) {
  return {
    resolveAll: m1(e === "text" ? Rz : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return p(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return p(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function p(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const k = f[h];
          if (!k.previous || k.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function m1(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function Rz(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const p = a[o];
        if (typeof p == "string") {
          for (s = p.length; p.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (p === -2)
          d = !0, l++;
        else if (p !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const p = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...p.start
        }, i.start.offset === i.end.offset ? Object.assign(i, p) : (e.splice(r, 0, ["enter", p, n], ["exit", p, n]), r += 2);
      }
      r++;
    }
  return e;
}
const Dz = {
  42: Zt,
  43: Zt,
  45: Zt,
  48: Zt,
  49: Zt,
  50: Zt,
  51: Zt,
  52: Zt,
  53: Zt,
  54: Zt,
  55: Zt,
  56: Zt,
  57: Zt,
  62: i1
}, Pz = {
  91: z3
}, Az = {
  [-2]: nm,
  [-1]: nm,
  32: nm
}, Lz = {
  35: W3,
  42: Ms,
  45: [_x, Ms],
  60: J3,
  61: _x,
  95: Ms,
  96: kx,
  126: kx
}, Vz = {
  38: o1,
  92: a1
}, zz = {
  [-5]: tm,
  [-4]: tm,
  [-3]: tm,
  33: fz,
  38: o1,
  42: Mh,
  60: [y3, rz],
  91: yz,
  92: [q3, a1],
  93: lg,
  95: Mh,
  96: I3
}, Uz = {
  null: [Mh, $z]
}, Mz = {
  null: [42, 95]
}, Bz = {
  null: []
}, qz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Mz,
  contentInitial: Pz,
  disable: Bz,
  document: Dz,
  flow: Lz,
  flowInitial: Az,
  insideSpan: Uz,
  string: Vz,
  text: zz
}, Symbol.toStringTag, { value: "Module" }));
function Hz(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: L(I),
    check: L(F),
    consume: g,
    enter: D,
    exit: O,
    interrupt: L(F, {
      interrupt: !0
    })
  }, p = {
    code: null,
    containerState: {},
    defineSkip: N,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: k,
    write: f
  };
  let u = n.tokenize.call(p, d);
  return n.resolveAll && o.push(n), p;
  function f(W) {
    return s = kr(s, W), j(), s[s.length - 1] !== null ? [] : (K(n, 0), p.events = sg(o, p.events, p), p.events);
  }
  function h(W, Y) {
    return Kz(k(W), Y);
  }
  function k(W) {
    return Wz(s, W);
  }
  function C() {
    const {
      _bufferIndex: W,
      _index: Y,
      line: P,
      column: B,
      offset: ee
    } = i;
    return {
      _bufferIndex: W,
      _index: Y,
      line: P,
      column: B,
      offset: ee
    };
  }
  function N(W) {
    a[W.line] = W.column, re();
  }
  function j() {
    let W;
    for (; i._index < s.length; ) {
      const Y = s[i._index];
      if (typeof Y == "string")
        for (W = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === W && i._bufferIndex < Y.length; )
          _(Y.charCodeAt(i._bufferIndex));
      else
        _(Y);
    }
  }
  function _(W) {
    u = u(W);
  }
  function g(W) {
    In(W) ? (i.line++, i.column = 1, i.offset += W === -3 ? 2 : 1, re()) : W !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), p.previous = W;
  }
  function D(W, Y) {
    const P = Y || {};
    return P.type = W, P.start = C(), p.events.push(["enter", P, p]), l.push(P), P;
  }
  function O(W) {
    const Y = l.pop();
    return Y.end = C(), p.events.push(["exit", Y, p]), Y;
  }
  function I(W, Y) {
    K(W, Y.from);
  }
  function F(W, Y) {
    Y.restore();
  }
  function L(W, Y) {
    return P;
    function P(B, ee, Ne) {
      let ue, oe, fe, V;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        Oe(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        Oe([
          /** @type {Construct} */
          B
        ])
      ) : ke(B);
      function ke(Ie) {
        return Ue;
        function Ue(De) {
          const Be = De !== null && Ie[De], Ae = De !== null && Ie.null, Je = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return Oe(Je)(De);
        }
      }
      function Oe(Ie) {
        return ue = Ie, oe = 0, Ie.length === 0 ? Ne : q(Ie[oe]);
      }
      function q(Ie) {
        return Ue;
        function Ue(De) {
          return V = J(), fe = Ie, Ie.partial || (p.currentConstruct = Ie), Ie.name && p.parser.constructs.disable.null.includes(Ie.name) ? sn() : Ie.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            Y ? Object.assign(Object.create(p), Y) : p,
            d,
            Ge,
            sn
          )(De);
        }
      }
      function Ge(Ie) {
        return W(fe, V), ee;
      }
      function sn(Ie) {
        return V.restore(), ++oe < ue.length ? q(ue[oe]) : Ne;
      }
    }
  }
  function K(W, Y) {
    W.resolveAll && !o.includes(W) && o.push(W), W.resolve && Hr(p.events, Y, p.events.length - Y, W.resolve(p.events.slice(Y), p)), W.resolveTo && (p.events = W.resolveTo(p.events, p));
  }
  function J() {
    const W = C(), Y = p.previous, P = p.currentConstruct, B = p.events.length, ee = Array.from(l);
    return {
      from: B,
      restore: Ne
    };
    function Ne() {
      i = W, p.previous = Y, p.currentConstruct = P, p.events.length = B, l = ee, re();
    }
  }
  function re() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function Wz(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function Kz(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function Gz(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      n3([qz, ...(e || {}).extensions || []])
    ),
    content: a(c3),
    defined: [],
    document: a(u3),
    flow: a(Iz),
    lazy: {},
    string: a(Tz),
    text: a(Oz)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return Hz(i, o, l);
    }
  }
}
function Yz(e) {
  for (; !s1(e); )
    ;
  return e;
}
const xx = /[\0\t\n\r]/g;
function Jz() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let p, u, f, h, k;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (xx.lastIndex = f, p = xx.exec(o), h = p && p.index !== void 0 ? p.index : o.length, k = o.charCodeAt(h), !p) {
        n = o.slice(f);
        break;
      }
      if (k === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), k) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const Qz = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Xz(e) {
  return e.replace(Qz, Zz);
}
function Zz(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return r1(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return og(r) || e;
}
const p1 = {}.hasOwnProperty;
function eU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), nU(r)(Yz(Gz(r).document().write(Jz()(e, n, !0))));
}
function nU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: o(se),
      blockQuote: o(Ae),
      characterEscape: J,
      characterReference: J,
      codeFenced: o(Je),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Je, s),
      codeText: o($e, s),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: o(Me),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(en),
      hardBreakEscape: o(le),
      hardBreakTrailing: o(le),
      htmlFlow: o(xe, s),
      htmlFlowData: J,
      htmlText: o(xe, s),
      htmlTextData: J,
      image: o(Ve),
      label: s,
      link: o(Pe),
      listItem: o(Q),
      listItemValue: h,
      listOrdered: o(vn, f),
      listUnordered: o(vn),
      paragraph: o(E),
      reference: q,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(se),
      strong: o(z),
      thematicBreak: o(ce)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: I,
      autolink: d(),
      autolinkEmail: Be,
      autolinkProtocol: De,
      blockQuote: d(),
      characterEscapeValue: re,
      characterReferenceMarkerHexadecimal: sn,
      characterReferenceMarkerNumeric: sn,
      characterReferenceValue: Ie,
      characterReference: Ue,
      codeFenced: d(j),
      codeFencedFence: N,
      codeFencedFenceInfo: k,
      codeFencedFenceMeta: C,
      codeFlowValue: re,
      codeIndented: d(_),
      codeText: d(ee),
      codeTextData: re,
      data: re,
      definition: d(),
      definitionDestinationString: O,
      definitionLabelString: g,
      definitionTitleString: D,
      emphasis: d(),
      hardBreakEscape: d(Y),
      hardBreakTrailing: d(Y),
      htmlFlow: d(P),
      htmlFlowData: re,
      htmlText: d(B),
      htmlTextData: re,
      image: d(ue),
      label: fe,
      labelText: oe,
      lineEnding: W,
      link: d(Ne),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: Ge,
      resourceDestinationString: V,
      resourceTitleString: ke,
      resource: Oe,
      setextHeading: d(K),
      setextHeadingLineSequence: L,
      setextHeadingText: F,
      strong: d(),
      thematicBreak: d()
    }
  };
  f1(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(U) {
    let G = {
      type: "root",
      children: []
    };
    const ye = {
      stack: [G],
      tokenStack: [],
      config: n,
      enter: l,
      exit: p,
      buffer: s,
      resume: u,
      data: r
    }, je = [];
    let Re = -1;
    for (; ++Re < U.length; )
      if (U[Re][1].type === "listOrdered" || U[Re][1].type === "listUnordered")
        if (U[Re][0] === "enter")
          je.push(Re);
        else {
          const rn = je.pop();
          Re = a(U, rn, Re);
        }
    for (Re = -1; ++Re < U.length; ) {
      const rn = n[U[Re][0]];
      p1.call(rn, U[Re][1].type) && rn[U[Re][1].type].call(Object.assign({
        sliceSerialize: U[Re][2].sliceSerialize
      }, ye), U[Re][1]);
    }
    if (ye.tokenStack.length > 0) {
      const rn = ye.tokenStack[ye.tokenStack.length - 1];
      (rn[1] || Sx).call(ye, void 0, rn[0]);
    }
    for (G.position = {
      start: oi(U.length > 0 ? U[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: oi(U.length > 0 ? U[U.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Re = -1; ++Re < n.transforms.length; )
      G = n.transforms[Re](G) || G;
    return G;
  }
  function a(U, G, ye) {
    let je = G - 1, Re = -1, rn = !1, kn, an, pn, $n;
    for (; ++je <= ye; ) {
      const _n = U[je];
      switch (_n[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          _n[0] === "enter" ? Re++ : Re--, $n = void 0;
          break;
        }
        case "lineEndingBlank": {
          _n[0] === "enter" && (kn && !$n && !Re && !pn && (pn = je), $n = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          $n = void 0;
      }
      if (!Re && _n[0] === "enter" && _n[1].type === "listItemPrefix" || Re === -1 && _n[0] === "exit" && (_n[1].type === "listUnordered" || _n[1].type === "listOrdered")) {
        if (kn) {
          let Fn = je;
          for (an = void 0; Fn--; ) {
            const Ze = U[Fn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              an && (U[an][1].type = "lineEndingBlank", rn = !0), Ze[1].type = "lineEnding", an = Fn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          pn && (!an || pn < an) && (kn._spread = !0), kn.end = Object.assign({}, an ? U[an][1].start : _n[1].end), U.splice(an || je, 0, ["exit", kn, _n[2]]), je++, ye++;
        }
        if (_n[1].type === "listItemPrefix") {
          const Fn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, _n[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          kn = Fn, U.splice(je, 0, ["enter", Fn, _n[2]]), je++, ye++, pn = void 0, $n = !0;
        }
      }
    }
    return U[G][1]._spread = rn, ye;
  }
  function o(U, G) {
    return ye;
    function ye(je) {
      l.call(this, U(je), je), G && G.call(this, je);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(U, G, ye) {
    this.stack[this.stack.length - 1].children.push(U), this.stack.push(U), this.tokenStack.push([G, ye || void 0]), U.position = {
      start: oi(G.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(U) {
    return G;
    function G(ye) {
      U && U.call(this, ye), p.call(this, ye);
    }
  }
  function p(U, G) {
    const ye = this.stack.pop(), je = this.tokenStack.pop();
    if (je)
      je[0].type !== U.type && (G ? G.call(this, U, je[0]) : (je[1] || Sx).call(this, U, je[0]));
    else throw new Error("Cannot close `" + U.type + "` (" + xo({
      start: U.start,
      end: U.end
    }) + "): it’s not open");
    ye.position.end = oi(U.end);
  }
  function u() {
    return ZV(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(U) {
    if (this.data.expectingFirstListItemValue) {
      const G = this.stack[this.stack.length - 2];
      G.start = Number.parseInt(this.sliceSerialize(U), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function k() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.lang = U;
  }
  function C() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.meta = U;
  }
  function N() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U.replace(/(\r?\n|\r)$/g, "");
  }
  function g(U) {
    const G = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = G, ye.identifier = ma(this.sliceSerialize(U)).toLowerCase();
  }
  function D() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = U;
  }
  function O() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = U;
  }
  function I(U) {
    const G = this.stack[this.stack.length - 1];
    if (!G.depth) {
      const ye = this.sliceSerialize(U).length;
      G.depth = ye;
    }
  }
  function F() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function L(U) {
    const G = this.stack[this.stack.length - 1];
    G.depth = this.sliceSerialize(U).codePointAt(0) === 61 ? 1 : 2;
  }
  function K() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(U) {
    const ye = this.stack[this.stack.length - 1].children;
    let je = ye[ye.length - 1];
    (!je || je.type !== "text") && (je = ie(), je.position = {
      start: oi(U.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ye.push(je)), this.stack.push(je);
  }
  function re(U) {
    const G = this.stack.pop();
    G.value += this.sliceSerialize(U), G.position.end = oi(U.end);
  }
  function W(U) {
    const G = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ye = G.children[G.children.length - 1];
      ye.position.end = oi(U.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(G.type) && (J.call(this, U), re.call(this, U));
  }
  function Y() {
    this.data.atHardBreak = !0;
  }
  function P() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function B() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function ee() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function Ne() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = G, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function ue() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = G, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function oe(U) {
    const G = this.sliceSerialize(U), ye = this.stack[this.stack.length - 2];
    ye.label = Xz(G), ye.identifier = ma(G).toLowerCase();
  }
  function fe() {
    const U = this.stack[this.stack.length - 1], G = this.resume(), ye = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ye.type === "link") {
      const je = U.children;
      ye.children = je;
    } else
      ye.alt = G;
  }
  function V() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = U;
  }
  function ke() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = U;
  }
  function Oe() {
    this.data.inReference = void 0;
  }
  function q() {
    this.data.referenceType = "collapsed";
  }
  function Ge(U) {
    const G = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = G, ye.identifier = ma(this.sliceSerialize(U)).toLowerCase(), this.data.referenceType = "full";
  }
  function sn(U) {
    this.data.characterReferenceType = U.type;
  }
  function Ie(U) {
    const G = this.sliceSerialize(U), ye = this.data.characterReferenceType;
    let je;
    ye ? (je = r1(G, ye === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : je = og(G);
    const Re = this.stack[this.stack.length - 1];
    Re.value += je;
  }
  function Ue(U) {
    const G = this.stack.pop();
    G.position.end = oi(U.end);
  }
  function De(U) {
    re.call(this, U);
    const G = this.stack[this.stack.length - 1];
    G.url = this.sliceSerialize(U);
  }
  function Be(U) {
    re.call(this, U);
    const G = this.stack[this.stack.length - 1];
    G.url = "mailto:" + this.sliceSerialize(U);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Je() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function $e() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Me() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function en() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function le() {
    return {
      type: "break"
    };
  }
  function xe() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ve() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function vn(U) {
    return {
      type: "list",
      ordered: U.type === "listOrdered",
      start: null,
      spread: U._spread,
      children: []
    };
  }
  function Q(U) {
    return {
      type: "listItem",
      spread: U._spread,
      checked: null,
      children: []
    };
  }
  function E() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function z() {
    return {
      type: "strong",
      children: []
    };
  }
  function ie() {
    return {
      type: "text",
      value: ""
    };
  }
  function ce() {
    return {
      type: "thematicBreak"
    };
  }
}
function oi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function f1(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? f1(e, i) : tU(e, i);
  }
}
function tU(e, n) {
  let r;
  for (r in n)
    if (p1.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Sx(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + xo({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + xo({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + xo({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function rU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return eU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function iU(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function aU(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function oU(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function sU(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function lU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function cU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ia(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const p = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, p), e.applyData(n, p);
}
function dU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function uU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function h1(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function mU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return h1(e, n);
  const a = { src: Ia(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function pU(e, n) {
  const r = { src: Ia(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function fU(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function hU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return h1(e, n);
  const a = { href: Ia(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function yU(e, n) {
  const r = { href: Ia(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function gU(e, n, r) {
  const i = e.all(n), a = r ? vU(r) : y1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const p = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, p), e.applyData(n, p);
}
function vU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = y1(r[i]);
  }
  return n;
}
function y1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function kU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function bU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function _U(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function xU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function SU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = tg(n.children[1]), d = JC(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function NU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const p = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, k = s ? s[d] : void 0;
    k && (h.align = k);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), p.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(p, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function jU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Nx = 9, jx = 32;
function wU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      wx(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(wx(n.slice(a), a > 0, !1)), o.join("");
}
function wx(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Nx || o === jx; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Nx || o === jx; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function CU(e, n) {
  const r = { type: "text", value: wU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function FU(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const IU = {
  blockquote: iU,
  break: aU,
  code: oU,
  delete: sU,
  emphasis: lU,
  footnoteReference: cU,
  heading: dU,
  html: uU,
  imageReference: mU,
  image: pU,
  inlineCode: fU,
  linkReference: hU,
  link: yU,
  listItem: gU,
  list: kU,
  paragraph: bU,
  // @ts-expect-error: root is different, but hard to type.
  root: _U,
  strong: xU,
  table: SU,
  tableCell: jU,
  tableRow: NU,
  text: CU,
  thematicBreak: FU,
  toml: ss,
  yaml: ss,
  definition: ss,
  footnoteDefinition: ss
};
function ss() {
}
const g1 = -1, Ll = 0, sl = 1, ll = 2, cg = 3, dg = 4, ug = 5, mg = 6, v1 = 7, k1 = 8, Cx = typeof self == "object" ? self : globalThis, EU = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Ll:
      case g1:
        return r(s, a);
      case sl: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case ll: {
        const l = r({}, a);
        for (const [d, p] of s)
          l[i(d)] = i(p);
        return l;
      }
      case cg:
        return r(new Date(s), a);
      case dg: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case ug: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, p] of s)
          l.set(i(d), i(p));
        return l;
      }
      case mg: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case v1: {
        const { name: l, message: d } = s;
        return r(new Cx[l](d), a);
      }
      case k1:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Cx[o](s), a);
  };
  return i;
}, Fx = (e) => EU(/* @__PURE__ */ new Map(), e)(0), Xi = "", { toString: $U } = {}, { keys: TU } = Object, Ja = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ll, n];
  const r = $U.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [sl, Xi];
    case "Object":
      return [ll, Xi];
    case "Date":
      return [cg, Xi];
    case "RegExp":
      return [dg, Xi];
    case "Map":
      return [ug, Xi];
    case "Set":
      return [mg, Xi];
  }
  return r.includes("Array") ? [sl, r] : r.includes("Error") ? [v1, r] : [ll, r];
}, ls = ([e, n]) => e === Ll && (n === "function" || n === "symbol"), OU = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = Ja(s);
    switch (l) {
      case Ll: {
        let u = s;
        switch (d) {
          case "bigint":
            l = k1, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([g1], s);
        }
        return a([l, u], s);
      }
      case sl: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case ll: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of TU(s))
          (e || !ls(Ja(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case cg:
        return a([l, s.toISOString()], s);
      case dg: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case ug: {
        const u = [], f = a([l, u], s);
        for (const [h, k] of s)
          (e || !(ls(Ja(h)) || ls(Ja(k)))) && u.push([o(h), o(k)]);
        return f;
      }
      case mg: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !ls(Ja(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: p } = s;
    return a([l, { name: d, message: p }], s);
  };
  return o;
}, Ix = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return OU(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, cl = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Fx(Ix(e, n)) : structuredClone(e)
) : (e, n) => Fx(Ix(e, n));
function RU(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function DU(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function PU(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || RU, i = e.options.footnoteBackLabel || DU, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const p = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!p)
      continue;
    const u = e.all(p), f = String(p.identifier).toUpperCase(), h = Ia(f.toLowerCase());
    let k = 0;
    const C = [], N = e.footnoteCounts.get(f);
    for (; N !== void 0 && ++k <= N; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, k);
      typeof g == "string" && (g = { type: "text", value: g }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (k > 1 ? "-" + k : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, k),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const j = u[u.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const g = j.children[j.children.length - 1];
      g && g.type === "text" ? g.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...C);
    } else
      u.push(...C);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(p, _), l.push(_);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...cl(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const b1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return zU;
    if (typeof e == "function")
      return Vl(e);
    if (typeof e == "object")
      return Array.isArray(e) ? AU(e) : LU(e);
    if (typeof e == "string")
      return VU(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function AU(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = b1(e[r]);
  return Vl(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function LU(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Vl(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function VU(e) {
  return Vl(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Vl(e) {
  return n;
  function n(r, i, a) {
    return !!(UU(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function zU() {
  return !0;
}
function UU(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const _1 = [], MU = !0, Ex = !1, BU = "skip";
function qU(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = b1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, p, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const k = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (k ? "<" + k + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let k = _1, C, N, j;
      if ((!n || o(d, p, u[u.length - 1] || void 0)) && (k = HU(r(d, u)), k[0] === Ex))
        return k;
      if ("children" in d && d.children) {
        const _ = (
          /** @type {UnistParent} */
          d
        );
        if (_.children && k[0] !== BU)
          for (N = (i ? _.children.length : -1) + s, j = u.concat(_); N > -1 && N < _.children.length; ) {
            const g = _.children[N];
            if (C = l(g, N, j)(), C[0] === Ex)
              return C;
            N = typeof C[1] == "number" ? C[1] : N + s;
          }
      }
      return k;
    }
  }
}
function HU(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [MU, e] : e == null ? _1 : [e];
}
function x1(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), qU(e, o, l, a);
  function l(d, p) {
    const u = p[p.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const Bh = {}.hasOwnProperty, WU = {};
function KU(e, n) {
  const r = n || WU, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...IU, ...r.handlers }, l = {
    all: p,
    applyData: YU,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: GU,
    wrap: QU
  };
  return x1(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, k = l.handlers[h];
    if (Bh.call(l.handlers, h) && k)
      return k(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: N, ...j } = u, _ = cl(j);
        return _.children = l.all(u), _;
      }
      return cl(u);
    }
    return (l.options.unknownHandler || JU)(l, u, f);
  }
  function p(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let k = -1;
      for (; ++k < h.length; ) {
        const C = l.one(h[k], u);
        if (C) {
          if (k && h[k - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = $x(C.value)), !Array.isArray(C) && C.type === "element")) {
            const N = C.children[0];
            N && N.type === "text" && (N.value = $x(N.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function GU(e, n) {
  e.position && (n.position = IV(e));
}
function YU(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, cl(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function JU(e, n) {
  const r = n.data || {}, i = "value" in n && !(Bh.call(r, "hProperties") || Bh.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function QU(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function $x(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Tx(e, n) {
  const r = KU(e, n), i = r.one(e, void 0), a = PU(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function XU(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Tx(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Tx(r, { file: i, ...e || n })
    );
  };
}
function Ox(e) {
  if (e)
    throw e;
}
var rm, Rx;
function ZU() {
  if (Rx) return rm;
  Rx = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(p) {
    return typeof Array.isArray == "function" ? Array.isArray(p) : n.call(p) === "[object Array]";
  }, o = function(p) {
    if (!p || n.call(p) !== "[object Object]")
      return !1;
    var u = e.call(p, "constructor"), f = p.constructor && p.constructor.prototype && e.call(p.constructor.prototype, "isPrototypeOf");
    if (p.constructor && !u && !f)
      return !1;
    var h;
    for (h in p)
      ;
    return typeof h > "u" || e.call(p, h);
  }, s = function(p, u) {
    r && u.name === "__proto__" ? r(p, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : p[u.name] = u.newValue;
  }, l = function(p, u) {
    if (u === "__proto__")
      if (e.call(p, u)) {
        if (i)
          return i(p, u).value;
      } else return;
    return p[u];
  };
  return rm = function d() {
    var p, u, f, h, k, C, N = arguments[0], j = 1, _ = arguments.length, g = !1;
    for (typeof N == "boolean" && (g = N, N = arguments[1] || {}, j = 2), (N == null || typeof N != "object" && typeof N != "function") && (N = {}); j < _; ++j)
      if (p = arguments[j], p != null)
        for (u in p)
          f = l(N, u), h = l(p, u), N !== h && (g && h && (o(h) || (k = a(h))) ? (k ? (k = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(N, { name: u, newValue: d(g, C, h) })) : typeof h < "u" && s(N, { name: u, newValue: h }));
    return N;
  }, rm;
}
var eM = ZU();
const im = /* @__PURE__ */ hy(eM);
function qh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function nM() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...p) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (p[f] === null || p[f] === void 0) && (p[f] = a[f]);
      a = p, u ? tM(u, l)(...p) : s(null, ...p);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function tM(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (p) {
      const u = (
        /** @type {Error} */
        p
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Ar = { basename: rM, dirname: iM, extname: aM, join: oM, sep: "/" };
function rM(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Bo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function iM(e) {
  if (Bo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function aM(e) {
  Bo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function oM(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    Bo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : sM(r);
}
function sM(e) {
  Bo(e);
  const n = e.codePointAt(0) === 47;
  let r = lM(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function lM(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function Bo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const cM = { cwd: dM };
function dM() {
  return "/";
}
function Hh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function uM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Hh(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return mM(e);
}
function mM(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const am = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class S1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? Hh(n) ? r = { path: n } : typeof n == "string" || pM(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : cM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < am.length; ) {
      const o = am[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      am.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ar.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    sm(n, "basename"), om(n, "basename"), this.path = Ar.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ar.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Dx(this.basename, "dirname"), this.path = Ar.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ar.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (om(n, "extname"), Dx(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ar.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Hh(n) && (n = uM(n)), sm(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ar.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    sm(n, "stem"), om(n, "stem"), this.path = Ar.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Bt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function om(e, n) {
  if (e && e.includes(Ar.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Ar.sep + "`"
    );
}
function sm(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Dx(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function pM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const fM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), hM = {}.hasOwnProperty;
class pg extends fM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = nM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new pg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(im(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (dm("data", this.frozen), this.namespace[n] = r, this) : hM.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (dm("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = cs(n), i = this.parser || this.Parser;
    return lm("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), lm("process", this.parser || this.Parser), cm("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = cs(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return p(u);
        const k = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(k, h);
        vM(C) ? h.value = C : h.result = C, p(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function p(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), lm("processSync", this.parser || this.Parser), cm("processSync", this.compiler || this.Compiler), this.process(n, a), Ax("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Ox(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Px(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = cs(r);
      a.run(n, d, p);
      function p(u, f, h) {
        const k = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(k) : i(void 0, k, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Ax("runSync", "run", i), a;
    function o(s, l) {
      Ox(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = cs(r), a = this.compiler || this.Compiler;
    return cm("stringify", a), Px(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (dm("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(p) {
      if (typeof p == "function")
        d(p, []);
      else if (typeof p == "object")
        if (Array.isArray(p)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            p
          );
          d(u, f);
        } else
          s(p);
      else
        throw new TypeError("Expected usable value, not `" + p + "`");
    }
    function s(p) {
      if (!("plugins" in p) && !("settings" in p))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(p.plugins), p.settings && (a.settings = im(!0, a.settings, p.settings));
    }
    function l(p) {
      let u = -1;
      if (p != null) if (Array.isArray(p))
        for (; ++u < p.length; ) {
          const f = p[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + p + "`");
    }
    function d(p, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === p) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([p, ...u]);
      else if (u.length > 0) {
        let [k, ...C] = u;
        const N = i[h][1];
        qh(N) && qh(k) && (k = im(!0, N, k)), i[h] = [p, k, ...C];
      }
    }
  }
}
const yM = new pg().freeze();
function lm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function cm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function dm(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Px(e) {
  if (!qh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Ax(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function cs(e) {
  return gM(e) ? e : new S1(e);
}
function gM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function vM(e) {
  return typeof e == "string" || kM(e);
}
function kM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const bM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Lx = [], Vx = { allowDangerousHtml: !0 }, _M = /^(https?|ircs?|mailto|xmpp)$/i, xM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function SM(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Lx, d = e.remarkPlugins || Lx, p = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Vx } : Vx, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || NM, k = yM().use(rU).use(d).use(XU, p).use(l), C = new S1();
  typeof i == "string" && (C.value = i);
  for (const g of xM)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + bM + g.id, void 0);
  const N = k.parse(C);
  let j = k.runSync(N, C);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), x1(j, _), DV(j, {
    Fragment: Zn.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Zn.jsx,
    jsxs: Zn.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function _(g, D, O) {
    if (g.type === "raw" && O && typeof D == "number")
      return u ? O.children.splice(D, 1) : O.children[D] = { type: "text", value: g.value }, D;
    if (g.type === "element") {
      let I;
      for (I in em)
        if (Object.hasOwn(em, I) && Object.hasOwn(g.properties, I)) {
          const F = g.properties[I], L = em[I];
          (L === null || L.includes(g.tagName)) && (g.properties[I] = h(String(F || ""), I, g));
        }
    }
    if (g.type === "element") {
      let I = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!I && r && typeof D == "number" && (I = !r(g, D, O)), I && O && typeof D == "number")
        return f && g.children ? O.children.splice(D, 1, ...g.children) : O.children.splice(D, 1), D;
    }
  }
}
function NM(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    _M.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var um = { exports: {} }, Qa = {}, zx;
function jM() {
  if (zx) return Qa;
  zx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Qa.Fragment = r, Qa.jsx = s, Qa.jsxs = s, Qa;
}
var ds = {}, Ux;
function wM() {
  return Ux || (Ux = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ds.Fragment = i, ds.jsx = zn, ds.jsxs = Wn;
  })()), ds;
}
var Mx;
function CM() {
  return Mx || (Mx = 1, process.env.NODE_ENV === "production" ? um.exports = jM() : um.exports = wM()), um.exports;
}
var ae = CM();
const FM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, IM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, EM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, $M = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, TM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, OM = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": FM,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": IM,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": EM,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": $M,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": TM
};
function qo(e) {
  return OM[e] ?? {};
}
const RM = qo(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), DM = qo(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), us = ({
  title: e,
  children: n
}) => /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), PM = "_issueAvatar_kc0sw_1", AM = "_issueField_kc0sw_9", LM = "_issueDescription_kc0sw_12", ms = {
  issueAvatar: PM,
  issueField: AM,
  issueDescription: LM
}, N1 = ({ issue: e }) => /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
  /* @__PURE__ */ ae.jsx(us, { title: "Assignee", children: /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: ms.issueAvatar,
      children: [
        /* @__PURE__ */ ae.jsx(
          py,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ ae.jsx($.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ ae.jsx(us, { title: "Team", children: /* @__PURE__ */ ae.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ms.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ ae.jsx(us, { title: "Project", children: /* @__PURE__ */ ae.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ms.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ ae.jsx(us, { title: "Description", children: /* @__PURE__ */ ae.jsx(SM, { className: ms.issueDescription, children: e.description }) })
] }), VM = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), zM = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), UM = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), MM = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), BM = /* @__PURE__ */ ae.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), j1 = {
  0: VM,
  1: BM,
  2: MM,
  3: UM,
  4: zM
}, qM = (e) => e in j1, dl = ({ priority: e }) => qM(e) ? j1[e] : /* @__PURE__ */ ae.jsx(Jn, { "data-testid": "defaultPriorityTag", children: e }), HM = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), WM = (e, n) => /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ ae.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ ae.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), KM = (e, n) => /* @__PURE__ */ ae.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ ae.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ ae.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), GM = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), YM = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), JM = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Wh = {
  backlog: (e, n) => HM(e, n),
  unstarted: (e, n) => WM(e, n),
  started: (e, n) => KM(e, n),
  done: (e, n) => GM(e, n),
  canceled: (e, n) => YM(e, n),
  completed: (e, n) => JM(e, n)
}, QM = (e) => e in Wh, ul = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => QM(e) ? Wh[e](n, r) : Wh.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), XM = "_wrapper_e0qj3_1", ZM = "_resultTitle_e0qj3_21", e4 = "_resultTooltipTitle_e0qj3_28", n4 = "_resultLinkIcon_e0qj3_31", Xa = {
  wrapper: XM,
  resultTitle: ZM,
  resultTooltipTitle: e4,
  resultLinkIcon: n4
}, t4 = ({
  issue: e
}) => {
  const [n, r] = me(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = uy(dI()), o = _t(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ ae.jsx(
    Xe,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", className: Xa.wrapper, children: [
        /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ ae.jsx(
              ul,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ ae.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ ae.jsx(dl, { priority: e.priority })
          ] }),
          /* @__PURE__ */ ae.jsx(Jn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ ae.jsx(
            $.Heading,
            {
              variant: "heading-3",
              className: Xa.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ ae.jsx(N1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ ae.jsx(
        mt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Xa.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ae.jsx(
                    ul,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ ae.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ ae.jsx(dl, { priority: e.priority })
                ] }),
                /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "4", className: Xa.resultTitle, children: e.title }),
                n && /* @__PURE__ */ ae.jsx(
                  ve,
                  {
                    className: Xa.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, r4 = "_loader_13xpk_1", i4 = "_dropdown_13xpk_8", a4 = "_loadMore_13xpk_13", mm = {
  loader: r4,
  dropdown: i4,
  loadMore: a4
}, o4 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = me(), [a, o] = me([]), [s, l] = me(""), [d, p] = me(!1), { useLazyQuery: u } = hn(), [f, { data: h, loading: k, networkStatus: C }] = u(
    RM,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  yi(
    () => {
      !k && s !== "" && C === tr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Qe(() => {
    k || o([]);
  }, [s]), Qe(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: O }) => O
      ), _ = a.filter(
        (O) => !n.find((I) => I.id === O.id)
      ), g = _.filter(
        (O) => !j.find(
          (I) => I.id === O.id
        )
      ), D = j.filter(
        (O) => !n.find((I) => I.id === O.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...D] : D
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [..._, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && p(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const N = () => {
    !k && s !== "" && C === tr.ready ? (p(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ ae.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ ae.jsxs(
    ci,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: mm.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const _ = j.target.value;
          l(_);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ ae.jsx(t4, { issue: j }, j.id)),
        r?.hasNextPage && !k && s !== "" && a.length && /* @__PURE__ */ ae.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => N(),
            className: mm.loadMore,
            children: /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        k && s !== "" && /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", className: mm.loader, children: /* @__PURE__ */ ae.jsx(fn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !k && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, s4 = "_collapse_su0f9_1", l4 = "_collapseHeader_su0f9_8", c4 = "_collapseContent_su0f9_31", d4 = "_url_su0f9_35", u4 = "_externalLink_su0f9_51", m4 = "_emptyState_su0f9_55", si = {
  collapse: s4,
  collapseHeader: l4,
  collapseContent: c4,
  url: d4,
  externalLink: u4,
  emptyState: m4
}, p4 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = me(s), { track: p } = Cn();
  return n ? /* @__PURE__ */ ae.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ ae.jsx(
          $.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: si.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(ve, { name: "external-link" }),
            variant: "tertiary",
            className: si.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ ae.jsxs(
            br,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: si.collapse,
              children: [
                /* @__PURE__ */ ae.jsx(br.Header, { className: si.collapseHeader, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ ae.jsx(Xe, { content: /* @__PURE__ */ ae.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(
                        ul,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ ae.jsxs(
                        $.ExternalLink,
                        {
                          className: si.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ ae.jsx(ve, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ ae.jsx(Xe, { content: /* @__PURE__ */ ae.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(dl, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ ae.jsx(Jn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ ae.jsx(br.Content, { className: si.collapseContent, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ ae.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ ae.jsx(Jn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(N1, { issue: u }),
                  /* @__PURE__ */ ae.jsx(
                    ct,
                    {
                      slotStart: /* @__PURE__ */ ae.jsx(ve, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ ae.jsxs(
                    Lt,
                    {
                      slotEnd: /* @__PURE__ */ ae.jsx(ve, { name: "external-link" }),
                      variant: "tertiary",
                      className: si.externalLink,
                      onClick: () => {
                        p("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ ae.jsx(
          ct,
          {
            slotStart: /* @__PURE__ */ ae.jsx(ve, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(ve, { name: "external-link" }),
            variant: "tertiary",
            className: si.externalLink,
            onClick: () => {
              p("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, f4 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, w1 = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => w1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, h4 = "_modalBody_iv3ua_1", y4 = "_error_iv3ua_5", g4 = "_dropdown_iv3ua_16", Zi = {
  modalBody: h4,
  error: y4,
  dropdown: g4
}, v4 = qo(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), k4 = qo(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), b4 = qo(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), _4 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = hn(), { control: p, handleSubmit: u, reset: f } = ut(), [h, k] = me([]), [C, N] = me(), [j, _] = me([]), [g, D] = me(), [O, I] = me([]), [F, L] = me(), [K, J] = me([]), [re, W] = me(), [Y, P] = me([]), [B, ee] = me(), [Ne, ue] = me(!1), { useMutation: oe } = hn(), { track: fe } = Cn(), [V, { loading: ke }] = oe(
    v4,
    {
      onError: () => {
        ue(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: ($e) => {
        const Me = {
          identifier: $e.Linear?.issueCreate?.issue?.identifier,
          url: $e.Linear?.issueCreate?.issue?.url
        };
        $e.Linear && $e.Linear?.issueCreate?.issue?.id && (a($e.Linear?.issueCreate?.issue?.id), Be(Me), ue(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${$e.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), fe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Oe,
    { data: q, loading: Ge, error: sn }
  ] = l(k4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: ($e) => {
      const Me = $e.Linear.teams.edges.map(
        ({ node: en }) => en
      );
      k(Me), J($e.Linear.issuePriorityValues), s(`${E4}${$e.Linear.organization.urlKey}`);
    }
  }), [Ie, { data: Ue, loading: De }] = l(b4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: ($e) => {
      const Me = $e?.Linear?.team?.projects?.edges?.map(
        ({ node: le }) => le
      );
      _(Me);
      const en = $e?.Linear?.team?.states?.edges?.map(
        ({ node: le }) => le
      );
      I(en);
      const se = $e?.Linear?.team?.templates?.edges?.map(
        ({ node: le }) => le
      );
      P(
        se.filter(
          (le) => le.type === "issue"
        )
      );
    }
  }), Be = ($e) => {
    r(!1), D(void 0), N(void 0), L(void 0), W(void 0), ee(void 0), $e && (e($e), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = ($e) => {
    q && !Ge && (V({
      variables: {
        issueTitle: $e.title,
        issueDescription: $e?.description,
        teamId: $e.team.id,
        projectId: $e?.project?.id,
        statusId: $e?.status?.id,
        priority: $e?.priority?.priority
      }
    }), ue(!0));
  };
  Qe(() => {
    n && Oe();
  }, [n]);
  const Je = () => {
    fe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ ae.jsxs(
    wt,
    {
      isOpen: n,
      onClose: () => {
        Je(), Be();
      },
      children: [
        /* @__PURE__ */ ae.jsx(
          Ct,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Je(), Be();
            }
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Ft,
          {
            className: Zi.modalBody,
            "data-testid": "createIssueModalBody",
            children: sn ? /* @__PURE__ */ ae.jsx(En, { error: sn }) : /* @__PURE__ */ ae.jsx("form", { onSubmit: u(Ae), id: "issueCreationForm", children: /* @__PURE__ */ ae.jsxs(nt, { children: [
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: p,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: $e, onChange: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ ae.jsx(
                    We,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: en?.message ?? null
                      },
                      children: /* @__PURE__ */ ae.jsx(
                        ci,
                        {
                          dropdownProps: { className: Zi.dropdown },
                          placeholder: "Select Linear team",
                          className: dt({ [Zi.error]: en }),
                          getItemTitleByValue: (se) => se?.name,
                          onChange: (se) => {
                            D(void 0), L(void 0), W(void 0), ee(void 0), N(se.selectedValues[0]), Ie({
                              variables: { teamId: se.selectedValues[0].id }
                            }), Me(se.selectedValues[0]);
                          },
                          value: C ? [$e] : void 0,
                          children: h?.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx($.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: p,
                  name: "project",
                  render: ({ field: { value: $e, onChange: Me } }) => {
                    const en = De ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ ae.jsx(We, { label: "Project", children: /* @__PURE__ */ ae.jsx(
                      ci,
                      {
                        dropdownProps: { className: Zi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (se) => {
                          D(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: g ? [$e] : en,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          De && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          Ue && !De && j.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx($.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 6, children: /* @__PURE__ */ ae.jsx(We, { label: "Template", children: /* @__PURE__ */ ae.jsx(
                ci,
                {
                  clearable: !0,
                  dropdownProps: { className: Zi.dropdown },
                  disabled: !C || De,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: ($e) => $e?.name,
                  onChange: ($e) => {
                    if ($e.selectedValues.length > 0) {
                      ee($e.selectedValues[0]);
                      const Me = JSON.parse(
                        $e.selectedValues[0].templateData
                      ), en = K.filter(
                        (Ve) => Ve.priority === Me.priority
                      );
                      W(
                        en ? en[0] : void 0
                      );
                      const se = O.filter(
                        (Ve) => Ve.id === Me.stateId
                      );
                      L(
                        se ? se[0] : void 0
                      );
                      const le = j.filter(
                        (Ve) => Ve.id === Me.projectId
                      );
                      D(
                        le ? le[0] : void 0
                      );
                      const xe = Me.description;
                      f({
                        title: Me?.title,
                        priority: en[0],
                        status: se[0],
                        project: le[0],
                        description: xe ? w1(xe, f4) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), D(void 0), W(void 0), L(void 0), ee(void 0);
                  },
                  value: B ? [B] : void 0,
                  children: Y?.map(($e) => /* @__PURE__ */ ae.jsx(
                    mt.Item,
                    {
                      value: $e,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ ae.jsx($.Paragraph, { children: $e.name })
                    },
                    $e.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 6, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: p,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: $e, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ ae.jsx(
                    qr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Me || "",
                        onChange: $e
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: p,
                  name: "status",
                  render: ({ field: { value: $e, onChange: Me } }) => {
                    const en = De ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(We, { label: "Status", children: /* @__PURE__ */ ae.jsx(
                      ci,
                      {
                        dropdownProps: { className: Zi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (se) => {
                          L(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: F ? [$e] : en,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          De && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          Ue && !De && O.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      ul,
                                      {
                                        type: se.type,
                                        color: se.color,
                                        name: se.name
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx($.Paragraph, { children: se.name })
                                  ]
                                }
                              )
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: p,
                  name: "priority",
                  render: ({ field: { value: $e, onChange: Me } }) => {
                    const en = Ge ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(We, { label: "Priority", children: /* @__PURE__ */ ae.jsx(
                      ci,
                      {
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (se) => {
                          W(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: re ? [$e] : en,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          De && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          q && !Ge && K.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      dl,
                                      {
                                        priority: se.priority
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx($.Paragraph, { children: se.label })
                                  ]
                                }
                              )
                            },
                            se.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: p,
                  name: "description",
                  render: ({
                    field: { onChange: $e, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ ae.jsx(
                    lI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Me || "",
                        onChange: $e
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Et,
          {
            confirmOnClick: u(Ae),
            confirmProps: {
              disabled: ke || !q,
              isLoading: Ne || Ge || De,
              loadingIndicator: /* @__PURE__ */ ae.jsx(fn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Je(), Be();
            }
          }
        )
      ]
    }
  );
}, x4 = "_modalWrapper_4kh9u_1", S4 = "_copyButton_4kh9u_6", N4 = "_copyWrapper_4kh9u_15", j4 = "_copyField_4kh9u_24", w4 = "_externalLink_4kh9u_47", C4 = "_externalLinkIcon_4kh9u_52", F4 = "_textWrapper_4kh9u_56", xi = {
  modalWrapper: x4,
  copyButton: S4,
  copyWrapper: N4,
  copyField: j4,
  externalLink: w4,
  externalLinkIcon: C4,
  textWrapper: F4
}, I4 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ ae.jsxs(
  wt,
  {
    isOpen: !!n && e,
    className: xi.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ ae.jsx(
        Ct,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ ae.jsx(Ft, { children: /* @__PURE__ */ ae.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ ae.jsxs($.Paragraph, { className: xi.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ ae.jsxs(
                $.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: xi.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ ae.jsx(ve, { name: "external-link", className: xi.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ ae.jsx(We, { label: "Linear issue link", children: /* @__PURE__ */ ae.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: xi.copyWrapper,
                children: [
                  /* @__PURE__ */ ae.jsx(
                    cr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: xi.copyField
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(
                    cI,
                    {
                      className: xi.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ ae.jsx(
        Et,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), E4 = "https://linear.app/", $4 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), [a, o] = me([]), [s, l] = me(!1), [d, p] = me(!1), [u, f] = me(!1), [h, k] = me(), { useLazyQuery: C } = hn(), [N, j] = me(""), _ = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: D } = Cn(), {
    loading: O,
    data: I,
    error: F,
    store: L
  } = dy(e?.conversationId ?? null), [
    K,
    {
      data: J,
      loading: re,
      networkStatus: W,
      error: Y
    }
  ] = C(DM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    !O && !F && I && I?.linear?.issues?.length > 0 ? (o(I.linear.issues), K({
      variables: {
        linkedIssues: I.linear.issues
      }
    })) : !O && !F && (i([]), o([]));
  }, [I, O, F]), Qe(() => {
    J && J?.Linear && !re && W === tr.ready && Object.keys(J).length > 0 && i(J.Linear.issues?.edges?.map(({ node: ue }) => ue));
  }, [J, re, W]);
  const P = (ue) => {
    ue && ue?.team?.organization?.urlKey && D("linear:link:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: ue.id
    });
    const oe = (fe) => fe.id === ue?.id;
    r.some((fe) => fe && oe(fe)) || (I && a.length === 0 && o([]), L({
      linear: {
        issues: [...a, ue.id]
      }
    }));
  }, B = (ue) => {
    const oe = I?.linear.issues.filter((fe) => fe !== ue) || [];
    D("linear:unlink:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: ue
    }), i(r.filter(({ id: fe }) => fe !== ue)), o(oe), L({
      linear: {
        issues: oe
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), L({
      linear: {
        issues: []
      }
    });
  }, Ne = O || re || !I && !F || (I?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !O && !re && (Y || F) ? /* @__PURE__ */ ae.jsx(En, { error: Y || F }) : /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ ae.jsxs(
      wt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ ae.jsx(
            Ct,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ ae.jsx(Ft, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ ae.jsx(
            Et,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      _4,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ue) => p(ue),
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        addToLinkedIssueIds: (ue) => {
          L({
            linear: {
              issues: [...a, ue]
            }
          });
        },
        setCreatedIssue: (ue) => k(ue),
        organizationUrl: N,
        setOrganizationUrl: (ue) => j(ue)
      }
    ),
    /* @__PURE__ */ ae.jsx(
      I4,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          _ && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
            /* @__PURE__ */ ae.jsx(
              ct,
              {
                variant: "primary",
                onClick: () => {
                  D("linear:create:new:issue:clicked", {
                    linearInstanceUrl: N
                  }), p(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ ae.jsx($.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ ae.jsx(o4, { handleSelect: P, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      p4,
      {
        linkedIssues: r,
        isLoading: Ne,
        handleUnlinkIssue: B,
        showUnlinkAllModal: (ue) => l(ue),
        showUnlinkAllButton: g,
        organizationUrl: N
      }
    )
  ] });
}, Kh = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Si = "LINEAR", T4 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, O4 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: T4
  }), {
    create: d,
    update: p,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = dr({
    integrationId: e,
    integrationType: Si,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = ur({
    integrationId: e,
    fieldDefinitions: Kh,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = mr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => fr(J, {
    fieldDefinitions: Kh,
    isCreationMode: s,
    create: d,
    update: p,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ ae.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ ae.jsx(hr, { cause: k }),
        /* @__PURE__ */ ae.jsxs(nt, { children: [
          /* @__PURE__ */ ae.jsx(Z, { children: /* @__PURE__ */ ae.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ae.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(We, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ ae.jsx(
            bn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(We, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ ae.jsx(
            bn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ ae.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Si,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ ae.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ ae.jsx(
          yr,
          {
            integrationType: Si,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ae.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ae.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Si,
                  " integration, all links between Dixa and ",
                  Si,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ae.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Si,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ae.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Si,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pm = { exports: {} }, Za = {}, Bx;
function R4() {
  if (Bx) return Za;
  Bx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Za.Fragment = r, Za.jsx = s, Za.jsxs = s, Za;
}
var ps = {}, qx;
function D4() {
  return qx || (qx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ps.Fragment = i, ps.jsx = zn, ps.jsxs = Wn;
  })()), ps;
}
var Hx;
function P4() {
  return Hx || (Hx = 1, process.env.NODE_ENV === "production" ? pm.exports = R4() : pm.exports = D4()), pm.exports;
}
var Fe = P4();
const A4 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, L4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, V4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, z4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, U4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, M4 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": A4,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": L4,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": V4,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": z4,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": U4
};
function zl(e) {
  return M4[e] ?? {};
}
const B4 = zl(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), q4 = zl(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), H4 = zl(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), W4 = zl(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function fm(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const K4 = "_wrapper_27vny_1", G4 = "_copyIcon_27vny_12", eo = {
  wrapper: K4,
  copyIcon: G4
}, Y4 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = fm(), { isCopied: i, copy: a } = fm(), { isCopied: o, copy: s } = fm();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: p,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: k,
    enrolled_at: C,
    referral_url: N
  } = e, j = f ? Gn(f).isSame(Date.now(), "day") : !1, { name: _, first_name: g, last_name: D } = p ?? {}, O = _ ?? (`${g} ${D}`.trim() || "A customer has no name"), I = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: eo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: eo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-2", children: O }),
          j && /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "secondary", children: Gn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    k && /* @__PURE__ */ Fe.jsx(b, { gap: "200", children: /* @__PURE__ */ Fe.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Gn(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(ve, { size: l, name: "mail" }),
        /* @__PURE__ */ Fe.jsx($.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: eo.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(ve, { size: l, name: "link" }),
        /* @__PURE__ */ Fe.jsx(Xe, { content: "Shopify shop", children: /* @__PURE__ */ Fe.jsx(
          $.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: eo.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(ve, { size: l, name: "external-link" }),
        /* @__PURE__ */ Fe.jsx(Xe, { content: "Referral link", children: /* @__PURE__ */ Fe.jsx(
          $.ExternalLink,
          {
            href: N,
            target: "_blank",
            rel: "noreferrer",
            children: N.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: eo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, J4 = "_list_1q5b5_5", Q4 = "_listItem_1q5b5_8", X4 = "_listItemEdit_1q5b5_15", Z4 = "_notificationText_1q5b5_19", va = {
  list: J4,
  listItem: Q4,
  listItemEdit: X4,
  notificationText: Z4
}, e5 = "_modalBody_1clhs_1", n5 = {
  modalBody: e5
}, t5 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), [d, p] = me(n), [u, f] = me(""), [h, k] = me(), [C, { loading: N }] = o(
    H4,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), W();
      }
    }
  ), [j, { loading: _ }] = o(W4), g = N || _, D = !!h, O = n === d ? "Change the value to update the points" : "", I = isNaN(d), F = I ? "Points can not be empty" : "", L = d > n && d - n > 1e6, K = L ? "Points can not exceed 1,000,000" : "", J = () => {
    if (!r) {
      k(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((Y) => {
      const P = Y?.networkError;
      (P ? P?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), W()) : (l("loyaltylion:add:points:failed"), k(["Failed to add points, try again later."]));
    }), d < n && j({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((Y) => {
      Y.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), W()) : "errors" in Y && (l("loyaltylion:remove:points:failed"), k(
        Y.errors?.map((P) => P.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), k(["Failed to remove points, try again later."]);
    });
  }, re = () => {
    I && p(n), f(""), i();
  }, W = () => {
    a(), re();
  };
  return /* @__PURE__ */ Fe.jsxs(
    wt,
    {
      isOpen: e,
      onClose: re,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Fe.jsx(Ct, { title: "Change points", onClose: re }),
        /* @__PURE__ */ Fe.jsxs(Ft, { className: n5.modalBody, children: [
          /* @__PURE__ */ Fe.jsxs(nt, { children: [
            /* @__PURE__ */ Fe.jsx(Z, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              qr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: K || F,
                  warning: O
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (Y) => p(Y?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Fe.jsx(Z, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              qr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (Y) => f(Y?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && D && /* @__PURE__ */ Fe.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Fe.jsx(Ye, { children: h?.map((Y, P) => /* @__PURE__ */ Fe.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: Y,
              contentLeft: /* @__PURE__ */ Fe.jsx(
                ve,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            P
          )) }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => J(),
            confirmProps: {
              isLoading: g,
              disabled: I || L || n === d,
              loadingIndicator: /* @__PURE__ */ Fe.jsx(fn, { size: 16 })
            },
            cancelOnClick: re
          }
        )
      ]
    }
  );
}, r5 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Fe.jsx(Ye.Text, { variant: "dense", className: va.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Fe.jsx(Xe, { content: "Edit points", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: va.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Mn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, i5 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = me(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, p = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Fe.jsx(Ye, { className: va.list, children: p.map(({ id: u, points: f, label: h, setIsModalOpen: k }) => /* @__PURE__ */ Fe.jsx(
      r5,
      {
        points: f,
        label: h,
        setIsModalOpen: k
      },
      u
    )) }),
    /* @__PURE__ */ Fe.jsx(
      t5,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, a5 = "_reward_1wxia_1", o5 = {
  reward: a5
}, s5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Fe.jsx(b, { gap: "100", flexDirection: "column", className: o5.reward, children: /* @__PURE__ */ Fe.jsx(Xe, { content: a ?? "No description", children: /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ve, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Fe.jsxs(Mn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        $.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, l5 = ({ customer: e }) => {
  const { useQuery: n } = hn(), [r, i] = me(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(q4, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return ba({ errors: d }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "No rewards found"
      }
    ) : aw({ errors: d }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Fe.jsx(En, { error: s });
  }
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(fn, {}) }) : /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Fe.jsx(s5, { reward: d }, d.id)) })
  ] });
}, c5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Xe, { content: "Insights segment", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, d5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = Cn(), [a, o] = me(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: p,
    showAvailableRewards: u
  } = n, f = !l && !d && !p && !u, {
    loading: h,
    error: k,
    data: C,
    refetch: N
  } = r(B4, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Qe(() => {
    if (C && !h) {
      const j = (C?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? k ? ba({
    errors: k.graphQLErrors
  }) ? /* @__PURE__ */ Fe.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: va.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(En, { error: k }) : h ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(fn, {}) }) : f ? /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Fe.jsxs(Fe.Fragment, { children: [
        l && /* @__PURE__ */ Fe.jsx(Y4, { customer: a }),
        d && /* @__PURE__ */ Fe.jsx(c5, { customer: a }),
        p && /* @__PURE__ */ Fe.jsx(
          i5,
          {
            customer: a,
            refetchCustomerData: N
          }
        ),
        u && /* @__PURE__ */ Fe.jsx(l5, { customer: a })
      ] }) : /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Gh = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Wx = "LOYALTYLION", u5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, m5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: u5
  }), {
    create: l,
    update: d,
    remove: p,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: Wx,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: Gh,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => fr(K, {
    fieldDefinitions: Gh,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ Fe.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Fe.jsx(hr, { cause: h }),
        /* @__PURE__ */ Fe.jsxs(nt, { children: [
          /* @__PURE__ */ Fe.jsx(Z, { children: /* @__PURE__ */ Fe.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            ZF,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: "Show customer summary", children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: "Show tags", children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: "Show points balance", children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: "Show available rewards", children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ Fe.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          yr,
          {
            integrationType: Wx,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hm = { exports: {} }, no = {}, Kx;
function p5() {
  if (Kx) return no;
  Kx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return no.Fragment = r, no.jsx = s, no.jsxs = s, no;
}
var fs = {}, Gx;
function f5() {
  return Gx || (Gx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    fs.Fragment = i, fs.jsx = zn, fs.jsxs = Wn;
  })()), fs;
}
var Yx;
function h5() {
  return Yx || (Yx = 1, process.env.NODE_ENV === "production" ? hm.exports = p5() : hm.exports = f5()), hm.exports;
}
var mn = h5();
const y5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, g5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": y5
};
function v5(e) {
  return g5[e] ?? {};
}
function Jx(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function k5(e) {
  if (Array.isArray(e)) return e;
}
function b5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], d = !0, p = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(d = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); d = !0) ;
    } catch (u) {
      p = !0, a = u;
    } finally {
      try {
        if (!d && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (p) throw a;
      }
    }
    return l;
  }
}
function _5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x5(e, n) {
  return k5(e) || b5(e, n) || S5(e, n) || _5();
}
function S5(e, n) {
  if (e) {
    if (typeof e == "string") return Jx(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Jx(e, n) : void 0;
  }
}
const C1 = Object.entries, Qx = Object.setPrototypeOf, N5 = Object.isFrozen, j5 = Object.getPrototypeOf, w5 = Object.getOwnPropertyDescriptor;
let At = Object.freeze, Vt = Object.seal, aa = Object.create, F1 = typeof Reflect < "u" && Reflect, Yh = F1.apply, Jh = F1.construct;
At || (At = function(e) {
  return e;
});
Vt || (Vt = function(e) {
  return e;
});
Yh || (Yh = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
Jh || (Jh = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const to = xt(Array.prototype.forEach), C5 = xt(Array.prototype.lastIndexOf), Xx = xt(Array.prototype.pop), ea = xt(Array.prototype.push), F5 = xt(Array.prototype.splice), ui = Array.isArray, vo = xt(String.prototype.toLowerCase), ym = xt(String.prototype.toString), Zx = xt(String.prototype.match), ro = xt(String.prototype.replace), eS = xt(String.prototype.indexOf), I5 = xt(String.prototype.trim), E5 = xt(Number.prototype.toString), $5 = xt(Boolean.prototype.toString), nS = typeof BigInt > "u" ? null : xt(BigInt.prototype.toString), tS = typeof Symbol > "u" ? null : xt(Symbol.prototype.toString), It = xt(Object.prototype.hasOwnProperty), io = xt(Object.prototype.toString), Tt = xt(RegExp.prototype.test), Ni = T5(TypeError);
function xt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Yh(e, n, i);
  };
}
function T5(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Jh(e, r);
  };
}
function Hn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vo;
  if (Qx && Qx(e, null), !ui(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (N5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function O5(e) {
  for (let n = 0; n < e.length; n++)
    It(e, n) || (e[n] = null);
  return e;
}
function Ht(e) {
  const n = aa(null);
  for (const i of C1(e)) {
    var r = x5(i, 2);
    const a = r[0], o = r[1];
    It(e, a) && (ui(o) ? n[a] = O5(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Ht(o) : n[a] = o);
  }
  return n;
}
function R5(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return E5(e);
    case "boolean":
      return $5(e);
    case "bigint":
      return nS ? nS(e) : "0";
    case "symbol":
      return tS ? tS(e) : "Symbol()";
    case "undefined":
      return io(e);
    case "function":
    case "object": {
      if (e === null)
        return io(e);
      const n = e, r = Pr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : io(i);
      }
      return io(e);
    }
    default:
      return io(e);
  }
}
function Pr(e, n) {
  for (; e !== null; ) {
    const i = w5(e, n);
    if (i) {
      if (i.get)
        return xt(i.get);
      if (typeof i.value == "function")
        return xt(i.value);
    }
    e = j5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function D5(e) {
  try {
    return Tt(e, ""), !0;
  } catch {
    return !1;
  }
}
const rS = At(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), gm = At(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), vm = At(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), P5 = At(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), km = At(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), A5 = At(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), iS = At(["#text"]), aS = At(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), bm = At(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), oS = At(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), hs = At(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), L5 = Vt(/{{[\w\W]*|^[\w\W]*}}/g), V5 = Vt(/<%[\w\W]*|^[\w\W]*%>/g), z5 = Vt(/\${[\w\W]*/g), U5 = Vt(/^data-[\-\w.\u00B7-\uFFFF]+$/), M5 = Vt(/^aria-[\-\w]+$/), sS = Vt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), B5 = Vt(/^(?:\w+script|data):/i), q5 = Vt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), H5 = Vt(/^html$/i), W5 = Vt(/^[a-z][.\w]*(-[.\w]+)+$/i), lS = Vt(/<[/\w!]/g), K5 = Vt(/<[/\w]/g), G5 = Vt(/<\/no(script|embed|frames)/i), Y5 = Vt(/\/>/i), Dr = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, J5 = function() {
  return typeof window > "u" ? null : window;
}, Q5 = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, cS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, li = function(e, n, r, i) {
  return It(e, n) && ui(e[n]) ? Hn(i.base ? Ht(i.base) : {}, e[n], i.transform) : r;
};
function I1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : J5();
  const n = (H) => I1(H);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Dr.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, d = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const u = e.DOMParser, f = e.trustedTypes, h = l.prototype, k = Pr(h, "cloneNode"), C = Pr(h, "remove"), N = Pr(h, "nextSibling"), j = Pr(h, "childNodes"), _ = Pr(h, "parentNode"), g = Pr(h, "shadowRoot"), D = Pr(h, "attributes"), O = s && s.prototype ? Pr(s.prototype, "nodeType") : null, I = s && s.prototype ? Pr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const H = r.createElement("template");
    H.content && H.content.ownerDocument && (r = H.content.ownerDocument);
  }
  let F, L = "", K, J = !1, re = 0;
  const W = function() {
    if (re > 0)
      throw Ni('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, Y = function(H) {
    W(), re++;
    try {
      return F.createHTML(H);
    } finally {
      re--;
    }
  }, P = function(H) {
    W(), re++;
    try {
      return F.createScriptURL(H);
    } finally {
      re--;
    }
  }, B = function() {
    return J || (K = Q5(f, a), J = !0), K;
  }, ee = r, Ne = ee.implementation, ue = ee.createNodeIterator, oe = ee.createDocumentFragment, fe = ee.getElementsByTagName, V = i.importNode;
  let ke = cS();
  n.isSupported = typeof C1 == "function" && typeof _ == "function" && Ne && Ne.createHTMLDocument !== void 0;
  const Oe = L5, q = V5, Ge = z5, sn = U5, Ie = M5, Ue = B5, De = q5, Be = W5;
  let Ae = sS, Je = null;
  const $e = Hn({}, [...rS, ...gm, ...vm, ...km, ...iS]);
  let Me = null;
  const en = Hn({}, [...aS, ...bm, ...oS, ...hs]);
  let se = Object.seal(aa(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), le = null, xe = null;
  const Ve = Object.seal(aa(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, vn = !0, Q = !1, E = !0, z = !1, ie = !0, ce = !1, U = !1, G = null, ye = null, je = !1, Re = !1, rn = !1, kn = !1, an = !0, pn = !1;
  const $n = "user-content-";
  let _n = !0, Fn = !1, Ze = {}, yn = null;
  const Le = Hn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let cn = null;
  const dn = Hn({}, ["audio", "video", "img", "source", "image", "track"]);
  let Nn = null;
  const Bn = Hn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Sn = "http://www.w3.org/1998/Math/MathML", Dn = "http://www.w3.org/2000/svg", gn = "http://www.w3.org/1999/xhtml";
  let xn = gn, An = !1, Ln = null;
  const wn = Hn({}, [Sn, Dn, gn], ym), jn = At(["mi", "mo", "mn", "ms", "mtext"]);
  let Vn = Hn({}, jn);
  const qn = At(["annotation-xml"]);
  let zn = Hn({}, qn);
  const Wn = Hn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], m = "text/html";
  let y = null, w = null;
  const T = r.createElement("form"), S = function(H) {
    return H instanceof RegExp || H instanceof Function;
  }, x = function() {
    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (w && w === H)
      return;
    (!H || typeof H != "object") && (H = {}), H = Ht(H), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(H.PARSER_MEDIA_TYPE) === -1 ? m : H.PARSER_MEDIA_TYPE, y = t === "application/xhtml+xml" ? ym : vo, Je = li(H, "ALLOWED_TAGS", $e, {
      transform: y
    }), Me = li(H, "ALLOWED_ATTR", en, {
      transform: y
    }), Ln = li(H, "ALLOWED_NAMESPACES", wn, {
      transform: ym
    }), Nn = li(H, "ADD_URI_SAFE_ATTR", Bn, {
      transform: y,
      base: Bn
    }), cn = li(H, "ADD_DATA_URI_TAGS", dn, {
      transform: y,
      base: dn
    }), yn = li(H, "FORBID_CONTENTS", Le, {
      transform: y
    }), le = li(H, "FORBID_TAGS", Ht({}), {
      transform: y
    }), xe = li(H, "FORBID_ATTR", Ht({}), {
      transform: y
    }), Ze = It(H, "USE_PROFILES") ? H.USE_PROFILES && typeof H.USE_PROFILES == "object" ? Ht(H.USE_PROFILES) : H.USE_PROFILES : !1, Pe = H.ALLOW_ARIA_ATTR !== !1, vn = H.ALLOW_DATA_ATTR !== !1, Q = H.ALLOW_UNKNOWN_PROTOCOLS || !1, E = H.ALLOW_SELF_CLOSE_IN_ATTR !== !1, z = H.SAFE_FOR_TEMPLATES || !1, ie = H.SAFE_FOR_XML !== !1, ce = H.WHOLE_DOCUMENT || !1, Re = H.RETURN_DOM || !1, rn = H.RETURN_DOM_FRAGMENT || !1, kn = H.RETURN_TRUSTED_TYPE || !1, je = H.FORCE_BODY || !1, an = H.SANITIZE_DOM !== !1, pn = H.SANITIZE_NAMED_PROPS || !1, _n = H.KEEP_CONTENT !== !1, Fn = H.IN_PLACE || !1, Ae = D5(H.ALLOWED_URI_REGEXP) ? H.ALLOWED_URI_REGEXP : sS, xn = typeof H.NAMESPACE == "string" ? H.NAMESPACE : gn, Vn = It(H, "MATHML_TEXT_INTEGRATION_POINTS") && H.MATHML_TEXT_INTEGRATION_POINTS && typeof H.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ht(H.MATHML_TEXT_INTEGRATION_POINTS) : Hn({}, jn), zn = It(H, "HTML_INTEGRATION_POINTS") && H.HTML_INTEGRATION_POINTS && typeof H.HTML_INTEGRATION_POINTS == "object" ? Ht(H.HTML_INTEGRATION_POINTS) : Hn({}, qn);
    const Ee = It(H, "CUSTOM_ELEMENT_HANDLING") && H.CUSTOM_ELEMENT_HANDLING && typeof H.CUSTOM_ELEMENT_HANDLING == "object" ? Ht(H.CUSTOM_ELEMENT_HANDLING) : aa(null);
    if (se = aa(null), It(Ee, "tagNameCheck") && S(Ee.tagNameCheck) && (se.tagNameCheck = Ee.tagNameCheck), It(Ee, "attributeNameCheck") && S(Ee.attributeNameCheck) && (se.attributeNameCheck = Ee.attributeNameCheck), It(Ee, "allowCustomizedBuiltInElements") && typeof Ee.allowCustomizedBuiltInElements == "boolean" && (se.allowCustomizedBuiltInElements = Ee.allowCustomizedBuiltInElements), Vt(se), z && (vn = !1), rn && (Re = !0), Ze && (Je = Hn({}, iS), Me = aa(null), Ze.html === !0 && (Hn(Je, rS), Hn(Me, aS)), Ze.svg === !0 && (Hn(Je, gm), Hn(Me, bm), Hn(Me, hs)), Ze.svgFilters === !0 && (Hn(Je, vm), Hn(Me, bm), Hn(Me, hs)), Ze.mathMl === !0 && (Hn(Je, km), Hn(Me, oS), Hn(Me, hs))), Ve.tagCheck = null, Ve.attributeCheck = null, It(H, "ADD_TAGS") && (typeof H.ADD_TAGS == "function" ? Ve.tagCheck = H.ADD_TAGS : ui(H.ADD_TAGS) && (Je === $e && (Je = Ht(Je)), Hn(Je, H.ADD_TAGS, y))), It(H, "ADD_ATTR") && (typeof H.ADD_ATTR == "function" ? Ve.attributeCheck = H.ADD_ATTR : ui(H.ADD_ATTR) && (Me === en && (Me = Ht(Me)), Hn(Me, H.ADD_ATTR, y))), It(H, "ADD_URI_SAFE_ATTR") && ui(H.ADD_URI_SAFE_ATTR) && Hn(Nn, H.ADD_URI_SAFE_ATTR, y), It(H, "FORBID_CONTENTS") && ui(H.FORBID_CONTENTS) && (yn === Le && (yn = Ht(yn)), Hn(yn, H.FORBID_CONTENTS, y)), It(H, "ADD_FORBID_CONTENTS") && ui(H.ADD_FORBID_CONTENTS) && (yn === Le && (yn = Ht(yn)), Hn(yn, H.ADD_FORBID_CONTENTS, y)), _n && (Je["#text"] = !0), ce && Hn(Je, ["html", "head", "body"]), Je.table && (Hn(Je, ["tbody"]), delete le.tbody), H.TRUSTED_TYPES_POLICY) {
      if (typeof H.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Ni('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof H.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Ni('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const He = F;
      F = H.TRUSTED_TYPES_POLICY;
      try {
        L = Y("");
      } catch (ln) {
        throw F = He, ln;
      }
    } else H.TRUSTED_TYPES_POLICY === null ? (F = void 0, L = "") : (F === void 0 && (F = B()), F && typeof L == "string" && (L = Y("")));
    At && At(H), w = H;
  }, X = Hn({}, [...gm, ...vm, ...P5]), A = Hn({}, [...km, ...A5]), M = function(H, Ee, He) {
    return Ee.namespaceURI === gn ? H === "svg" : Ee.namespaceURI === Sn ? H === "svg" && (He === "annotation-xml" || Vn[He]) : !!X[H];
  }, de = function(H, Ee, He) {
    return Ee.namespaceURI === gn ? H === "math" : Ee.namespaceURI === Dn ? H === "math" && zn[He] : !!A[H];
  }, ze = function(H, Ee, He) {
    return Ee.namespaceURI === Dn && !zn[He] || Ee.namespaceURI === Sn && !Vn[He] ? !1 : !A[H] && (Wn[H] || !X[H]);
  }, Te = function(H) {
    let Ee = _(H);
    (!Ee || !Ee.tagName) && (Ee = {
      namespaceURI: xn,
      tagName: "template"
    });
    const He = vo(H.tagName), ln = vo(Ee.tagName);
    return Ln[H.namespaceURI] ? H.namespaceURI === Dn ? M(He, Ee, ln) : H.namespaceURI === Sn ? de(He, Ee, ln) : H.namespaceURI === gn ? ze(He, Ee, ln) : !!(t === "application/xhtml+xml" && Ln[H.namespaceURI]) : !1;
  }, te = function(H) {
    ea(n.removed, {
      element: H
    });
    try {
      _(H).removeChild(H);
    } catch {
      if (C(H), !_(H))
        throw Ni("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, un = function(H) {
    const Ee = j(H);
    if (Ee) {
      const ln = [];
      to(Ee, (Rn) => {
        ea(ln, Rn);
      }), to(ln, (Rn) => {
        try {
          C(Rn);
        } catch {
        }
      });
    }
    const He = D(H);
    if (He)
      for (let ln = He.length - 1; ln >= 0; --ln) {
        const Rn = He[ln], et = Rn && Rn.name;
        if (typeof et == "string")
          try {
            H.removeAttribute(et);
          } catch {
          }
      }
  }, On = function(H, Ee) {
    try {
      ea(n.removed, {
        attribute: Ee.getAttributeNode(H),
        from: Ee
      });
    } catch {
      ea(n.removed, {
        attribute: null,
        from: Ee
      });
    }
    if (Ee.removeAttribute(H), H === "is")
      if (Re || rn)
        try {
          te(Ee);
        } catch {
        }
      else
        try {
          Ee.setAttribute(H, "");
        } catch {
        }
  }, Kn = function(H) {
    const Ee = D(H);
    if (Ee)
      for (let He = Ee.length - 1; He >= 0; --He) {
        const ln = Ee[He], Rn = ln && ln.name;
        if (!(typeof Rn != "string" || Me[y(Rn)]))
          try {
            H.removeAttribute(Rn);
          } catch {
          }
      }
  }, PF = function(H) {
    const Ee = [H];
    for (; Ee.length > 0; ) {
      const He = Ee.pop();
      (O ? O(He) : He.nodeType) === Dr.element && Kn(He);
      const ln = j(He);
      if (ln)
        for (let Rn = ln.length - 1; Rn >= 0; --Rn)
          Ee.push(ln[Rn]);
    }
  }, Ug = function(H) {
    let Ee = null, He = null;
    if (je)
      H = "<remove></remove>" + H;
    else {
      const et = Zx(H, /^[\r\n\t ]+/);
      He = et && et[0];
    }
    t === "application/xhtml+xml" && xn === gn && (H = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + H + "</body></html>");
    const ln = F ? Y(H) : H;
    if (xn === gn)
      try {
        Ee = new u().parseFromString(ln, t);
      } catch {
      }
    if (!Ee || !Ee.documentElement) {
      Ee = Ne.createDocument(xn, "template", null);
      try {
        Ee.documentElement.innerHTML = An ? L : ln;
      } catch {
      }
    }
    const Rn = Ee.body || Ee.documentElement;
    return H && He && Rn.insertBefore(r.createTextNode(He), Rn.childNodes[0] || null), xn === gn ? fe.call(Ee, ce ? "html" : "body")[0] : ce ? Ee.documentElement : Rn;
  }, Mg = function(H) {
    return ue.call(
      H.ownerDocument || H,
      H,
      // eslint-disable-next-line no-bitwise
      d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT | d.SHOW_PROCESSING_INSTRUCTION | d.SHOW_CDATA_SECTION,
      null
    );
  }, Go = function(H) {
    return H = ro(H, Oe, " "), H = ro(H, q, " "), H = ro(H, Ge, " "), H;
  }, Yl = function(H) {
    var Ee;
    H.normalize();
    const He = ue.call(
      H.ownerDocument || H,
      H,
      // eslint-disable-next-line no-bitwise
      d.SHOW_TEXT | d.SHOW_COMMENT | d.SHOW_CDATA_SECTION | d.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let ln = He.nextNode();
    for (; ln; )
      ln.data = Go(ln.data), ln = He.nextNode();
    const Rn = (Ee = H.querySelectorAll) === null || Ee === void 0 ? void 0 : Ee.call(H, "template");
    Rn && to(Rn, (et) => {
      Ki(et.content) && Yl(et.content);
    });
  }, Yo = function(H) {
    const Ee = I ? I(H) : null;
    return typeof Ee != "string" || y(Ee) !== "form" ? !1 : typeof H.nodeName != "string" || typeof H.textContent != "string" || typeof H.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    H.attributes !== D(H) || typeof H.removeAttribute != "function" || typeof H.setAttribute != "function" || typeof H.namespaceURI != "string" || typeof H.insertBefore != "function" || typeof H.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    H.nodeType !== O(H) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    H.childNodes !== j(H);
  }, Ki = function(H) {
    if (!O || typeof H != "object" || H === null)
      return !1;
    try {
      return O(H) === Dr.documentFragment;
    } catch {
      return !1;
    }
  }, Oa = function(H) {
    if (!O || typeof H != "object" || H === null)
      return !1;
    try {
      return typeof O(H) == "number";
    } catch {
      return !1;
    }
  };
  function Yr(H, Ee, He) {
    H.length !== 0 && to(H, (ln) => {
      ln.call(n, Ee, He, w);
    });
  }
  const AF = function(H, Ee) {
    return !!(ie && H.hasChildNodes() && !Oa(H.firstElementChild) && Tt(lS, H.textContent) && Tt(lS, H.innerHTML) || ie && H.namespaceURI === gn && Ee === "style" && Oa(H.firstElementChild) || H.nodeType === Dr.processingInstruction || ie && H.nodeType === Dr.comment && Tt(K5, H.data));
  }, LF = function(H, Ee) {
    if (!le[Ee] && Hg(Ee) && (se.tagNameCheck instanceof RegExp && Tt(se.tagNameCheck, Ee) || se.tagNameCheck instanceof Function && se.tagNameCheck(Ee)))
      return !1;
    if (_n && !yn[Ee]) {
      const He = _(H), ln = j(H);
      if (ln && He) {
        const Rn = ln.length;
        for (let et = Rn - 1; et >= 0; --et) {
          const tt = Fn ? ln[et] : k(ln[et], !0);
          He.insertBefore(tt, N(H));
        }
      }
    }
    return te(H), !0;
  }, Bg = function(H) {
    if (Yr(ke.beforeSanitizeElements, H, null), Yo(H))
      return te(H), !0;
    const Ee = y(I ? I(H) : H.nodeName);
    if (Yr(ke.uponSanitizeElement, H, {
      tagName: Ee,
      allowedTags: Je
    }), AF(H, Ee))
      return te(H), !0;
    if (le[Ee] || !(Ve.tagCheck instanceof Function && Ve.tagCheck(Ee)) && !Je[Ee])
      return LF(H, Ee);
    if ((O ? O(H) : H.nodeType) === Dr.element && !Te(H) || (Ee === "noscript" || Ee === "noembed" || Ee === "noframes") && Tt(G5, H.innerHTML))
      return te(H), !0;
    if (z && H.nodeType === Dr.text) {
      const He = Go(H.textContent);
      H.textContent !== He && (ea(n.removed, {
        element: H.cloneNode()
      }), H.textContent = He);
    }
    return Yr(ke.afterSanitizeElements, H, null), !1;
  }, qg = function(H, Ee, He) {
    if (xe[Ee] || an && (Ee === "id" || Ee === "name") && (He in r || He in T))
      return !1;
    const ln = Me[Ee] || Ve.attributeCheck instanceof Function && Ve.attributeCheck(Ee, H);
    if (!(vn && Tt(sn, Ee)) && !(Pe && Tt(Ie, Ee))) {
      if (ln) {
        if (!Nn[Ee] && !Tt(Ae, ro(He, De, "")) && !((Ee === "src" || Ee === "xlink:href" || Ee === "href") && H !== "script" && eS(He, "data:") === 0 && cn[H]) && !(Q && !Tt(Ue, ro(He, De, ""))) && He)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(Hg(H) && (se.tagNameCheck instanceof RegExp && Tt(se.tagNameCheck, H) || se.tagNameCheck instanceof Function && se.tagNameCheck(H)) && (se.attributeNameCheck instanceof RegExp && Tt(se.attributeNameCheck, Ee) || se.attributeNameCheck instanceof Function && se.attributeNameCheck(Ee, H)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        Ee === "is" && se.allowCustomizedBuiltInElements && (se.tagNameCheck instanceof RegExp && Tt(se.tagNameCheck, He) || se.tagNameCheck instanceof Function && se.tagNameCheck(He)))
      ) return !1;
    }
    return !0;
  }, VF = Hn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Hg = function(H) {
    return !VF[vo(H)] && Tt(Be, H);
  }, zF = function(H, Ee, He, ln) {
    if (F && typeof f == "object" && typeof f.getAttributeType == "function" && !He)
      switch (f.getAttributeType(H, Ee)) {
        case "TrustedHTML":
          return Y(ln);
        case "TrustedScriptURL":
          return P(ln);
      }
    return ln;
  }, UF = function(H, Ee, He, ln) {
    try {
      He ? H.setAttributeNS(He, Ee, ln) : H.setAttribute(Ee, ln), Yo(H) ? te(H) : Xx(n.removed);
    } catch {
      On(Ee, H);
    }
  }, Wg = function(H) {
    Yr(ke.beforeSanitizeAttributes, H, null);
    const Ee = H.attributes;
    if (!Ee || Yo(H))
      return;
    const He = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Me,
      forceKeepAttr: void 0
    };
    let ln = Ee.length;
    const Rn = y(H.nodeName);
    for (; ln--; ) {
      const et = Ee[ln], tt = et.name, ki = et.namespaceURI, ii = et.value, Qt = y(tt), ai = ii;
      let qt = tt === "value" ? ai : I5(ai);
      if (He.attrName = Qt, He.attrValue = qt, He.keepAttr = !0, He.forceKeepAttr = void 0, Yr(ke.uponSanitizeAttribute, H, He), qt = He.attrValue, pn && (Qt === "id" || Qt === "name") && eS(qt, $n) !== 0 && (On(tt, H), qt = $n + qt), ie && Tt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, qt)) {
        On(tt, H);
        continue;
      }
      if (Qt === "attributename" && Zx(qt, "href")) {
        On(tt, H);
        continue;
      }
      if (!He.forceKeepAttr) {
        if (!He.keepAttr) {
          On(tt, H);
          continue;
        }
        if (!E && Tt(Y5, qt)) {
          On(tt, H);
          continue;
        }
        if (z && (qt = Go(qt)), !qg(Rn, Qt, qt)) {
          On(tt, H);
          continue;
        }
        qt = zF(Rn, Qt, ki, qt), qt !== ai && UF(H, tt, ki, qt);
      }
    }
    Yr(ke.afterSanitizeAttributes, H, null);
  }, Jo = function(H) {
    let Ee = null;
    const He = Mg(H);
    for (Yr(ke.beforeSanitizeShadowDOM, H, null); Ee = He.nextNode(); )
      if (Yr(ke.uponSanitizeShadowNode, Ee, null), Bg(Ee), Wg(Ee), Ki(Ee.content) && Jo(Ee.content), (O ? O(Ee) : Ee.nodeType) === Dr.element) {
        const ln = g(Ee);
        Ki(ln) && (Jl(ln), Jo(ln));
      }
    Yr(ke.afterSanitizeShadowDOM, H, null);
  }, Jl = function(H) {
    const Ee = [{
      node: H,
      shadow: null
    }];
    for (; Ee.length > 0; ) {
      const He = Ee.pop();
      if (He.shadow) {
        Jo(He.shadow);
        continue;
      }
      const ln = He.node, Rn = (O ? O(ln) : ln.nodeType) === Dr.element, et = j(ln);
      if (et)
        for (let tt = et.length - 1; tt >= 0; --tt)
          Ee.push({
            node: et[tt],
            shadow: null
          });
      if (Rn) {
        const tt = I ? I(ln) : null;
        if (typeof tt == "string" && y(tt) === "template") {
          const ki = ln.content;
          Ki(ki) && Ee.push({
            node: ki,
            shadow: null
          });
        }
      }
      if (Rn) {
        const tt = g(ln);
        Ki(tt) && Ee.push({
          node: null,
          shadow: tt
        }, {
          node: tt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(H) {
    let Ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = null, ln = null, Rn = null, et = null;
    if (An = !H, An && (H = "<!-->"), typeof H != "string" && !Oa(H) && (H = R5(H), typeof H != "string"))
      throw Ni("dirty is not a string, aborting");
    if (!n.isSupported)
      return H;
    U ? (Je = G, Me = ye) : x(Ee), (ke.uponSanitizeElement.length > 0 || ke.uponSanitizeAttribute.length > 0) && (Je = Ht(Je)), ke.uponSanitizeAttribute.length > 0 && (Me = Ht(Me)), n.removed = [];
    const tt = Fn && typeof H != "string" && Oa(H);
    if (tt) {
      const Qt = I ? I(H) : H.nodeName;
      if (typeof Qt == "string") {
        const ai = y(Qt);
        if (!Je[ai] || le[ai])
          throw Ni("root node is forbidden and cannot be sanitized in-place");
      }
      if (Yo(H))
        throw Ni("root node is clobbered and cannot be sanitized in-place");
      try {
        Jl(H);
      } catch (ai) {
        throw un(H), ai;
      }
    } else if (Oa(H))
      He = Ug("<!---->"), ln = He.ownerDocument.importNode(H, !0), ln.nodeType === Dr.element && ln.nodeName === "BODY" || ln.nodeName === "HTML" ? He = ln : He.appendChild(ln), Jl(ln);
    else {
      if (!Re && !z && !ce && // eslint-disable-next-line unicorn/prefer-includes
      H.indexOf("<") === -1)
        return F && kn ? Y(H) : H;
      if (He = Ug(H), !He)
        return Re ? null : kn ? L : "";
    }
    He && je && te(He.firstChild);
    const ki = Mg(tt ? H : He);
    try {
      for (; Rn = ki.nextNode(); )
        Bg(Rn), Wg(Rn), Ki(Rn.content) && Jo(Rn.content);
    } catch (Qt) {
      throw tt && un(H), Qt;
    }
    if (tt)
      return to(n.removed, (Qt) => {
        Qt.element && PF(Qt.element);
      }), z && Yl(H), H;
    if (Re) {
      if (z && Yl(He), rn)
        for (et = oe.call(He.ownerDocument); He.firstChild; )
          et.appendChild(He.firstChild);
      else
        et = He;
      return (Me.shadowroot || Me.shadowrootmode) && (et = V.call(i, et, !0)), et;
    }
    let ii = ce ? He.outerHTML : He.innerHTML;
    return ce && Je["!doctype"] && He.ownerDocument && He.ownerDocument.doctype && He.ownerDocument.doctype.name && Tt(H5, He.ownerDocument.doctype.name) && (ii = "<!DOCTYPE " + He.ownerDocument.doctype.name + `>
` + ii), z && (ii = Go(ii)), F && kn ? Y(ii) : ii;
  }, n.setConfig = function() {
    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    x(H), U = !0, G = Je, ye = Me;
  }, n.clearConfig = function() {
    w = null, U = !1, G = null, ye = null, F = K, L = "";
  }, n.isValidAttribute = function(H, Ee, He) {
    w || x({});
    const ln = y(H), Rn = y(Ee);
    return qg(ln, Rn, He);
  }, n.addHook = function(H, Ee) {
    typeof Ee == "function" && It(ke, H) && ea(ke[H], Ee);
  }, n.removeHook = function(H, Ee) {
    if (It(ke, H)) {
      if (Ee !== void 0) {
        const He = C5(ke[H], Ee);
        return He === -1 ? void 0 : F5(ke[H], He, 1)[0];
      }
      return Xx(ke[H]);
    }
  }, n.removeHooks = function(H) {
    It(ke, H) && (ke[H] = []);
  }, n.removeAllHooks = function() {
    ke = cS();
  }, n;
}
var X5 = I1();
const Z5 = "_messageContainer_1rxr4_1", eB = "_chip_1rxr4_7", nB = "_chipLabel_1rxr4_10", tB = "_chipValue_1rxr4_13", ys = {
  messageContainer: Z5,
  chip: eB,
  chipLabel: nB,
  chipValue: tB
}, dS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, rB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: p,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? p ?? u ?? o;
  };
  return /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ mn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ mn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ mn.jsx(Xe, { content: "Conversation Attributes", children: /* @__PURE__ */ mn.jsx(
        py,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ mn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ mn.jsx(Jn, { className: ys.chip, children: /* @__PURE__ */ mn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ mn.jsxs(st, { className: ys.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ mn.jsx(st, { className: ys.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ mn.jsx(
      b,
      {
        className: ys.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? dS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? dS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ mn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ mn.jsx($.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ mn.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ mn.jsx(uI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ mn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: X5.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ mn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ mn.jsx(
      mI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ mn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, iB = "_conversation_1draa_1", aB = "_conversationSubLine_1draa_9", oB = "_modal_1draa_14", _m = {
  conversation: iB,
  conversationSubLine: aB,
  modal: oB
}, sB = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), lB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), cB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = me(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ mn.jsxs(b, { className: _m.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ mn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ mn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ mn.jsx($.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ mn.jsx(Mn, { size: "small", variant: "info", children: Gn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ mn.jsx(
          $.Heading,
          {
            variant: "heading-4",
            className: _m.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ mn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ mn.jsx(Jn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ mn.jsx(Xe, { content: "Show conversation preview", children: /* @__PURE__ */ mn.jsx(
        rr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ mn.jsxs(
      wt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: _m.modal,
        children: [
          /* @__PURE__ */ mn.jsx(
            Ct,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ mn.jsx(Ft, { children: /* @__PURE__ */ mn.jsx(
            rB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: sB(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: lB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, dB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = me(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Qn(
    () => e?.sort((d, p) => p?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, p) => /* @__PURE__ */ mn.jsx(
      cB,
      {
        conversation: d,
        conversationContext: n
      },
      `${p}-${d?.id}`
    )),
    s && /* @__PURE__ */ mn.jsxs(
      ct,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, uB = v5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), mB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = hn(), { data: l, loading: d, error: p } = s(uB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), p ? /* @__PURE__ */ mn.jsx(En, { error: p }) : d ? /* @__PURE__ */ mn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ mn.jsx(fn, {}) }) : r?.length === 0 ? /* @__PURE__ */ mn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ mn.jsx(
    dB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, Qh = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], xm = "MIUROS", pB = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, fB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: pB
  }), {
    create: d,
    update: p,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = dr({
    integrationId: e,
    integrationType: xm,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = ur({
    integrationId: e,
    fieldDefinitions: Qh,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = mr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => fr(J, {
    fieldDefinitions: Qh,
    isCreationMode: s,
    create: d,
    update: p,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ mn.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ mn.jsx(hr, { cause: k }),
        /* @__PURE__ */ mn.jsxs(nt, { children: [
          /* @__PURE__ */ mn.jsx(Z, { children: /* @__PURE__ */ mn.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ mn.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Pn,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Ir,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Pn,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (J) => !Number.isNaN(Number.parseInt(J, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ mn.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: xm,
              label: "Authorize"
            }
          ),
          o && O !== null && /* @__PURE__ */ mn.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ mn.jsx(
          yr,
          {
            integrationType: xm,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Sm = { exports: {} }, ao = {}, uS;
function hB() {
  if (uS) return ao;
  uS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ao.Fragment = r, ao.jsx = s, ao.jsxs = s, ao;
}
var gs = {}, mS;
function yB() {
  return mS || (mS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    gs.Fragment = i, gs.jsx = zn, gs.jsxs = Wn;
  })()), gs;
}
var pS;
function gB() {
  return pS || (pS = 1, process.env.NODE_ENV === "production" ? Sm.exports = hB() : Sm.exports = yB()), Sm.exports;
}
var Ce = gB();
const vB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, kB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, bB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, _B = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": vB,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": kB,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": bB
};
function fg(e) {
  return _B[e] ?? {};
}
const xB = fg(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), SB = fg(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), NB = fg(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Xh(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const jB = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, E1 = "DD MMM YYYY @ HH:mm", wB = "_list_2c4dq_1", CB = "_listItem_2c4dq_4", FB = "_copyIcon_2c4dq_12", Di = {
  list: wB,
  listItem: CB,
  copyIcon: FB
}, Zh = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Xh(), l = 14, {
    first_name: d,
    last_name: p,
    address1: u,
    address2: f,
    city: h,
    zip: k,
    country_code: C
  } = e ?? {}, N = `${d} ${p}`.trim() || void 0, j = `${h} ${k}`.trim() || void 0, _ = [N, u, f, j, C].filter(
    Boolean
  );
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(ve, { size: l, name: n }),
      i ? /* @__PURE__ */ Ce.jsx(fn, { size: l }) : /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: _.map((g, D) => /* @__PURE__ */ Ce.jsx(st, { children: g }, D)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ce.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ce.jsx(Xe, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: l,
          name: "exclamation",
          className: Di.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ce.jsx(Xe, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(_.join(", ")),
          className: Di.copyIcon
        }
      ) })
    ] })
  ] });
}, IB = "_wrapper_1nher_1", EB = {
  wrapper: IB
}, $B = ({
  customer: e,
  store: n
}) => {
  const { track: r } = Cn(), { isCopied: i, copy: a } = Xh(), { isCopied: o, copy: s } = Xh(), { useQuery: l } = hn(), d = e?.id, {
    loading: p,
    error: u,
    data: f
  } = l(SB, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, k = !p && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (Qe(() => {
    k && r("recharge:profile:received");
  }, [k, r]), u)
    return /* @__PURE__ */ Ce.jsx(En, { error: u });
  if (!e)
    return null;
  const {
    id: N,
    phone: j,
    email: _,
    first_name: g,
    last_name: D,
    created_at: O,
    has_valid_payment_method: I
  } = e, F = 14, L = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${N}` : null, K = `${g || ""} ${D || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { className: EB.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-2", children: K }),
    O && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: Gn(O).format(E1) })
    ] }),
    _ && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "mail" }),
        /* @__PURE__ */ Ce.jsx($.ExternalLink, { href: `mailto:${_}`, children: _ })
      ] }),
      /* @__PURE__ */ Ce.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: F,
          name: i ? "done" : "copy",
          onClick: () => a(_),
          className: Di.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "phone" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ Ce.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: F,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: Di.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ce.jsx(
      Zh,
      {
        address: k,
        icon: "home",
        isLoading: p,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "credit-card" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: F,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    L && /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "external-link" }),
      /* @__PURE__ */ Ce.jsx(
        $.ExternalLink,
        {
          href: L,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, TB = "_order_1dlaa_1", OB = "_orderIsOpen_1dlaa_9", RB = "_orderHeader_1dlaa_12", DB = "_note_1dlaa_16", vs = {
  order: TB,
  orderIsOpen: OB,
  orderHeader: RB,
  note: DB
}, PB = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = Cn(), [a, o] = me(n), {
    id: s,
    status: l,
    charge: d,
    currency: p,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: k,
    total_price: C,
    is_prepaid: N
  } = e, j = 14, _ = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      className: dt(vs.order, {
        [vs.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: vs.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: Gn(f).format(E1) }) }),
                /* @__PURE__ */ Ce.jsxs($.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ce.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Ce.jsx(Xe, { content: "Note", children: /* @__PURE__ */ Ce.jsx(
            $.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: vs.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "activity" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: jB(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "credit-card" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "cog" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ce.jsxs($.Paragraph, { variant: "4", children: [
                C,
                " ",
                p
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsx(
            Zh,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            Zh,
            {
              address: k,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          _ && /* @__PURE__ */ Ce.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ce.jsx(ve, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, AB = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = Cn(), { useQuery: i } = hn(), {
    loading: a,
    error: o,
    data: s
  } = i(NB, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ce.jsx(En, { error: o });
  const p = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ce.jsx(Mn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(fn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Ce.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ce.jsx($.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Ce.jsx(
        PB,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      p && /* @__PURE__ */ Ce.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(p, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ce.jsx(ve, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, LB = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ce.jsxs(Ye, { className: Di.list, children: [
      /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Di.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Di.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, VB = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: p,
    data: u
  } = r(xB, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (p) {
    const k = p.graphQLErrors;
    return bl({ errors: k }) ? /* @__PURE__ */ Ce.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: k }) ? /* @__PURE__ */ Ce.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ce.jsx(En, { error: p });
  }
  return d ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(fn, {}) }) : f ? l ? /* @__PURE__ */ Ce.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ce.jsx($B, { customer: f, store: h }),
        o && /* @__PURE__ */ Ce.jsx(LB, { customer: f }),
        s && /* @__PURE__ */ Ce.jsx(AB, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ce.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, ey = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], zB = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, UB = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: zB
  }), {
    create: l,
    update: d,
    remove: p,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: ey,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => fr(K, {
    fieldDefinitions: ey,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ Ce.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Ce.jsx(hr, { cause: h }),
        /* @__PURE__ */ Ce.jsxs(nt, { children: [
          /* @__PURE__ */ Ce.jsx(Z, { children: /* @__PURE__ */ Ce.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Ir,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: "Displays details of a customer", children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: "Displays the subscription overview", children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ Ce.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ce.jsx(
          yr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Nm = { exports: {} }, oo = {}, fS;
function MB() {
  if (fS) return oo;
  fS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var ks = {}, hS;
function BB() {
  return hS || (hS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    ks.Fragment = i, ks.jsx = zn, ks.jsxs = Wn;
  })()), ks;
}
var yS;
function qB() {
  return yS || (yS = 1, process.env.NODE_ENV === "production" ? Nm.exports = MB() : Nm.exports = BB()), Nm.exports;
}
var be = qB(), $1 = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))($1 || {}), pa = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(pa || {});
const HB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, WB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, KB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, GB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, YB = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": HB,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': WB,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": KB,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": GB
};
function Ul(e) {
  return YB[e] ?? {};
}
const JB = Ul(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), QB = Ul(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), XB = Ul(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), ZB = Ul(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), eq = "_list_l5y5y_85", nq = "_listItem_l5y5y_95", tq = "_listItemHighlighted_l5y5y_103", rq = "_listItemEdit_l5y5y_106", iq = "_clickableIcon_l5y5y_120", wr = {
  list: eq,
  listItem: nq,
  listItemHighlighted: tq,
  listItemEdit: rq,
  clickableIcon: iq
}, hg = "rivoLoyaltyShopifyApiHostName", T1 = "https://admin.shopify.com";
function O1(e) {
  return e.split(".")[0];
}
const aq = "_wrapper_1xucg_1", gS = {
  wrapper: aq
}, oq = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = Cn(), { isCopied: i, copy: a } = Jt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: d,
    verified_email: p
  } = o, u = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ be.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ be.jsxs(b, { className: gS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx(
      b,
      {
        justifyContent: "space-between",
        className: gS.block,
        alignItems: "center",
        children: /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    d && /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ be.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ be.jsx(ve, { size: u, name: "mail" }),
        /* @__PURE__ */ be.jsx($.ExternalLink, { href: `mailto:${d}`, children: d }),
        /* @__PURE__ */ be.jsx(
          Xe,
          {
            content: p ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ be.jsx(b, { alignItems: "center", children: /* @__PURE__ */ be.jsx(
              ve,
              {
                size: u,
                color: p ? "green.500" : "red.500",
                name: p ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ be.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ be.jsx(
        ve,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: wr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(ve, { size: u, name: "sign-in" }),
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ be.jsx(
        ve,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ be.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ be.jsx(ve, { size: u, name: "external-link" }),
      /* @__PURE__ */ be.jsx(
        $.ExternalLink,
        {
          href: sq(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function sq(e, n) {
  const r = O1(e);
  return `${T1}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const lq = "_list_rxh85_1", cq = "_listItem_rxh85_6", vS = {
  list: lq,
  listItem: cq
}, dq = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = hn(), {
    loading: i,
    error: a,
    data: o
  } = r(QB, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, d = () => a ? /* @__PURE__ */ be.jsx(En, { error: a }) : i ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(fn, {}) }) : s.length === 0 ? /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ be.jsx(Ye, { className: vS.list, children: s.map((p) => /* @__PURE__ */ be.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: vS.listItem,
      children: [
        /* @__PURE__ */ be.jsx(ve, { size: l, name: "external-link" }),
        /* @__PURE__ */ be.jsx(
          $.ExternalLink,
          {
            href: uq(
              n,
              p.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: p.title
          }
        )
      ]
    },
    p.product_id
  )) });
  return /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Favorite products" }),
    d()
  ] }) });
};
function uq(e, n) {
  const r = O1(e);
  return `${T1}/store/${r}/products/${n}`;
}
const mq = "_modalBody_1clhs_1", pq = {
  modalBody: mq
};
function fq(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function hq(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const yq = $1, bs = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, gq = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), [d, p] = me(r), [u, f] = me(""), [h, k] = me(!0), [C, N] = me(), j = {
    min: 0,
    max: 1e5
  }, [_, { loading: g }] = o(
    ZB,
    {
      onCompleted: () => {
        const re = d > r ? bs.addPoints : bs.removePoints;
        s({
          title: "Success",
          text: re.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(re.successEventName), J();
      }
    }
  ), D = () => {
    p(r), f(""), k(!0), N(void 0);
  };
  Qe(() => {
    n && D();
  }, [n]);
  const O = !!C, I = fq(d, j), F = hq(r, d), L = () => {
    if (d !== r) {
      const re = d > r ? bs.addPoints : bs.removePoints, W = !h;
      _({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: d - r,
            // eslint-disable-next-line camelcase
            ...u && { internal_note: u },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: yq.Manual,
            // eslint-disable-next-line camelcase
            skip_email: W
          }
        }
      }).catch(() => {
        l(re.failEventName), N([re.failEventText]);
      });
    }
  }, K = () => {
    D(), i();
  }, J = () => {
    a(), K();
  };
  return /* @__PURE__ */ be.jsxs(
    wt,
    {
      isOpen: n,
      onClose: K,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ be.jsx(Ct, { title: "Change points", onClose: K }),
        /* @__PURE__ */ be.jsxs(Ft, { className: pq.modalBody, children: [
          /* @__PURE__ */ be.jsxs(nt, { children: [
            /* @__PURE__ */ be.jsx(Z, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ be.jsx(
              qr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: j.min,
                max: j.max,
                meta: {
                  error: I,
                  warning: F
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (re) => p(re?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ be.jsx(Z, { span: 6, children: /* @__PURE__ */ be.jsx(
              qr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: u,
                  onChange: (re) => f(re?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ be.jsx(Z, { span: 6, children: /* @__PURE__ */ be.jsx(We, { label: "Notify the customer by email", children: /* @__PURE__ */ be.jsx(
              cw,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => k(!h)
                }
              }
            ) }) })
          ] }),
          !g && O && /* @__PURE__ */ be.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ be.jsx(Ye, { children: C?.map((re, W) => /* @__PURE__ */ be.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: re,
              contentLeft: /* @__PURE__ */ be.jsx(
                ve,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            W
          )) }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => L(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ be.jsx(fn, { size: 16 }),
              disabled: !!(I || F)
            },
            cancelOnClick: K
          }
        )
      ]
    }
  );
}, na = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = ow(n);
  return /* @__PURE__ */ be.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(wr.listItem, {
        [wr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ be.jsx(Xe, { content: r, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Li(n)
      ] }) })
    }
  );
}, kS = {
  [pa.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [pa.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [pa.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, vq = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? kS[i.loyalty_status] : kS[pa.Guest], o = a?.name === pa.Excluded, s = i.lifetime_earnings_tally ?? 0, l = i.total_spent ?? 0, d = Math.trunc(i.points_tally ?? 0), p = i.next_vip_tier, u = i.next_vip_tier?.to_spend_or_earn ?? 0, f = p?.name ?? "None", [h, k] = me(!1), C = 10, N = () => /* @__PURE__ */ be.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(wr.listItem),
      children: /* @__PURE__ */ be.jsx(Xe, { content: a.tooltip, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ be.jsx(Mn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), j = () => o ? N() : /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: dt(
          wr.listItem,
          wr.listItemHighlighted,
          {
            [wr.listItemEdit]: n
          }
        ),
        onClick: () => n ? k(!0) : void 0,
        children: /* @__PURE__ */ be.jsx(Xe, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ be.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ be.jsx(
                  ve,
                  {
                    name: "pen",
                    size: C,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: Li(d) })
              ]
            }
          )
        ] }) })
      }
    ),
    u != null && f && /* @__PURE__ */ be.jsx(
      na,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: u.toFixed(2)
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s?.toFixed(2)
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l.toFixed(2)
      }
    ),
    N(),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ be.jsx(
      na,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ be.jsx(Ye, { className: wr.list, children: j() })
    ] }),
    /* @__PURE__ */ be.jsx(
      gq,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: d,
        onClose: () => k(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, kq = ({
  ordersCount: e
}) => /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ be.jsx(Ye, { className: wr.list, children: /* @__PURE__ */ be.jsx(Ye.Text, { variant: "dense", className: wr.listItem, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), bq = "_reward_1gmba_1", _q = "_voucherCode_1gmba_14", bS = {
  reward: bq,
  voucherCode: _q
}, xq = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Jt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ be.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ be.jsxs(b, { gap: "100", flexDirection: "column", className: bS.reward, children: [
    /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(ve, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ be.jsxs(Mn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ be.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ be.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ be.jsx(ve, { size: 14, name: "tag" }),
            /* @__PURE__ */ be.jsx(b, { children: /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", className: bS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ be.jsx(Xe, { content: "Copy reward code", children: /* @__PURE__ */ be.jsx(
            ve,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: wr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, Sq = ({
  customer: e
}) => {
  const { useQuery: n } = hn(), {
    loading: r,
    error: i,
    data: a
  } = n(XB, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => Nq({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ be.jsx(En, { error: i }) : r ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(fn, {}) }) : o.length > 0 ? /* @__PURE__ */ be.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ be.jsx(
    xq,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function Nq(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const jq = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, d = r[hg].toString(), { useQuery: p } = hn(), { track: u } = Cn(), [f, h] = me(!1), k = n?.customer?.email, {
    loading: C,
    error: N,
    data: j,
    refetch: _
  } = p(JB, {
    skip: !k,
    variables: {
      email: k
    }
  }), g = !C && j ? j.RivoLoyalty?.return_customer?.data : void 0;
  Qe(() => {
    !C && g && !f && (u("rivoloyalty:customer:received"), h(!0));
  }, [C, g]);
  const D = () => /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (N) {
    const O = N.graphQLErrors;
    return ba({ errors: O }) ? D() : bl({ errors: O }) ? /* @__PURE__ */ be.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: O }) ? /* @__PURE__ */ be.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ be.jsx(En, { error: N });
  }
  return C ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(fn, {}) }) : !k || !g ? D() : /* @__PURE__ */ be.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ be.jsx(
          oq,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        i && /* @__PURE__ */ be.jsx(
          kq,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ be.jsx(
          vq,
          {
            customer: g,
            refetchCustomerData: _,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ be.jsx(
          dq,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        l && /* @__PURE__ */ be.jsx(Sq, { customer: g })
      ]
    }
  );
};
var Ho = (e) => e.type === "checkbox", Ti = (e) => e instanceof Date, Yt = (e) => e == null;
const R1 = (e) => typeof e == "object";
var gt = (e) => !Yt(e) && !Array.isArray(e) && R1(e) && !Ti(e), D1 = (e) => gt(e) && e.target ? Ho(e.target) ? e.target.checked : e.target.value : e, wq = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, P1 = (e, n) => e.has(wq(n)), Cq = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return gt(n) && n.hasOwnProperty("isPrototypeOf");
}, yg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Dt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(yg && (e instanceof Blob || i)) && (r || gt(e)))
    if (n = r ? [] : {}, !r && !Cq(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Dt(e[a]));
  else
    return e;
  return n;
}
var Ml = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ht = (e) => e === void 0, tn = (e, n, r) => {
  if (!n || !gt(e))
    return r;
  const i = Ml(n.split(/[,[\].]+?/)).reduce((a, o) => Yt(a) ? a : a[o], e);
  return ht(i) || i === e ? ht(e[n]) ? r : e[n] : i;
}, sr = (e) => typeof e == "boolean", gg = (e) => /^\w*$/.test(e), A1 = (e) => Ml(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = gg(n) ? [n] : A1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const p = e[l];
      d = gt(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ml = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Cr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ei = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Fq = qe.createContext(null), vg = () => qe.useContext(Fq);
var L1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Cr.all && (n._proxyFormState[s] = !i || Cr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function Iq(e) {
  const n = vg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = qe.useRef(a);
  return p.current = a, qe.useEffect(() => r._subscribe({
    name: p.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => L1(s, r, d.current, !1), [s, r]);
}
var Mr = (e) => typeof e == "string", V1 = (e, n, r, i, a) => Mr(e) ? (i && n.watch.add(e), tn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), tn(r, o))) : (i && (n.watchAll = !0), r);
function Eq(e) {
  const n = vg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(V1(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [p, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), p;
}
function $q(e) {
  const n = vg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = P1(a._names.array, r), l = Eq({
    control: a,
    name: r,
    defaultValue: tn(a._formValues, r, tn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = Iq({
    control: a,
    name: r,
    exact: !0
  }), p = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!tn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!tn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!tn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!tn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => tn(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((j) => u.current.onChange({
    target: {
      value: D1(j),
      name: r
    },
    type: ml.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: tn(a._formValues, r),
      name: r
    },
    type: ml.BLUR
  }), [r, a._formValues]), C = qe.useCallback((j) => {
    const _ = tn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = qe.useMemo(() => ({
    name: r,
    value: l,
    ...sr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: C
  }), [r, i, d.disabled, h, k, C, l]);
  return qe.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...sr(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const _ = (g, D) => {
      const O = tn(a._fields, g);
      O && O._f && (O._f.mount = D);
    };
    if (_(r, !0), j) {
      const g = Dt(tn(a._options.defaultValues, r));
      it(a._defaultValues, r, g), ht(tn(a._formValues, r)) && it(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
var Tq = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, No = (e) => Array.isArray(e) ? e : [e], _S = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ny = (e) => Yt(e) || !R1(e);
function mi(e, n) {
  if (ny(e) || ny(n))
    return e === n;
  if (Ti(e) && Ti(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ti(o) && Ti(s) || gt(o) && gt(s) || Array.isArray(o) && Array.isArray(s) ? !mi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Kt = (e) => gt(e) && !Object.keys(e).length, kg = (e) => e.type === "file", Fr = (e) => typeof e == "function", pl = (e) => {
  if (!yg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, z1 = (e) => e.type === "select-multiple", bg = (e) => e.type === "radio", Oq = (e) => bg(e) || Ho(e), jm = (e) => pl(e) && e.isConnected;
function Rq(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ht(e) ? i++ : e[n[i++]];
  return e;
}
function Dq(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ht(e[n]))
      return !1;
  return !0;
}
function Nt(e, n) {
  const r = Array.isArray(n) ? n : gg(n) ? [n] : A1(n), i = r.length === 1 ? e : Rq(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (gt(i) && Kt(i) || Array.isArray(i) && Dq(i)) && Nt(e, r.slice(0, -1)), e;
}
var U1 = (e) => {
  for (const n in e)
    if (Fr(e[n]))
      return !0;
  return !1;
};
function fl(e, n = {}) {
  const r = Array.isArray(e);
  if (gt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || gt(e[i]) && !U1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, fl(e[i], n[i])) : Yt(e[i]) || (n[i] = !0);
  return n;
}
function M1(e, n, r) {
  const i = Array.isArray(e);
  if (gt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || gt(e[a]) && !U1(e[a]) ? ht(n) || ny(r[a]) ? r[a] = Array.isArray(e[a]) ? fl(e[a], []) : { ...fl(e[a]) } : M1(e[a], Yt(n) ? {} : n[a], r[a]) : r[a] = !mi(e[a], n[a]);
  return r;
}
var so = (e, n) => M1(e, n, fl(n));
const xS = {
  value: !1,
  isValid: !1
}, SS = { value: !0, isValid: !0 };
var B1 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ht(e[0].attributes.value) ? ht(e[0].value) || e[0].value === "" ? SS : { value: e[0].value, isValid: !0 } : SS
    ) : xS;
  }
  return xS;
}, q1 = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ht(e) ? e : n ? e === "" ? NaN : e && +e : r && Mr(e) ? new Date(e) : i ? i(e) : e;
const NS = {
  isValid: !1,
  value: null
};
var H1 = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, NS) : NS;
function jS(e) {
  const n = e.ref;
  return kg(n) ? n.files : bg(n) ? H1(e.refs).value : z1(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Ho(n) ? B1(e.refs).value : q1(ht(n.value) ? e.ref.value : n.value, e);
}
var Pq = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = tn(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, hl = (e) => e instanceof RegExp, lo = (e) => ht(e) ? e : hl(e) ? e.source : gt(e) ? hl(e.value) ? e.value.source : e.value : e, wS = (e) => ({
  isOnSubmit: !e || e === Cr.onSubmit,
  isOnBlur: e === Cr.onBlur,
  isOnChange: e === Cr.onChange,
  isOnAll: e === Cr.all,
  isOnTouch: e === Cr.onTouched
});
const CS = "AsyncFunction";
var Aq = (e) => !!e && !!e.validate && !!(Fr(e.validate) && e.validate.constructor.name === CS || gt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === CS)), Lq = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), FS = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const jo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = tn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (jo(l, n))
          break;
      } else if (gt(l) && jo(l, n))
        break;
    }
  }
};
function IS(e, n, r) {
  const i = tn(e, r);
  if (i || gg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = tn(n, o), l = tn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Vq = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Kt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Cr.all));
}, zq = (e, n, r) => !e || !n || e === n || No(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), Uq = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, Mq = (e, n) => !Ml(tn(e, n)).length && Nt(e, n), Bq = (e, n, r) => {
  const i = No(tn(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, Bs = (e) => Mr(e);
function ES(e, n, r = "validate") {
  if (Bs(e) || Array.isArray(e) && e.every(Bs) || sr(e) && !e)
    return {
      type: r,
      message: Bs(e) ? e : "",
      ref: n
    };
}
var ta = (e) => gt(e) && !hl(e) ? e : {
  value: e,
  message: ""
}, $S = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: p, minLength: u, min: f, max: h, pattern: k, validate: C, name: N, valueAsNumber: j, mount: _ } = e._f, g = tn(r, N);
  if (!_ || n.has(N))
    return {};
  const D = l ? l[0] : s, O = (Y) => {
    a && D.reportValidity && (D.setCustomValidity(sr(Y) ? "" : Y || ""), D.reportValidity());
  }, I = {}, F = bg(s), L = Ho(s), K = F || L, J = (j || kg(s)) && ht(s.value) && ht(g) || pl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, re = Tq.bind(null, N, i, I), W = (Y, P, B, ee = ei.maxLength, Ne = ei.minLength) => {
    const ue = Y ? P : B;
    I[N] = {
      type: Y ? ee : Ne,
      message: ue,
      ref: s,
      ...re(Y ? ee : Ne, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!K && (J || Yt(g)) || sr(g) && !g || L && !B1(l).isValid || F && !H1(l).isValid)) {
    const { value: Y, message: P } = Bs(d) ? { value: !!d, message: d } : ta(d);
    if (Y && (I[N] = {
      type: ei.required,
      message: P,
      ref: D,
      ...re(ei.required, P)
    }, !i))
      return O(P), I;
  }
  if (!J && (!Yt(f) || !Yt(h))) {
    let Y, P;
    const B = ta(h), ee = ta(f);
    if (!Yt(g) && !isNaN(g)) {
      const Ne = s.valueAsNumber || g && +g;
      Yt(B.value) || (Y = Ne > B.value), Yt(ee.value) || (P = Ne < ee.value);
    } else {
      const Ne = s.valueAsDate || new Date(g), ue = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), oe = s.type == "time", fe = s.type == "week";
      Mr(B.value) && g && (Y = oe ? ue(g) > ue(B.value) : fe ? g > B.value : Ne > new Date(B.value)), Mr(ee.value) && g && (P = oe ? ue(g) < ue(ee.value) : fe ? g < ee.value : Ne < new Date(ee.value));
    }
    if ((Y || P) && (W(!!Y, B.message, ee.message, ei.max, ei.min), !i))
      return O(I[N].message), I;
  }
  if ((p || u) && !J && (Mr(g) || o && Array.isArray(g))) {
    const Y = ta(p), P = ta(u), B = !Yt(Y.value) && g.length > +Y.value, ee = !Yt(P.value) && g.length < +P.value;
    if ((B || ee) && (W(B, Y.message, P.message), !i))
      return O(I[N].message), I;
  }
  if (k && !J && Mr(g)) {
    const { value: Y, message: P } = ta(k);
    if (hl(Y) && !g.match(Y) && (I[N] = {
      type: ei.pattern,
      message: P,
      ref: s,
      ...re(ei.pattern, P)
    }, !i))
      return O(P), I;
  }
  if (C) {
    if (Fr(C)) {
      const Y = await C(g, r), P = ES(Y, D);
      if (P && (I[N] = {
        ...P,
        ...re(ei.validate, P.message)
      }, !i))
        return O(P.message), I;
    } else if (gt(C)) {
      let Y = {};
      for (const P in C) {
        if (!Kt(Y) && !i)
          break;
        const B = ES(await C[P](g, r), D, P);
        B && (Y = {
          ...B,
          ...re(P, B.message)
        }, O(B.message), i && (I[N] = Y));
      }
      if (!Kt(Y) && (I[N] = {
        ref: D,
        ...Y
      }, !i))
        return I;
    }
  }
  return O(!0), I;
};
const qq = {
  mode: Cr.onSubmit,
  reValidateMode: Cr.onChange,
  shouldFocusError: !0
};
function Hq(e = {}) {
  let n = {
    ...qq,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Fr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = gt(n.defaultValues) || gt(n.values) ? Dt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Dt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, p = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: _S(),
    state: _S()
  }, k = wS(n.mode), C = wS(n.reValidateMode), N = n.criteriaMode === Cr.all, j = (Q) => (E) => {
    clearTimeout(p), p = setTimeout(Q, E);
  }, _ = async (Q) => {
    if (!n.disabled && (u.isValid || f.isValid || Q)) {
      const E = n.resolver ? Kt((await J()).errors) : await W(i, !0);
      E !== r.isValid && h.state.next({
        isValid: E
      });
    }
  }, g = (Q, E) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((Q || Array.from(l.mount)).forEach((z) => {
      z && (E ? it(r.validatingFields, z, E) : Nt(r.validatingFields, z));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Kt(r.validatingFields)
    }));
  }, D = (Q, E = [], z, ie, ce = !0, U = !0) => {
    if (ie && z && !n.disabled) {
      if (s.action = !0, U && Array.isArray(tn(i, Q))) {
        const G = z(tn(i, Q), ie.argA, ie.argB);
        ce && it(i, Q, G);
      }
      if (U && Array.isArray(tn(r.errors, Q))) {
        const G = z(tn(r.errors, Q), ie.argA, ie.argB);
        ce && it(r.errors, Q, G), Mq(r.errors, Q);
      }
      if ((u.touchedFields || f.touchedFields) && U && Array.isArray(tn(r.touchedFields, Q))) {
        const G = z(tn(r.touchedFields, Q), ie.argA, ie.argB);
        ce && it(r.touchedFields, Q, G);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = so(a, o)), h.state.next({
        name: Q,
        isDirty: P(Q, E),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, Q, E);
  }, O = (Q, E) => {
    it(r.errors, Q, E), h.state.next({
      errors: r.errors
    });
  }, I = (Q) => {
    r.errors = Q, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (Q, E, z, ie) => {
    const ce = tn(i, Q);
    if (ce) {
      const U = tn(o, Q, ht(z) ? tn(a, Q) : z);
      ht(U) || ie && ie.defaultChecked || E ? it(o, Q, E ? U : jS(ce._f)) : Ne(Q, U), s.mount && _();
    }
  }, L = (Q, E, z, ie, ce) => {
    let U = !1, G = !1;
    const ye = {
      name: Q
    };
    if (!n.disabled) {
      if (!z || ie) {
        (u.isDirty || f.isDirty) && (G = r.isDirty, r.isDirty = ye.isDirty = P(), U = G !== ye.isDirty);
        const je = mi(tn(a, Q), E);
        G = !!tn(r.dirtyFields, Q), je ? Nt(r.dirtyFields, Q) : it(r.dirtyFields, Q, !0), ye.dirtyFields = r.dirtyFields, U = U || (u.dirtyFields || f.dirtyFields) && G !== !je;
      }
      if (z) {
        const je = tn(r.touchedFields, Q);
        je || (it(r.touchedFields, Q, z), ye.touchedFields = r.touchedFields, U = U || (u.touchedFields || f.touchedFields) && je !== z);
      }
      U && ce && h.state.next(ye);
    }
    return U ? ye : {};
  }, K = (Q, E, z, ie) => {
    const ce = tn(r.errors, Q), U = (u.isValid || f.isValid) && sr(E) && r.isValid !== E;
    if (n.delayError && z ? (d = j(() => O(Q, z)), d(n.delayError)) : (clearTimeout(p), d = null, z ? it(r.errors, Q, z) : Nt(r.errors, Q)), (z ? !mi(ce, z) : ce) || !Kt(ie) || U) {
      const G = {
        ...ie,
        ...U && sr(E) ? { isValid: E } : {},
        errors: r.errors,
        name: Q
      };
      r = {
        ...r,
        ...G
      }, h.state.next(G);
    }
  }, J = async (Q) => {
    g(Q, !0);
    const E = await n.resolver(o, n.context, Pq(Q || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(Q), E;
  }, re = async (Q) => {
    const { errors: E } = await J(Q);
    if (Q)
      for (const z of Q) {
        const ie = tn(E, z);
        ie ? it(r.errors, z, ie) : Nt(r.errors, z);
      }
    else
      r.errors = E;
    return E;
  }, W = async (Q, E, z = {
    valid: !0
  }) => {
    for (const ie in Q) {
      const ce = Q[ie];
      if (ce) {
        const { _f: U, ...G } = ce;
        if (U) {
          const ye = l.array.has(U.name), je = ce._f && Aq(ce._f);
          je && u.validatingFields && g([ie], !0);
          const Re = await $S(ce, l.disabled, o, N, n.shouldUseNativeValidation && !E, ye);
          if (je && u.validatingFields && g([ie]), Re[U.name] && (z.valid = !1, E))
            break;
          !E && (tn(Re, U.name) ? ye ? Bq(r.errors, Re, U.name) : it(r.errors, U.name, Re[U.name]) : Nt(r.errors, U.name));
        }
        !Kt(G) && await W(G, E, z);
      }
    }
    return z.valid;
  }, Y = () => {
    for (const Q of l.unMount) {
      const E = tn(i, Q);
      E && (E._f.refs ? E._f.refs.every((z) => !jm(z)) : !jm(E._f.ref)) && Be(Q);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (Q, E) => !n.disabled && (Q && E && it(o, Q, E), !mi(Oe(), a)), B = (Q, E, z) => V1(Q, l, {
    ...s.mount ? o : ht(E) ? a : Mr(Q) ? { [Q]: E } : E
  }, z, E), ee = (Q) => Ml(tn(s.mount ? o : a, Q, n.shouldUnregister ? tn(a, Q, []) : [])), Ne = (Q, E, z = {}) => {
    const ie = tn(i, Q);
    let ce = E;
    if (ie) {
      const U = ie._f;
      U && (!U.disabled && it(o, Q, q1(E, U)), ce = pl(U.ref) && Yt(E) ? "" : E, z1(U.ref) ? [...U.ref.options].forEach((G) => G.selected = ce.includes(G.value)) : U.refs ? Ho(U.ref) ? U.refs.length > 1 ? U.refs.forEach((G) => (!G.defaultChecked || !G.disabled) && (G.checked = Array.isArray(ce) ? !!ce.find((ye) => ye === G.value) : ce === G.value)) : U.refs[0] && (U.refs[0].checked = !!ce) : U.refs.forEach((G) => G.checked = G.value === ce) : kg(U.ref) ? U.ref.value = "" : (U.ref.value = ce, U.ref.type || h.state.next({
        name: Q,
        values: Dt(o)
      })));
    }
    (z.shouldDirty || z.shouldTouch) && L(Q, ce, z.shouldTouch, z.shouldDirty, !0), z.shouldValidate && ke(Q);
  }, ue = (Q, E, z) => {
    for (const ie in E) {
      const ce = E[ie], U = `${Q}.${ie}`, G = tn(i, U);
      (l.array.has(Q) || gt(ce) || G && !G._f) && !Ti(ce) ? ue(U, ce, z) : Ne(U, ce, z);
    }
  }, oe = (Q, E, z = {}) => {
    const ie = tn(i, Q), ce = l.array.has(Q), U = Dt(E);
    it(o, Q, U), ce ? (h.array.next({
      name: Q,
      values: Dt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && z.shouldDirty && h.state.next({
      name: Q,
      dirtyFields: so(a, o),
      isDirty: P(Q, U)
    })) : ie && !ie._f && !Yt(U) ? ue(Q, U, z) : Ne(Q, U, z), FS(Q, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? Q : void 0,
      values: Dt(o)
    });
  }, fe = async (Q) => {
    s.mount = !0;
    const E = Q.target;
    let z = E.name, ie = !0;
    const ce = tn(i, z), U = (G) => {
      ie = Number.isNaN(G) || Ti(G) && isNaN(G.getTime()) || mi(G, tn(o, z, G));
    };
    if (ce) {
      let G, ye;
      const je = E.type ? jS(ce._f) : D1(Q), Re = Q.type === ml.BLUR || Q.type === ml.FOCUS_OUT, rn = !Lq(ce._f) && !n.resolver && !tn(r.errors, z) && !ce._f.deps || Uq(Re, tn(r.touchedFields, z), r.isSubmitted, C, k), kn = FS(z, l, Re);
      it(o, z, je), Re ? (ce._f.onBlur && ce._f.onBlur(Q), d && d(0)) : ce._f.onChange && ce._f.onChange(Q);
      const an = L(z, je, Re), pn = !Kt(an) || kn;
      if (!Re && h.state.next({
        name: z,
        type: Q.type,
        values: Dt(o)
      }), rn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Re && _() : Re || _()), pn && h.state.next({ name: z, ...kn ? {} : an });
      if (!Re && kn && h.state.next({ ...r }), n.resolver) {
        const { errors: $n } = await J([z]);
        if (U(je), ie) {
          const _n = IS(r.errors, i, z), Fn = IS($n, i, _n.name || z);
          G = Fn.error, z = Fn.name, ye = Kt($n);
        }
      } else
        g([z], !0), G = (await $S(ce, l.disabled, o, N, n.shouldUseNativeValidation))[z], g([z]), U(je), ie && (G ? ye = !1 : (u.isValid || f.isValid) && (ye = await W(i, !0)));
      ie && (ce._f.deps && ke(ce._f.deps), K(z, ye, G, an));
    }
  }, V = (Q, E) => {
    if (tn(r.errors, E) && Q.focus)
      return Q.focus(), 1;
  }, ke = async (Q, E = {}) => {
    let z, ie;
    const ce = No(Q);
    if (n.resolver) {
      const U = await re(ht(Q) ? Q : ce);
      z = Kt(U), ie = Q ? !ce.some((G) => tn(U, G)) : z;
    } else Q ? (ie = (await Promise.all(ce.map(async (U) => {
      const G = tn(i, U);
      return await W(G && G._f ? { [U]: G } : G);
    }))).every(Boolean), !(!ie && !r.isValid) && _()) : ie = z = await W(i);
    return h.state.next({
      ...!Mr(Q) || (u.isValid || f.isValid) && z !== r.isValid ? {} : { name: Q },
      ...n.resolver || !Q ? { isValid: z } : {},
      errors: r.errors
    }), E.shouldFocus && !ie && jo(i, V, Q ? ce : l.mount), ie;
  }, Oe = (Q) => {
    const E = {
      ...s.mount ? o : a
    };
    return ht(Q) ? E : Mr(Q) ? tn(E, Q) : Q.map((z) => tn(E, z));
  }, q = (Q, E) => ({
    invalid: !!tn((E || r).errors, Q),
    isDirty: !!tn((E || r).dirtyFields, Q),
    error: tn((E || r).errors, Q),
    isValidating: !!tn(r.validatingFields, Q),
    isTouched: !!tn((E || r).touchedFields, Q)
  }), Ge = (Q) => {
    Q && No(Q).forEach((E) => Nt(r.errors, E)), h.state.next({
      errors: Q ? r.errors : {}
    });
  }, sn = (Q, E, z) => {
    const ie = (tn(i, Q, { _f: {} })._f || {}).ref, ce = tn(r.errors, Q) || {}, { ref: U, message: G, type: ye, ...je } = ce;
    it(r.errors, Q, {
      ...je,
      ...E,
      ref: ie
    }), h.state.next({
      name: Q,
      errors: r.errors,
      isValid: !1
    }), z && z.shouldFocus && ie && ie.focus && ie.focus();
  }, Ie = (Q, E) => Fr(Q) ? h.state.subscribe({
    next: (z) => Q(B(void 0, E), z)
  }) : B(Q, E, !0), Ue = (Q) => h.state.subscribe({
    next: (E) => {
      zq(Q.name, E.name, Q.exact) && Vq(E, Q.formState || u, Pe, Q.reRenderRoot) && Q.callback({
        values: { ...o },
        ...r,
        ...E
      });
    }
  }).unsubscribe, De = (Q) => (s.mount = !0, f = {
    ...f,
    ...Q.formState
  }, Ue({
    ...Q,
    formState: f
  })), Be = (Q, E = {}) => {
    for (const z of Q ? No(Q) : l.mount)
      l.mount.delete(z), l.array.delete(z), E.keepValue || (Nt(i, z), Nt(o, z)), !E.keepError && Nt(r.errors, z), !E.keepDirty && Nt(r.dirtyFields, z), !E.keepTouched && Nt(r.touchedFields, z), !E.keepIsValidating && Nt(r.validatingFields, z), !n.shouldUnregister && !E.keepDefaultValue && Nt(a, z);
    h.state.next({
      values: Dt(o)
    }), h.state.next({
      ...r,
      ...E.keepDirty ? { isDirty: P() } : {}
    }), !E.keepIsValid && _();
  }, Ae = ({ disabled: Q, name: E }) => {
    (sr(Q) && s.mount || Q || l.disabled.has(E)) && (Q ? l.disabled.add(E) : l.disabled.delete(E));
  }, Je = (Q, E = {}) => {
    let z = tn(i, Q);
    const ie = sr(E.disabled) || sr(n.disabled);
    return it(i, Q, {
      ...z || {},
      _f: {
        ...z && z._f ? z._f : { ref: { name: Q } },
        name: Q,
        mount: !0,
        ...E
      }
    }), l.mount.add(Q), z ? Ae({
      disabled: sr(E.disabled) ? E.disabled : n.disabled,
      name: Q
    }) : F(Q, !0, E.value), {
      ...ie ? { disabled: E.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!E.required,
        min: lo(E.min),
        max: lo(E.max),
        minLength: lo(E.minLength),
        maxLength: lo(E.maxLength),
        pattern: lo(E.pattern)
      } : {},
      name: Q,
      onChange: fe,
      onBlur: fe,
      ref: (ce) => {
        if (ce) {
          Je(Q, E), z = tn(i, Q);
          const U = ht(ce.value) && ce.querySelectorAll && ce.querySelectorAll("input,select,textarea")[0] || ce, G = Oq(U), ye = z._f.refs || [];
          if (G ? ye.find((je) => je === U) : U === z._f.ref)
            return;
          it(i, Q, {
            _f: {
              ...z._f,
              ...G ? {
                refs: [
                  ...ye.filter(jm),
                  U,
                  ...Array.isArray(tn(a, Q)) ? [{}] : []
                ],
                ref: { type: U.type, name: Q }
              } : { ref: U }
            }
          }), F(Q, !1, void 0, U);
        } else
          z = tn(i, Q, {}), z._f && (z._f.mount = !1), (n.shouldUnregister || E.shouldUnregister) && !(P1(l.array, Q) && s.action) && l.unMount.add(Q);
      }
    };
  }, $e = () => n.shouldFocusError && jo(i, V, l.mount), Me = (Q) => {
    sr(Q) && (h.state.next({ disabled: Q }), jo(i, (E, z) => {
      const ie = tn(i, z);
      ie && (E.disabled = ie._f.disabled || Q, Array.isArray(ie._f.refs) && ie._f.refs.forEach((ce) => {
        ce.disabled = ie._f.disabled || Q;
      }));
    }, 0, !1));
  }, en = (Q, E) => async (z) => {
    let ie;
    z && (z.preventDefault && z.preventDefault(), z.persist && z.persist());
    let ce = Dt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: U, values: G } = await J();
      r.errors = U, ce = G;
    } else
      await W(i);
    if (l.disabled.size)
      for (const U of l.disabled)
        it(ce, U, void 0);
    if (Nt(r.errors, "root"), Kt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await Q(ce, z);
      } catch (U) {
        ie = U;
      }
    } else
      E && await E({ ...r.errors }, z), $e(), setTimeout($e);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Kt(r.errors) && !ie,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ie)
      throw ie;
  }, se = (Q, E = {}) => {
    tn(i, Q) && (ht(E.defaultValue) ? oe(Q, Dt(tn(a, Q))) : (oe(Q, E.defaultValue), it(a, Q, Dt(E.defaultValue))), E.keepTouched || Nt(r.touchedFields, Q), E.keepDirty || (Nt(r.dirtyFields, Q), r.isDirty = E.defaultValue ? P(Q, Dt(tn(a, Q))) : P()), E.keepError || (Nt(r.errors, Q), u.isValid && _()), h.state.next({ ...r }));
  }, le = (Q, E = {}) => {
    const z = Q ? Dt(Q) : a, ie = Dt(z), ce = Kt(Q), U = ce ? a : ie;
    if (E.keepDefaultValues || (a = z), !E.keepValues) {
      if (E.keepDirtyValues) {
        const G = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(so(a, o))
        ]);
        for (const ye of Array.from(G))
          tn(r.dirtyFields, ye) ? it(U, ye, tn(o, ye)) : oe(ye, tn(U, ye));
      } else {
        if (yg && ht(Q))
          for (const G of l.mount) {
            const ye = tn(i, G);
            if (ye && ye._f) {
              const je = Array.isArray(ye._f.refs) ? ye._f.refs[0] : ye._f.ref;
              if (pl(je)) {
                const Re = je.closest("form");
                if (Re) {
                  Re.reset();
                  break;
                }
              }
            }
          }
        for (const G of l.mount)
          oe(G, tn(U, G));
      }
      o = Dt(U), h.array.next({
        values: { ...U }
      }), h.state.next({
        values: { ...U }
      });
    }
    l = {
      mount: E.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!E.keepIsValid || !!E.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: E.keepSubmitCount ? r.submitCount : 0,
      isDirty: ce ? !1 : E.keepDirty ? r.isDirty : !!(E.keepDefaultValues && !mi(Q, a)),
      isSubmitted: E.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: ce ? {} : E.keepDirtyValues ? E.keepDefaultValues && o ? so(a, o) : r.dirtyFields : E.keepDefaultValues && Q ? so(a, Q) : E.keepDirty ? r.dirtyFields : {},
      touchedFields: E.keepTouched ? r.touchedFields : {},
      errors: E.keepErrors ? r.errors : {},
      isSubmitSuccessful: E.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (Q, E) => le(Fr(Q) ? Q(o) : Q, E), Ve = (Q, E = {}) => {
    const z = tn(i, Q), ie = z && z._f;
    if (ie) {
      const ce = ie.refs ? ie.refs[0] : ie.ref;
      ce.focus && (ce.focus(), E.shouldSelect && Fr(ce.select) && ce.select());
    }
  }, Pe = (Q) => {
    r = {
      ...r,
      ...Q
    };
  }, vn = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: q,
      handleSubmit: en,
      setError: sn,
      _subscribe: Ue,
      _runSchema: J,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: D,
      _setDisabledField: Ae,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: le,
      _resetDefaultValues: () => Fr(n.defaultValues) && n.defaultValues().then((Q) => {
        xe(Q, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(Q) {
        s = Q;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(Q) {
        l = Q;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(Q) {
        n = {
          ...n,
          ...Q
        };
      }
    },
    subscribe: De,
    trigger: ke,
    register: Je,
    handleSubmit: en,
    watch: Ie,
    setValue: oe,
    getValues: Oe,
    reset: xe,
    resetField: se,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Ve,
    getFieldState: q
  };
  return {
    ...vn,
    formControl: vn
  };
}
function Wq(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Fr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Fr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Hq(e),
    formState: i
  }, e.formControl && e.defaultValues && !Fr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !mi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Kt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = L1(i, o), n.current;
}
var _s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function W1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var wm = { exports: {} }, co = {}, TS;
function Kq() {
  if (TS) return co;
  TS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return co.Fragment = r, co.jsx = s, co.jsxs = s, co;
}
var xs = {}, OS;
function Gq() {
  return OS || (OS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    xs.Fragment = i, xs.jsx = zn, xs.jsxs = Wn;
  })()), xs;
}
var RS;
function Yq() {
  return RS || (RS = 1, process.env.NODE_ENV === "production" ? wm.exports = Kq() : wm.exports = Gq()), wm.exports;
}
var wo = Yq();
function Jq(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Cm, DS;
function vi() {
  if (DS) return Cm;
  DS = 1;
  var e = Array.isArray;
  return Cm = e, Cm;
}
var Fm, PS;
function K1() {
  if (PS) return Fm;
  PS = 1;
  var e = typeof _s == "object" && _s && _s.Object === Object && _s;
  return Fm = e, Fm;
}
var Im, AS;
function Gr() {
  if (AS) return Im;
  AS = 1;
  var e = K1(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Im = r, Im;
}
var Em, LS;
function Wo() {
  if (LS) return Em;
  LS = 1;
  var e = Gr(), n = e.Symbol;
  return Em = n, Em;
}
var $m, VS;
function Qq() {
  if (VS) return $m;
  VS = 1;
  var e = Wo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var u = i.call(s);
    return p && (l ? s[a] = d : delete s[a]), u;
  }
  return $m = o, $m;
}
var Tm, zS;
function Xq() {
  if (zS) return Tm;
  zS = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Tm = r, Tm;
}
var Om, US;
function Ea() {
  if (US) return Om;
  US = 1;
  var e = Wo(), n = Qq(), r = Xq(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Om = s, Om;
}
var Rm, MS;
function Hi() {
  if (MS) return Rm;
  MS = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Rm = e, Rm;
}
var Dm, BS;
function _g() {
  if (BS) return Dm;
  BS = 1;
  var e = Ea(), n = Hi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Dm = i, Dm;
}
var Pm, qS;
function Zq() {
  if (qS) return Pm;
  qS = 1;
  var e = vi(), n = _g(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Pm = a, Pm;
}
var Am, HS;
function $a() {
  if (HS) return Am;
  HS = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Am = e, Am;
}
var Lm, WS;
function G1() {
  if (WS) return Lm;
  WS = 1;
  var e = Ea(), n = $a(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Lm = s, Lm;
}
var Vm, KS;
function e6() {
  if (KS) return Vm;
  KS = 1;
  var e = Gr(), n = e["__core-js_shared__"];
  return Vm = n, Vm;
}
var zm, GS;
function n6() {
  if (GS) return zm;
  GS = 1;
  var e = e6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return zm = r, zm;
}
var Um, YS;
function Y1() {
  if (YS) return Um;
  YS = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Um = r, Um;
}
var Mm, JS;
function t6() {
  if (JS) return Mm;
  JS = 1;
  var e = G1(), n = n6(), r = $a(), i = Y1(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, p = l.hasOwnProperty, u = RegExp(
    "^" + d.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return Mm = f, Mm;
}
var Bm, QS;
function r6() {
  if (QS) return Bm;
  QS = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Bm = e, Bm;
}
var qm, XS;
function Wi() {
  if (XS) return qm;
  XS = 1;
  var e = t6(), n = r6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return qm = r, qm;
}
var Hm, ZS;
function Bl() {
  if (ZS) return Hm;
  ZS = 1;
  var e = Wi(), n = e(Object, "create");
  return Hm = n, Hm;
}
var Wm, e0;
function i6() {
  if (e0) return Wm;
  e0 = 1;
  var e = Bl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Wm = n, Wm;
}
var Km, n0;
function a6() {
  if (n0) return Km;
  n0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Km = e, Km;
}
var Gm, t0;
function o6() {
  if (t0) return Gm;
  t0 = 1;
  var e = Bl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Gm = a, Gm;
}
var Ym, r0;
function s6() {
  if (r0) return Ym;
  r0 = 1;
  var e = Bl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Ym = i, Ym;
}
var Jm, i0;
function l6() {
  if (i0) return Jm;
  i0 = 1;
  var e = Bl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Jm = r, Jm;
}
var Qm, a0;
function c6() {
  if (a0) return Qm;
  a0 = 1;
  var e = i6(), n = a6(), r = o6(), i = s6(), a = l6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Qm = o, Qm;
}
var Xm, o0;
function d6() {
  if (o0) return Xm;
  o0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Xm = e, Xm;
}
var Zm, s0;
function J1() {
  if (s0) return Zm;
  s0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Zm = e, Zm;
}
var ep, l0;
function ql() {
  if (l0) return ep;
  l0 = 1;
  var e = J1();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return ep = n, ep;
}
var np, c0;
function u6() {
  if (c0) return np;
  c0 = 1;
  var e = ql(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return np = i, np;
}
var tp, d0;
function m6() {
  if (d0) return tp;
  d0 = 1;
  var e = ql();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return tp = n, tp;
}
var rp, u0;
function p6() {
  if (u0) return rp;
  u0 = 1;
  var e = ql();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return rp = n, rp;
}
var ip, m0;
function f6() {
  if (m0) return ip;
  m0 = 1;
  var e = ql();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return ip = n, ip;
}
var ap, p0;
function Hl() {
  if (p0) return ap;
  p0 = 1;
  var e = d6(), n = u6(), r = m6(), i = p6(), a = f6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ap = o, ap;
}
var op, f0;
function xg() {
  if (f0) return op;
  f0 = 1;
  var e = Wi(), n = Gr(), r = e(n, "Map");
  return op = r, op;
}
var sp, h0;
function h6() {
  if (h0) return sp;
  h0 = 1;
  var e = c6(), n = Hl(), r = xg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return sp = i, sp;
}
var lp, y0;
function y6() {
  if (y0) return lp;
  y0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return lp = e, lp;
}
var cp, g0;
function Wl() {
  if (g0) return cp;
  g0 = 1;
  var e = y6();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return cp = n, cp;
}
var dp, v0;
function g6() {
  if (v0) return dp;
  v0 = 1;
  var e = Wl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return dp = n, dp;
}
var up, k0;
function v6() {
  if (k0) return up;
  k0 = 1;
  var e = Wl();
  function n(r) {
    return e(this, r).get(r);
  }
  return up = n, up;
}
var mp, b0;
function k6() {
  if (b0) return mp;
  b0 = 1;
  var e = Wl();
  function n(r) {
    return e(this, r).has(r);
  }
  return mp = n, mp;
}
var pp, _0;
function b6() {
  if (_0) return pp;
  _0 = 1;
  var e = Wl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return pp = n, pp;
}
var fp, x0;
function Q1() {
  if (x0) return fp;
  x0 = 1;
  var e = h6(), n = g6(), r = v6(), i = k6(), a = b6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, fp = o, fp;
}
var hp, S0;
function _6() {
  if (S0) return hp;
  S0 = 1;
  var e = Q1(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var p = i.apply(this, s);
      return o.cache = d.set(l, p) || d, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, hp = r, hp;
}
var yp, N0;
function x6() {
  if (N0) return yp;
  N0 = 1;
  var e = _6(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return yp = r, yp;
}
var gp, j0;
function S6() {
  if (j0) return gp;
  j0 = 1;
  var e = x6(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, p) {
      o.push(d ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return gp = i, gp;
}
var vp, w0;
function X1() {
  if (w0) return vp;
  w0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return vp = e, vp;
}
var kp, C0;
function N6() {
  if (C0) return kp;
  C0 = 1;
  var e = Wo(), n = X1(), r = vi(), i = _g(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return kp = s, kp;
}
var bp, F0;
function j6() {
  if (F0) return bp;
  F0 = 1;
  var e = N6();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return bp = n, bp;
}
var _p, I0;
function Ta() {
  if (I0) return _p;
  I0 = 1;
  var e = vi(), n = Zq(), r = S6(), i = j6();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return _p = a, _p;
}
var xp, E0;
function Kl() {
  if (E0) return xp;
  E0 = 1;
  var e = _g();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return xp = n, xp;
}
var Sp, $0;
function Z1() {
  if ($0) return Sp;
  $0 = 1;
  var e = Ta(), n = Kl();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Sp = r, Sp;
}
var Np, T0;
function eF() {
  if (T0) return Np;
  T0 = 1;
  var e = Wi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Np = n, Np;
}
var jp, O0;
function nF() {
  if (O0) return jp;
  O0 = 1;
  var e = eF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return jp = n, jp;
}
var wp, R0;
function Sg() {
  if (R0) return wp;
  R0 = 1;
  var e = nF(), n = J1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return wp = a, wp;
}
var Cp, D0;
function Ng() {
  if (D0) return Cp;
  D0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Cp = r, Cp;
}
var Fp, P0;
function w6() {
  if (P0) return Fp;
  P0 = 1;
  var e = Sg(), n = Ta(), r = Ng(), i = $a(), a = Kl();
  function o(s, l, d, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var C = a(l[u]), N = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var j = k[C];
        N = p ? p(j, C, k) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(k, C, N), k = k[C];
    }
    return s;
  }
  return Fp = o, Fp;
}
var Ip, A0;
function C6() {
  if (A0) return Ip;
  A0 = 1;
  var e = Z1(), n = w6(), r = Ta();
  function i(a, o, s) {
    for (var l = -1, d = o.length, p = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(p, r(u, a), f);
    }
    return p;
  }
  return Ip = i, Ip;
}
var Ep, L0;
function F6() {
  if (L0) return Ep;
  L0 = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Ep = e, Ep;
}
var $p, V0;
function I6() {
  if (V0) return $p;
  V0 = 1;
  var e = Ea(), n = Hi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return $p = i, $p;
}
var Tp, z0;
function jg() {
  if (z0) return Tp;
  z0 = 1;
  var e = I6(), n = Hi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Tp = o, Tp;
}
var Op, U0;
function wg() {
  if (U0) return Op;
  U0 = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Op = n, Op;
}
var Rp, M0;
function E6() {
  if (M0) return Rp;
  M0 = 1;
  var e = Ta(), n = jg(), r = vi(), i = Ng(), a = wg(), o = Kl();
  function s(l, d, p) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && p(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return Rp = s, Rp;
}
var Dp, B0;
function $6() {
  if (B0) return Dp;
  B0 = 1;
  var e = F6(), n = E6();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Dp = r, Dp;
}
var Pp, q0;
function T6() {
  if (q0) return Pp;
  q0 = 1;
  var e = C6(), n = $6();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Pp = r, Pp;
}
var Ap, H0;
function Cg() {
  if (H0) return Ap;
  H0 = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Ap = e, Ap;
}
var Lp, W0;
function O6() {
  if (W0) return Lp;
  W0 = 1;
  var e = Wo(), n = jg(), r = vi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Lp = a, Lp;
}
var Vp, K0;
function R6() {
  if (K0) return Vp;
  K0 = 1;
  var e = Cg(), n = O6();
  function r(i, a, o, s, l) {
    var d = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++d < p; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Vp = r, Vp;
}
var zp, G0;
function D6() {
  if (G0) return zp;
  G0 = 1;
  var e = R6();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return zp = n, zp;
}
var Up, Y0;
function P6() {
  if (Y0) return Up;
  Y0 = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Up = e, Up;
}
var Mp, J0;
function A6() {
  if (J0) return Mp;
  J0 = 1;
  var e = P6(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), p = Array(d); ++l < d; )
        p[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(p), e(i, this, u);
    };
  }
  return Mp = r, Mp;
}
var Bp, Q0;
function L6() {
  if (Q0) return Bp;
  Q0 = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Bp = e, Bp;
}
var qp, X0;
function tF() {
  if (X0) return qp;
  X0 = 1;
  function e(n) {
    return n;
  }
  return qp = e, qp;
}
var Hp, Z0;
function V6() {
  if (Z0) return Hp;
  Z0 = 1;
  var e = L6(), n = eF(), r = tF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Hp = i, Hp;
}
var Wp, eN;
function z6() {
  if (eN) return Wp;
  eN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Wp = i, Wp;
}
var Kp, nN;
function U6() {
  if (nN) return Kp;
  nN = 1;
  var e = V6(), n = z6(), r = n(e);
  return Kp = r, Kp;
}
var Gp, tN;
function rF() {
  if (tN) return Gp;
  tN = 1;
  var e = D6(), n = A6(), r = U6();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Gp = i, Gp;
}
var Yp, rN;
function M6() {
  if (rN) return Yp;
  rN = 1;
  var e = T6(), n = rF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Yp = r, Yp;
}
var B6 = M6();
const iF = /* @__PURE__ */ W1(B6), q6 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function aF(e) {
  const n = iF(e, q6);
  return {
    controller: $q(n),
    controllerProps: n
  };
}
const H6 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function W6(e) {
  const { controller: n, controllerProps: r } = aF(e), i = {
    ...iF(e, H6),
    required: Jq(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Jp, iN;
function K6() {
  if (iN) return Jp;
  iN = 1;
  var e = Hl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Jp = n, Jp;
}
var Qp, aN;
function G6() {
  if (aN) return Qp;
  aN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Qp = e, Qp;
}
var Xp, oN;
function Y6() {
  if (oN) return Xp;
  oN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Xp = e, Xp;
}
var Zp, sN;
function J6() {
  if (sN) return Zp;
  sN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Zp = e, Zp;
}
var ef, lN;
function Q6() {
  if (lN) return ef;
  lN = 1;
  var e = Hl(), n = xg(), r = Q1(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return ef = a, ef;
}
var nf, cN;
function X6() {
  if (cN) return nf;
  cN = 1;
  var e = Hl(), n = K6(), r = G6(), i = Y6(), a = J6(), o = Q6();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, nf = s, nf;
}
var tf, dN;
function Z6() {
  if (dN) return tf;
  dN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return tf = e, tf;
}
var rf, uN;
function Ko() {
  if (uN) return rf;
  uN = 1;
  var e = Sg(), n = nF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, p = a.length; ++d < p; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return rf = r, rf;
}
var af, mN;
function eH() {
  if (mN) return af;
  mN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return af = e, af;
}
var qs = { exports: {} }, of, pN;
function nH() {
  if (pN) return of;
  pN = 1;
  function e() {
    return !1;
  }
  return of = e, of;
}
qs.exports;
var fN;
function oF() {
  return fN || (fN = 1, (function(e, n) {
    var r = Gr(), i = nH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, p = d || i;
    e.exports = p;
  })(qs, qs.exports)), qs.exports;
}
var sf, hN;
function tH() {
  if (hN) return sf;
  hN = 1;
  var e = Ea(), n = wg(), r = Hi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", p = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", C = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", D = "[object Float64Array]", O = "[object Int8Array]", I = "[object Int16Array]", F = "[object Int32Array]", L = "[object Uint8Array]", K = "[object Uint8ClampedArray]", J = "[object Uint16Array]", re = "[object Uint32Array]", W = {};
  W[g] = W[D] = W[O] = W[I] = W[F] = W[L] = W[K] = W[J] = W[re] = !0, W[i] = W[a] = W[j] = W[o] = W[_] = W[s] = W[l] = W[d] = W[p] = W[u] = W[f] = W[h] = W[k] = W[C] = W[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!W[e(P)];
  }
  return sf = Y, sf;
}
var lf, yN;
function Fg() {
  if (yN) return lf;
  yN = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return lf = e, lf;
}
var Hs = { exports: {} };
Hs.exports;
var gN;
function Ig() {
  return gN || (gN = 1, (function(e, n) {
    var r = K1(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Hs, Hs.exports)), Hs.exports;
}
var cf, vN;
function rH() {
  if (vN) return cf;
  vN = 1;
  var e = tH(), n = Fg(), r = Ig(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return cf = a, cf;
}
var df, kN;
function sF() {
  if (kN) return df;
  kN = 1;
  var e = eH(), n = jg(), r = vi(), i = oF(), a = Ng(), o = rH(), s = Object.prototype, l = s.hasOwnProperty;
  function d(p, u) {
    var f = r(p), h = !f && n(p), k = !f && !h && i(p), C = !f && !h && !k && o(p), N = f || h || k || C, j = N ? e(p.length, String) : [], _ = j.length;
    for (var g in p)
      (u || l.call(p, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return df = d, df;
}
var uf, bN;
function Eg() {
  if (bN) return uf;
  bN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return uf = n, uf;
}
var mf, _N;
function lF() {
  if (_N) return mf;
  _N = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return mf = e, mf;
}
var pf, xN;
function iH() {
  if (xN) return pf;
  xN = 1;
  var e = lF(), n = e(Object.keys, Object);
  return pf = n, pf;
}
var ff, SN;
function aH() {
  if (SN) return ff;
  SN = 1;
  var e = Eg(), n = iH(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return ff = a, ff;
}
var hf, NN;
function cF() {
  if (NN) return hf;
  NN = 1;
  var e = G1(), n = wg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return hf = r, hf;
}
var yf, jN;
function $g() {
  if (jN) return yf;
  jN = 1;
  var e = sF(), n = aH(), r = cF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return yf = i, yf;
}
var gf, wN;
function oH() {
  if (wN) return gf;
  wN = 1;
  var e = Ko(), n = $g();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return gf = r, gf;
}
var vf, CN;
function sH() {
  if (CN) return vf;
  CN = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return vf = e, vf;
}
var kf, FN;
function lH() {
  if (FN) return kf;
  FN = 1;
  var e = $a(), n = Eg(), r = sH(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || d.push(p);
    return d;
  }
  return kf = o, kf;
}
var bf, IN;
function Tg() {
  if (IN) return bf;
  IN = 1;
  var e = sF(), n = lH(), r = cF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return bf = i, bf;
}
var _f, EN;
function cH() {
  if (EN) return _f;
  EN = 1;
  var e = Ko(), n = Tg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return _f = r, _f;
}
var Ws = { exports: {} };
Ws.exports;
var $N;
function dH() {
  return $N || ($N = 1, (function(e, n) {
    var r = Gr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(p, u) {
      if (u)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = d;
  })(Ws, Ws.exports)), Ws.exports;
}
var xf, TN;
function uH() {
  if (TN) return xf;
  TN = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return xf = e, xf;
}
var Sf, ON;
function mH() {
  if (ON) return Sf;
  ON = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Sf = e, Sf;
}
var Nf, RN;
function dF() {
  if (RN) return Nf;
  RN = 1;
  function e() {
    return [];
  }
  return Nf = e, Nf;
}
var jf, DN;
function Og() {
  if (DN) return jf;
  DN = 1;
  var e = mH(), n = dF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return jf = o, jf;
}
var wf, PN;
function pH() {
  if (PN) return wf;
  PN = 1;
  var e = Ko(), n = Og();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return wf = r, wf;
}
var Cf, AN;
function Rg() {
  if (AN) return Cf;
  AN = 1;
  var e = lF(), n = e(Object.getPrototypeOf, Object);
  return Cf = n, Cf;
}
var Ff, LN;
function uF() {
  if (LN) return Ff;
  LN = 1;
  var e = Cg(), n = Rg(), r = Og(), i = dF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Ff = o, Ff;
}
var If, VN;
function fH() {
  if (VN) return If;
  VN = 1;
  var e = Ko(), n = uF();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return If = r, If;
}
var Ef, zN;
function mF() {
  if (zN) return Ef;
  zN = 1;
  var e = Cg(), n = vi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Ef = r, Ef;
}
var $f, UN;
function hH() {
  if (UN) return $f;
  UN = 1;
  var e = mF(), n = Og(), r = $g();
  function i(a) {
    return e(a, r, n);
  }
  return $f = i, $f;
}
var Tf, MN;
function pF() {
  if (MN) return Tf;
  MN = 1;
  var e = mF(), n = uF(), r = Tg();
  function i(a) {
    return e(a, r, n);
  }
  return Tf = i, Tf;
}
var Of, BN;
function yH() {
  if (BN) return Of;
  BN = 1;
  var e = Wi(), n = Gr(), r = e(n, "DataView");
  return Of = r, Of;
}
var Rf, qN;
function gH() {
  if (qN) return Rf;
  qN = 1;
  var e = Wi(), n = Gr(), r = e(n, "Promise");
  return Rf = r, Rf;
}
var Df, HN;
function vH() {
  if (HN) return Df;
  HN = 1;
  var e = Wi(), n = Gr(), r = e(n, "Set");
  return Df = r, Df;
}
var Pf, WN;
function kH() {
  if (WN) return Pf;
  WN = 1;
  var e = Wi(), n = Gr(), r = e(n, "WeakMap");
  return Pf = r, Pf;
}
var Af, KN;
function Dg() {
  if (KN) return Af;
  KN = 1;
  var e = yH(), n = xg(), r = gH(), i = vH(), a = kH(), o = Ea(), s = Y1(), l = "[object Map]", d = "[object Object]", p = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), C = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != p || i && g(new i()) != u || a && g(new a()) != f) && (g = function(D) {
    var O = o(D), I = O == d ? D.constructor : void 0, F = I ? s(I) : "";
    if (F)
      switch (F) {
        case k:
          return h;
        case C:
          return l;
        case N:
          return p;
        case j:
          return u;
        case _:
          return f;
      }
    return O;
  }), Af = g, Af;
}
var Lf, GN;
function bH() {
  if (GN) return Lf;
  GN = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Lf = r, Lf;
}
var Vf, YN;
function _H() {
  if (YN) return Vf;
  YN = 1;
  var e = Gr(), n = e.Uint8Array;
  return Vf = n, Vf;
}
var zf, JN;
function Pg() {
  if (JN) return zf;
  JN = 1;
  var e = _H();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return zf = n, zf;
}
var Uf, QN;
function xH() {
  if (QN) return Uf;
  QN = 1;
  var e = Pg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Uf = n, Uf;
}
var Mf, XN;
function SH() {
  if (XN) return Mf;
  XN = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Mf = n, Mf;
}
var Bf, ZN;
function NH() {
  if (ZN) return Bf;
  ZN = 1;
  var e = Wo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Bf = i, Bf;
}
var qf, ej;
function jH() {
  if (ej) return qf;
  ej = 1;
  var e = Pg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return qf = n, qf;
}
var Hf, nj;
function wH() {
  if (nj) return Hf;
  nj = 1;
  var e = Pg(), n = xH(), r = SH(), i = NH(), a = jH(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", p = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", C = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", D = "[object Int32Array]", O = "[object Uint8Array]", I = "[object Uint8ClampedArray]", F = "[object Uint16Array]", L = "[object Uint32Array]";
  function K(J, re, W) {
    var Y = J.constructor;
    switch (re) {
      case k:
        return e(J);
      case o:
      case s:
        return new Y(+J);
      case C:
        return n(J, W);
      case N:
      case j:
      case _:
      case g:
      case D:
      case O:
      case I:
      case F:
      case L:
        return a(J, W);
      case l:
        return new Y();
      case d:
      case f:
        return new Y(J);
      case p:
        return r(J);
      case u:
        return new Y();
      case h:
        return i(J);
    }
  }
  return Hf = K, Hf;
}
var Wf, tj;
function CH() {
  if (tj) return Wf;
  tj = 1;
  var e = $a(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Wf = r, Wf;
}
var Kf, rj;
function FH() {
  if (rj) return Kf;
  rj = 1;
  var e = CH(), n = Rg(), r = Eg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Kf = i, Kf;
}
var Gf, ij;
function IH() {
  if (ij) return Gf;
  ij = 1;
  var e = Dg(), n = Hi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Gf = i, Gf;
}
var Yf, aj;
function EH() {
  if (aj) return Yf;
  aj = 1;
  var e = IH(), n = Fg(), r = Ig(), i = r && r.isMap, a = i ? n(i) : e;
  return Yf = a, Yf;
}
var Jf, oj;
function $H() {
  if (oj) return Jf;
  oj = 1;
  var e = Dg(), n = Hi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jf = i, Jf;
}
var Qf, sj;
function TH() {
  if (sj) return Qf;
  sj = 1;
  var e = $H(), n = Fg(), r = Ig(), i = r && r.isSet, a = i ? n(i) : e;
  return Qf = a, Qf;
}
var Xf, lj;
function OH() {
  if (lj) return Xf;
  lj = 1;
  var e = X6(), n = Z6(), r = Sg(), i = oH(), a = cH(), o = dH(), s = uH(), l = pH(), d = fH(), p = hH(), u = pF(), f = Dg(), h = bH(), k = wH(), C = FH(), N = vi(), j = oF(), _ = EH(), g = $a(), D = TH(), O = $g(), I = Tg(), F = 1, L = 2, K = 4, J = "[object Arguments]", re = "[object Array]", W = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", ee = "[object GeneratorFunction]", Ne = "[object Map]", ue = "[object Number]", oe = "[object Object]", fe = "[object RegExp]", V = "[object Set]", ke = "[object String]", Oe = "[object Symbol]", q = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", $e = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", se = {};
  se[J] = se[re] = se[Ge] = se[sn] = se[W] = se[Y] = se[Ie] = se[Ue] = se[De] = se[Be] = se[Ae] = se[Ne] = se[ue] = se[oe] = se[fe] = se[V] = se[ke] = se[Oe] = se[Je] = se[$e] = se[Me] = se[en] = !0, se[P] = se[B] = se[q] = !1;
  function le(xe, Ve, Pe, vn, Q, E) {
    var z, ie = Ve & F, ce = Ve & L, U = Ve & K;
    if (Pe && (z = Q ? Pe(xe, vn, Q, E) : Pe(xe)), z !== void 0)
      return z;
    if (!g(xe))
      return xe;
    var G = N(xe);
    if (G) {
      if (z = h(xe), !ie)
        return s(xe, z);
    } else {
      var ye = f(xe), je = ye == B || ye == ee;
      if (j(xe))
        return o(xe, ie);
      if (ye == oe || ye == J || je && !Q) {
        if (z = ce || je ? {} : C(xe), !ie)
          return ce ? d(xe, a(z, xe)) : l(xe, i(z, xe));
      } else {
        if (!se[ye])
          return Q ? xe : {};
        z = k(xe, ye, ie);
      }
    }
    E || (E = new e());
    var Re = E.get(xe);
    if (Re)
      return Re;
    E.set(xe, z), D(xe) ? xe.forEach(function(an) {
      z.add(le(an, Ve, Pe, an, xe, E));
    }) : _(xe) && xe.forEach(function(an, pn) {
      z.set(pn, le(an, Ve, Pe, pn, xe, E));
    });
    var rn = U ? ce ? u : p : ce ? I : O, kn = G ? void 0 : rn(xe);
    return n(kn || xe, function(an, pn) {
      kn && (pn = an, an = xe[pn]), r(z, pn, le(an, Ve, Pe, pn, xe, E));
    }), z;
  }
  return Xf = le, Xf;
}
var Zf, cj;
function RH() {
  if (cj) return Zf;
  cj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Zf = e, Zf;
}
var eh, dj;
function DH() {
  if (dj) return eh;
  dj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return eh = e, eh;
}
var nh, uj;
function PH() {
  if (uj) return nh;
  uj = 1;
  var e = Z1(), n = DH();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return nh = r, nh;
}
var th, mj;
function AH() {
  if (mj) return th;
  mj = 1;
  var e = Ta(), n = RH(), r = PH(), i = Kl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var p = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++p < u; ) {
      var f = i(d[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return th = s, th;
}
var rh, pj;
function LH() {
  if (pj) return rh;
  pj = 1;
  var e = Ea(), n = Rg(), r = Hi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function p(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return rh = p, rh;
}
var ih, fj;
function VH() {
  if (fj) return ih;
  fj = 1;
  var e = LH();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return ih = n, ih;
}
var ah, hj;
function zH() {
  if (hj) return ah;
  hj = 1;
  var e = X1(), n = OH(), r = AH(), i = Ta(), a = Ko(), o = VH(), s = rF(), l = pF(), d = 1, p = 2, u = 4, f = s(function(h, k) {
    var C = {};
    if (h == null)
      return C;
    var N = !1;
    k = e(k, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), C), N && (C = n(C, d | p | u, o));
    for (var j = k.length; j--; )
      r(C, k[j]);
    return C;
  });
  return ah = f, ah;
}
zH();
var UH = tF();
const MH = /* @__PURE__ */ W1(UH), ra = ({
  transformValue: e = MH,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = aF(a);
  return /* @__PURE__ */ wo.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ wo.jsx(
      Fo,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ wo.jsx(lw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, yj = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = W6(e);
  return /* @__PURE__ */ wo.jsx(We, { ...i, children: /* @__PURE__ */ wo.jsx(
    cr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: We.getStatus(i.meta)
    }
  ) });
}, ty = [
  {
    key: "rivoLoyaltyApiKey",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: hg,
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], gj = "RIVOLOYALTY", Ss = "Rivo Loyalty", BH = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [hg]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, qH = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = Wq({
    mode: "onChange",
    defaultValues: BH
  }), {
    create: l,
    update: d,
    remove: p,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: gj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: ty,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => fr(K, {
    fieldDefinitions: ty,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ be.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ be.jsx(hr, { cause: h }),
        /* @__PURE__ */ be.jsxs(nt, { children: [
          /* @__PURE__ */ be.jsx(Z, { children: /* @__PURE__ */ be.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            yj,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            yj,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: "Shopify API host name",
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (K) => kl(K) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            Ir,
            {
              name: "rivoLoyaltyApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: "Show orders overview", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: "Show loyalty", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: "Allow adjusting loyalty points", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: "Show favorite products", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: "Show available rewards", children: /* @__PURE__ */ be.jsx(
            ra,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && D !== null && /* @__PURE__ */ be.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          yr,
          {
            integrationType: gj,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ be.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ be.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ be.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ss,
                  " integration, all links between Dixa and ",
                  Ss,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ be.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ss,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ be.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ss,
                  " ",
                  'integration "',
                  L,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var oh = { exports: {} }, uo = {}, vj;
function HH() {
  if (vj) return uo;
  vj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return uo.Fragment = r, uo.jsx = s, uo.jsxs = s, uo;
}
var Ns = {}, kj;
function WH() {
  return kj || (kj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    Ns.Fragment = i, Ns.jsx = zn, Ns.jsxs = Wn;
  })()), Ns;
}
var bj;
function KH() {
  return bj || (bj = 1, process.env.NODE_ENV === "production" ? oh.exports = HH() : oh.exports = WH()), oh.exports;
}
var v = KH();
const _j = "__PairingContext__", GH = () => globalThis[_j] ?? (() => {
  const e = sw({});
  return globalThis[_j] = e, e;
})(), YH = GH(), JH = () => uy(YH), QH = "_banner_d9pot_1", XH = "_list_d9pot_8", xj = {
  banner: QH,
  list: XH
}, Sj = "https://apps.shopify.com/dixa-dashboard", ZH = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, yl = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = JH(), [i, a] = me(!1), [o, s] = me(null), l = ZH[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Sj,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Sj, "_blank", "noopener,noreferrer");
  }, p = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", className: xj.banner, children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(ve, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ v.jsx($.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ v.jsx($.Paragraph, { as: "div", children: /* @__PURE__ */ v.jsx(p, { className: xj.list, children: l.listItems.map((u, f) => /* @__PURE__ */ v.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ v.jsx($.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ v.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ v.jsx(
      ct,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(fn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, gl = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "displayRefundOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayEmailMarketingConsent",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "apiAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientId",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], Nj = "SHOPIFY", eW = [
  { name: "displayRefundOrder", label: "Display the refund order button" },
  {
    name: "displayPartialRefundOrder",
    label: "Displays the partial refund order button"
  },
  { name: "displayCancelOrder", label: "Displays the cancel order button" },
  {
    name: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button'
  },
  { name: "displayOrdersOverview", label: "Displays short orders overview" },
  {
    name: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer"
  },
  {
    name: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer"
  },
  { name: "displayDiscountCodes", label: "Displays available discount codes" },
  {
    name: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button"
  },
  { name: "displayCreateOrder", label: "Displays the create order button" },
  {
    name: "displayCreateDraftOrder",
    label: "Displays the create draft order button"
  },
  {
    name: "displayDuplicateOrder",
    label: "Displays the duplicate order button"
  }
], nW = {
  enabled: !1,
  name: "",
  ...xl(
    [],
    gl
  )
}, tW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: nW
  }), {
    create: l,
    update: d,
    remove: p,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: Nj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: gl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = g?.additionalProperties, L = F?.tokenSource === "marketplace_app", K = !!F?.isUsingOAuth, J = !L, re = (Y) => fr(Y, {
    fieldDefinitions: gl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), W = s.watch("name");
  return /* @__PURE__ */ v.jsx(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: re,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: o ? /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(
        yl,
        {
          label: "Connect your Shopify store",
          bannerVariant: "install"
        }
      ) }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(hr, { cause: h }),
        /* @__PURE__ */ v.jsxs(nt, { children: [
          J && /* @__PURE__ */ v.jsx(
            yl,
            {
              label: "Upgrade to simplified connection",
              bannerVariant: "migration"
            }
          ),
          /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ v.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          J && K && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ir,
              {
                name: "shopifyClientId",
                label: "Client ID",
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client ID is required" },
                componentProps: {
                  placeholder: "Client ID from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ir,
              {
                name: "shopifyClientSecret",
                label: "Client Secret",
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client Secret is required" },
                componentProps: {
                  placeholder: "Client Secret from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          J && !K && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ir,
              {
                name: "apiAccessToken",
                label: "API Access Token",
                control: s.control,
                isCreationMode: o,
                rules: { required: "API access token is required" },
                componentProps: {
                  placeholder: "API access token from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          L ? /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            Pn,
            {
              name: "apiHostName",
              label: "Connected Shopify store",
              control: s.control,
              componentProps: {
                readOnly: !0,
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }) : /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            Pn,
            {
              name: "apiHostName",
              label: "API host name",
              control: s.control,
              rules: {
                required: "API host name is required",
                validate: (Y) => kl(Y) || !0
              },
              componentProps: {
                placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          eW.map(({ name: Y, label: P }) => /* @__PURE__ */ v.jsxs(oI, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(We, { label: P, children: /* @__PURE__ */ v.jsx(
              bn,
              {
                name: Y,
                control: s.control
              }
            ) }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }, Y)),
          a && D !== null && /* @__PURE__ */ v.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ v.jsx(
          yr,
          {
            integrationType: Nj,
            integrationId: e,
            widgetName: W,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ] })
    }
  );
}, rW = (e) => /* @__PURE__ */ v.jsx(yl, { ...e, bannerVariant: "install" }), iW = (e) => /* @__PURE__ */ v.jsx(yl, { ...e, bannerVariant: "migration" }), aW = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], oW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], sW = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: rW
  }
], lW = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], jj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: iW,
    additionalProperties: { renderAboveForm: !0 }
  }
], fF = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], wj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => kl(e)
  },
  ...fF
];
var oa = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(oa || {}), Pi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Pi || {}), zr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(zr || {}), hF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(hF || {}), ry = /* @__PURE__ */ ((e) => (e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e))(ry || {}), Ii = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Ii || {}), Ai = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Ai || {}), Ks = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Ks || {}), yF = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(yF || {});
const cW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, dW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, uW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, mW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, pW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, fW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, hW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, yW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderMarkAsPaid" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderMarkAsPaidInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderMarkAsPaid" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, gW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, vW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, kW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, bW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, _W = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, xW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "discountCodes" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalDiscountsSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, SW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "discount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customerGets" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountPercentage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "percentage" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountAmount" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, NW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, jW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifySuggestedRefund" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundLineItemInput" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "refundLineItems" }, value: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } } }, { kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }] } }] } }] } }] }, wW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, CW = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": cW,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": dW,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": uW,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": mW,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": pW,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": fW,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": hW,
  "\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": yW,
  "\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": gW,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": vW,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": kW,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": bW,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": _W,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": xW,
  "\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SW,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": NW,
  "\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": jW,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": wW
};
function ir(e) {
  return CW[e] ?? {};
}
const FW = ir(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), IW = ir(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            discountCodes
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true, refundShipping: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              subtotalSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              totalTaxSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              shipping {
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                maximumRefundableSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            currentTotalDiscountsSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), EW = ir(
  /* GraphQL */
  `
  query shopifySuggestedRefund(
    $orderId: ID!
    $refundLineItems: [Shopify_RefundLineItemInput!]
    $refundShipping: Boolean
    $suggestFullRefund: Boolean
  ) {
    Shopify {
      order(id: $orderId) {
        id
        suggestedRefund(
          refundLineItems: $refundLineItems
          refundShipping: $refundShipping
          suggestFullRefund: $suggestFullRefund
        ) {
          amountSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          subtotalSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          totalTaxSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          shipping {
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            maximumRefundableSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          suggestedTransactions {
            accountNumber
            gateway
            kind
            parentTransaction {
              id
            }
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          refundLineItems {
            lineItem {
              id
              quantity
            }
          }
        }
      }
    }
  }
`
), $W = ir(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), TW = ir(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Ag = ir(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), OW = ir(
  /* GraphQL */
  `
  query searchDiscountCodes($query: String, $first: Int, $after: String) {
    Shopify {
      discountNodes(query: $query, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          discount {
            __typename

            ... on Shopify_DiscountCodeApp {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
              customerGets {
                value {
                  __typename

                  ... on Shopify_DiscountPercentage {
                    percentage
                  }

                  ... on Shopify_DiscountAmount {
                    amount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), RW = ir(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), DW = ir(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), PW = ir(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), AW = ir(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), LW = ir(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), VW = ir(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), gF = jl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, zW = jl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, vF = ir(
  /* GraphQL */
  `
  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {
    Shopify {
      orderMarkAsPaid(input: $input) {
        order {
          id
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), UW = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = hn(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: d,
    error: p,
    data: u,
    refetch: f,
    networkStatus: h
  } = r(FW, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: d,
    customerError: p,
    customerData: u,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, MW = () => {
  const { useLazyQuery: e } = hn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(IW);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Br(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const kF = (e, n) => (n ?? []).map(({ amountSet: r, gateway: i, parentTransaction: a }) => ({
  amount: String(r?.presentmentMoney?.amount ?? "0.00"),
  gateway: i ?? "",
  kind: yF.Refund,
  orderId: e,
  parentId: a?.id
})), bF = ({
  orderId: e,
  transactions: n,
  refundLineItems: r,
  refundShipping: i,
  note: a,
  notify: o = !0
}) => ({
  orderId: e,
  notify: o,
  note: a,
  refundLineItems: r,
  transactions: n,
  shipping: {
    fullRefund: i
  }
}), BW = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    currentTotalDiscountsSet: r.currentTotalDiscountsSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      subtotal: r.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
      tax: r.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: kF(
        r.id,
        r.suggestedRefund?.suggestedTransactions
      ),
      shipping: {
        fullRefund: !0,
        amount: r.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
        maximumRefundable: r.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    discountCodes: r.discountCodes,
    refunds: r.refunds
  }));
}, Cj = [
  {
    value: Ai.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Ai.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Ai.Paid,
    label: "Paid",
    description: "The payment has been completed"
  }
], Fj = [
  {
    value: Ks.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Ks.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Ks.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], _F = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), sa = (e) => qW(HW(e)), qW = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), HW = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, xF = ({
  orderId: e,
  refundShipping: n,
  refundLineItems: r,
  suggestFullRefund: i,
  skip: a
}) => {
  const { useQuery: o } = hn(), {
    data: s,
    previousData: l,
    loading: d,
    error: p
  } = o(EW, {
    skip: a,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: !0,
    variables: {
      orderId: e,
      refundShipping: n,
      refundLineItems: r,
      suggestFullRefund: i
    }
  }), u = a ? void 0 : s?.Shopify?.order?.suggestedRefund ?? l?.Shopify?.order?.suggestedRefund;
  return { suggestedRefund: Qn(() => {
    if (u)
      return {
        amount: String(u.amountSet.presentmentMoney.amount),
        subtotal: String(u.subtotalSet.presentmentMoney.amount),
        tax: String(u.totalTaxSet.presentmentMoney.amount),
        currency: u.amountSet.presentmentMoney.currencyCode,
        shipping: {
          amount: String(
            u.shipping.amountSet.presentmentMoney.amount
          ),
          maximumRefundable: String(
            u.shipping.maximumRefundableSet.presentmentMoney.amount
          )
        },
        transactions: kF(
          e,
          u.suggestedTransactions
        ),
        refundLineItems: u.refundLineItems.map(
          ({ lineItem: f }) => ({
            lineItemId: f.id,
            quantity: f.quantity
          })
        )
      };
  }, [u, e]), isLoading: d, error: p };
}, WW = {
  nodes: [],
  hasMoreResults: !1
}, Ij = (e) => "codes" in e.discount ? e.discount.codes.nodes[0]?.code ?? "" : "", KW = (e) => [...e].sort(
  (n, r) => Ij(n).localeCompare(Ij(r))
), GW = (e) => {
  const n = e?.Shopify?.discountNodes;
  return {
    nodes: KW(n?.nodes ?? []),
    hasMoreResults: !!n?.pageInfo?.hasNextPage
  };
}, YW = 300, Ej = 2, JW = 250, SF = ({
  enabled: e = !0
} = {}) => {
  const { useLazyQuery: n, showNotification: r } = hn(), [i, a] = me(""), [o, s] = me([]), [l, d] = me(!1), [p, u] = me(!1), f = Er(null), h = Er(0), [k] = n(OW, {
    fetchPolicy: "no-cache"
  }), C = (j) => {
    s(j.nodes), d(j.hasMoreResults);
  }, N = async (j, _) => {
    const g = h.current + 1;
    h.current = g, u(!0);
    try {
      const D = await k({
        variables: { query: j, first: JW }
      });
      if (g !== h.current)
        return;
      if (D.error)
        throw D.error;
      const O = GW(D.data);
      _ && (f.current = O), C(O);
    } catch {
      if (g !== h.current)
        return;
      C(WW), r({
        title: "Something went wrong",
        text: "Could not search for discount codes. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    } finally {
      g === h.current && u(!1);
    }
  };
  return yi(
    () => {
      if (!e)
        return;
      const j = i.trim(), _ = j.length === 0;
      if (!(!_ && j.length < Ej)) {
        if (_ && f.current) {
          C(f.current);
          return;
        }
        N(
          _ ? void 0 : j,
          _
        );
      }
    },
    YW,
    [i, e]
  ), {
    discountNodes: o,
    isLoading: p,
    hasMoreResults: l,
    filter: i,
    setFilter: a,
    minSearchCharacters: Ej
  };
}, QW = "_list_alvh6_1", XW = "_listItem_alvh6_4", ZW = "_fullWidth_alvh6_15", e9 = "_boxWrapper_alvh6_19", Mt = {
  list: QW,
  listItem: XW,
  fullWidth: ZW,
  boxWrapper: e9
}, n9 = "_modal_1vkwz_1", t9 = "_disabled_1vkwz_5", sh = {
  modal: n9,
  disabled: t9
}, $j = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Pi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Pi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Pi.Unknown
  }
], Tj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: zr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: zr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: zr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: zr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: zr.Unsubscribed
  }
], r9 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = Cn(), { useMutation: l, showNotification: d } = hn(), [p, u] = me(), [f, h] = me(), [k, C] = x_(!0), [N, j] = x_(!0), _ = !!p, g = e.customer?.email, D = e.customer?.phone_number, O = e.customer?.given_name, I = e.customer?.family_name, F = {
    email: g ?? "",
    phone: D ?? "",
    firstName: O ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, L = ut({
    defaultValues: F
  });
  Qe(() => {
    f?.forEach((P) => {
      const B = P?.field?.[0];
      B && (L.setError(B, {
        type: "server",
        message: P.message
      }), L.setFocus(B));
    });
  }, [f, L]);
  const [K, { error: J, reset: re }] = l(LW, {
    onError: (P) => {
      u(P.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (P) => {
      const B = P?.Shopify?.customerCreate?.userErrors || [];
      B.length > 0 ? (h(B), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), W = _t(
    (P) => {
      a(!0), u(void 0), K({
        variables: {
          input: {
            firstName: P.firstName,
            lastName: P.lastName,
            ...k && { email: P.email },
            ...N && { phone: P.phone },
            ...P.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: P.smsMarketingState,
                marketingOptInLevel: P.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [K, a, N, k]
  ), Y = () => {
    r(!1), re(), u(void 0), L.reset(F);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: Y, className: sh.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Create new customer", onClose: Y }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "First name",
          name: "firstName",
          control: L.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "Last name",
          name: "lastName",
          control: L.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "Email",
          name: "email",
          control: L.control,
          rules: {
            required: k ? "Email is required" : void 0
          },
          componentProps: {
            className: dt({
              [sh.disabled]: !k
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Fo,
                {
                  disabled: !N,
                  name: "hasEmail",
                  value: "email",
                  checked: k,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "Phone",
          name: "phone",
          control: L.control,
          rules: {
            required: N ? "Phone is required" : void 0
          },
          componentProps: {
            className: dt({
              [sh.disabled]: !N
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Fo,
                {
                  disabled: !k,
                  name: "hasPhone",
                  value: "phone",
                  checked: N,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: L.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = Tj.find(
                (ee) => ee.value === P
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Tj.map((P) => /* @__PURE__ */ v.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: L.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = $j.find(
                (ee) => ee.value === P
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: $j.map((P) => /* @__PURE__ */ v.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      _ && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { children: p })
      ] }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(L.formState.isValid && L.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
        },
        confirmOnClick: L.handleSubmit(W),
        cancelOnClick: Y,
        confirmName: J ? "Close" : "Save",
        cancelName: J ? void 0 : "Cancel"
      }
    )
  ] });
}, i9 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = me(!1), [a, o] = me(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
        slotStart: /* @__PURE__ */ v.jsx(ve, { size: 14, name: "user-plus", color: "green.500" }),
        className: Mt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ v.jsx(
      r9,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Lg = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, iy = "DD MMM YYYY @ HH:mm", a9 = "_wrapper_10fld_1", o9 = "_copyIcon_10fld_7", js = {
  wrapper: a9,
  copyIcon: o9
}, s9 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Br(), { isCopied: l, copy: d } = Br(), { track: p } = Cn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: k,
    tags: C = [],
    verifiedEmail: N
  } = e, j = h?.emailAddress, _ = k?.phoneNumber, g = Lg(u), D = `https://${n}/admin/customers/${g ?? ""}`, O = i && a === tr.refetch, I = 14;
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { className: js.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: f }),
        O ? /* @__PURE__ */ v.jsx(fn, { size: I }) : /* @__PURE__ */ v.jsx(Xe, { content: "Reload customer", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: I,
            name: "sync",
            onClick: () => {
              p("shopify:refreshed", { shopifyId: u }), r();
            },
            className: js.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ve, { size: I, name: "mail" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ v.jsx(
            Xe,
            {
              content: N ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
                ve,
                {
                  size: I,
                  color: N ? "green.500" : "red.500",
                  name: N ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: js.copyIcon
          }
        ) })
      ] }),
      _ && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ve, { size: I, name: "phone" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `tel:${_}`, children: _ })
        ] }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => d(_),
            className: js.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(ve, { size: I, name: "external-link" }),
        /* @__PURE__ */ v.jsx(
          $.ExternalLink,
          {
            href: D,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((F) => /* @__PURE__ */ v.jsx(Jn, { children: F }, `${u}-${F}`)) })
    ] })
  ] });
}, l9 = "_creationModal_pbe64_1", c9 = "_detailsModal_pbe64_5", d9 = "_percentageSuffix_pbe64_9", lh = {
  creationModal: l9,
  detailsModal: c9,
  percentageSuffix: d9
}, u9 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, m9 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: hF.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Oj = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Rj = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Dj = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], p9 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Jt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ v.jsxs(Ye, { children: [
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(
            ve,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: Gn(e?.startsAt).format(jt) })
      ] }) })
    ] }),
    /* @__PURE__ */ v.jsx(We, { label: "Discount code", children: /* @__PURE__ */ v.jsx(
      cr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, f9 = "shopify-discount-code-form", Pj = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, h9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = Cn(), { useMutation: i, showNotification: a } = hn(), [o, s] = me(
    []
  ), [l, d] = me(), p = ut({
    mode: "all",
    defaultValues: Pj
  });
  Qe(() => {
    o?.forEach((I) => {
      const F = I?.field?.[1];
      F && p.setError(F, {
        type: "server",
        message: I.message
      });
    });
  }, [o, p]);
  const u = !!l, f = p.watch("minimumRequirementOption"), h = p.watch("customerGetsOption"), k = Qn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: N,
      error: j,
      reset: _
    }
  ] = i(VW, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const F = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (F && F.length > 0)
        s(F);
      else {
        const L = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        L && "codes" in L && d(L), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    p.setValue("code", u9(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, D = (I) => {
    C({
      variables: {
        input: m9(I)
      }
    });
  }, O = () => {
    p.reset(Pj), s([]), _(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: O,
      className: dt({
        [lh.creationModal]: !u,
        [lh.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: O
          }
        ),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          u && /* @__PURE__ */ v.jsx(p9, { codeDiscount: l }),
          !u && /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: f9, onSubmit: p.handleSubmit(D), children: [
            /* @__PURE__ */ v.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ v.jsx(
              my,
              {
                variant: "info",
                description: /* @__PURE__ */ v.jsx($.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ v.jsxs(nt, { children: [
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Title",
                  name: "title",
                  control: p.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  control: p.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, F) => I === F,
                    onChange: () => {
                      p.setValue("customerGets", void 0), p.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const F = Oj.find(
                        (L) => L.value === I
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: Oj.map((I) => /* @__PURE__ */ v.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: p.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ v.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: lh.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Code",
                  name: "code",
                  control: p.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  control: p.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, F) => I === F,
                    onChange: () => {
                      p.setValue("minimumRequirementValue", void 0), p.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const F = Rj.find(
                        (L) => L.value === I
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: Rj.map((I) => /* @__PURE__ */ v.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  name: "minimumRequirementValue",
                  label: k,
                  control: p.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: p.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, F) => I === F,
                    getItemTitleByValue: (I) => {
                      const F = Dj.find(
                        (L) => L.value === I
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: Dj.map((I) => /* @__PURE__ */ v.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ v.jsx(En, { error: j })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !u && !(p.formState.isValid && p.formState.isDirty),
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? O : p.handleSubmit(D),
            cancelOnClick: u ? void 0 : O
          }
        )
      ]
    }
  );
}, y9 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Br();
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(ve, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ v.jsx(
          rr,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, g9 = ({
  discountCode: e
}) => {
  const { discount: n } = e;
  if (!("codes" in n))
    return null;
  const r = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: n.title }),
    /* @__PURE__ */ v.jsx(Ye, { children: r.map((i) => /* @__PURE__ */ v.jsx(Ye.Item, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(y9, { code: i.code }) }, i.code)) })
  ] });
}, v9 = "_modal_11d6e_1", k9 = "_modalBody_11d6e_4", b9 = "_codeContainer_11d6e_9", ch = {
  modal: v9,
  modalBody: k9,
  codeContainer: b9
}, _9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const {
    discountNodes: r,
    isLoading: i,
    filter: a,
    setFilter: o,
    minSearchCharacters: s
  } = SF({ enabled: e }), l = r.length === 0, d = () => {
    o(""), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: e, onClose: d, className: ch.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Discount codes", onClose: d }),
    /* @__PURE__ */ v.jsxs(Ft, { className: ch.modalBody, children: [
      /* @__PURE__ */ v.jsx(
        cr,
        {
          type: "search",
          icon: "search",
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (p) => {
            o(p.target.value);
          }
        }
      ),
      i && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }),
      !i && l && /* @__PURE__ */ v.jsx(
        Io,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !i && !l && r.map((p) => /* @__PURE__ */ v.jsx("div", { className: ch.codeContainer, children: /* @__PURE__ */ v.jsx(g9, { discountCode: p }) }, p.id))
    ] }),
    /* @__PURE__ */ v.jsx(Et, { confirmName: "Close", confirmOnClick: d })
  ] });
}, x9 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = me(!1), [i, a] = me(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          ct,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          ct,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      _9,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      h9,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, S9 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? iw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case oa.Invalid:
      case oa.NotSubscribed:
      case zr.NotSubscribed:
        return "red.500";
      case oa.Pending:
      case zr.Pending:
      case oa.Unsubscribed:
      case zr.Unsubscribed:
        return "orange.500";
      case oa.Subscribed:
      case zr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Pi.SingleOptIn:
      case Pi.ConfirmedOptIn:
        return "green.500";
      case Pi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: p,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ v.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Mn, { size: "small", variant: "info", children: Gn(l).format(iy) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ v.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Mn, { size: "small", variant: "info", children: Gn(u).format(iy) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(p), children: i(p) }) })
      ] })
    ] })
  ] });
}, N9 = (e) => {
  const { discount: n } = e;
  switch (n.__typename) {
    case "Shopify_DiscountCodeBasic": {
      if (n.status !== ry.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      if (!r)
        return null;
      const { value: i } = n.customerGets;
      return i.__typename === "Shopify_DiscountPercentage" ? {
        code: r,
        kind: "percentage",
        percentage: Number((i.percentage * 100).toFixed(2))
      } : i.__typename === "Shopify_DiscountAmount" ? {
        code: r,
        kind: "fixedAmount",
        amount: String(i.amount.amount),
        currencyCode: i.amount.currencyCode
      } : null;
    }
    case "Shopify_DiscountCodeFreeShipping": {
      if (n.status !== ry.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      return r ? { code: r, kind: "freeShipping" } : null;
    }
    default:
      return null;
  }
}, j9 = (e) => {
  const n = e.map(N9).filter(
    (i) => !!i
  ), r = /* @__PURE__ */ new Map();
  return n.forEach((i) => {
    r.has(i.code) || r.set(i.code, i);
  }), Array.from(r.values());
}, NF = (e) => {
  if (e)
    switch (e.kind) {
      case "percentage":
        return {
          itemPercentageDiscountCode: {
            code: e.code,
            percentage: e.percentage
          }
        };
      case "fixedAmount":
        return {
          itemFixedDiscountCode: {
            code: e.code,
            amountSet: {
              shopMoney: {
                amount: e.amount,
                currencyCode: e.currencyCode
              }
            }
          }
        };
      case "freeShipping":
        return { freeShippingDiscountCode: { code: e.code } };
      default:
        return;
    }
}, w9 = (e) => e ? [e.code] : void 0, ay = (e) => {
  switch (e.kind) {
    case "percentage":
      return `${e.percentage}% off`;
    case "fixedAmount":
      return `${e.amount} ${e.currencyCode} off`;
    case "freeShipping":
      return "Free shipping";
    default:
      return "";
  }
}, jF = ({
  enabled: e
}) => {
  const n = Or(), { discountNodes: r, isLoading: i, filter: a, setFilter: o, minSearchCharacters: s } = SF({ enabled: e }), l = Qn(
    () => j9(r),
    [r]
  ), d = a.trim().length > 0;
  if (!i && !d && l.length === 0)
    return null;
  const p = !i && l.length === 0;
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Discount code",
      control: n.control,
      name: "discountCode",
      componentProps: {
        clearable: !0,
        placeholder: "Search discount codes",
        tabIndex: 0,
        equalityFn: (u, f) => u?.code === f?.code,
        getItemTitleByValue: (u) => u ? /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
          u.code,
          " · ",
          ay(u)
        ] }) : null,
        filter: {
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (u) => {
            o(u.target.value);
          }
        },
        onToggleDropdown: (u) => {
          !u && a !== "" && o("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        i && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }) }),
        !i && l.map((u) => /* @__PURE__ */ v.jsx(mt.Item, { value: u, children: /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "200",
            children: [
              d ? /* @__PURE__ */ v.jsx(
                dw,
                {
                  text: u.code,
                  highlight: a
                }
              ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: u.code }),
              /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "tertiary", children: ay(u) })
            ]
          }
        ) }, u.code)),
        p && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Io,
          {
            title: "No discount codes found",
            description: "Try changing your search criteria."
          }
        ) })
      ] })
    }
  );
}, ji = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ v.jsx(
  bt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ v.jsx(
      qr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), C9 = "_modal_1wlra_1", F9 = {
  modal: C9
};
function Aj(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Lj = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Vj = "shopify-shiping-address-form", I9 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: p, showNotification: u } = hn(), { track: f } = Cn(), [h, k] = me(!1), [C, N] = me({}), j = !l, [
    _,
    { error: g, reset: D }
  ] = p(RW, {
    onError: () => {
      k(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (W) => {
      k(!1);
      const Y = W?.Shopify?.orderUpdate?.userErrors;
      if (Y != null && Y.length > 0) {
        const P = Y.reduce(
          (B, ee) => {
            const Ne = ee.field;
            if (Ne == null || Ne.length === 0)
              return B;
            const ue = Ne[Ne.length - 1];
            return ue != null && (B[ue] = ee.message), B;
          },
          {}
        );
        N(P);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), re();
    }
  }), O = _t(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Lj.find(
        (W) => W === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: F, formState: L, reset: K } = ut({
    mode: "all",
    defaultValues: O()
  }), J = F((W) => {
    if (j) {
      if (k(!0), !o || !a) {
        k(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: Y, ...P } = W, B = {
        ...P,
        countryCode: Y
      };
      _({
        variables: {
          input: {
            id: a,
            shippingAddress: B
          }
        }
      });
    } else
      l(W), re();
  });
  Qe(() => {
    r && K(O());
  }, [r, n, K, O]);
  const re = () => {
    K(O()), N({}), D(), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: re,
      className: F9.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: e, onClose: () => re() }),
        /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: Vj, onSubmit: J, children: [
          g && /* @__PURE__ */ v.jsx(En, { error: g }),
          /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              ji,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              _r,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (W) => W ? Aj(W) : ""
                },
                children: Lj.filter((W) => s.includes(W)).map((W) => /* @__PURE__ */ v.jsx(mt.Item, { value: W, children: /* @__PURE__ */ v.jsx($.Paragraph, { children: Aj(W) }) }, W))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !(L.isValid && L.isDirty),
              type: "submit",
              form: Vj,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
            },
            confirmOnClick: () => {
              g && re();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), re();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, E9 = "_clickableIcon_33mqm_1", dh = {
  clickableIcon: E9
}, zj = ({
  formFieldName: e,
  ...n
}) => {
  const r = Or(), { field: i } = Ty({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ v.jsx(
    oy,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, oy = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: p = !1
}) => {
  const [u, f] = me(!1), [h, k] = me(p), { isCopied: C, copy: N } = Br(), { track: j } = Cn(), _ = 14, g = o && (!!r || !!l), D = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), O = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && eI(n.countryCodeV2), F = _t(() => [
    O,
    n?.company,
    n?.address1,
    n?.address2,
    D,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, O, D, I]);
  if (!n)
    return null;
  const L = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { size: _, name: s, color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => k(!h),
              className: dh.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: _,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
            O && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: O }),
            n?.company && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address2 }),
            D && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: D }),
            n?.province && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ v.jsx(Xe, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: _,
            name: "pen",
            onClick: () => L(),
            className: dh.clickableIcon
          }
        ) }),
        /* @__PURE__ */ v.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: _,
            name: C ? "done" : "copy",
            onClick: () => N(F()),
            className: dh.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ v.jsx(
      I9,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, wF = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Or(), i = pi({ control: r.control, name: "lineItems" }), a = pi({
    control: r.control,
    name: "billingAddress"
  }), o = pi({
    control: r.control,
    name: "shippingAddress"
  }), s = pi({
    control: r.control,
    name: "discountCode"
  }), l = Qn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (u) => n.includes(u.id)
  ) : i, [i, n]), d = Qn(() => !l || l.length === 0 ? 0 : l.reduce((u, f) => {
    const h = f.priceRangeV2?.minVariantPrice?.amount || 0, k = f.quantity || 0;
    return u + h * k;
  }, 0), [l]), p = l?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ v.jsx(
        zj,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ v.jsx(
        zj,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(Nl, {}),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: `${d.toFixed(2)} ${p}` })
    ] }),
    s && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
          "Discount (",
          s.code,
          ")"
        ] }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: ay(s) })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "The discount will be deducted after the order is created." })
    ] }),
    /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, $9 = "_productTableHeader_6h6pl_1", T9 = "_productImage_6h6pl_5", Co = {
  productTableHeader: $9,
  productImage: T9
}, Vg = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, O9 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Or(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Vg(e);
  return /* @__PURE__ */ v.jsxs(at.Tr, { children: [
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ v.jsx(
        _a,
        {
          src: d,
          alt: e.title,
          className: Co.productImage
        }
      ),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(
      Pn,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(rr, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, R9 = 300, mo = 2, D9 = 25, P9 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = hn(), [i, a] = me(""), [o, s] = me([]), l = Or(), d = l.watch("selectedProductId"), [p, { loading: u, networkStatus: f }] = n(Ag, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (N) => {
      const j = N?.Shopify?.products?.nodes || [];
      s(
        j.filter((_) => !!_).sort((_, g) => _.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  yi(
    () => {
      i.trim().length >= mo && !u && f === tr.ready ? p({
        variables: {
          query: i.trim(),
          productCount: D9,
          mediaCount: 1
        }
      }) : i.trim().length < mo && s([]);
    },
    R9,
    [i]
  ), Qe(() => {
    if (!d) return;
    const N = o.find(
      (j) => j.id === d
    );
    N && e(N), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== tr.ready, k = i.trim().length >= mo, C = !o.length && !h && k;
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${mo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (N) => {
          const j = o.find(
            (_) => _.id === N
          );
          return j ? /* @__PURE__ */ v.jsx($.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (N) => {
            a(N.target.value);
          }
        },
        onToggleDropdown: (N) => {
          !N && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }) }),
        !h && o.map((N) => {
          const j = N.totalInventory <= 0, _ = Vg(N);
          return /* @__PURE__ */ v.jsx(
            mt.Item,
            {
              value: N.id,
              isDisabled: j,
              children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                  _ && /* @__PURE__ */ v.jsx(
                    _a,
                    {
                      src: _,
                      alt: N.title,
                      className: Co.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ v.jsx(
                    dw,
                    {
                      text: N.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: N.title })
                ] }),
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: j ? "Out of stock" : `${N.totalInventory} in stock` })
              ] })
            },
            N.id
          );
        }),
        C && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Io,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !k && !h && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Io,
          {
            title: "Search for products",
            description: `Type at least ${mo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, zg = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const p = Or(), u = p.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (j) => !o.includes(j?.id)
  ) : [], k = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), C = h.some(
    (j) => a.includes(j?.id)
  ) && !k, N = _t(
    (j) => {
      const _ = p.getValues("lineItems"), g = _.findIndex(
        (D) => D?.id === j.id
      );
      if (g > -1) {
        const D = p.getValues(`lineItems.${g}.quantity`) || 0, O = [..._];
        O[g] = {
          ...O[g],
          quantity: D + 1
        }, p.setValue("lineItems", O);
      } else
        p.setValue("lineItems", [
          ..._,
          { ...j, quantity: 1 }
        ]);
    },
    [p]
  );
  return /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ v.jsx(P9, { onProductSelected: N }),
    !f && e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(fn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(
          Io,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ v.jsx(b, { margin: "300 0", children: /* @__PURE__ */ v.jsxs(
      at,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Co.productTable,
        children: [
          /* @__PURE__ */ v.jsx(at.Thead, { className: Co.productTableHeader, children: /* @__PURE__ */ v.jsxs(at.Tr, { children: [
            n && /* @__PURE__ */ v.jsx(at.Th, { children: /* @__PURE__ */ v.jsx(
              Kg,
              {
                checked: k,
                indeterminate: C,
                onChange: () => d?.(!k)
              }
            ) }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Product" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "In stock" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Price" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Quantity" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Total" }),
            !r && /* @__PURE__ */ v.jsx(at.Th, {})
          ] }) }),
          /* @__PURE__ */ v.jsx(at.Tbody, { children: u?.map((j, _) => {
            if (!n)
              return /* @__PURE__ */ v.jsx(
                O9,
                {
                  product: j,
                  index: _,
                  onRemove: () => {
                    const Y = u.filter(
                      (P, B) => B !== _
                    );
                    p.setValue("lineItems", Y);
                  }
                },
                `${j?.id}-${_}`
              );
            const g = j, D = g.priceRangeV2.minVariantPrice.amount, O = g.priceRangeV2.minVariantPrice.currencyCode, I = `lineItems.${_}.quantity`, F = p.watch(I) || 0, L = D * F, K = Vg(g), J = a.includes(g.id), re = o.includes(g.id), W = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ v.jsxs(
              at.Tr,
              {
                style: re ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(
                    Kg,
                    {
                      checked: J,
                      disabled: re,
                      onChange: () => l?.(g.id, !J)
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                    K && /* @__PURE__ */ v.jsx(
                      _a,
                      {
                        src: K,
                        alt: g.title,
                        className: Co.productImage
                      }
                    ),
                    /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.title }),
                      re && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${D} ${O}` }) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(
                    Pn,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: re || W <= 1,
                      name: I,
                      control: p.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: W,
                        tabIndex: 0
                      }
                    },
                    `${I}-${p.watch(I)}`
                  ) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${L} ${O}` }) }),
                  !r && /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(
                    rr,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const Y = u.filter(
                          (P, B) => B !== _
                        );
                        p.setValue("lineItems", Y), J && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${_}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, CF = ({
  previousOrderStatus: e
} = {}) => {
  const n = Or();
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Cj.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ v.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Cj.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ v.jsx(mt.Item, { value: r.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, FF = () => {
  const e = Or();
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Fj.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Fj.map((n) => /* @__PURE__ */ v.jsx(mt.Item, { value: n.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, A9 = "_modal_1mprq_1", L9 = {
  modal: A9
}, uh = "create-shopify-order-form", V9 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), [d, p] = me(!1), [
    u,
    f
  ] = me(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, k = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Ai.Pending,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, [C, N] = me([]), j = ut({
    mode: "all",
    defaultValues: k
  }), _ = j.watch("lineItems").length > 0, g = () => {
    j.reset(k), N([]), i(!1);
  };
  Qe(() => {
    C.length > 0 && j.setValue("tags", C, { shouldDirty: !0 });
  }, [C, j]);
  const D = Er(!1), O = () => {
    a(), p(!1), s({
      title: "Success",
      text: "The order was created successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), l("shopify:order:create:succeeded"), g();
  }, I = () => {
    a(), p(!1), s({
      title: "Order created but not marked as paid",
      text: "The order was created but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), g();
  }, F = () => {
    p(!1), s({
      title: "Something went wrong",
      text: "The order creation was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), l("shopify:order:create:failed"), g();
  }, [L] = o(vF, {
    onError: I,
    onCompleted: (B) => {
      const ee = B.Shopify?.orderMarkAsPaid?.userErrors;
      if (ee && ee.length > 0) {
        I();
        return;
      }
      O();
    }
  }), [K, { error: J }] = o(gF, {
    onError: F,
    onCompleted: (B) => {
      const ee = B.Shopify?.orderCreate, Ne = ee?.order?.id;
      if (ee?.userErrors?.length || !Ne) {
        F();
        return;
      }
      if (D.current) {
        L({ variables: { input: { id: Ne } } });
        return;
      }
      O();
    }
  }), [re, { error: W }] = o(
    zW,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), Y = (B) => {
    const ee = B.lineItems.map((fe) => ({
      productId: fe.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: fe.priceRangeV2.maxVariantPrice.amount,
          currencyCode: fe.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: fe.quantity
    }));
    p(!0);
    const Ne = sa(B?.billingAddress), ue = sa(
      B?.shippingAddress
    ), oe = B.financialStatus === Ai.Paid;
    D.current = oe, K({
      variables: {
        order: {
          lineItems: ee,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: B.customNote,
          tags: B.tags,
          financialStatus: oe ? void 0 : B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          discountCode: NF(B.discountCode),
          shippingAddress: ue,
          billingAddress: Ne
        }
      }
    });
  }, P = (B) => {
    const ee = B.lineItems.map((oe) => ({
      title: oe.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: oe.priceRangeV2.maxVariantPrice.amount,
        currencyCode: oe.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: oe.quantity
    }));
    f(!0);
    const Ne = sa(B?.billingAddress), ue = sa(
      B?.shippingAddress
    );
    re({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: B.customNote,
          tags: B.tags,
          lineItems: ee,
          discountCodes: w9(B.discountCode),
          shippingAddress: ue,
          billingAddress: Ne
        }
      }
    });
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: g,
      className: L9.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx($y, { ...j, children: /* @__PURE__ */ v.jsx("form", { id: uh, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(zg, {}) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              bt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ v.jsx(
                  We,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ee) => {
                          ee.key === "Enter" && (ee.preventDefault(), ee.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Sl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ee) => {
                              N(ee);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(CF, {}),
              /* @__PURE__ */ v.jsx(FF, {}),
              /* @__PURE__ */ v.jsx(jF, { enabled: e }),
              /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(wF, {})
              }
            ) }) })
          ] }) }) }),
          (J || W) && /* @__PURE__ */ v.jsx(En, { error: J || W })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: uh,
              disabled: !_ || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(Y),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(P)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: uh,
                disabled: !_ || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, z9 = "_modal_al73g_1", U9 = {
  modal: z9
}, Uj = [
  {
    label: "Customer",
    value: Ii.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Ii.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Ii.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Ii.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Ii.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Ii.Staff,
    description: "Staff made an error."
  }
], M9 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = Cn(), { useMutation: d, showNotification: p } = hn(), [u, f] = me([]), h = u.length > 0, k = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = ut({
    defaultValues: k
  }), [N, { error: j, reset: _ }] = d(PW, {
    onError: () => {
      o(!1), p({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (O) => {
      const I = O.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), p({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const F = O.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, F ? 0 : 4e3), p({
          title: "Success",
          text: `${F ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = _t(
    (O) => {
      O.reason != null && (o(!0), N({
        variables: {
          orderId: O.orderId,
          reason: O.reason,
          refundMethod: O.refundMethod,
          restock: O.restock,
          notifyCustomer: O.notifyCustomer,
          staffNote: O.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), D = () => {
    i(!1), _(), f([]), C.reset(k);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: D, className: U9.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Cancel order ${r}`, onClose: D }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (O, I) => O === I,
            getItemTitleByValue: (O) => {
              if (!O)
                return "";
              const I = Uj.find(
                (F) => F.value === O
              );
              return /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: Uj.map((O) => /* @__PURE__ */ v.jsx(mt.Item, { value: O.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Refund order", children: /* @__PURE__ */ v.jsx(
        bn,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Restock items", children: /* @__PURE__ */ v.jsx(bn, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Notify the customer", children: /* @__PURE__ */ v.jsx(bn, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: u.map((O) => /* @__PURE__ */ v.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ v.jsx(ve, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: O.code }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
              "(",
              O.field?.join(","),
              ") ",
              O.message
            ] })
          ]
        },
        O.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(g),
        cancelOnClick: D,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, B9 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = me(!1), [s, l] = me(!1);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Mt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ v.jsx(
      M9,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, q9 = "_modal_1mprq_1", H9 = {
  modal: q9
}, W9 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = hn(), { track: p } = Cn(), [u, f] = me(!1), [h, k] = me(e?.tags || []), C = "duplicate-shopify-order-form", N = (ue) => ({
    firstName: ue?.firstName,
    lastName: ue?.lastName,
    company: ue?.company,
    address1: ue?.address1,
    address2: ue?.address2,
    city: ue?.city,
    provinceCode: ue?.provinceCode,
    zip: ue?.zip,
    countryCode: ue?.countryCodeV2,
    phone: ue?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: N(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: N(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, _ = ut({
    mode: "all",
    defaultValues: j
  }), g = _.watch("lineItems").length > 0, D = Qn(
    () => (e?.lineItems || []).map((ue) => ue.product?.id).filter((ue) => !!ue),
    [e]
  ), O = Qn(
    () => _F(D),
    [D]
  ), {
    data: I,
    loading: F,
    error: L
  } = d(Ag, {
    skip: !O,
    variables: {
      query: O,
      productCount: D.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    L && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [L, l]), Qe(() => {
    if (!r || F || !I || _.getValues("lineItems")?.length)
      return;
    const ue = I?.Shopify?.products?.nodes || [], oe = [];
    e?.lineItems?.forEach((fe) => {
      const V = ue.find(
        (ke) => ke.id === fe.product?.id
      );
      V && oe.push({
        ...V,
        quantity: fe.quantity || 1,
        sku: fe.sku,
        discountedUnitPrice: fe.discountedUnitPriceSet?.shopMoney
      });
    }), oe.length > 0 && _.setValue("lineItems", oe, { shouldDirty: !0 });
  }, [r, I, F, e, _]), Qe(() => {
    (h.length > 0 || (_.getValues("tags") || []).length > 0) && _.setValue("tags", h, { shouldDirty: !0 });
  }, [h, _]);
  const K = Er(!1), J = () => {
    o(), f(!1), l({
      title: "Success",
      text: "The order was duplicated successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), p("shopify:order:duplicate:succeeded"), Ne();
  }, re = () => {
    o(), f(!1), l({
      title: "Order duplicated but not marked as paid",
      text: "The order was duplicated but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), Ne();
  }, W = () => {
    f(!1), l({
      title: "Something went wrong",
      text: "The order duplication was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), p("shopify:order:duplicate:failed"), Ne();
  }, [Y] = s(vF, {
    onError: re,
    onCompleted: (ue) => {
      const oe = ue.Shopify?.orderMarkAsPaid?.userErrors;
      if (oe && oe.length > 0) {
        re();
        return;
      }
      J();
    }
  }), [P, { error: B }] = s(gF, {
    onError: W,
    onCompleted: (ue) => {
      const oe = ue.Shopify?.orderCreate, fe = oe?.order?.id;
      if (oe?.userErrors?.length || !fe) {
        W();
        return;
      }
      if (K.current) {
        Y({ variables: { input: { id: fe } } });
        return;
      }
      J();
    }
  }), ee = (ue) => {
    const oe = ue.lineItems.map((ke) => ({
      productId: ke.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ke.discountedUnitPrice?.amount ?? ke.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ke.discountedUnitPrice?.currencyCode ?? ke.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ke.quantity,
      sku: ke.sku
    })), fe = (e?.shippingLines ?? []).map(
      (ke) => ({
        title: ke.title,
        code: ke.code,
        source: ke.source,
        priceSet: {
          shopMoney: {
            amount: ke.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ke.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0);
    const V = ue.financialStatus === Ai.Paid;
    K.current = V, P({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: oe,
          shippingLines: fe,
          note: ue.customNote,
          tags: ue.tags,
          financialStatus: V ? void 0 : ue.financialStatus,
          fulfillmentStatus: ue.fulfillmentStatus,
          discountCode: NF(ue.discountCode),
          shippingAddress: sa(ue?.shippingAddress),
          billingAddress: sa(ue?.billingAddress)
        }
      }
    });
  }, Ne = () => {
    _.reset(j), k(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: Ne,
      className: H9.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: `Duplicate order ${n}`, onClose: Ne }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx($y, { ..._, children: /* @__PURE__ */ v.jsx("form", { id: C, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(zg, { loading: F }) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              bt,
              {
                name: "tags",
                render: ({ fieldState: { error: ue } }) => /* @__PURE__ */ v.jsx(
                  We,
                  {
                    label: "Tags",
                    meta: {
                      error: ue?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (oe) => {
                          oe.key === "Enter" && (oe.preventDefault(), oe.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Sl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (oe) => {
                              k(oe);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(jF, { enabled: r }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(
                CF,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ v.jsx(FF, {}),
              /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(wF, {})
              }
            ) }) })
          ] }) }) }),
          B && /* @__PURE__ */ v.jsx(En, { error: B })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !g || u || F,
              isLoading: u || F,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: _.handleSubmit(ee)
          }
        )
      ]
    }
  );
}, K9 = "_copyIcon_1dlzg_1", G9 = {
  copyIcon: K9
}, Y9 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Br();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (d) => d > 0
  ), s = n.every(
    ({ id: d, quantity: p }) => (r[d] || 0) >= p
  ), l = n.map(
    ({ title: d, quantity: p, variantTitle: u }) => u ? `${p}x ${d} (${u})` : `${p}x ${d}`
  ).join(`
`);
  return /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx(ve, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ v.jsx(Xe, { content: "Copy line items", children: /* @__PURE__ */ v.jsx(
            ve,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(l),
              className: G9.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ v.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ v.jsx(Jn, { color: "red.500", children: s ? "The order has been refunded" : "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ v.jsx(Ye, { children: n.map(({ id: d, title: p, quantity: u, variantTitle: f, image: h }) => {
      const k = r[d], C = k > 0, N = k > 1 ? `Refunded (${k} items)` : "Refunded";
      return /* @__PURE__ */ v.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ v.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ v.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
            p,
            " ",
            f && `(${f})`,
            C && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", color: "red.500", children: N })
          ] }),
          contentRight: h?.url && /* @__PURE__ */ v.jsx(_a, { src: `${h?.url}&height=48`, alt: p })
        },
        `list-${e}-${d}`
      );
    }) })
  ] });
}, J9 = jl`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, Q9 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, IF = (e) => {
  const n = {}, r = Q9(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, ws = (e, n) => `${Number(e || 0).toFixed(2)} ${n}`, EF = ({
  refund: e,
  currencyCode: n,
  refundShipping: r,
  onToggleShipping: i,
  isLoading: a = !1
}) => {
  const o = e?.currency || n, s = Number(e?.shipping.maximumRefundable || 0) > 0, l = s && r;
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: ws(e?.subtotal || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Tax" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: ws(e?.tax || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(
          Fo,
          {
            name: "refundShipping",
            value: "shipping",
            checked: l,
            disabled: !s || a,
            onChange: () => i(!r)
          }
        ),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: "Refund shipping" })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: ws(e?.shipping.amount || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Total refund" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: ws(e?.amount || "0", o) })
    ] })
  ] });
}, X9 = "_modal_1mprq_1", Z9 = {
  modal: X9
}, Mj = "partial-refund-shopify-order-form", e7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), { useQuery: d } = hn(), [p, u] = me(!1), [f, h] = me([]), [k, C] = me(!1), N = Qn(
    () => e?.refunds ? IF(e) : {},
    [e]
  ), j = Qn(
    () => (e?.lineItems || []).filter((oe) => (N[oe.id] || 0) >= (oe.quantity || 0)).map((oe) => oe.product?.id).filter((oe) => !!oe),
    [e, N]
  ), _ = Qn(() => {
    const oe = {};
    return (e?.lineItems || []).forEach((fe) => {
      if (fe.product?.id) {
        const V = N[fe.id] || 0, ke = Math.max(
          0,
          (fe.quantity || 0) - V
        );
        oe[fe.product.id] = ke;
      }
    }), oe;
  }, [e, N]), g = Qn(
    () => (e?.lineItems || []).map((oe) => oe.product?.id).filter((oe) => !!oe),
    [e]
  ), D = Qn(
    () => _F(g),
    [g]
  ), {
    data: O,
    loading: I,
    error: F
  } = d(Ag, {
    skip: !D,
    variables: {
      query: D,
      productCount: g.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    F && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [F, s]);
  const L = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, K = ut({
    mode: "all",
    defaultValues: L
  }), J = f.length > 0;
  Qe(() => {
    !J && k && C(!1);
  }, [J, k]);
  const re = pi({
    control: K.control,
    name: "lineItems"
  }), W = Qn(
    () => (re || []).filter(
      (oe) => f.includes(oe.id)
    ).map((oe) => {
      const fe = e?.lineItems?.find(
        (q) => q.product?.id === oe.id
      ), V = N[fe?.id || ""] || 0, ke = (fe?.quantity || 0) - V, Oe = Math.max(
        0,
        Math.min(ke, oe.quantity || 0)
      );
      return fe && Oe > 0 ? { lineItemId: fe.id, quantity: Oe } : void 0;
    }).filter(
      (oe) => !!oe
    ),
    [re, f, e, N]
  ), { suggestedRefund: Y, isLoading: P } = xF({
    orderId: e.id,
    refundShipping: k,
    refundLineItems: W,
    skip: !J
  }), [B, { error: ee }] = o(
    J9,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), ue();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), ue();
      }
    }
  );
  Qe(() => {
    if (!r || I || !O || K.getValues("lineItems")?.length)
      return;
    const oe = O?.Shopify?.products?.nodes || [], fe = [];
    e?.lineItems?.forEach((V) => {
      const ke = oe.find(
        (Oe) => Oe.id === V.product?.id
      );
      if (ke) {
        const Oe = N[V.id] || 0, q = (V.quantity || 1) - Oe;
        fe.push({
          ...ke,
          quantity: q > 0 ? q : V.quantity || 1
        });
      }
    }), fe.length > 0 && (K.setValue("lineItems", fe, { shouldDirty: !0 }), h([]));
  }, [
    r,
    O,
    I,
    e,
    K,
    N
  ]);
  const Ne = (oe) => {
    u(!0), B({
      variables: {
        input: bF({
          orderId: e.id,
          transactions: Y?.transactions,
          refundLineItems: W,
          refundShipping: k,
          note: oe.customNote || void 0,
          notify: !0
        })
      }
    });
  }, ue = () => {
    K.reset(L), u(!1), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: ue, className: Z9.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${n}`, onClose: ue }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx($y, { ...K, children: /* @__PURE__ */ v.jsx("form", { id: Mj, children: /* @__PURE__ */ v.jsxs(nt, { children: [
        /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
          zg,
          {
            loading: I,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: j,
            maxQuantities: _,
            onToggleSelect: (oe, fe) => {
              h((V) => fe ? Array.from(/* @__PURE__ */ new Set([...V, oe])) : V.filter((ke) => ke !== oe));
            },
            onToggleSelectAll: (oe) => {
              const fe = (K.getValues("lineItems") || []).map((V) => V.id).filter((V) => !j.includes(V));
              h(oe ? fe : []);
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ v.jsx(
          Pn,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Mt.boxWrapper,
            children: /* @__PURE__ */ v.jsx(
              EF,
              {
                refund: Y,
                currencyCode: e.currencyCode,
                refundShipping: k,
                onToggleShipping: C,
                isLoading: P
              }
            )
          }
        ) }) })
      ] }) }) }),
      ee && /* @__PURE__ */ v.jsx(En, { error: ee })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          type: "submit",
          form: Mj,
          disabled: !J || p || I || P || !Y,
          isLoading: p || I,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: K.handleSubmit(Ne)
      }
    )
  ] });
}, n7 = "_modal_al73g_1", t7 = {
  modal: n7
}, r7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  isOpen: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l } = hn(), { track: d } = Cn(), { id: p, name: u, currencyCode: f } = e, [h, k] = me(!0), [C, N] = me(), { suggestedRefund: j, isLoading: _ } = xF({
    orderId: p,
    suggestFullRefund: !0,
    refundShipping: h,
    skip: !i
  }), [g, { loading: D }] = s(
    DW,
    {
      onError: (F) => N(F),
      onCompleted: (F) => {
        const L = F.Shopify?.refundCreate?.userErrors;
        if (L && L.length > 0) {
          N(
            new fw({
              graphQLErrors: L.map((K) => ({
                message: K.message
              }))
            })
          );
          return;
        }
        l({
          title: "Order refunded",
          text: `You refunded order ${u}`,
          icon: "check-circle-filled",
          severity: "success"
        }), o(), O();
      }
    }
  ), O = () => {
    k(!0), N(void 0), a(!1);
  }, I = () => {
    j && (d("shopify:order:refund:confirmed", { shopifyId: n, orderId: p }), g({
      variables: {
        input: bF({
          orderId: p,
          transactions: j.transactions,
          refundLineItems: j.refundLineItems,
          refundShipping: h,
          notify: e.suggestedRefund.notify
        })
      }
    }));
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: i, onClose: O, className: t7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${u}`, onClose: O }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ v.jsx(
        EF,
        {
          refund: j,
          currencyCode: f,
          refundShipping: h,
          onToggleShipping: k,
          isLoading: _
        }
      ),
      C && /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
        /* @__PURE__ */ v.jsx(En, { error: C }),
        /* @__PURE__ */ v.jsx(
          Lt,
          {
            variant: "secondary",
            style: {
              color: "var(--dixa-typography-color-link)",
              padding: "var(--dixa-size-spacer-100)"
            },
            navigate: () => window.open(r, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
            children: "View order in Shopify"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !j || _ || D,
          isLoading: D || _,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Confirm order refund",
        confirmOnClick: I
      }
    )
  ] });
}, i7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { showModal: a } = hn(), { track: o } = Cn(), { suggestedRefund: s, id: l } = e, [d, p] = me(!1), u = parseFloat(String(s?.amount)), f = !isNaN(u) && u > 0, h = _t(() => {
    o("shopify:order:refund:requested", { shopifyId: n, orderId: l }), f ? p(!0) : a({
      headline: `Refund Order ${e.name}`,
      children: /* @__PURE__ */ v.jsx($.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [n, l, e.name, f, a, o]);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        onClick: h,
        disabled: s?.refundLineItems?.length === 0 || !f,
        slotStart: /* @__PURE__ */ v.jsx(ve, { size: 14, name: "undo" }),
        className: Mt.fullWidth,
        children: "Full refund"
      }
    ),
    /* @__PURE__ */ v.jsx(
      r7,
      {
        order: e,
        shopifyId: n,
        orderLink: r,
        isOpen: d,
        setIsOpen: p,
        refetchOrders: i
      }
    )
  ] });
}, a7 = "_modal_al73g_1", o7 = {
  modal: a7
}, s7 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = Cn(), { useMutation: s, showNotification: l } = hn(), [d, p] = me(n), [u, f] = me(!1), h = ut({
    defaultValues: {
      tags: n
    }
  });
  Qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [k, { error: C, reset: N }] = s(AW, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = _t(
    (g) => {
      f(!0), k({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((D) => {
        const O = D.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: O });
      });
    },
    [e, h, k]
  ), _ = () => {
    i(!1), N();
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: _, className: o7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Manage tags for order", onClose: _ }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        bt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ v.jsx(
            We,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ v.jsx(
                Sl,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (D) => p(D)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ v.jsx(En, { error: C })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: _,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, l7 = "_editIcon_1yp2k_1", c7 = "_copyIcon_1yp2k_2", Bj = {
  editIcon: l7,
  copyIcon: c7
}, d7 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = me(!1), { isCopied: o, copy: s } = Br(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((p, u) => /* @__PURE__ */ v.jsx(Mn, { size: "small", variant: "primary", children: p }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Edit tags", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: l,
            name: "pen",
            className: Bj.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ v.jsx(Xe, { content: "Copy tags", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: l,
            name: o ? "done" : "copy",
            className: Bj.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      s7,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, u7 = "_icon_cddi1_1", m7 = "_link_cddi1_6", qj = {
  icon: u7,
  link: m7
}, p7 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Br(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ v.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ v.jsx(
        $.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: qj.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ v.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ v.jsx(
        ve,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: qj.icon
        }
      ) })
    }
  );
}, f7 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ v.jsx(ve, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ v.jsx(Ye, { children: e.map((n) => /* @__PURE__ */ v.jsx(p7, { trackingInfo: n }, n.number)) })
] }), h7 = "_copyIcon_u5m0p_1", y7 = "_strikethrough_u5m0p_6", g7 = "_order_u5m0p_10", v7 = "_orderIsOpen_u5m0p_18", k7 = "_orderHeader_u5m0p_21", wi = {
  copyIcon: h7,
  strikethrough: y7,
  order: g7,
  orderIsOpen: v7,
  orderHeader: k7
}, b7 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: p,
  refetchOrders: u
}) => {
  const { track: f } = Cn(), { isCopied: h, copy: k } = Br(), { isCopied: C, copy: N } = Br(), { isCopied: j, copy: _ } = Br(), [g, D] = me(!1), [O, I] = me(!1), [F, L] = me(r), {
    id: K,
    name: J,
    createdAt: re,
    status: W,
    currentTotalPriceSet: Y,
    currencyCode: P,
    lineItems: B,
    billingAddress: ee,
    shippingAddress: Ne,
    trackingInfos: ue,
    tags: oe,
    discountCodes: fe,
    currentTotalDiscountsSet: V
  } = e, ke = !!Ne, Oe = Lg(K), q = `https://${l}/admin/orders/${Oe ?? ""}`, Ge = Y?.shopMoney?.amount ?? 0, sn = W.includes("cancelled"), Ie = (en) => new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: P
  }).format(en), Ue = Number(
    V?.shopMoney?.amount ?? 0
  ), De = Ue > 0, Be = fe?.join(", ") ?? "", Ae = Ie(Number(Ge)), Je = Ie(
    Number(Ge) + Ue
  ), $e = e?.refunds ? IF(e) : {}, Me = !!B?.length && B.every((en) => ($e[en.id] || 0) >= (en.quantity || 0));
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      className: dt(wi.order, {
        [wi.orderIsOpen]: F
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: wi.orderHeader,
            onClick: () => L(!F),
            children: [
              /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
                re && /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Gn(re).format(iy) }) }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "1", children: [
                  "Order ",
                  J
                ] })
              ] }),
              /* @__PURE__ */ v.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: F ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        F && /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: J.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => k(J.replace("#", "")),
                    className: wi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: W })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order status", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: j ? "done" : "copy",
                    onClick: () => _(W),
                    className: wi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order value" }),
                    De && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: wi.strikethrough, children: Je }),
                    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Ae }),
                      Be && /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", color: "tertiary", children: [
                        "(",
                        Be,
                        ")"
                      ] })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order value", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: C ? "done" : "copy",
                    onClick: () => N(Ge),
                    className: wi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsx(
            d7,
            {
              orderId: K,
              tags: oe,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            oy,
            {
              openByDefault: !ke,
              labelText: "Billing address",
              address: ee,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            oy,
            {
              openByDefault: ke,
              shopifyId: n,
              orderId: K,
              icon: "map-pin",
              labelText: "Shipping address",
              address: Ne,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            Y9,
            {
              orderId: K,
              lineItems: B,
              refundedQuantities: $e
            }
          ),
          /* @__PURE__ */ v.jsx(f7, { trackingInfos: ue }),
          (o || p) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ v.jsx(
              i7,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: q
              }
            ),
            p && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              ct,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => I(!0),
                className: Mt.fullWidth,
                disabled: sn || Me,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              ct,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => D(!0),
                className: Mt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ v.jsx(
              B9,
              {
                orderId: K,
                orderName: J,
                disabled: sn,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(q, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: K
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ v.jsx(
          W9,
          {
            order: e,
            shopifyId: n,
            orderName: J,
            isOpen: g,
            setIsOpen: D,
            refetchOrders: u
          }
        ),
        O && /* @__PURE__ */ v.jsx(
          e7,
          {
            order: e,
            orderName: J,
            isOpen: O,
            setIsOpen: I,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, _7 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: p
}) => {
  const { track: u } = Cn(), [f, h] = me([]), [k, C] = me(!1), N = Lg(p?.id), j = `https://${n}/admin/orders?customer_id=${N ?? ""}`, {
    getCustomerOrders: _,
    isCustomerOrdersLoading: g,
    customerOrdersError: D,
    customerOrders: O,
    refetchCustomerOrders: I
  } = MW();
  return Qe(() => {
    !g && N && _({
      variables: {
        query: `customer_id:${N}`
      }
    });
  }, [N]), Qe(() => {
    const F = O?.Shopify?.orders?.edges;
    F && h(BW({ ordersData: F }));
  }, [O]), p ? D ? /* @__PURE__ */ v.jsx(En, { error: D }) : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ v.jsx(Mn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: f.map((F, L) => /* @__PURE__ */ v.jsx(
        b7,
        {
          order: F,
          openByDefault: L === 0,
          shopifyId: p?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${L}-${F.id}`
      )) }),
      /* @__PURE__ */ v.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: p?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ v.jsx(
      V9,
      {
        isOpen: k,
        setIsOpen: C,
        shopifyCustomer: p,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, x7 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ v.jsxs(Ye, { className: Mt.list, children: [
      /* @__PURE__ */ v.jsx(Ye.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, S7 = "_segmentName_1dkhk_1", N7 = {
  segmentName: S7
}, j7 = 100, Cs = 10, w7 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = hn(), [i, a] = me([]), [o, s] = me(Cs), [l, d] = me(!1), p = Qn(
    () => i.filter((N) => N.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    $W,
    {
      skip: !e,
      variables: {
        first: j7
      },
      onCompleted: (N) => {
        const j = N?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const _ = j.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, D) => g.name.localeCompare(D.name));
          a(_), h({
            variables: {
              customerId: e,
              segmentIds: _.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: k, error: C }
  ] = r(TW, {
    onCompleted: (N) => {
      const j = N?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const _ = i.map((g) => {
          const D = j.find(
            (O) => O.segmentId === g.id
          );
          return {
            ...g,
            ...D?.isMember && { isMember: D.isMember }
          };
        }).sort(
          (g, D) => g.isMember === D.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(_);
      }
    }
  });
  return Qe(() => {
    s(l ? i.length : Cs);
  }, [l]), e ? /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ v.jsx(Mn, { variant: "success", size: "small", children: p })
    ] }),
    u && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ v.jsx(En, { error: f }),
    C && /* @__PURE__ */ v.jsx(En, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ v.jsxs(Ye, { className: Mt.list, children: [
      i.slice(0, o).map(({ id: N, name: j, isMember: _ }) => /* @__PURE__ */ v.jsx(Ye.Text, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(
        Xe,
        {
          content: `${_ ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: N7.segmentName, children: j }),
            k && /* @__PURE__ */ v.jsx(fn, { size: 12 }),
            !k && /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(
              ve,
              {
                color: _ ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, N)),
      i.length > Cs && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ v.jsx(
        ct,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Cs} more`
        }
      ) })
    ] })
  ] }) : null;
}, C7 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1);
  Qe(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: d
  } = UW({ conversationContext: e, forcePhoneLookup: r }), [p, u] = me(), [f, h] = me(
    []
  ), k = n.apiHostName, C = n.displayRefundOrder ?? !1, N = n.displayCancelOrder ?? !1, j = n.enableEditShippingAddress ?? !1, _ = n.displayEmailMarketingConsent ?? !1, g = n.displayOrdersOverview ?? !1, D = n.displaySegmentMembership ?? !1, O = n.displayDiscountCodeCreation ?? !1, I = n.displayDiscountCodes ?? !1, F = n.displayCreateOrder ?? !1, L = n.displayDuplicateOrder ?? !1, K = n.displayCreateDraftOrder ?? !1, J = n.displayPartialRefundOrder ?? !1;
  if (Qe(() => {
    const re = s?.Shopify?.customers?.edges[0]?.node, W = !!e.customer?.phone_number && !!e.customer?.email;
    re && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(re)) : !re && !a && W && !r ? i(!0) : u(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ v.jsx(En, { error: o, retry: l });
  if (!a && !o && !p) {
    const re = `https://${k}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ v.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ v.jsx(
              i9,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ v.jsx(
              Lt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(re, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && d !== tr.refetch ? /* @__PURE__ */ v.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ v.jsx(fn, {}) }) : /* @__PURE__ */ v.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ v.jsx(
          s9,
          {
            customer: p,
            shopifyDomain: k,
            refresh: l,
            loading: a,
            networkStatus: d
          }
        ),
        g && /* @__PURE__ */ v.jsx(
          x7,
          {
            totalOrders: p?.numberOfOrders,
            amountSpent: p?.amountSpent
          }
        ),
        D && /* @__PURE__ */ v.jsx(w7, { shopifyId: p?.id }),
        _ && /* @__PURE__ */ v.jsx(S9, { customer: p }),
        I && /* @__PURE__ */ v.jsx(
          x9,
          {
            displayDiscountCodeCreation: O
          }
        ),
        /* @__PURE__ */ v.jsx(
          _7,
          {
            shopifyCustomer: p,
            shopifyDomain: k,
            displayRefund: C,
            displayCancel: N,
            displayCreateOrder: F,
            displayCreateDraftOrder: K,
            enableEditShippingAddress: j,
            customerCountryCodes: f,
            displayDuplicateOrder: L,
            displayPartialRefundOrder: J
          }
        )
      ]
    }
  );
}, Ot = [];
for (let e = 0; e < 256; ++e)
  Ot.push((e + 256).toString(16).slice(1));
function F7(e, n = 0) {
  return (Ot[e[n + 0]] + Ot[e[n + 1]] + Ot[e[n + 2]] + Ot[e[n + 3]] + "-" + Ot[e[n + 4]] + Ot[e[n + 5]] + "-" + Ot[e[n + 6]] + Ot[e[n + 7]] + "-" + Ot[e[n + 8]] + Ot[e[n + 9]] + "-" + Ot[e[n + 10]] + Ot[e[n + 11]] + Ot[e[n + 12]] + Ot[e[n + 13]] + Ot[e[n + 14]] + Ot[e[n + 15]]).toLowerCase();
}
const I7 = new Uint8Array(16);
function E7() {
  return crypto.getRandomValues(I7);
}
function $7(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : T7(e);
}
function T7(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? E7();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, F7(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var mh = { exports: {} }, po = {}, Hj;
function O7() {
  if (Hj) return po;
  Hj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return po.Fragment = r, po.jsx = s, po.jsxs = s, po;
}
var Fs = {}, Wj;
function R7() {
  return Wj || (Wj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    Fs.Fragment = i, Fs.jsx = zn, Fs.jsxs = Wn;
  })()), Fs;
}
var Kj;
function D7() {
  return Kj || (Kj = 1, process.env.NODE_ENV === "production" ? mh.exports = O7() : mh.exports = R7()), mh.exports;
}
var R = D7(), $F = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))($F || {}), sy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(sy || {});
const P7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, A7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, L7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, V7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, z7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, U7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, M7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, B7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, q7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, H7 = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": P7,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": A7,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": L7,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": V7,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": z7,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": U7,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": M7,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": B7,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": q7
};
function ri(e) {
  return H7[e] ?? {};
}
const W7 = ri(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), K7 = ri(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), G7 = ri(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), Y7 = ri(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), J7 = ri(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), Q7 = ri(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), X7 = ri(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), Z7 = ri(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), eK = ri(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), nK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = Cn(), [i, a] = me(), [o, s] = me(), [l, d] = me(), {
    loading: p,
    error: u,
    data: f,
    refetch: h
  } = n(W7, {
    skip: !e,
    variables: { contactId: e }
  });
  return Qe(() => {
    const k = f?.Voyado?.ContactsV_GetContactById;
    !p && k && typeof k == "object" && ("id" in k && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in k && a(k.attributes), "preferences" in k && s(k.preferences), "consents" in k && d(
      k?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !p && (!k || typeof k != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, p]), Qn(
    () => ({
      isLoading: p,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function Gs(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const tK = {
  count: 0,
  items: []
}, rK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = Cn(), [i, a] = me(tK), {
    loading: o,
    error: s,
    data: l
  } = n(Y7, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, p = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (p?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...p.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: p.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, iK = {
  count: 0,
  totalCount: 0,
  items: []
}, aK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = Cn(), [i, a] = me(
    iK
  ), {
    loading: o,
    error: s,
    data: l
  } = n(J7, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: p } = d;
      p && r("voyado:transactions:received", { count: p });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, oK = ({
  conversationContext: e
}) => {
  const { useQuery: n } = hn(), [r, i] = me(void 0), [a, o] = me(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: p,
    data: u,
    refetch: f
  } = n(G7, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: p,
    refetch: f
  };
}, sK = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = hn(), [i, a] = me(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(K7, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Qe(() => {
    const p = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && p && Object.hasOwn(p, "memberlevel")) {
      const u = p?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Qn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, lK = "_pointer_pn2q5_54", cK = "_list_pn2q5_59", dK = "_listItem_pn2q5_69", pt = {
  pointer: lK,
  list: cK,
  listItem: dK
}, uK = "_modalBody_1clhs_1", mK = {
  modalBody: uK
}, pK = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), d = r?.id, p = r?.balance ?? 0, u = {
    balance: p?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: k } = ut({
    defaultValues: u,
    mode: "onChange"
  }), C = pi({ control: f }), N = parseInt(C?.balance ?? "0", 10), j = p === N, _ = j ? "Change the value to update the points" : "", g = N < 0, D = g ? "Points can not be negative" : "", O = C.description === "", I = O ? "Description can not be empty" : "";
  Qe(() => {
    N > p ? h(
      "transactionType",
      sy.Addition
    ) : N < p && h(
      "transactionType",
      sy.Deduction
    );
  }, [p, N, h]);
  const [F, { loading: L, error: K, reset: J }] = o(eK, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), re = () => {
    if (d) {
      const Y = $7();
      F({
        variables: {
          input: {
            accountId: d,
            transactionId: Y,
            amount: Math.abs(N - p),
            transactionType: C.transactionType,
            description: C.description,
            source: $F.UpdateBalance
          }
        }
      }).then(async (P) => {
        P?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), W());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, W = () => {
    k(u), J(), n();
  };
  return /* @__PURE__ */ R.jsxs(
    wt,
    {
      isOpen: e,
      onClose: W,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ R.jsx(Ct, { title: "Update points balance", onClose: W }),
        /* @__PURE__ */ R.jsxs(Ft, { className: mK.modalBody, children: [
          /* @__PURE__ */ R.jsxs(nt, { children: [
            /* @__PURE__ */ R.jsx(Z, { span: 6, children: /* @__PURE__ */ R.jsx(
              bt,
              {
                name: "balance",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ R.jsx(
                  qr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: _ || D
                    },
                    input: {
                      ...Y,
                      value: Y.value.toString(),
                      onChange: (P) => Y.onChange(P)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ R.jsx(Z, { span: 6, children: /* @__PURE__ */ R.jsx(
              bt,
              {
                name: "description",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ R.jsx(
                  qr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: Y,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          K && /* @__PURE__ */ R.jsx(En, { error: K })
        ] }),
        /* @__PURE__ */ R.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => re(),
            confirmProps: {
              isLoading: L,
              disabled: j || g || O,
              loadingIndicator: /* @__PURE__ */ R.jsx(fn, { size: 16 })
            },
            cancelOnClick: W
          }
        )
      ]
    }
  );
}, fK = "_wrapper_1ge6c_1", hK = "_block_1ge6c_12", Gj = {
  wrapper: fK,
  block: hK
}, yK = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = hn(), { isCopied: i, copy: a } = Gs(), { isCopied: o, copy: s } = Gs(), { isCopied: l, copy: d } = Gs(), [p, u] = me(!1), [f, h] = me(), [k, C] = me(!1), {
    loading: N,
    data: j,
    refetch: _
  } = r(X7, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Qe(() => {
    if (j) {
      const ee = j?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [j]);
  const g = !!f?.id, D = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: O,
    lastName: I,
    street: F,
    zipCode: L,
    city: K,
    country: J,
    isRegistrationCompleted: re,
    email: W,
    mobilePhone: Y
  } = e, P = 14, B = `${O || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", className: Gj.wrapper, children: [
    /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Gj.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-2", children: B }),
          N && /* @__PURE__ */ R.jsx(fn, { size: 12 }),
          g && !N && /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ R.jsxs(Mn, { size: "small", variant: "warning", children: [
              D,
              " points"
            ] }),
            /* @__PURE__ */ R.jsx(Xe, { content: "Update points balance", children: /* @__PURE__ */ R.jsx(
              ve,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: pt.pointer
              }
            ) }),
            k && /* @__PURE__ */ R.jsx(Xe, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ R.jsx(
              ve,
              {
                name: "info",
                size: 12,
                className: pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (F || K || L || J || Y || W) && /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
      Y && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "phone" }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Y })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(Y),
            className: pt.pointer
          }
        )
      ] }),
      W && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "mail" }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: W })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            size: P,
            name: i ? "done" : "copy",
            onClick: () => a(W),
            className: pt.pointer
          }
        )
      ] }),
      (F || K || L || J) && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "home" }),
          /* @__PURE__ */ R.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ R.jsx(st, { children: F }),
            /* @__PURE__ */ R.jsxs(st, { children: [
              L,
              " ",
              K
            ] }),
            /* @__PURE__ */ R.jsx(st, { children: J })
          ] })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => d(`${F}, ${L} ${K}, ${J}`),
            className: pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "sign-in" }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            name: re ? "check-circle-filled" : "close-circle-filled",
            color: re ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ R.jsx(
      pK,
      {
        isOpen: p,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: _
      }
    )
  ] });
}, gK = "_list_yud4a_7", vK = "_listItem_yud4a_11", kK = "_listItemTooltip_yud4a_15", bK = "_listItemTimestamp_yud4a_18", Is = {
  list: gK,
  listItem: vK,
  listItemTooltip: kK,
  listItemTimestamp: bK
}, _K = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ R.jsx(Ye, { className: Is.list, children: e.map((n, r) => /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: Is.listItem, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ R.jsx(Xe, { content: n?.comment, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: dt({
          [Is.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ R.jsx($.Paragraph, { className: Is.listItemTimestamp, children: Gn(n.date).format(jt) }),
          n?.comment && /* @__PURE__ */ R.jsx(ve, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ R.jsx(
      ve,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), xK = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Gn(e.latestChange).format(jt) : null, o = e?.expires ? `${Gn(e.expires).fromNow()} (${Gn(e.expires).format(jt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ R.jsx(Xe, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ R.jsx(
        ve,
        {
          name: "question",
          size: 14,
          className: pt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsxs(Ye, { className: pt.list, children: [
      s && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, SK = "_tagHover_kzbzk_1", NK = "_channelUnsubscribed_kzbzk_6", Yj = {
  tagHover: SK,
  channelUnsubscribed: NK
}, ph = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = Cn(), { useMutation: l } = hn(), [d, p] = me(!1), [u, { loading: f }] = l(Z7), h = async ({
    newPreference: C,
    isSubscribed: N,
    channelType: j
  }) => {
    p(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? N ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : N ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => p(!1));
    }, 1e3);
  }, k = d || f;
  return /* @__PURE__ */ R.jsx(Xe, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ R.jsx(
    Jn,
    {
      className: Yj.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ R.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: dt({
            [Yj.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            k ? /* @__PURE__ */ R.jsx(fn, { size: 16 }) : /* @__PURE__ */ R.jsx(ve, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, jK = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        ph,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        ph,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        ph,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, wK = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: p,
    attributes: u,
    preferences: f,
    consents: h
  } = nK({ contactId: e }), {
    isLoading: k,
    error: C,
    memberLevel: N
  } = sK({ contactId: e, skip: !s }), j = k || l, _ = Qn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || C ? ba({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ R.jsx(En, { error: d || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    r && /* @__PURE__ */ R.jsx(
      yK,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ R.jsx(xK, { memberLevel: N }),
    i && /* @__PURE__ */ R.jsx(
      jK,
      {
        refetchContact: p,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ R.jsx(_K, { contactConsents: _ })
  ] });
}, ly = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, CK = "_list_zu4s7_1", FK = "_listItem_zu4s7_4", IK = "_listSum_zu4s7_7", Es = {
  list: CK,
  listItem: FK,
  listSum: IK
}, EK = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ R.jsxs(Ye, { className: Es.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: Es.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: s, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ R.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flex: "auto", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ R.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: ly(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ R.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(Es.listItem, Es.listSum),
      children: /* @__PURE__ */ R.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: ly(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), $K = "_transaction_1kr8d_1", TK = "_transactionIsOpen_1kr8d_9", OK = "_transactionHeader_1kr8d_12", RK = "_transactionHeaderSubLine_1kr8d_15", DK = "_transactionHeaderAlignItemRight_1kr8d_19", ia = {
  transaction: $K,
  transactionIsOpen: TK,
  transactionHeader: OK,
  transactionHeaderSubLine: RK,
  transactionHeaderAlignItemRight: DK
}, PK = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: p,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", k = f ?? 0, C = p?.length ? p : [];
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: dt(ia.transaction, {
        [ia.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ia.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ R.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Gn(o).format(jt) }),
                  /* @__PURE__ */ R.jsxs(
                    $.Heading,
                    {
                      variant: "heading-4",
                      className: ia.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ia.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-4", children: ly(k, h) }),
                      /* @__PURE__ */ R.jsxs(
                        $.Heading,
                        {
                          variant: "heading-4",
                          className: ia.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ R.jsx(Nl, {}),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ R.jsx(
                  EK,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: k
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, AK = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = aK({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ R.jsx(En, { error: r }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          s === 0 && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ R.jsx(
            PK,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, LK = "_message_4z55u_54", VK = "_messageIsOpen_4z55u_62", zK = "_messageHeader_4z55u_66", UK = "_messageText_4z55u_70", MK = "_buttonLink_4z55u_93", fo = {
  message: LK,
  messageIsOpen: VK,
  messageHeader: zK,
  messageText: UK,
  buttonLink: MK
}, fh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, hh = (e, n) => n && e in fh && n in fh[e] ? fh[e][n] : null, BK = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { track: a } = Cn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: p,
    status: u,
    messageLink: f,
    messageText: h
  } = e, k = l ? hh("type", l) : null, C = d ? hh("source", d) : null, N = u ? hh("status", u) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: dt(fo.message, {
        [fo.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: fo.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
                  k && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
                    /* @__PURE__ */ R.jsx(ve, { name: k, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Gn(s).format(jt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ R.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ R.jsx(Nl, {}),
          /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            N && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(ve, { name: N }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(ve, { name: C }),
              " ",
              d
            ] }) }),
            p && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(ve, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", className: fo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ R.jsx(
            Lt,
            {
              slotEnd: /* @__PURE__ */ R.jsx(ve, { name: "external-link" }),
              variant: "tertiary",
              className: fo.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, qK = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = rK({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ R.jsx(En, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      l && o?.map((d, p) => /* @__PURE__ */ R.jsx(
        BK,
        {
          message: d || void 0,
          openByDefault: p === 0
        },
        p
      )),
      !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Gl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Jj = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = Gs(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = _t(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(ve, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ R.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ R.jsx(
      ve,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: pt.pointer
      }
    ) })
  ] });
}, HK = "_order_19t4p_1", WK = "_orderIsOpen_19t4p_9", KK = "_orderHeader_19t4p_12", GK = "_orderIconColor_19t4p_15", Lr = {
  order: HK,
  orderIsOpen: WK,
  orderHeader: KK,
  orderIconColor: GK
}, YK = "_delivery_1m9nb_1", JK = "_deliveryCode_1m9nb_4", yh = {
  delivery: YK,
  deliveryCode: JK
}, QK = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ R.jsx(
      ve,
      {
        size: l,
        name: "eye",
        className: Lr.orderIconColor
      }
    ),
    /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ R.jsx(
        Xe,
        {
          content: /* @__PURE__ */ R.jsxs($.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Gn(s).format(jt)
          ] }),
          children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ R.jsx(
              $.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: yh.delivery,
                    children: [
                      /* @__PURE__ */ R.jsx(ve, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ R.jsx(
              $.Paragraph,
              {
                variant: "4",
                className: dt(yh.delivery, yh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ R.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ R.jsx(
      ve,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: pt.pointer
      }
    ) })
  ] });
}, XK = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        ve,
        {
          size: 14,
          name: "file-text",
          className: Lr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ R.jsx(Ye, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(Ye.Item, { className: pt.listItem, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ R.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ R.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: pt.listItemAlignRight,
              children: [
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Gl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, ZK = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        ve,
        {
          size: 14,
          name: "tag",
          className: Lr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ R.jsx(Ye, { className: pt.list, children: r?.map((i) => /* @__PURE__ */ R.jsx(
      Ye.Item,
      {
        className: pt.listItem,
        contentLeft: /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ R.jsx(
          Xe,
          {
            content: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ R.jsx(b, { children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Gl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ R.jsx(
          _a,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, eG = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        ve,
        {
          size: 14,
          name: "credit-card",
          className: Lr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ R.jsx(Ye, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(
      Ye.Item,
      {
        className: pt.listItem,
        children: /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ R.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: Gn(i?.paidAt).format(jt) }),
                    /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Gl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, nG = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: p,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: k,
    totalPrice: C
  } = e, N = 14;
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: dt(Lr.order, {
        [Lr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Lr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                p && /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Gn(p).format(jt) }) }),
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ R.jsx(
                rr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              ve,
              {
                size: N,
                name: "activity",
                className: Lr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ R.jsx(Xe, { content: "Internal status", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ R.jsx(Xe, { content: "External status", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: s }) }) }),
                /* @__PURE__ */ R.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ R.jsx($.Paragraph, { as: "span", variant: "5", children: Gn(u).format(jt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              ve,
              {
                size: N,
                name: "chart-bar",
                className: Lr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Gl({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              ve,
              {
                size: N,
                name: "channels",
                className: Lr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ R.jsx(Jj, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ R.jsx(
            Jj,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: k
            }
          ),
          /* @__PURE__ */ R.jsx(QK, { delivery: e.delivery }),
          /* @__PURE__ */ R.jsx(ZK, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ R.jsx(XK, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ R.jsx(
            eG,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, tG = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || ba({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ R.jsx(En, { error: e }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: r }), rG = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), [r, i] = me([]), { track: a } = Cn(), {
    loading: o,
    error: s,
    data: l
  } = n(Q7, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: p } = d;
        p && a("voyado:orders:received", { count: p });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsx(tG, { error: s, itemCount: r.length, children: r.map((d, p) => /* @__PURE__ */ R.jsx(
      nG,
      {
        order: d,
        openByDefault: p === 0
      },
      p
    )) })
  ] }) : null;
}, iG = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = oK({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: p,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: k,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? ba({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ R.jsx(En, { error: o }) : !d && !p && !u && !f && !h && !k ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ R.jsx(wK, { contactId: i, settings: n }),
        h && /* @__PURE__ */ R.jsx(qK, { contactId: i }),
        k && /* @__PURE__ */ R.jsx(AK, { contactId: i }),
        C && /* @__PURE__ */ R.jsx(rG, { contactId: i }),
        !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, cy = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], aG = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, oG = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: aG
  }), {
    create: l,
    update: d,
    remove: p,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: cy,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => fr(K, {
    fieldDefinitions: cy,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ R.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ R.jsx(hr, { cause: h }),
        /* @__PURE__ */ R.jsxs(nt, { children: [
          /* @__PURE__ */ R.jsx(Z, { children: /* @__PURE__ */ R.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(
            Ir,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(
            Pn,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show the customer attributes", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show preferences", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show audiences", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show consents", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show the last 5 messages", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show customer transactions", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show orders by contact", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: "Show member level", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ R.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ R.jsx(
          yr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var gh = { exports: {} }, ho = {}, Qj;
function sG() {
  if (Qj) return ho;
  Qj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, p) {
    var u, f = {}, h = null, k = null;
    p !== void 0 && (h = "" + p), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ho.Fragment = r, ho.jsx = s, ho.jsxs = s, ho;
}
var $s = {}, Xj;
function lG() {
  return Xj || (Xj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), p = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        D("error", t, m);
      }
    }
    function D(t, c, m) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", m = m.concat([w]));
        var T = m.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === p || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? m + "(" + w + ")" : m;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var m = t;
            return Y(m._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, Ne, ue, oe, fe, V, ke, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ee === 0) {
          Ne = console.log, ue = console.info, oe = console.warn, fe = console.error, V = console.group, ke = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function sn() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: Ne
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: oe
            }),
            error: B({}, t, {
              value: fe
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var m = Ae.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (te) {
              y = te;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, m) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return se(T(w), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, m, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + m + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", m, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var m = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var m = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, m, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, m, y, w) {
      {
        var T, S = {}, x = null, X = null;
        m !== void 0 && (U(m), x = "" + m), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(m);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = Dn(c);
        if (Sn[m])
          return;
        Sn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = P(c);
          vn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, m, y, w, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, m, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), te = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, m) {
      return jn(t, c, m, !0);
    }
    function qn(t, c, m) {
      return jn(t, c, m, !1);
    }
    var zn = qn, Wn = Vn;
    $s.Fragment = i, $s.jsx = zn, $s.jsxs = Wn;
  })()), $s;
}
var Zj;
function cG() {
  return Zj || (Zj = 1, process.env.NODE_ENV === "production" ? gh.exports = sG() : gh.exports = lG()), gh.exports;
}
var Se = cG();
const dG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, uG = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": dG
};
function mG(e) {
  return uG[e] ?? {};
}
const pG = mG(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), fG = "_copyIcon_1pfts_54", hG = "_list_1pfts_59", yG = "_listItem_1pfts_69", gG = "_listItemHighlighted_1pfts_78", ka = {
  copyIcon: fG,
  list: hG,
  listItem: yG,
  listItemHighlighted: gG
}, vG = "_wrapper_1xucg_1", kG = "_externalLink_1xucg_7", vh = {
  wrapper: vG,
  externalLink: kG
}, bG = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: p
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Se.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Se.jsxs(b, { className: vh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Se.jsx(
      b,
      {
        justifyContent: "space-between",
        className: vh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    p && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: Gn(p).format(jt) })
    ] }),
    l && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Se.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx(ve, { size: u, name: "mail" }),
        /* @__PURE__ */ Se.jsx("span", { className: vh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Se.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ Se.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Se.jsx(
        ve,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: ka.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Se.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx(ve, { size: u, name: "phone" }),
        /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Se.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ Se.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Se.jsx(
        ve,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: ka.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Xn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = ow(n);
  return /* @__PURE__ */ Se.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(ka.listItem, {
        [ka.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Se.jsx(Xe, { content: r, children: /* @__PURE__ */ Se.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Li(n)
      ] }) })
    }
  );
}, _G = ({
  loyalty: e
}) => /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Se.jsxs(Ye, { className: ka.list, children: [
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), xG = 0.8, SG = 0.4, ew = (e) => {
  if (e != null)
    return e >= xG ? /* @__PURE__ */ Se.jsx(Mn, { variant: "success", size: "small", children: "Positive" }) : e <= SG ? /* @__PURE__ */ Se.jsx(Mn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Se.jsx(Mn, { variant: "warning", size: "small", children: "Neutral" });
}, NG = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Se.jsxs(Ye, { className: ka.list, children: [
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: ew(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: ew(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Gn(e.last_review_date).format(
          jt
        )
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Xn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Se.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Se.jsx(Mn, { variant: "info", size: "small", children: /* @__PURE__ */ Se.jsx(Se.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), jG = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = Cn(), [a, o] = me(), [s, l] = me(!1), d = e?.customer?.email, p = e?.customer?.phone_number, u = !d && !p, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, k = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, N = n?.displaySubscriptions ?? !1, j = !f, _ = !h && !k && !C && !N, {
    loading: g,
    error: D,
    data: O
  } = r(pG, {
    skip: u || j,
    variables: {
      ...d && { email: d },
      ...!d && p && { phone: p },
      storeId: f,
      expand: "all"
    }
  });
  if (Qe(() => {
    const I = O?.Yotpo?.getCustomers?.customers?.[0];
    I ? (o(I), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [O?.Yotpo, g]), j)
    return /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Se.jsx(
      En,
      {
        error: new fw({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Se.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (_)
    return /* @__PURE__ */ Se.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Se.jsx(fn, {}) });
  if (s)
    return /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (D) {
    const I = D.graphQLErrors;
    return bl({ errors: I }) ? /* @__PURE__ */ Se.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: I }) ? /* @__PURE__ */ Se.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Se.jsx(En, { error: D });
  }
  return /* @__PURE__ */ Se.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Se.jsx(bG, { customerDetails: a }),
        k && /* @__PURE__ */ Se.jsx(
          NG,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Se.jsx(_G, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
}, wG = "_settingsWrapper_1ycvy_1", CG = "_settingsWrapperHeader_1ycvy_6", FG = "_settingsWrapperContent_1ycvy_10", IG = "_settingsWrapperContentCode_1ycvy_18", EG = "_settingsWrapperContentCURL_1ycvy_26", yo = {
  settingsWrapper: wG,
  settingsWrapperHeader: CG,
  settingsWrapperContent: FG,
  settingsWrapperContentCode: IG,
  settingsWrapperContentCURL: EG
}, TF = ({
  handleChangeText: e
}) => {
  const [n, r] = me(!1), { isCopied: i, copy: a } = Jt(), { control: o } = ut({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = pi({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = _t(() => {
    const p = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${p || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Se.jsx(Se.Fragment, { children: /* @__PURE__ */ Se.jsx(Z, { span: 6, children: /* @__PURE__ */ Se.jsxs(b, { flexDirection: "column", className: yo.settingsWrapper, children: [
    /* @__PURE__ */ Se.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: yo.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Se.jsx(ve, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Se.jsxs(
      b,
      {
        flexDirection: "column",
        className: yo.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Se.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Se.jsx(
            my,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Se.jsxs("ol", { children: [
                /* @__PURE__ */ Se.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Se.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Se.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Se.jsx("span", { className: yo.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Se.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Se.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Se.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Se.jsx(
            bt,
            {
              name: "storeId",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Se.jsx(
                qr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...p,
                    onChange: (u) => {
                      p.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Se.jsx(
            bt,
            {
              name: "secret",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Se.jsx(
                qr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: p
                }
              )
            }
          ),
          l && /* @__PURE__ */ Se.jsxs(Se.Fragment, { children: [
            /* @__PURE__ */ Se.jsx(We, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Se.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: yo.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Se.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Se.jsx(
              Xe,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Se.jsx(
                  ct,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, vl = [
  // The store id is populated by the OAuth flow, not edited in the form. It is
  // kept here so the runtime widget render can resolve it and so it round-trips
  // on update.
  {
    key: "yotpoStoreId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  // Secret, only written when editing a legacy token-authenticated widget.
  // Excluded from the read path; omitted from the update payload unless the
  // user re-enters it (preserving the stored value).
  {
    key: "yotpoAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], $G = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: fi
  }
], TG = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: TF
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], kh = "YOTPO", OG = {
  enabled: !1,
  name: "",
  ...xl(
    [],
    vl
  )
}, RG = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: OG
  }), {
    create: d,
    update: p,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = dr({
    integrationId: e,
    integrationType: kh,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = ur({
    integrationId: e,
    fieldDefinitions: vl,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = mr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = s || !!D?.additionalProperties?.isUsingOAuth, K = (re) => fr(re, {
    fieldDefinitions: vl,
    isCreationMode: s,
    create: d,
    update: p,
    renderConditions: F
  }), J = l.watch("name");
  return /* @__PURE__ */ Se.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: K,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ Se.jsx(hr, { cause: k }),
        /* @__PURE__ */ Se.jsxs(nt, { children: [
          /* @__PURE__ */ Se.jsx(Z, { children: /* @__PURE__ */ Se.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          !L && /* @__PURE__ */ Se.jsxs(Se.Fragment, { children: [
            /* @__PURE__ */ Se.jsx(
              TF,
              {
                handleChangeText: (re) => l.setValue("yotpoStoreId", re?.target.value ?? "")
              }
            ),
            /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(
              Pn,
              {
                name: "yotpoStoreId",
                label: "Yotpo store ID",
                control: l.control,
                rules: { required: "Yotpo store ID is required" },
                componentProps: {
                  placeholder: 'See "How to get the Yotpo access token" above.',
                  readOnly: !0,
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
            /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(
              Ir,
              {
                name: "yotpoAccessToken",
                label: "Yotpo access token",
                control: l.control,
                isCreationMode: s,
                rules: { required: "Yotpo access token is required" },
                componentProps: {
                  placeholder: "Insert the Yotpo access token",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Se.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(We, { label: "Show customer details", children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "showCustomerDetails",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(We, { label: "Show user generated content", children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "showUserGeneratedContent",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(We, { label: "Show loyalty data", children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "displayLoyalty",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          L && !s && e && /* @__PURE__ */ Se.jsx(
            fi,
            {
              configuration: n,
              integrationId: e,
              integrationType: kh,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ Se.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ Se.jsx(
          yr,
          {
            integrationType: kh,
            integrationId: e,
            widgetName: J,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
}, DG = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: sW,
  featureSettings: []
} : n ? {
  authSettings: lW,
  featureSettings: [...fF]
} : e ? {
  authSettings: [
    ...jj,
    ...aW
  ],
  featureSettings: [...wj]
} : {
  authSettings: [
    ...jj,
    ...oW
  ],
  featureSettings: [...wj]
}, OF = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, PG = OF(
  $G,
  TG
), AG = OF(
  rV,
  iV
), RF = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = DG(n), s = PG(r), l = AG(i);
  return {
    SHOPIFY: {
      widget: C7,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      fieldDefinitions: gl,
      WidgetSettings: tW,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: j2,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Th,
      WidgetSettings: F2
    },
    GITHUB: {
      widget: CP,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Ih,
      WidgetSettings: IP
    },
    MIUROS: {
      widget: mB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: Qh,
      WidgetSettings: fB
    },
    KLAVIYO: {
      widget: QL,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: ol,
      WidgetSettings: oV,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...l]
    },
    LINEAR: {
      widget: $4,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: Kh,
      WidgetSettings: O4
    },
    VOYADO: {
      widget: iG,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: cy,
      WidgetSettings: oG
    },
    LOYALTYLION: {
      widget: d5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Gh,
      WidgetSettings: m5
    },
    RECHARGE: {
      widget: VB,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: ey,
      WidgetSettings: UB
    },
    BRAZE: {
      widget: eD,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: rl,
      WidgetSettings: tD
    },
    YOTPO: {
      widget: jG,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      fieldDefinitions: vl,
      WidgetSettings: RG,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...s]
    },
    INGRID: {
      widget: tA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Eh,
      WidgetSettings: iA
    },
    RIVOLOYALTY: {
      widget: jq,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: ty,
      WidgetSettings: qH
    }
  };
}, LG = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? nI(r, e.defaultValue) : tI(r, e.defaultValue);
}, VG = (e, n) => e.map((r) => ({
  key: r.key,
  value: LG(r, n)
})), zG = ({ fieldDefinitions: e }, n) => VG(
  (e ?? []).filter(({ secret: r }) => !r),
  n
), UG = (e) => {
  const n = RF();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: zG(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, b8 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: p,
  widgetAnnotations: u
}) => {
  const f = Er(
    {}
  ), h = (F) => (f.current[F] || (f.current[F] = { current: null }), f.current[F]), { track: k } = Cn(), C = Qn(
    () => UG(e),
    [e]
  ), N = {
    headline: "",
    text: "",
    onConfirm: () => I(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [j, _] = me(N), [g, D] = me(!1), O = (F) => {
    D(!0), _(F);
  }, I = () => {
    D(!1), _(N);
  };
  return /* @__PURE__ */ Zn.jsxs(Zn.Fragment, { children: [
    C.map(
      ({
        id: F,
        name: L,
        type: K,
        widget: J,
        settings: re,
        misconfigured: W,
        renderConditions: Y,
        icon: P,
        iconColors: B,
        integrationKey: ee
      }, Ne) => {
        const ue = `partner-integration-${K}`, oe = u?.get(F) === !1, fe = /* @__PURE__ */ Zn.jsx(py, { icon: P, color: B }), V = re?.reduce(
          (ke, Oe) => (ke[Oe.key] = Oe.value, ke),
          {}
        );
        return s ? /* @__PURE__ */ Zn.jsx("div", { className: "icon-holder", children: fe }, `partner-icon-${F}`) : /* @__PURE__ */ Zn.jsxs(
          br,
          {
            onToggle: () => {
              k(
                o(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: F,
                  widgetType: K.toLowerCase()
                }
              ), a(ee);
            },
            isOpen: o(ee),
            className: ue,
            containerRef: (ke) => {
              h(ee).current = ke;
            },
            children: [
              /* @__PURE__ */ Zn.jsx(
                br.Header,
                {
                  className: dt({
                    [fT.unmatchedHeader]: oe
                  }),
                  wrap: "normal",
                  avatar: fe,
                  slotBeforeTitle: d?.(
                    ee,
                    Ne,
                    h(ee)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Zn.jsx(Zn.Fragment, { children: l?.(ee) }),
                  children: /* @__PURE__ */ Zn.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    L,
                    p?.(
                      Y ?? [],
                      F
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Zn.jsx(br.Content, { children: W ? /* @__PURE__ */ Zn.jsx(En, { isMisconfigured: !0 }) : /* @__PURE__ */ Zn.jsx(
                uw.Provider,
                {
                  value: {
                    onError: (ke, Oe) => console.warn(
                      `Something went wrong with a partner widget of type '${K}' and id '${F}'`,
                      ke,
                      Oe
                    )
                  },
                  children: /* @__PURE__ */ Zn.jsx(
                    Kw,
                    {
                      integrationId: F,
                      type: K,
                      configuration: n,
                      showNotification: i,
                      showModal: O,
                      children: sI(J, {
                        conversationContext: r,
                        settings: V
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ Zn.jsx(
      rI,
      {
        isOpen: g,
        setIsOpen: D,
        headline: j.headline,
        text: j.text,
        confirmLabel: j.confirmLabel,
        confirmVariant: j.confirmVariant,
        cancelLabel: j.cancelLabel,
        cancelVariant: j.cancelVariant,
        onConfirm: j.onConfirm ? () => {
          try {
            j.onConfirm && j.onConfirm();
          } finally {
            D(!1), _(N);
          }
        } : void 0,
        onCancel: j.onCancel ? () => {
          try {
            j.onCancel && j.onCancel();
          } finally {
            D(!1), _(N);
          }
        } : void 0,
        children: j.children
      }
    )
  ] });
}, _8 = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const l = RF()[r]?.WidgetSettings;
  return /* @__PURE__ */ Zn.jsx(
    uw.Provider,
    {
      value: {
        onError: (d, p) => console.warn(
          `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
          d,
          p
        )
      },
      children: /* @__PURE__ */ Zn.jsx(
        Kw,
        {
          integrationId: n,
          type: r,
          configuration: e,
          showNotification: a,
          children: /* @__PURE__ */ Zn.jsx(Zn.Fragment, { children: l && /* @__PURE__ */ Zn.jsx(
            l,
            {
              configuration: e,
              integrationId: n,
              handleRedirect: i,
              showNotification: a,
              automationCouplingState: o,
              renderConditionsEditor: s
            }
          ) })
        }
      )
    }
  );
}, nw = "__PairingContext__", DF = globalThis[nw] ?? (() => {
  const e = sw({});
  return globalThis[nw] = e, e;
})(), x8 = () => uy(DF), S8 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Zn.jsx(DF.Provider, { value: e, children: n }), MG = jl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function N8(e, { skip: n = !1 } = {}) {
  const [r, i] = me([]), [a, o] = me(!1);
  return Qe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Ww(e).query({
      query: MG
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
var Ts = { exports: {} }, tw;
function BG() {
  if (tw) return Ts.exports;
  tw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, F, L) {
    return Function.prototype.apply.call(I, F, L);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : r = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i(O) {
    console && console.warn && console.warn(O);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  Ts.exports = o, Ts.exports.once = _, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(O) {
    if (typeof O != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof O);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(O) {
      if (typeof O != "number" || O < 0 || a(O))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + O + ".");
      s = O;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function d(O) {
    return O._maxListeners === void 0 ? o.defaultMaxListeners : O._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(I) {
    for (var F = [], L = 1; L < arguments.length; L++) F.push(arguments[L]);
    var K = I === "error", J = this._events;
    if (J !== void 0)
      K = K && J.error === void 0;
    else if (!K)
      return !1;
    if (K) {
      var re;
      if (F.length > 0 && (re = F[0]), re instanceof Error)
        throw re;
      var W = new Error("Unhandled error." + (re ? " (" + re.message + ")" : ""));
      throw W.context = re, W;
    }
    var Y = J[I];
    if (Y === void 0)
      return !1;
    if (typeof Y == "function")
      n(Y, this, F);
    else
      for (var P = Y.length, B = C(Y, P), L = 0; L < P; ++L)
        n(B[L], this, F);
    return !0;
  };
  function p(O, I, F, L) {
    var K, J, re;
    if (l(F), J = O._events, J === void 0 ? (J = O._events = /* @__PURE__ */ Object.create(null), O._eventsCount = 0) : (J.newListener !== void 0 && (O.emit(
      "newListener",
      I,
      F.listener ? F.listener : F
    ), J = O._events), re = J[I]), re === void 0)
      re = J[I] = F, ++O._eventsCount;
    else if (typeof re == "function" ? re = J[I] = L ? [F, re] : [re, F] : L ? re.unshift(F) : re.push(F), K = d(O), K > 0 && re.length > K && !re.warned) {
      re.warned = !0;
      var W = new Error("Possible EventEmitter memory leak detected. " + re.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      W.name = "MaxListenersExceededWarning", W.emitter = O, W.type = I, W.count = re.length, i(W);
    }
    return O;
  }
  o.prototype.addListener = function(I, F) {
    return p(this, I, F, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, F) {
    return p(this, I, F, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(O, I, F) {
    var L = { fired: !1, wrapFn: void 0, target: O, type: I, listener: F }, K = u.bind(L);
    return K.listener = F, L.wrapFn = K, K;
  }
  o.prototype.once = function(I, F) {
    return l(F), this.on(I, f(this, I, F)), this;
  }, o.prototype.prependOnceListener = function(I, F) {
    return l(F), this.prependListener(I, f(this, I, F)), this;
  }, o.prototype.removeListener = function(I, F) {
    var L, K, J, re, W;
    if (l(F), K = this._events, K === void 0)
      return this;
    if (L = K[I], L === void 0)
      return this;
    if (L === F || L.listener === F)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete K[I], K.removeListener && this.emit("removeListener", I, L.listener || F));
    else if (typeof L != "function") {
      for (J = -1, re = L.length - 1; re >= 0; re--)
        if (L[re] === F || L[re].listener === F) {
          W = L[re].listener, J = re;
          break;
        }
      if (J < 0)
        return this;
      J === 0 ? L.shift() : N(L, J), L.length === 1 && (K[I] = L[0]), K.removeListener !== void 0 && this.emit("removeListener", I, W || F);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var F, L, K;
    if (L = this._events, L === void 0)
      return this;
    if (L.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : L[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete L[I]), this;
    if (arguments.length === 0) {
      var J = Object.keys(L), re;
      for (K = 0; K < J.length; ++K)
        re = J[K], re !== "removeListener" && this.removeAllListeners(re);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (F = L[I], typeof F == "function")
      this.removeListener(I, F);
    else if (F !== void 0)
      for (K = F.length - 1; K >= 0; K--)
        this.removeListener(I, F[K]);
    return this;
  };
  function h(O, I, F) {
    var L = O._events;
    if (L === void 0)
      return [];
    var K = L[I];
    return K === void 0 ? [] : typeof K == "function" ? F ? [K.listener || K] : [K] : F ? j(K) : C(K, K.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function(O, I) {
    return typeof O.listenerCount == "function" ? O.listenerCount(I) : k.call(O, I);
  }, o.prototype.listenerCount = k;
  function k(O) {
    var I = this._events;
    if (I !== void 0) {
      var F = I[O];
      if (typeof F == "function")
        return 1;
      if (F !== void 0)
        return F.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C(O, I) {
    for (var F = new Array(I), L = 0; L < I; ++L)
      F[L] = O[L];
    return F;
  }
  function N(O, I) {
    for (; I + 1 < O.length; I++)
      O[I] = O[I + 1];
    O.pop();
  }
  function j(O) {
    for (var I = new Array(O.length), F = 0; F < I.length; ++F)
      I[F] = O[F].listener || O[F];
    return I;
  }
  function _(O, I) {
    return new Promise(function(F, L) {
      function K(re) {
        O.removeListener(I, J), L(re);
      }
      function J() {
        typeof O.removeListener == "function" && O.removeListener("error", K), F([].slice.call(arguments));
      }
      D(O, I, J, { once: !0 }), I !== "error" && g(O, K, { once: !0 });
    });
  }
  function g(O, I, F) {
    typeof O.on == "function" && D(O, "error", I, F);
  }
  function D(O, I, F, L) {
    if (typeof O.on == "function")
      L.once ? O.once(I, F) : O.on(I, F);
    else if (typeof O.addEventListener == "function")
      O.addEventListener(I, function K(J) {
        L.once && O.removeEventListener(I, K), F(J);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof O);
  }
  return Ts.exports;
}
var qG = BG();
function j8() {
  const e = new qG.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  cT as GraphQLClientProvider,
  DF as PairingContext,
  S8 as PairingProvider,
  b8 as PartnerIntegrations,
  _8 as PartnerIntegrationsSettings,
  RF as getWidgetDefinitions,
  j8 as initializePartnerEventEmitter,
  x8 as usePairing,
  N8 as usePartnerIntegrationWidgetConfigurations
};
